[
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "961.817",
        "Q41r2": "0",
        "Q14r9": "11",
        "Q14r8": "2",
        "session": "cxe4cvgjfbhv6j24",
        "Q41r1": "0",
        "Q14r1": "11",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "13",
        "Q14r5": "15",
        "Q14r4": "8",
        "Q14r7": "5",
        "Q14r6": "11",
        "uuid": "aj2kdqe07h7hxnpt",
        "Q22_9c2": "6",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q22_version": "56",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "7",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "1",
        "Q21r7": "3",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "12/16/2025 12:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "db9d6a910ec94cdebbd1d958e8503071",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "6",
        "Q22_1c1": "7",
        "Q15r5": "5",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg4,/Vote/vote4,/Age/age1,/Rotate Selection/Top_to_Bottom,/Education/edu3,/Overall/qual,20251216_08:49_v6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v56,/Income/inc4,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q9r3": "3",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q30": "5",
        "Q39r3": "2",
        "Q9r5": "2",
        "Q9r6": "2",
        "Q22_6c1": "4",
        "Q22_6c2": "6",
        "Q22_4c2": "8",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Assistant: When you hear the term \"clean energy,\" what does it mean to you personally?  User: wind and solar  Assistant: It sounds like you have a positive association with clean energy, specifically wind and solar. What draws you to support these energy sources?  User: green house gases, pollution and scare resource causing conflict  Assistant: I see that you have concerns about greenhouse gases, pollution, and resource scarcity. Can you elaborate on what specific challenges or obstacles you perceive are currently facing clean energy initiatives?  User: investment  Assistant: Investment is indeed a critical challenge for clean energy. In your view, what do you see as the potential benefits of increasing investment in clean energy?  User: more innovation yielding better energy genreation  Assistant: That's a great point! Increased investment can certainly lead to more innovation and improved energy generation methods. Looking ahead, what do you think will happen if we don't produce as much energy as we need?  User: war  Assistant: Thank you for your response. Click continue to proceed.",
        "sectionLOIr4": "15.9726666667",
        "sectionLOIr1": "15.9726666667",
        "sectionLOIr3": "14.69445",
        "sectionLOIr2": "0.535033333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "5",
        "Q13": "1",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "1",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "record": "34",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "4",
        "Q22_scorer6": "12.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q9r1": "3",
        "Q15r6": "7",
        "Q15r7": "5",
        "Q9r4": "3",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "7",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "2002",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "gavin1",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "04228589-346f-4e5e-f52e-08db676bc9c5",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "2",
        "date": "12/16/2025 12:28",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=db9d6a910ec94cdebbd1d958e8503071&s5=04228589-346f-4e5e-f52e-08db676bc9c5&s2=gavin1&or_age=23&or_zip=90210&or_gender=m&or_householdincome=60000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "M",
        "GeoIP_Detailsr5": "Munster",
        "GeoIP_Detailsr2": "Ireland",
        "Q34r2": "0",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "ie"
    },
    {
        "Q1": "2014",
        "vctq1c22": "0",
        "vctq1c20": "0",
        "vctq1c21": "0",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "0.16",
        "dcua": "..",
        "DevType": "1",
        "session": "ates495dmmgj5zh1",
        "s5": "abc123",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "or1": "TC_01_0001",
        "vlist": "2",
        "uuid": "uub3jy9m2udvasxx",
        "vmobiledevice": "5",
        "s2": "abc123",
        "vctq1c25": "0",
        "markers": "term:Q1.ival gt 2007,Bottom_to_Top,20251216_12:38_v7,qual,sawterm:Q1.ival gt 2007,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "12/16/2025 15:24",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "date": "12/16/2025 15:24",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_01_0001&s5=abc123&s2=abc123&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "87",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "2014",
        "vctq1c22": "0",
        "vctq1c20": "0",
        "vctq1c21": "0",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "0.228",
        "dcua": "..",
        "DevType": "1",
        "session": "cqssp5wgd6638hsk",
        "s5": "orvid2",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36",
        "or1": "TC_03_00012",
        "vlist": "2",
        "uuid": "ka5xyy6qza1n5bq8",
        "vmobiledevice": "5",
        "s2": "s2_value2",
        "vctq1c25": "0",
        "markers": "term:Q1.ival gt 2007,Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,bad:/Rotate Selection/Bottom_to_Top,20251217_10:39_v10,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "12/17/2025 12:02",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "date": "12/17/2025 12:02",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_03_00012&s5=orvid2&s2=s2_value2&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "124",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "2014",
        "vctq1c22": "0",
        "vctq1c20": "0",
        "vctq1c21": "0",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "0.213",
        "dcua": "..",
        "DevType": "1",
        "session": "2ewx9enqhvr4cggd",
        "s5": "orvid2",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36",
        "or1": "TC_03_000123",
        "vlist": "2",
        "uuid": "pajk2hnt1msn34ra",
        "vmobiledevice": "5",
        "s2": "s2_value2",
        "vctq1c25": "0",
        "markers": "term:Q1.ival gt 2007,bad:/Rotate Selection/Top_to_Bottom,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,20251217_10:39_v10,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "12/17/2025 12:02",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "date": "12/17/2025 12:02",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_03_000123&s5=orvid2&s2=s2_value2&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "125",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "2014",
        "vctq1c22": "0",
        "vctq1c20": "0",
        "vctq1c21": "0",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "0.261",
        "dcua": "..",
        "DevType": "1",
        "session": "q0swans1996cz58s",
        "s5": "orvid2",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36",
        "or1": "TC_03_0001234",
        "vlist": "2",
        "uuid": "5uhvdx1skj03f3sm",
        "vmobiledevice": "5",
        "s2": "s2_value2",
        "vctq1c25": "0",
        "markers": "term:Q1.ival gt 2007,bad:/Rotate Selection/Top_to_Bottom,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,20251217_10:39_v10,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "12/17/2025 12:02",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "date": "12/17/2025 12:02",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_03_0001234&s5=orvid2&s2=s2_value2&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "126",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "50",
        "vbrowser": "10",
        "qtime": "184.7",
        "Q14r9": "13",
        "Q14r8": "0",
        "session": "bxju0cmn8pey0czy",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "0d62ev9d58t7ukx3",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "5",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "1",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "3",
        "Q21r3": "2",
        "Q21r2": "7",
        "Q21r5": "1",
        "Q21r4": "5",
        "Q21r7": "4",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "start_date": "12/17/2025 12:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "TC_03_00012345",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "8",
        "record": "127",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "bad:/Income/inc4,bad:/Education/edu3,bad:/Vote/vote1,Bottom_to_Top,sawterm:(dvfail.r1),term:(dvfail.r1),bad:/Ethnicity/eth2,qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/de_maxdiff/Q22/v86,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,20251217_10:39_v10,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "86",
        "Q37": "5",
        "Q35": "5",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "1",
        "Q39r1": "3",
        "Q22_6c1": "5",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "vicissitudo capto usitas aestus architecto usitas crebro",
        "sectionLOIr4": "3.07833333333",
        "sectionLOIr1": "3.07833333333",
        "sectionLOIr3": "2.37573333333",
        "sectionLOIr2": "0.0282333333333",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "4",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "1",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "10",
        "Q15r5": "4",
        "Q15r6": "4",
        "Q15r7": "10",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "4",
        "Q15r8": "8",
        "Q15r9": "1",
        "Q1": "1975",
        "Q3": "37",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "4",
        "Q22_8c2": "6",
        "Q22_8c1": "3",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "87",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "s2_value2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "orvid2",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "5",
        "Q8r6": "2",
        "Q8r1": "5",
        "Q8r3": "3",
        "Q8r2": "1",
        "date": "12/17/2025 15:12",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_03_00012345&s5=orvid2&s2=s2_value2&or_auto=1",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "464.935",
        "Q14r9": "32",
        "Q14r8": "20",
        "session": "bdnhgbzfasxgm0wv",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36",
        "Q14r3": "3",
        "Q14r2": "0",
        "Q14r5": "1",
        "Q14r4": "0",
        "Q14r7": "1",
        "Q14r6": "0",
        "uuid": "b8ymxsvd3pxpsvjk",
        "Q22_9c2": "3",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "5",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "1",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "3",
        "Q21r3": "5",
        "Q21r2": "7",
        "Q21r5": "1",
        "Q21r4": "6",
        "Q21r7": "4",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "1",
        "start_date": "12/18/2025 08:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "TC_03_0001218251123",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "4",
        "record": "155",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "qualified,/Vote/vote1,/Region/reg4,/Ethnicity/eth3,Bottom_to_Top,20251218_06:33_v11,/Education/edu1,/Age/age5,/Rotate Selection/Bottom_to_Top,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc4,/Gender/gen3,sawterm:(dvfail.r1),/de_maxdiff/Q22/v205",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "205",
        "Q37": "5",
        "Q35": "5",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "1",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "vicissitudo capto usitas aestus architecto usitas crebro",
        "sectionLOIr4": "7.7044",
        "sectionLOIr1": "7.7044",
        "sectionLOIr3": "7.33261666667",
        "sectionLOIr2": "5.77575",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "4",
        "Q15r5": "1",
        "Q15r6": "6",
        "Q15r7": "1",
        "Q15r1": "1",
        "Q15r2": "6",
        "Q15r3": "0",
        "Q15r8": "10",
        "Q15r9": "8",
        "Q1": "1970",
        "Q3": "13",
        "Q2": "4",
        "Q5": "2",
        "Q4": "2",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "43",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "s2_value1218251123",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "orvid1218251123",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "2",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "6",
        "Q8r6": "4",
        "Q8r1": "6",
        "Q8r3": "3",
        "Q8r2": "1",
        "date": "12/18/2025 08:38",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_03_0001218251123&s5=orvid1218251123&s2=s2_value1218251123&or_auto=1",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "31",
        "vbrowser": "10",
        "qtime": "66.568",
        "Q14r9": "20",
        "Q14r8": "30",
        "session": "x1vc6m03zbx0ugbr",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/142.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "2",
        "Q14r6": "0",
        "uuid": "4a66n1bt1rv6cuz5",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "1",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "6",
        "Q21r7": "3",
        "Q21r6": "7",
        "Q38": "2",
        "Q43": "1",
        "start_date": "12/18/2025 14:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "TC_03_0001218250505",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "4",
        "record": "161",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "bad:/Education/edu1,Bottom_to_Top,20251218_06:33_v11,sawterm:(dvfail.r1),term:(dvfail.r1),qual,bad:/Vote/vote1,bad:/Income/inc7,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Ethnicity/eth5,bad:/Age/age2,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen3,bad:/de_maxdiff/Q22/v298,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "3",
        "Q22_version": "298",
        "Q37": "5",
        "Q35": "5",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "6",
        "Q39r2": "3",
        "Q39r3": "1",
        "Q39r1": "3",
        "Q22_6c1": "7",
        "Q22_6c2": "4",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "ambulo saepe statim tondeo esse peccatus",
        "sectionLOIr4": "1.10946666667",
        "sectionLOIr1": "1.10946666667",
        "sectionLOIr3": "0.9368",
        "sectionLOIr2": "0.383516666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "87.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "25",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "6",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "1",
        "Q15r1": "0",
        "Q15r2": "6",
        "Q15r3": "0",
        "Q15r8": "9",
        "Q15r9": "5",
        "Q1": "1994",
        "Q3": "43",
        "Q2": "4",
        "Q5": "2",
        "Q4": "5",
        "Q6": "9",
        "Q22_8c2": "3",
        "Q22_8c1": "7",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "48",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "s2_value1218250505",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "orvid1218250505",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "6",
        "Q22_3c1": "2",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "5",
        "Q8r1": "4",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "12/18/2025 14:07",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_03_0001218250505&s5=orvid1218250505&s2=s2_value1218250505&or_auto=1",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "1086.296",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "g6c8wd1dmud1j5f2",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "25",
        "Q14r5": "25",
        "Q14r4": "7",
        "Q14r7": "3",
        "Q14r6": "0",
        "uuid": "fvan1g0fn76dt2ku",
        "Q22_9c2": "3",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q22_version": "121",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "3",
        "Q39r2": "4",
        "start_date": "12/18/2025 14:10",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "938f930148474a08ba8292f3ccbd846f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "5",
        "Q15r5": "8",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/Age/age2,/Ethnicity/eth3,Bottom_to_Top,20251218_06:33_v11,sawterm:(dvfail.r1),/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v121,qual,/Education/edu2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q30": "2",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "5",
        "Q22_6c2": "6",
        "Q22_4c2": "1",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "3",
        "Q24": "Clean energy represents technological innovation that reduces environmental impact while driving national technological leadership, offering a sustainable path to meeting America's future energy needs with minimal carbon emissions.",
        "sectionLOIr4": "18.1013",
        "sectionLOIr1": "18.1013",
        "sectionLOIr3": "15.2946666667",
        "sectionLOIr2": "2.5907",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "100",
        "HIDAge2": "2",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "162",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "3",
        "Q22_scorer6": "12.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "9",
        "Q9r1": "2",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1996",
        "Q3": "39",
        "Q2": "1",
        "Q5": "3",
        "Q4": "2",
        "Q6": "2",
        "Q22_8c2": "6",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e8b00a56-49ea-45a9-aaa9-3856105d5d14",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "7",
        "Q22_3c2": "6",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "12/18/2025 14:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=938f930148474a08ba8292f3ccbd846f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e8b00a56-49ea-45a9-aaa9-3856105d5d14&or_age=29&or_zip=19380&or_gender=m&or_householdincome=41250",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "852.82",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "3",
        "session": "c6tkahw0zkr1q6cq",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "20",
        "Q14r5": "17",
        "Q14r4": "7",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "sbvzwmc6cbqx0kfv",
        "Q22_9c2": "3",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q22_version": "93",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "2",
        "Q38": "3",
        "Q43": "3",
        "Q39r2": "4",
        "start_date": "12/18/2025 15:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "464dbf594d3a4253846d7e29067782c4",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "6",
        "Q22_1c1": "7",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Vote/vote3,/Region/reg3,/Ethnicity/eth1,20251218_06:33_v11,/Age/age1,/Rotate Selection/Top_to_Bottom,/Education/edu2,/Overall/qual,qual,/de_maxdiff/Q22/v93,/Gender/gen1,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q30": "4",
        "Q39r3": "4",
        "Q9r5": "2",
        "Q9r6": "2",
        "Q22_6c1": "7",
        "Q22_6c2": "6",
        "Q22_4c2": "6",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means innovative technologies that protect our environment, reduce pollution, and provide sustainable power sources for future generations. It's about using renewable resources like solar and wind to create electricity that doesn't harm our planet, supports technological advancement, and gives us energy independence.",
        "sectionLOIr4": "14.2091",
        "sectionLOIr1": "14.2091",
        "sectionLOIr3": "11.7835166667",
        "sectionLOIr2": "2.51821666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "5",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "87.5",
        "HIDAge2": "1",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "record": "163",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "0",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "10",
        "Q9r1": "1",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q9r4": "3",
        "Q15r1": "9",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "2003",
        "Q3": "49",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "1",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a5588e57-8f23-4caf-bb0b-b43d36bc456c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "12/18/2025 15:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=464dbf594d3a4253846d7e29067782c4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a5588e57-8f23-4caf-bb0b-b43d36bc456c&or_age=22&or_zip=25123&or_gender=m&or_householdincome=26000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "795.12",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "fpz4r1t2a5yt4dbs",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "20",
        "Q14r5": "15",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "7s2uw2eez3pvfxrs",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "1",
        "Q22_version": "229",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "2",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "12/18/2025 15:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "bba983689d5845779abf1f2f700abaf9",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "6",
        "Q22_1c1": "5",
        "Q15r5": "8",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Education/edu2,/Vote/vote4,Bottom_to_Top,20251218_06:33_v11,/de_maxdiff/Q22/v229,/Age/age2,/Rotate Selection/Bottom_to_Top,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "2",
        "Q9r6": "2",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Clean energy means a healthier future for my children, with less pollution and more sustainable ways of powering our world. It's about creating energy that doesn't harm the environment and can help protect the planet they'll inherit.",
        "sectionLOIr4": "13.24765",
        "sectionLOIr1": "13.24765",
        "sectionLOIr3": "11.0014",
        "sectionLOIr2": "1.72696666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "164",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "1",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q9r1": "1",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "9",
        "Q1": "2000",
        "Q3": "15",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1e75bef1-7560-41a2-89e2-70a8837a6f96",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "12/18/2025 15:32",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bba983689d5845779abf1f2f700abaf9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1e75bef1-7560-41a2-89e2-70a8837a6f96&or_age=23&or_zip=46060&or_gender=f&or_householdincome=26000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "777.806",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "3",
        "session": "pt4c8vbnzteubfzq",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "25",
        "Q14r5": "15",
        "Q14r4": "8",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "p99774jsbtbgj254",
        "Q22_9c2": "4",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q22_version": "284",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "8",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "5",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "12/18/2025 15:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ad7610e43c964722b2b2dc40189fc057",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "4",
        "Q22_1c1": "8",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg4,/Vote/vote4,20251218_06:33_v11,/Age/age1,/Rotate Selection/Top_to_Bottom,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v284,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "6",
        "Q30": "4",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "7",
        "Q22_6c2": "6",
        "Q22_4c2": "5",
        "Q22_4c1": "8",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "100",
        "Q23": "2",
        "Q24": "Clean energy means innovative technologies that reduce environmental impact while powering our future, creating sustainable solutions that balance technological progress with ecological responsibility.",
        "sectionLOIr4": "12.9599",
        "sectionLOIr1": "12.9599",
        "sectionLOIr3": "10.7540333333",
        "sectionLOIr2": "1.74873333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "1",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "87.5",
        "HIDAge2": "1",
        "Q22_scorer5": "50",
        "Q22_scorer4": "0",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "record": "165",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "12.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q9r1": "1",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "9",
        "Q1": "2003",
        "Q3": "2",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "4",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "2",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "62b5ee39-c1af-44f7-8e66-b8ce9a85a378",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "8",
        "Q22_3c2": "6",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "2",
        "date": "12/18/2025 15:46",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ad7610e43c964722b2b2dc40189fc057&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=62b5ee39-c1af-44f7-8e66-b8ce9a85a378&or_age=20&or_zip=99645&or_gender=m&or_householdincome=18000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "637.423",
        "Q41r2": "0",
        "Q14r9": "2",
        "Q14r8": "3",
        "session": "62bpdwnm4z3rkn95",
        "Q41r1": "1",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "20",
        "Q14r5": "22",
        "Q14r4": "5",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "14epnecb8uxfhvns",
        "Q22_9c2": "7",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q22_version": "88",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "3",
        "Q39r2": "3",
        "start_date": "12/18/2025 15:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e01dbaf03b904d8f9ba9c492c973a5a9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "2",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q9r2": "2",
        "markers": "qualified,/Vote/vote3,/Region/reg4,Bottom_to_Top,20251218_06:33_v11,sawterm:(dvfail.r1),/Education/edu3,/Age/age4,/Rotate Selection/Bottom_to_Top,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,/Income/inc5,/de_maxdiff/Q22/v88",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "7",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "2",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy represents a forward-looking approach to powering our society that minimizes environmental impact while driving technological innovation and economic opportunity. It's about creating sustainable solutions that protect our planet, reduce our dependence on fossil fuels, and generate new jobs and economic growth for local communities.",
        "sectionLOIr4": "10.6209833333",
        "sectionLOIr1": "10.6209833333",
        "sectionLOIr3": "8.73375",
        "sectionLOIr2": "1.79201666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "5",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "100",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "record": "166",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "8",
        "Q9r1": "2",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q9r4": "3",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1978",
        "Q3": "6",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "1",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "1dba3636-ac57-43bc-9720-b3a2f1ac6f75",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "6",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "4",
        "date": "12/18/2025 15:58",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e01dbaf03b904d8f9ba9c492c973a5a9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1dba3636-ac57-43bc-9720-b3a2f1ac6f75&or_age=22&or_zip=89102&or_gender=m&or_householdincome=25000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "850.135",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "3",
        "session": "1yq1dk25hy0q3k0v",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "20",
        "Q14r5": "20",
        "Q14r4": "5",
        "Q14r7": "2",
        "Q14r6": "4",
        "uuid": "tff0h84behrevth2",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q22_version": "191",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "5",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "2",
        "Q39r2": "3",
        "start_date": "12/18/2025 15:58",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "44a1ee61b93b4405ae1ca03c94c0e61d",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,20251218_06:33_v11,/Education/edu1,/Rotate Selection/Top_to_Bottom,/de_maxdiff/Q22/v191,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "2",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means innovative technologies that create jobs, reduce environmental impact, and provide sustainable power solutions for our future. It represents a smart approach to meeting our energy needs while protecting the environment and creating economic opportunities for working families like mine.",
        "sectionLOIr4": "14.1648",
        "sectionLOIr1": "14.1648",
        "sectionLOIr3": "11.7053",
        "sectionLOIr2": "2.617",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "1",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "record": "167",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "2",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "8",
        "Q9r1": "2",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "2000",
        "Q3": "21",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "1",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "614786b2-5053-4fb1-a362-ce7cffd7e718",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "12/18/2025 16:12",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=44a1ee61b93b4405ae1ca03c94c0e61d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=614786b2-5053-4fb1-a362-ce7cffd7e718&or_age=24&or_zip=21209&or_gender=m&or_householdincome=70000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "1228.108",
        "Q41r2": "0",
        "Q14r9": "2",
        "Q14r8": "5",
        "session": "spuzcyxrh8rxcdau",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "25",
        "Q14r5": "22",
        "Q14r4": "5",
        "Q14r7": "2",
        "Q14r6": "3",
        "uuid": "jp975m8y3vwr45gt",
        "Q22_9c2": "6",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q22_version": "5",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "1",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "2",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "Q39r2": "3",
        "start_date": "12/18/2025 16:13",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b1aa5415ced1465587481ecea936dbe8",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/de_maxdiff/Q22/v5,/Region/reg3,/Ethnicity/eth3,Bottom_to_Top,20251218_06:33_v11,/Age/age1,/Education/edu3,/Rotate Selection/Bottom_to_Top,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen2,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "2",
        "Q9r6": "2",
        "Q22_6c1": "5",
        "Q22_6c2": "3",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means a sustainable way of generating power that protects our environment, supports human health, and uses innovative technologies to minimize ecological harm. It's about creating energy solutions that don't compromise the planet's future or the well-being of communities, focusing on renewable sources like solar and wind that can provide electricity without the negative impacts of fossil fuels.",
        "sectionLOIr4": "20.46495",
        "sectionLOIr1": "20.46495",
        "sectionLOIr3": "16.2935",
        "sectionLOIr2": "2.91731666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "1",
        "Q22_scorer5": "100",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "record": "168",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "6",
        "Q22_scorer6": "12.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q9r1": "2",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q9r4": "3",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "2002",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "2",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "1",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "42299383-402e-4444-a6f1-8434022d21f3",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "5",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "12/18/2025 16:33",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b1aa5415ced1465587481ecea936dbe8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=42299383-402e-4444-a6f1-8434022d21f3&or_age=21&or_zip=78589&or_gender=f&or_householdincome=20000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "21",
        "vbrowser": "10",
        "qtime": "1228.844",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "4",
        "session": "1s0xzn4ae01nk5t2",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "18",
        "Q14r5": "23",
        "Q14r4": "8",
        "Q14r7": "3",
        "Q14r6": "2",
        "uuid": "ke8tyax3ra7vvy1n",
        "Q22_9c2": "3",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q22_version": "266",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "3",
        "Q21r2": "1",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "2",
        "Q39r2": "3",
        "start_date": "12/18/2025 16:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "396d65c366754f708f47f7e6a744e376",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,20251218_06:33_v11,/Age/age1,/Rotate Selection/Top_to_Bottom,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc3,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v266,sawterm:(dvfail.r1),/Education/edu1",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q30": "2",
        "Q39r3": "4",
        "Q9r5": "2",
        "Q9r6": "2",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means creating a sustainable future for my child, with power sources that don't harm the environment and can provide reliable electricity without compromising the planet's health. It's about finding practical solutions that balance technological innovation with environmental responsibility.",
        "sectionLOIr4": "20.47705",
        "sectionLOIr1": "20.47705",
        "sectionLOIr3": "16.4789333333",
        "sectionLOIr2": "4.8289",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "5",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "169",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q9r1": "1",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q9r4": "2",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2004",
        "Q3": "5",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "2",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "cbf2920e-6c4e-460f-8949-d723bf1ae49c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "12/18/2025 16:55",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=396d65c366754f708f47f7e6a744e376&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cbf2920e-6c4e-460f-8949-d723bf1ae49c&or_age=21&or_zip=95003&or_gender=m&or_householdincome=75000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "21",
        "vbrowser": "10",
        "qtime": "770.627",
        "Q41r2": "0",
        "Q14r9": "3",
        "Q14r8": "3",
        "session": "jz0vqurmesc116pm",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "12",
        "Q14r2": "20",
        "Q14r5": "20",
        "Q14r4": "8",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "zq7wk4zs9tg3vm82",
        "Q22_9c2": "6",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q22_version": "48",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "3",
        "Q39r2": "3",
        "start_date": "12/18/2025 16:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "Q39r1": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d99cd376fa5e439a8cc1a856fa23ff96",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "6",
        "Q22_1c1": "9",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,20251218_06:33_v11,/Age/age1,/Rotate Selection/Top_to_Bottom,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v48,Top_to_Bottom,/Income/inc2,sawterm:(dvfail.r1),/Vote/vote3,/Gender/gen1",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "8",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "8",
        "Q22_6c2": "4",
        "Q22_4c2": "6",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "100",
        "Q23": "2",
        "Q24": "Clean energy represents the future of technological innovation - sustainable power sources that reduce environmental impact while driving economic and technological progress. It's about creating smarter, more efficient ways to generate electricity that align with America's potential for global technological leadership.",
        "sectionLOIr4": "12.8402166667",
        "sectionLOIr1": "12.8402166667",
        "sectionLOIr3": "10.5716166667",
        "sectionLOIr2": "2.02475",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "1",
        "Q13": "1",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "1",
        "Q22_scorer5": "25",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "170",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "8",
        "Q22_2c2": "5",
        "Q22_scorer6": "0",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "8",
        "Q9r1": "2",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "9",
        "Q1": "2004",
        "Q3": "23",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "4",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "2",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "bb1eacd3-8076-4dd4-8121-52d92bb674c1",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "7",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "4",
        "date": "12/18/2025 17:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d99cd376fa5e439a8cc1a856fa23ff96&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=bb1eacd3-8076-4dd4-8121-52d92bb674c1&or_age=21&or_zip=48506&or_gender=m&or_householdincome=30000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "869.906",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "9pepa0mrsg6z8k3c",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "x3mm9zzrjth6awpn",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q22_version": "241",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "7",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "12/18/2025 17:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e33dfa54379e44fc999a1501065d4811",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "6",
        "Q22_1c1": "9",
        "Q15r5": "8",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,20251218_06:33_v11,/Age/age1,/Rotate Selection/Bottom_to_Top,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v241,/Gender/gen1,sawterm:(dvfail.r1),/Education/edu1,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "1",
        "Q22_6c2": "4",
        "Q22_4c2": "4",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Energy sources that are environmentally responsible, reduce pollution, and can be sustained long-term without depleting natural resources. To me, clean energy represents technological innovation that supports economic growth while minimizing negative environmental impacts.",
        "sectionLOIr4": "14.4943333333",
        "sectionLOIr1": "14.4943333333",
        "sectionLOIr3": "11.4137333333",
        "sectionLOIr2": "1.89573333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "1",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "87.5",
        "HIDAge2": "1",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "record": "171",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q9r1": "1",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "2003",
        "Q3": "36",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "6",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "209aec2c-0069-4d90-bbf2-5e02d51385fa",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "7",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "12/18/2025 17:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e33dfa54379e44fc999a1501065d4811&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=209aec2c-0069-4d90-bbf2-5e02d51385fa&or_age=20&or_zip=45150&or_gender=m&or_householdincome=39000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "28",
        "vbrowser": "10",
        "qtime": "1474.874",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "crgrvysh7nwefmpm",
        "Q41r1": "1",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "s29gnyuppgcn6jqk",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q22_version": "91",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "4",
        "Q21r2": "1",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "Q39r2": "3",
        "start_date": "12/19/2025 03:54",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "918b865d5a82441296e1a12658e5260e",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "3",
        "Q22_1c1": "2",
        "Q15r5": "7",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,Bottom_to_Top,20251218_06:33_v11,sawterm:(dvfail.r1),20251219_04:10_v12,/Age/age2,/Rotate Selection/Bottom_to_Top,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v91,/Income/inc5,/Gender/gen2,/Education/edu4",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q30": "1",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "2",
        "Q22_6c2": "4",
        "Q22_4c2": "4",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Clean energy represents a strategic, forward-looking approach to powering our economy with minimal environmental impact. To me, it's about developing sustainable technologies that reduce carbon emissions, create new job opportunities, and position the United States as a global leader in innovation.",
        "sectionLOIr4": "24.5771666667",
        "sectionLOIr1": "24.5771666667",
        "sectionLOIr3": "11.2625333333",
        "sectionLOIr2": "1.91581666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "1",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "75",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "record": "199",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q9r1": "2",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "8",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1997",
        "Q3": "6",
        "Q2": "2",
        "Q5": "5",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "53c4d9b6-c272-4458-beca-5920bf6e94b5",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "5",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "4",
        "date": "12/19/2025 04:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=918b865d5a82441296e1a12658e5260e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=53c4d9b6-c272-4458-beca-5920bf6e94b5&or_age=28&or_zip=80016&or_gender=f&or_householdincome=110000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "349.86",
        "Q41r2": "0",
        "Q14r9": "1",
        "Q14r8": "4",
        "session": "r81dpe2c7eb640kg",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "30",
        "Q14r2": "15",
        "Q14r5": "5",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "3",
        "uuid": "9sc4zbn0gvsvgbum",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "1",
        "Q22_version": "231",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "6",
        "Q21r7": "1",
        "Q21r6": "7",
        "Q38": "4",
        "Q43": "1",
        "Q39r2": "4",
        "start_date": "01/02/2026 15:25",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d8da16f3d3e24d909793451b359e8901",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "1",
        "Q15r5": "6",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Vote/vote1,/Region/reg1,/Ethnicity/eth1,/de_maxdiff/Q22/v231,/Education/edu1,/Rotate Selection/Top_to_Bottom,20251219_04:10_v12,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q9r3": "3",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q30": "1",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Clean energy to me is power that comes from sources that don’t pollute the air or water, that can keep jobs and give the community prosperity. It’s about reliable electricity for homes, trucks and good tools for people.",
        "sectionLOIr4": "5.8293",
        "sectionLOIr1": "5.8293",
        "sectionLOIr3": "5.36708333333",
        "sectionLOIr2": "0.16185",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "5",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "100",
        "record": "235",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "3",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q9r1": "2",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q9r4": "3",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "6",
        "Q1": "1970",
        "Q3": "39",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7906ed5c-de7e-407f-b513-c1c996dea0df",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/02/2026 15:31",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d8da16f3d3e24d909793451b359e8901&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7906ed5c-de7e-407f-b513-c1c996dea0df&isSynthetic=true&or_age=55&or_zip=19468&or_gender=m&or_householdincome=62000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "63",
        "vbrowser": "10",
        "qtime": "590.47",
        "Q41r2": "1",
        "Q14r9": "3",
        "Q14r8": "5",
        "session": "rf18qbk2j9ndf2bk",
        "Q41r1": "0",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "35",
        "Q14r2": "10",
        "Q14r5": "0",
        "Q14r4": "25",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "nu2u68z3x8myssqq",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q22_version": "190",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "6",
        "Q21r2": "1",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "3",
        "Q21r6": "7",
        "Q38": "4",
        "Q43": "1",
        "Q39r2": "4",
        "start_date": "01/02/2026 15:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "99bd2789738b48119fcc915ab5d0fd05",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "Q15r5": "6",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Vote/vote1,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20251219_04:10_v12,/de_maxdiff/Q22/v190,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc1,/Education/edu3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q9r3": "3",
        "Q36": "2",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q30": "1",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "Clean energy, to me, is just power that doesn’t come from burning coal or oil—basically electricity from things like solar or wind that don’t spew out greenhouse gases.  I see it as a good idea, but I’m cautious about the cost and reliability until it clearly beats the cheaper, proven fossil fuel options.",
        "sectionLOIr4": "9.83981666667",
        "sectionLOIr1": "9.83981666667",
        "sectionLOIr3": "8.84046666667",
        "sectionLOIr2": "0.253083333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "100",
        "record": "238",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "2",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q9r1": "2",
        "Q15r6": "6",
        "Q15r7": "6",
        "Q9r4": "3",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "6",
        "Q15r8": "6",
        "Q15r9": "6",
        "Q1": "1962",
        "Q3": "34",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "4",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "2",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "25476853-7e2c-455b-bc82-8f2bc0a0a0c5",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/02/2026 15:44",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=99bd2789738b48119fcc915ab5d0fd05&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=25476853-7e2c-455b-bc82-8f2bc0a0a0c5&isSynthetic=true&or_age=64&or_zip=28451&or_gender=m&or_householdincome=24960",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "510.357",
        "Q41r2": "0",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "61qux68xz2emjnz6",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "18",
        "Q14r5": "0",
        "Q14r4": "19",
        "Q14r7": "2",
        "Q14r6": "0",
        "uuid": "0nn56gkwmpxbegxs",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q22_version": "27",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "2",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "Q39r2": "3",
        "start_date": "01/02/2026 15:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "89bb637419cb4fcdbb27de8873365571",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "Q15r5": "7",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Vote/vote1,/Region/reg1,/Education/edu2,/Ethnicity/eth1,/de_maxdiff/Q22/v27,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20251219_04:10_v12,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q9r3": "3",
        "Q36": "2",
        "Q35": "2",
        "Q22_7c1": "2",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q30": "1",
        "Q39r3": "2",
        "Q9r5": "2",
        "Q9r6": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "3",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Clean energy is power that comes from sources like sunlight, wind, or water—whatever gives us cleaner air, a safer community, and a reliable supply we can afford for everyday life.",
        "sectionLOIr4": "8.50461666667",
        "sectionLOIr1": "8.50461666667",
        "sectionLOIr3": "7.84451666667",
        "sectionLOIr2": "0.133333333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "record": "241",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q9r1": "2",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q9r4": "3",
        "Q15r1": "7",
        "Q15r2": "7",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "2000",
        "Q3": "22",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "1",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/02/2026 15:55",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=89bb637419cb4fcdbb27de8873365571&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c&isSynthetic=true&or_age=25&or_zip=01604&or_gender=m&or_householdincome=69400",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "384.055",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "hkhjca4jbr1d403b",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "15",
        "Q14r5": "0",
        "Q14r4": "10",
        "Q14r7": "25",
        "Q14r6": "10",
        "uuid": "xtr6yxr9r9a52h7u",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q22_version": "173",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "5",
        "Q21r3": "7",
        "Q21r2": "1",
        "Q21r5": "4",
        "Q21r4": "2",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "1",
        "Q39r2": "4",
        "start_date": "01/05/2026 09:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "dfe41e2b93fb46b5ba3d6e675b0b18c8",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "9",
        "Q22_1c1": "6",
        "Q15r5": "8",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Vote/vote1,/Region/reg1,/Education/edu2,/Ethnicity/eth1,/de_maxdiff/Q22/v173,Bottom_to_Top,sawterm:(dvfail.r1),20251219_04:10_v12,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q9r3": "3",
        "Q36": "2",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q30": "1",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "It means energy that comes from non‑fossil sources—like wind, solar, or other renewables—that helps keep my family’s power bills reasonable and reduces my carbon footprint.",
        "sectionLOIr4": "6.3993",
        "sectionLOIr1": "6.3993",
        "sectionLOIr3": "5.54171666667",
        "sectionLOIr2": "0.176716666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "record": "265",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q9r1": "2",
        "Q15r6": "8",
        "Q15r7": "8",
        "Q9r4": "3",
        "Q15r1": "7",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "2000",
        "Q3": "22",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "1",
        "Q22_3c2": "9",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/05/2026 09:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=dfe41e2b93fb46b5ba3d6e675b0b18c8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c&isSynthetic=true&or_age=25&or_zip=01604&or_gender=m&or_householdincome=69400",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "667.993",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "20",
        "session": "v88hna17byv4evxf",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "25",
        "Q14r2": "25",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "9u1u5t61ebdp6q8q",
        "Q22_9c2": "9",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q22_version": "129",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "1",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "5",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "3",
        "Q21r6": "7",
        "Q38": "2",
        "Q43": "2",
        "Q39r2": "3",
        "start_date": "01/05/2026 09:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c5273298e0c44c79a7e70aa6f7015153",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "9",
        "Q22_1c1": "7",
        "Q15r5": "8",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg1,/Education/edu2,/Ethnicity/eth1,Bottom_to_Top,/de_maxdiff/Q22/v129,sawterm:(dvfail.r1),20251219_04:10_v12,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q9r3": "3",
        "Q37": "2",
        "Q35": "4",
        "Q22_7c1": "7",
        "Q39r4": "3",
        "Q22_7c2": "1",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "3",
        "Q22_6c1": "8",
        "Q22_6c2": "6",
        "Q22_4c2": "6",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "3",
        "Q24": "Clean energy, for me, means a reliable and affordable source that helps our family save on bills while keeping the planet healthier. It’s about balancing the benefits of jobs, innovation, and lower emissions with practical realities—like making sure the technology we use actually works in a busy household. I want power that’s clean, reliable, and cost‑effective, not just a buzzword.",
        "sectionLOIr4": "11.13155",
        "sectionLOIr1": "11.13155",
        "sectionLOIr3": "10.4841666667",
        "sectionLOIr2": "0.2818",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "87.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "record": "270",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "9",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q9r1": "2",
        "Q15r6": "8",
        "Q15r7": "8",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "8",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "2000",
        "Q3": "22",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "5",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "1",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/05/2026 10:04",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c5273298e0c44c79a7e70aa6f7015153&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c&isSynthetic=true&or_age=25&or_zip=01604&or_gender=m&or_householdincome=69400",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "371.859",
        "Q14r9": "10",
        "Q14r8": "50",
        "session": "bvcx86gz1c9ca88t",
        "Q41r1": "1",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "15",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "jh8e1q02yt0mjxgw",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "start_date": "01/05/2026 09:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "50a0555e4293485ba71e874926b6f17c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "1",
        "record": "271",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote1,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20251219_04:10_v12,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v256,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc4",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "256",
        "Q36": "2",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "7",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "Clean energy to me means reliable, cost‑effective power that keeps a shop running and customers satisfied without compromising the bottom line.",
        "sectionLOIr4": "6.19586666667",
        "sectionLOIr1": "6.19586666667",
        "sectionLOIr3": "5.43936666667",
        "sectionLOIr2": "0.248733333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "62.5",
        "HIDAge2": "5",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "100",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1970",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "4",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f2826b7a-fd35-4ff7-b2b1-7254758c8ea9",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/05/2026 09:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=50a0555e4293485ba71e874926b6f17c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f2826b7a-fd35-4ff7-b2b1-7254758c8ea9&isSynthetic=true&or_age=55&or_zip=77406&or_gender=m&or_householdincome=92500",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "493.756",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "2",
        "session": "tbzjwftr8h66mjnr",
        "Q41r1": "0",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "30",
        "Q14r2": "10",
        "Q14r5": "21",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "2",
        "uuid": "w41farmesw1g470z",
        "Q22_9c2": "1",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q22_version": "140",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "1",
        "Q39r2": "4",
        "start_date": "01/05/2026 09:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "5435d2334db74aac85d6933f9b950d87",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "2",
        "Q15r5": "6",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Vote/vote1,/Ethnicity/eth4,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20251219_04:10_v12,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v140,/Education/edu3,/Income/inc2",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q9r3": "3",
        "Q36": "2",
        "Q35": "2",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q30": "1",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "1",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Clean energy, to me, is the electricity we can get from the sun, wind, or water that doesn’t emit harmful pollutants or greenhouse gases. It’s a reliable, sustainable source that keeps our air and water cleaner while still meeting our everyday needs.",
        "sectionLOIr4": "8.22761666667",
        "sectionLOIr1": "8.22761666667",
        "sectionLOIr3": "7.17878333333",
        "sectionLOIr2": "0.221416666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "record": "273",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "6",
        "Q9r1": "2",
        "Q15r6": "6",
        "Q15r7": "6",
        "Q9r4": "3",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "6",
        "Q15r8": "6",
        "Q15r9": "6",
        "Q1": "1959",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/05/2026 10:01",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5435d2334db74aac85d6933f9b950d87&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "213.004",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "bxfcnnft7v6x5z7s",
        "Q41r1": "0",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "5",
        "Q14r2": "55",
        "Q14r5": "5",
        "Q14r4": "5",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "jtc9byx1gpephv32",
        "Q22_9c2": "6",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "4",
        "Q21r2": "5",
        "Q21r5": "2",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/05/2026 15:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "5802f37fbde349d68b68be53ee059736",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "5",
        "record": "293",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,/de_maxdiff/Q22/v219,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20251219_04:10_v12,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "219",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "5",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "It means energy that is environmentally friendly and helps reduce pollution, which aligns with my values of sustainability and community health.",
        "sectionLOIr4": "3.54765",
        "sectionLOIr1": "3.54765",
        "sectionLOIr3": "2.95346666667",
        "sectionLOIr2": "0.196316666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "4",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "7",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1959",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "4",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/05/2026 16:01",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5802f37fbde349d68b68be53ee059736&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "252.578",
        "Q14r9": "70",
        "Q14r8": "0",
        "session": "5raghv8vy1cxwa9v",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "cg4w9pkur8qaw25j",
        "Q22_9c2": "4",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "4",
        "Q21r2": "5",
        "Q21r5": "2",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/05/2026 16:02",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "3514f1810238434495baa8107a0837a1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "4",
        "record": "294",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20251219_04:10_v12,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v25,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "25",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "Clean energy means reliable, sustainable, and environmentally friendly power sources like solar and wind that support long-term stability and reduce reliance on fossil fuels.",
        "sectionLOIr4": "4.20791666667",
        "sectionLOIr1": "4.20791666667",
        "sectionLOIr3": "3.60863333333",
        "sectionLOIr2": "0.205766666667",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1970",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "4",
        "Q22_8c1": "3",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f2826b7a-fd35-4ff7-b2b1-7254758c8ea9",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/05/2026 16:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3514f1810238434495baa8107a0837a1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f2826b7a-fd35-4ff7-b2b1-7254758c8ea9&isSynthetic=true&or_age=55&or_zip=77406&or_gender=m&or_householdincome=92500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "305.365",
        "Q14r9": "1",
        "Q14r8": "1",
        "session": "5dt21akzph7zuz42",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "2",
        "Q14r2": "5",
        "Q14r5": "65",
        "Q14r4": "1",
        "Q14r7": "1",
        "Q14r6": "2",
        "uuid": "52u5ctp562d82etn",
        "Q22_9c2": "6",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "4",
        "Q21r2": "5",
        "Q21r5": "2",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/05/2026 16:02",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e1739cb74f874bc4a43f445c3913733a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "4",
        "record": "295",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v101,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20251219_04:10_v12,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "101",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "1",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "37.5",
        "Q23": "1",
        "Q24": "Clean energy means reliable and sustainable sources of power that are cost-effective and do not rely on volatile or environmentally harmful fossil fuels, which aligns with my values of stability, practicality, and long-term planning.",
        "sectionLOIr4": "5.08748333333",
        "sectionLOIr1": "5.08748333333",
        "sectionLOIr3": "4.46326666667",
        "sectionLOIr2": "0.258483333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1959",
        "Q3": "34",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "5",
        "Q22_8c1": "9",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "12",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "25476853-7e2c-455b-bc82-8f2bc0a0a0c5",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/05/2026 16:07",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e1739cb74f874bc4a43f445c3913733a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=25476853-7e2c-455b-bc82-8f2bc0a0a0c5&isSynthetic=true&or_age=64&or_zip=28451&or_gender=m&or_householdincome=24960",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "300.529",
        "Q14r9": "2",
        "Q14r8": "5",
        "session": "gefgcx0853q52vd6",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "15",
        "Q14r5": "43",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "j8s83r0nuxxtfvhc",
        "Q22_9c2": "2",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "3",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/05/2026 16:02",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "f671e07abd6146a8bc74676dccdb6669",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "6",
        "Q22_1c1": "4",
        "record": "296",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20251219_04:10_v12,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v104,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "104",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "It means energy that is environmentally friendly, sustainable, and helps reduce pollution, which aligns with my values and the long-term health of our communities.",
        "sectionLOIr4": "5.0072",
        "sectionLOIr1": "5.0072",
        "sectionLOIr3": "4.42718333333",
        "sectionLOIr2": "0.270416666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "1",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1959",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "4",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/05/2026 16:07",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f671e07abd6146a8bc74676dccdb6669&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "248.265",
        "Q14r9": "25",
        "Q14r8": "5",
        "session": "4gmxb98ud11un165",
        "Q41r1": "0",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "15",
        "Q14r5": "5",
        "Q14r4": "5",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "stz9khp7da4v53a3",
        "Q22_9c2": "3",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "7",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "4",
        "Q21r2": "5",
        "Q21r5": "2",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/05/2026 16:02",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6f11642400c2499d8752a47b438616f4",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "1",
        "Q22_1c1": "9",
        "record": "297",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Education/edu2,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20251219_04:10_v12,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v127,/Gender/gen1,Top_to_Bottom,/Income/inc3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "127",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "4",
        "Q22_4c2": "1",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "Renewable and sustainable energy sources that reduce environmental impact and provide long-term benefits for both the planet and the economy.",
        "sectionLOIr4": "4.13628333333",
        "sectionLOIr1": "4.13628333333",
        "sectionLOIr3": "3.4595",
        "sectionLOIr2": "0.246933333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "75",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "2",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "2000",
        "Q3": "22",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "6",
        "Q22_8c1": "9",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "5",
        "Q22_3c2": "9",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/05/2026 16:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6f11642400c2499d8752a47b438616f4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c&isSynthetic=true&or_age=25&or_zip=01604&or_gender=m&or_householdincome=69400",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "106.734",
        "session": "6m4ckrwa2dxk2qrk",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "bube2z5puynnhnah",
        "Q22_9c2": "1",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "Q22_5c2": "4",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/08/2026 13:54",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "c6003912164443b6b7711219eb3cf4e7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "5",
        "record": "365",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),/Education/edu3,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,/Gender/gen3,/de_maxdiff/Q22/v10",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "10",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "3",
        "Q22_6c1": "5",
        "Q22_6c2": "1",
        "Q22_4c2": "6",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q12": "1",
        "Q23": "2",
        "Q24": "Clean energy represents a sustainable and environmentally responsible approach to meeting our energy needs, focusing on reducing pollution and combating climate change.",
        "sectionLOIr4": "1.7773",
        "sectionLOIr1": "1.7773",
        "sectionLOIr3": "1.48828333333",
        "sectionLOIr2": "0.1597",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "3",
        "Q13": "3",
        "Q22_scorer8": "37.5",
        "Q22_scorer7": "75",
        "Q22_scorer6": "37.5",
        "Q22_scorer5": "100",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q22_scorer2": "62.5",
        "Q22_scorer1": "0",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "3",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e4fb1a02-2872-4cb5-a214-c07a0cf43de2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/08/2026 13:56",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c6003912164443b6b7711219eb3cf4e7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e4fb1a02-2872-4cb5-a214-c07a0cf43de2&isSynthetic=true&or_age=76&or_zip=53916&or_gender=m&or_householdincome=55000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "162.495",
        "session": "8w4ccy3zqtge4drw",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "ngpghzej5wdvqfta",
        "Q22_9c2": "2",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/08/2026 14:49",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "4401fe8c7eca4680adc4e10f05099ae0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "366",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/de_maxdiff/Q22/v55,Bottom_to_Top,sawterm:(dvfail.r1),/Education/edu3,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,/Gender/gen3,/Vote/vote4",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "55",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "1",
        "Q22_4c2": "2",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q12": "1",
        "Q23": "3",
        "Q24": "Renewable energy sources that produce little to no greenhouse gas emissions and contribute to a sustainable, healthier environment.",
        "sectionLOIr4": "2.70685",
        "sectionLOIr1": "2.70685",
        "sectionLOIr3": "2.26401666667",
        "sectionLOIr2": "0.22115",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q22_scorer8": "50",
        "Q22_scorer7": "50",
        "Q22_scorer6": "75",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q22_scorer2": "25",
        "Q22_scorer1": "0",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "3",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "3",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "05973ce7-fd1f-4b56-98cb-5a871abc2415",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/08/2026 14:52",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4401fe8c7eca4680adc4e10f05099ae0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=05973ce7-fd1f-4b56-98cb-5a871abc2415&isSynthetic=true&or_age=64&or_zip=75035&or_gender=m&or_householdincome=68000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "163.598",
        "session": "rj7wyjn73m2vyx8v",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "p8hc8dejk16vtu2z",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "Q22_5c2": "1",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "1",
        "Q21r5": "4",
        "Q21r4": "5",
        "Q21r7": "2",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/08/2026 14:49",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "6621495e862b4183bd434d7c50a197d8",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "367",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,/Education/edu3,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,Top_to_Bottom,/de_maxdiff/Q22/v161,/Gender/gen3",
        "Q33": "2",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "161",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q12": "1",
        "Q23": "2",
        "Q24": "Clean energy refers to renewable and sustainable sources like solar, wind, and hydroelectric power that have minimal environmental impact and help combat climate change.",
        "sectionLOIr4": "2.72528333333",
        "sectionLOIr1": "2.72528333333",
        "sectionLOIr3": "2.30551666667",
        "sectionLOIr2": "0.212916666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q22_scorer8": "50",
        "Q22_scorer7": "25",
        "Q22_scorer6": "50",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q22_scorer2": "37.5",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "2",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "4",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5750420b-e6bc-455b-83b8-696f03d335d5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "6",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/08/2026 14:52",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6621495e862b4183bd434d7c50a197d8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5750420b-e6bc-455b-83b8-696f03d335d5&isSynthetic=true&or_age=34&or_zip=18042&or_gender=f&or_householdincome=216000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "169.471",
        "session": "u3m7b82bz9snsb9v",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "9hw8rvz7a3edkb58",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "4",
        "Q21r7": "1",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/08/2026 14:49",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "3e2057c5cca34661ab15d8580c102a4c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "4",
        "record": "368",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,/de_maxdiff/Q22/v74,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,/Education/edu3,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,Top_to_Bottom,/Gender/gen3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "74",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q12": "1",
        "Q23": "2",
        "Q24": "Clean energy represents a sustainable and environmentally responsible approach to meeting our energy needs, focusing on reducing pollution and promoting long-term ecological balance.",
        "sectionLOIr4": "2.82311666667",
        "sectionLOIr1": "2.82311666667",
        "sectionLOIr3": "2.43283333333",
        "sectionLOIr2": "0.214566666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q22_scorer8": "50",
        "Q22_scorer7": "25",
        "Q22_scorer6": "50",
        "Q22_scorer5": "0",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q22_scorer2": "62.5",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "3",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a72e2d0b-1feb-4b39-9111-8e46139da56a",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/08/2026 14:52",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3e2057c5cca34661ab15d8580c102a4c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a72e2d0b-1feb-4b39-9111-8e46139da56a&isSynthetic=true&or_age=76&or_zip=07031&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "146.333",
        "session": "ax373fz8dshman93",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "r3n6q7nmetnewjqk",
        "Q22_9c2": "3",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "Q22_5c2": "3",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "5",
        "Q21r3": "3",
        "Q21r2": "4",
        "Q21r5": "2",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/08/2026 14:49",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "4fd1a4238abc4aa4b0be69a24fca6742",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "4",
        "record": "369",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,/de_maxdiff/Q22/v282,sawterm:(dvfail.r1),/Education/edu3,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,/Gender/gen2",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "282",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "2",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "6",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q12": "1",
        "Q23": "2",
        "Q24": "It means using energy sources that have minimal environmental impact, such as solar, wind, and hydroelectric power, which help reduce pollution and combat climate change.",
        "sectionLOIr4": "2.43756666667",
        "sectionLOIr1": "2.43756666667",
        "sectionLOIr3": "2.01135",
        "sectionLOIr2": "0.188616666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q22_scorer8": "50",
        "Q22_scorer7": "37.5",
        "Q22_scorer6": "37.5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q22_scorer2": "37.5",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "9",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "314daf13-e200-4e55-8816-3a5df32f63b8",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/08/2026 14:52",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4fd1a4238abc4aa4b0be69a24fca6742&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=314daf13-e200-4e55-8816-3a5df32f63b8&isSynthetic=true&or_age=46&or_zip=73036&or_gender=f&or_householdincome=93500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "152.167",
        "session": "gzb15tevgzyjpzqb",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "tfspnd9usqhnbc9p",
        "Q22_9c2": "6",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "4",
        "Q21r7": "1",
        "Q21r6": "2",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/08/2026 14:52",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "80c30781dfcd4aa998c4bda7cb6471bd",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "370",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/de_maxdiff/Q22/v176,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,/Education/edu3,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,Top_to_Bottom,/Gender/gen2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "176",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q12": "1",
        "Q23": "1",
        "Q24": "It means a sustainable, environmentally friendly energy source that helps reduce pollution and combat climate change.",
        "sectionLOIr4": "2.53451666667",
        "sectionLOIr1": "2.53451666667",
        "sectionLOIr3": "2.1324",
        "sectionLOIr2": "0.139733333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q22_scorer8": "25",
        "Q22_scorer7": "37.5",
        "Q22_scorer6": "25",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q22_scorer2": "37.5",
        "Q22_scorer1": "25",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "1",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "6",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "0b160a57-313d-4bf2-af41-4a63e04d99fb",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/08/2026 14:55",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=80c30781dfcd4aa998c4bda7cb6471bd&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0b160a57-313d-4bf2-af41-4a63e04d99fb&isSynthetic=true&or_age=61&or_zip=53589&or_gender=f&or_householdincome=67000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "160.205",
        "session": "gfdnnk7pv9jyyj3d",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "j9kmp0rbt9mv505b",
        "Q22_9c2": "2",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "Q22_5c2": "1",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "1",
        "Q21r5": "4",
        "Q21r4": "5",
        "Q21r7": "2",
        "Q21r6": "3",
        "Q38": "1",
        "Q43": "4",
        "start_date": "01/08/2026 14:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "bfa98febd58b43bf9e29708ee086c738",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "5",
        "record": "371",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),/Education/edu3,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v62,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,/Gender/gen3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "62",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q12": "1",
        "Q23": "1",
        "Q24": "It represents a sustainable and environmentally responsible approach to energy production that minimizes harm to the planet and promotes long-term ecological balance.",
        "sectionLOIr4": "2.6684",
        "sectionLOIr1": "2.6684",
        "sectionLOIr3": "2.27885",
        "sectionLOIr2": "0.187933333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q22_scorer8": "50",
        "Q22_scorer7": "50",
        "Q22_scorer6": "87.5",
        "Q22_scorer5": "100",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q22_scorer2": "12.5",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "9",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "3",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "3",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "048f3342-0f32-4f46-9f60-be45f3bba450",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "5",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/08/2026 14:55",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bfa98febd58b43bf9e29708ee086c738&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=048f3342-0f32-4f46-9f60-be45f3bba450&isSynthetic=true&or_age=51&or_zip=85303&or_gender=f&or_householdincome=30000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "170.057",
        "session": "qde9d7re23178gwu",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "9yn4xpb4966q88hh",
        "Q22_9c2": "5",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "1",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "7",
        "Q21r5": "4",
        "Q21r4": "5",
        "Q21r7": "2",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/08/2026 14:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "931e8c4ad31846d9bfd52f2b9f974543",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "4",
        "record": "372",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,/Education/edu3,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,Top_to_Bottom,/Gender/gen3,/de_maxdiff/Q22/v99",
        "Q33": "2",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "99",
        "Q37": "1",
        "Q35": "5",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "6",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q12": "1",
        "Q23": "1",
        "Q24": "It represents a sustainable, environmentally responsible, and healthier way to meet our energy needs while reducing dependence on fossil fuels and promoting long-term ecological balance.",
        "sectionLOIr4": "2.8329",
        "sectionLOIr1": "2.8329",
        "sectionLOIr3": "2.4544",
        "sectionLOIr2": "0.1821",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "3",
        "Q13": "3",
        "Q22_scorer8": "50",
        "Q22_scorer7": "37.5",
        "Q22_scorer6": "62.5",
        "Q22_scorer5": "0",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q22_scorer2": "50",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "5",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "3",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8c385138-8f10-492f-9976-8ae41784cf5b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/08/2026 14:56",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=931e8c4ad31846d9bfd52f2b9f974543&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8c385138-8f10-492f-9976-8ae41784cf5b&isSynthetic=true&or_age=29&or_zip=32465&or_gender=m&or_householdincome=92000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "155.705",
        "session": "ngsueg625ms7trr7",
        "Q41r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "vlist": "2",
        "uuid": "f14cxj4hn9s75r2r",
        "Q22_9c2": "2",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "Q22_5c2": "7",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "4",
        "Q21r2": "5",
        "Q21r5": "2",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/08/2026 14:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "82faa251dc594def989d543ac39b1e51",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "record": "373",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),/Education/edu3,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,20260107_14:01_v13,/Income/inc5,/de_maxdiff/Q22/v243,/Gender/gen3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "243",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "1",
        "Q22_4c2": "7",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q12": "1",
        "Q23": "3",
        "Q24": "Clean energy refers to renewable and sustainable sources of power that minimize environmental impact and contribute to a healthier planet for future generations.",
        "sectionLOIr4": "2.59373333333",
        "sectionLOIr1": "2.59373333333",
        "sectionLOIr3": "2.22403333333",
        "sectionLOIr2": "0.170116666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q22_scorer8": "12.5",
        "Q22_scorer7": "12.5",
        "Q22_scorer6": "75",
        "Q22_scorer5": "100",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q22_scorer2": "37.5",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "HIDAge2": "2",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q18": "3",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "3",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r2": "0",
        "Q40r3": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b3c10ee9-69bb-48d4-9913-0ed0919b3bf1",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/08/2026 14:55",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=82faa251dc594def989d543ac39b1e51&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b3c10ee9-69bb-48d4-9913-0ed0919b3bf1&isSynthetic=true&or_age=39&or_zip=48235&or_gender=f&or_householdincome=75750",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "299.069",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "3",
        "session": "actp9swdc1wu8rwh",
        "Q41r1": "0",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "25",
        "Q14r2": "15",
        "Q14r5": "15",
        "Q14r4": "10",
        "Q14r7": "2",
        "Q14r6": "10",
        "uuid": "y9x6kfhppnhgffzj",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q22_version": "237",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "3",
        "Q21r2": "5",
        "Q21r5": "4",
        "Q21r4": "1",
        "Q21r7": "6",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/09/2026 07:42",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "5",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "0d3d89ff3ef844a3bf4e13619ca4bc07",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "2",
        "Q15r5": "8",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/de_maxdiff/Q22/v237,/Region/reg3,/Vote/vote4,/Ethnicity/eth2,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "3",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "1",
        "Q9r6": "2",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Energy that doesn't mess up the air and can help my family save some money in the long run",
        "sectionLOIr4": "4.98245",
        "sectionLOIr1": "4.98245",
        "sectionLOIr3": "3.99003333333",
        "sectionLOIr2": "0.44",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "record": "397",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "7",
        "Q9r1": "1",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "6",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2002",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "add654c7-d066-46a8-a2ac-bea5e58c0935",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "2",
        "Q22_3c2": "5",
        "Q8r5": "6",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/09/2026 07:47",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0d3d89ff3ef844a3bf4e13619ca4bc07&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=add654c7-d066-46a8-a2ac-bea5e58c0935&isSynthetic=true&or_age=21&or_zip=79925&or_gender=f&or_householdincome=25000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "AN",
        "GeoIP_Detailsr5": "Andalusia",
        "GeoIP_Detailsr2": "Spain",
        "Q34r2": "1",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "es"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "287.164",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "3",
        "session": "rfjzq8jk7rw5a7ex",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "25",
        "Q14r2": "15",
        "Q14r5": "20",
        "Q14r4": "10",
        "Q14r7": "2",
        "Q14r6": "10",
        "uuid": "83f85srmdhadx5wr",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q22_version": "225",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "2",
        "Q21r5": "3",
        "Q21r4": "1",
        "Q21r7": "6",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/09/2026 07:49",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "5",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "945dbecf5ef14e818d125c2e305fea07",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "Q15r5": "5",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),/Education/edu1,20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v225,/Gender/gen2,/Income/inc1",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "1",
        "Q9r6": "2",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Energy that doesn't mess up the air and helps keep things running without making a big mess",
        "sectionLOIr4": "4.7834",
        "sectionLOIr1": "4.7834",
        "sectionLOIr3": "3.83356666667",
        "sectionLOIr2": "0.41705",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "record": "398",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q9r1": "1",
        "Q15r6": "7",
        "Q15r7": "5",
        "Q9r4": "3",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "5",
        "Q15r8": "6",
        "Q15r9": "6",
        "Q1": "1978",
        "Q3": "47",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d3f98cfd-2c35-47fc-9b4c-4de699c283a0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "6",
        "Q8r4": "1",
        "Q8r6": "2",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "2",
        "date": "01/09/2026 07:54",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=945dbecf5ef14e818d125c2e305fea07&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d3f98cfd-2c35-47fc-9b4c-4de699c283a0&isSynthetic=true&or_age=45&or_zip=23690&or_gender=f&or_householdincome=33000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "AN",
        "GeoIP_Detailsr5": "Andalusia",
        "GeoIP_Detailsr2": "Spain",
        "Q34r2": "1",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "es"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "74.061",
        "Q14r9": "14",
        "Q14r8": "1",
        "session": "8fmua4va5ybhff41",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "19",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "4",
        "Q14r7": "1",
        "Q14r6": "5",
        "uuid": "77g3hxbz0mpjkpvn",
        "Q22_9c2": "2",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "3",
        "Q21r4": "2",
        "Q21r7": "1",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/12/2026 07:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "760de4854e4843cab50572e3602381c8",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "8",
        "record": "437",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/de_maxdiff/Q22/v110,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "110",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "7",
        "Q39r4": "5",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "1",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "75",
        "Q23": "2",
        "Q24": "It means using energy from the sun and wind, which doesn't pollute as much.",
        "sectionLOIr4": "1.2327",
        "sectionLOIr1": "1.2327",
        "sectionLOIr3": "1.02116666667",
        "sectionLOIr2": "0.136183333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "87.5",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "0",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "2",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "0",
        "Q15r4": "10",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1995",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "9",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "79a42ccb-3210-45b7-9a14-6ab461f4ca8c",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "7",
        "Q22_3c2": "2",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "1",
        "Q8r2": "2",
        "date": "01/12/2026 07:31",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=760de4854e4843cab50572e3602381c8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=79a42ccb-3210-45b7-9a14-6ab461f4ca8c&isSynthetic=true&or_age=42&or_zip=48858&or_gender=f&or_householdincome=18000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "AN",
        "GeoIP_Detailsr5": "Andalusia",
        "GeoIP_Detailsr2": "Spain",
        "Q34r2": "0",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "es"
    },
    {
        "HIDAge": "49",
        "vbrowser": "10",
        "qtime": "135.778",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "05ryt9jvgbx6a2rr",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "4",
        "uuid": "jnk7se82k11r8v20",
        "Q22_9c2": "5",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 08:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "50fb591e1e884f9e8bfb793b845f1ebc",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "7",
        "record": "444",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v22,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "22",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "4",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "It's energy that doesn't pollute, but I'm not sure how much it actually costs in the long run.",
        "sectionLOIr4": "2.26125",
        "sectionLOIr1": "2.26125",
        "sectionLOIr3": "1.85876666667",
        "sectionLOIr2": "0.178766666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "5",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "6",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "6",
        "Q15r8": "6",
        "Q15r9": "6",
        "Q1": "1976",
        "Q3": "21",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3ecdd8eb-61c9-402b-8d19-1629df2f98eb",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "6",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/12/2026 08:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=50fb591e1e884f9e8bfb793b845f1ebc&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3ecdd8eb-61c9-402b-8d19-1629df2f98eb&isSynthetic=true&or_age=49&or_zip=20866&or_gender=m&or_householdincome=130127",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "AN",
        "GeoIP_Detailsr5": "Andalusia",
        "GeoIP_Detailsr2": "Spain",
        "Q34r2": "0",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "es"
    },
    {
        "HIDAge": "80",
        "vbrowser": "10",
        "qtime": "116.439",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "tdk7f484gcgm002p",
        "Q41r1": "0",
        "Q14r1": "29",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "znj7b1q2s6xjervj",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/12/2026 08:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "59b5d1dcfe5a4970a7fc3cde8350fd05",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "6",
        "Q22_1c1": "8",
        "record": "445",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,/de_maxdiff/Q22/v281,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Education/edu3,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "281",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "2",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "2",
        "Q24": "It means using energy from the sun, wind, and other natural sources that don't pollute as much as coal or gas.",
        "sectionLOIr4": "1.93888333333",
        "sectionLOIr1": "1.93888333333",
        "sectionLOIr3": "1.6811",
        "sectionLOIr2": "0.175566666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "0",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "7",
        "Q15r3": "5",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1945",
        "Q3": "30",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "4",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "69d0c929-c3e0-4d5e-8e73-867cffb6a596",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 08:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=59b5d1dcfe5a4970a7fc3cde8350fd05&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=69d0c929-c3e0-4d5e-8e73-867cffb6a596&isSynthetic=true&or_age=80&or_zip=03246&or_gender=f&or_householdincome=25000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "AN",
        "GeoIP_Detailsr5": "Andalusia",
        "GeoIP_Detailsr2": "Spain",
        "Q34r2": "0",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "es"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "145.42",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "r9kftuwah667dkpe",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "13",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "3dp3chb7w02uw2bw",
        "Q22_9c2": "9",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "6",
        "Q21r6": "1",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/12/2026 09:52",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "39ace494307a4e398b16a4b8cadbbb53",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "485",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Education/edu2,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Ethnicity/eth1,/de_maxdiff/Q22/v289,/Gender/gen2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "289",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "9",
        "Q22_4c2": "9",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, like solar or wind, but I'm not too sure about the details.",
        "sectionLOIr4": "2.42086666667",
        "sectionLOIr1": "2.42086666667",
        "sectionLOIr3": "2.0827",
        "sectionLOIr2": "0.294716666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "10",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "6",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1979",
        "Q3": "38",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "13",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "dc8fef4f-9554-40b0-948c-1085ce82a743",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 09:55",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=39ace494307a4e398b16a4b8cadbbb53&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=dc8fef4f-9554-40b0-948c-1085ce82a743&isSynthetic=true&or_age=46&or_zip=97479&or_gender=f&or_householdincome=106700",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "52",
        "vbrowser": "10",
        "qtime": "139.828",
        "Q14r9": "9",
        "Q14r8": "2",
        "session": "rh4hw295022fjch4",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "24",
        "Q14r4": "5",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "wphsyrzggv91cmfn",
        "Q22_9c2": "3",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "start_date": "01/12/2026 09:52",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c9ca593935f8450595283250a81611b1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "486",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v124,/Ethnicity/eth4,/Region/reg2,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Vote/vote1,/Gender/gen1,/Income/inc6,/Education/edu4",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "124",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "8",
        "Q22_6c2": "4",
        "Q22_4c2": "6",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "62.5",
        "Q23": "2",
        "Q24": "It means energy that's less harmful to the environment, but I'm not sure how much it's actually changed compared to traditional sources.",
        "sectionLOIr4": "2.32486666667",
        "sectionLOIr1": "2.32486666667",
        "sectionLOIr3": "1.8255",
        "sectionLOIr2": "0.2572",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "4",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1973",
        "Q3": "36",
        "Q2": "1",
        "Q5": "6",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "3",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "057de5fe-323e-44f6-9bb8-1e482061d4a0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 09:55",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c9ca593935f8450595283250a81611b1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=057de5fe-323e-44f6-9bb8-1e482061d4a0&isSynthetic=true&or_age=52&or_zip=44212&or_gender=m&or_householdincome=156000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "141.004",
        "Q14r9": "13",
        "Q14r8": "4",
        "session": "rd9ycba6nx3mf5yf",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "12",
        "Q14r2": "17",
        "Q14r5": "13",
        "Q14r4": "8",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "j160037uuq2ah0zh",
        "Q22_9c2": "4",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "start_date": "01/12/2026 09:52",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "5dc62aa998ce4703a555d44b4bef55d3",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "7",
        "record": "487",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote1,/Ethnicity/eth4,/Region/reg2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v12,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "12",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "4",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "It means stuff that's better for the environment and helps the economy, but I'm not sure how much it actually changes things.",
        "sectionLOIr4": "2.34756666667",
        "sectionLOIr1": "2.34756666667",
        "sectionLOIr3": "1.94571666667",
        "sectionLOIr2": "0.30035",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "5",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1979",
        "Q3": "26",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "97d4ad8b-bed7-49e9-accd-3ffda4026d11",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "2",
        "Q22_3c2": "5",
        "Q8r5": "6",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/12/2026 09:55",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5dc62aa998ce4703a555d44b4bef55d3&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=97d4ad8b-bed7-49e9-accd-3ffda4026d11&isSynthetic=true&or_age=45&or_zip=65201&or_gender=m&or_householdincome=71150",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "148.572",
        "Q14r9": "10",
        "Q14r8": "2",
        "session": "jp3at7am8xu7zjf3",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "19",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "2jnq2tn4rmq2xqav",
        "Q22_9c2": "5",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 09:52",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "748b5330d4044c1ba481547bfebb92fe",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "488",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/de_maxdiff/Q22/v125,/Overall/qual,/Education/edu4,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc6,/Gender/gen2,/Age/age3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "125",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "1",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "8",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "2",
        "Q24": "It means reliable and sustainable power sources that can support both our tech needs and long-term goals without relying too much on old systems.",
        "sectionLOIr4": "2.47423333333",
        "sectionLOIr1": "2.47423333333",
        "sectionLOIr3": "2.13856666667",
        "sectionLOIr2": "0.299016666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "87.5",
        "HIDAge2": "3",
        "Q22_scorer5": "0",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "4",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "10",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1981",
        "Q3": "41",
        "Q2": "2",
        "Q5": "6",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "3",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d13527c4-6f15-4628-9c54-5115bd6aa1e4",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "7",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 09:55",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=748b5330d4044c1ba481547bfebb92fe&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d13527c4-6f15-4628-9c54-5115bd6aa1e4&isSynthetic=true&or_age=44&or_zip=29644&or_gender=f&or_householdincome=150000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "80",
        "vbrowser": "10",
        "qtime": "135.753",
        "Q14r9": "13",
        "Q14r8": "4",
        "session": "qfgc6x9nw8wbduz5",
        "Q41r1": "0",
        "Q14r1": "31",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "13",
        "Q14r5": "9",
        "Q14r4": "4",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ckbpsme7e3xyn4p3",
        "Q22_9c2": "9",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "3",
        "Q21r4": "6",
        "Q21r7": "1",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 09:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "01f10c975c1c43d4a9a78d96af387019",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "2",
        "record": "489",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,/de_maxdiff/Q22/v291,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "291",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "9",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "It means using energy that doesn't pollute as much, like solar or wind, so the air is better and the environment is safer.",
        "sectionLOIr4": "2.2574",
        "sectionLOIr1": "2.2574",
        "sectionLOIr3": "1.87458333333",
        "sectionLOIr2": "0.2669",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1945",
        "Q3": "7",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "63d88d14-c750-4634-af5e-5bb58957d9d6",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 09:58",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=01f10c975c1c43d4a9a78d96af387019&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=63d88d14-c750-4634-af5e-5bb58957d9d6&isSynthetic=true&or_age=80&or_zip=06611&or_gender=m&or_householdincome=38000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "72",
        "vbrowser": "10",
        "qtime": "134.981",
        "Q14r9": "9",
        "Q14r8": "2",
        "session": "txuqtkmfwjeth444",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "5",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "h5w91b8mq9yfby5x",
        "Q22_9c2": "9",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "1",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 09:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d2f68df67bdb4b9fbb676b0d36e54a8b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "490",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v265,/Ethnicity/eth1,/Age/age6,/Education/edu3,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "265",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "It means using energy from the sun, wind, or water that doesn't pollute my air or harm my health.",
        "sectionLOIr4": "2.2472",
        "sectionLOIr1": "2.2472",
        "sectionLOIr3": "1.9113",
        "sectionLOIr2": "0.2555",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "6",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1953",
        "Q3": "5",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "38ca5a85-5bad-4305-bd9e-34ceca3c18e3",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 09:58",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d2f68df67bdb4b9fbb676b0d36e54a8b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=38ca5a85-5bad-4305-bd9e-34ceca3c18e3&isSynthetic=true&or_age=70&or_zip=90039&or_gender=f&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "134.27",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "b6v55nqb4hum7kvv",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "18",
        "Q14r2": "13",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "gbrfv94z7c719pm5",
        "Q22_9c2": "4",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/12/2026 09:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b535ec0faaeb442b97606df114d0738e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "491",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v71,Top_to_Bottom,/Gender/gen2,/Income/inc1",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "71",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "It means something that don't cost me nothin' and don't mess up my stuff.",
        "sectionLOIr4": "2.23555",
        "sectionLOIr1": "2.23555",
        "sectionLOIr3": "1.91198333333",
        "sectionLOIr2": "0.27145",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "12.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "4",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1959",
        "Q3": "19",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "13",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "40630523-b1a3-49c8-b36a-03ffe3aa4f10",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "3",
        "Q22_3c2": "4",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 09:58",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b535ec0faaeb442b97606df114d0738e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=40630523-b1a3-49c8-b36a-03ffe3aa4f10&isSynthetic=true&or_age=64&or_zip=71327&or_gender=f&or_householdincome=26648",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "73",
        "vbrowser": "10",
        "qtime": "140.888",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "bz31gek814278f0t",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "utnfwdufg6n8tfbj",
        "Q22_9c2": "9",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/12/2026 09:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d317e48854084108a15a4a530752d0c5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "492",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote4,/Ethnicity/eth3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v154,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "154",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "5",
        "Q22_7c2": "9",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, like solar or wind, but I'm not sure how much of a difference it really makes.",
        "sectionLOIr4": "2.34583333333",
        "sectionLOIr1": "2.34583333333",
        "sectionLOIr3": "2.02388333333",
        "sectionLOIr2": "0.2213",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "8",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1952",
        "Q3": "14",
        "Q2": "1",
        "Q5": "4",
        "Q4": "2",
        "Q6": "3",
        "Q22_8c2": "4",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "345f9099-8b41-4f27-a873-d9a7f50aa3a7",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 09:58",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d317e48854084108a15a4a530752d0c5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=345f9099-8b41-4f27-a873-d9a7f50aa3a7&isSynthetic=true&or_age=73&or_zip=61032&or_gender=m&or_householdincome=34288",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "38",
        "vbrowser": "10",
        "qtime": "122.361",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "sb9ahm17ewem889y",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "1a1rpm5mbrqqbxek",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "1",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/12/2026 09:58",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "8c546e0ee86242f18fa353be41de4fa0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "493",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/de_maxdiff/Q22/v206,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc6,/Education/edu3,/Gender/gen2,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "206",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "It means using energy that doesn't pollute my home or the neighborhood, like solar or wind, so the air is better for me and my dog.",
        "sectionLOIr4": "2.02695",
        "sectionLOIr1": "2.02695",
        "sectionLOIr3": "1.66765",
        "sectionLOIr2": "0.204616666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "3",
        "Q22_scorer5": "0",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "5",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1987",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c8bb12c4-2a03-4900-a180-a33de615e6a5",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "3",
        "Q8r5": "6",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:00",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8c546e0ee86242f18fa353be41de4fa0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c8bb12c4-2a03-4900-a180-a33de615e6a5&isSynthetic=true&or_age=38&or_zip=79907&or_gender=f&or_householdincome=19760",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "73",
        "vbrowser": "10",
        "qtime": "135.899",
        "Q14r9": "29",
        "Q14r8": "5",
        "session": "0qfkff6y0ezuzf89",
        "Q41r1": "0",
        "Q14r1": "9",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "9",
        "Q14r5": "14",
        "Q14r4": "5",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "pj19dy8nj4gccubn",
        "Q22_9c2": "9",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "2",
        "Q21r4": "5",
        "Q21r7": "3",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/12/2026 09:58",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "98996674865744c095ab85d5df4c7323",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "494",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v224,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Vote/vote4,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "3",
        "Q31": "3",
        "Q22_version": "224",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "5",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "2",
        "Q22_6c1": "2",
        "Q22_6c2": "9",
        "Q22_4c2": "4",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "62.5",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, but I'm not sure how much of a difference it really makes in the big picture.",
        "sectionLOIr4": "2.26138333333",
        "sectionLOIr1": "2.26138333333",
        "sectionLOIr3": "1.8631",
        "sectionLOIr2": "0.20795",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "8",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "6",
        "Q15r7": "6",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1952",
        "Q3": "4",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c10ae6d2-e38c-45b2-9eca-63f6cae677cc",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:01",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=98996674865744c095ab85d5df4c7323&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c10ae6d2-e38c-45b2-9eca-63f6cae677cc&isSynthetic=true&or_age=73&or_zip=72034&or_gender=f&or_householdincome=21300",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "149.639",
        "Q14r9": "5",
        "Q14r8": "0",
        "session": "5uv6m2k9721qvr57",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "26",
        "Q14r2": "21",
        "Q14r5": "11",
        "Q14r4": "11",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "bza243e9rd6v5vp1",
        "Q22_9c2": "7",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 09:58",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "a2bbd2f76d3c4a23ab49c0bc6f09c66c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "2",
        "record": "495",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth4,sawterm:(dvfail.r1),20260109_07:39_v14,/de_maxdiff/Q22/v21,/Overall/qual,/Education/edu4,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,/Age/age3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "21",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "9",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, like solar or wind, but I'm not sure how much difference it really makes in the long run.",
        "sectionLOIr4": "2.49048333333",
        "sectionLOIr1": "2.49048333333",
        "sectionLOIr3": "2.10358333333",
        "sectionLOIr2": "0.212",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "3",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1989",
        "Q3": "39",
        "Q2": "2",
        "Q5": "5",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7379c765-8b56-4cc8-bff0-de75f8ced96c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/12/2026 10:01",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a2bbd2f76d3c4a23ab49c0bc6f09c66c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7379c765-8b56-4cc8-bff0-de75f8ced96c&isSynthetic=true&or_age=34&or_zip=19006&or_gender=f&or_householdincome=65000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "28",
        "vbrowser": "10",
        "qtime": "126.495",
        "Q14r9": "10",
        "Q14r8": "10",
        "session": "dfck49vuxw171cjp",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "10",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "10",
        "Q14r6": "10",
        "uuid": "mmn34dn94ryzuuqr",
        "Q22_9c2": "5",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 09:58",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d079b10aa43c420783dd8266141652b4",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "496",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,/de_maxdiff/Q22/v194,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "194",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "5",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "2",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, like solar or wind, but I'm not sure how much it really helps.",
        "sectionLOIr4": "2.10636666667",
        "sectionLOIr1": "2.10636666667",
        "sectionLOIr3": "1.80626666667",
        "sectionLOIr2": "0.180783333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "0",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1997",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "726ee825-b3a4-450b-ba36-c672e999de8a",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:01",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d079b10aa43c420783dd8266141652b4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=726ee825-b3a4-450b-ba36-c672e999de8a&isSynthetic=true&or_age=28&or_zip=92301&or_gender=m&or_householdincome=57000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "114.109",
        "Q14r9": "14",
        "Q14r8": "2",
        "session": "f66j5bajme5js3s6",
        "Q41r1": "0",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "4",
        "Q14r7": "2",
        "Q14r6": "4",
        "uuid": "bfj9rvkycabmnhx4",
        "Q22_9c2": "9",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "4",
        "Q21r5": "2",
        "Q21r4": "6",
        "Q21r7": "3",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 10:01",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2ec376a8a0264334821624c614856042",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "497",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote4,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/de_maxdiff/Q22/v260,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "260",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "It means using energy that doesn't pollute as much, but I'm not sure how much it really helps or if it's worth the cost.",
        "sectionLOIr4": "1.89975",
        "sectionLOIr1": "1.89975",
        "sectionLOIr3": "1.58913333333",
        "sectionLOIr2": "0.15595",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "5",
        "Q15r2": "7",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1998",
        "Q3": "31",
        "Q2": "1",
        "Q5": "2",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "cb3b89a7-b66a-4b9d-9981-0db04c7ffcd0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:03",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2ec376a8a0264334821624c614856042&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cb3b89a7-b66a-4b9d-9981-0db04c7ffcd0&isSynthetic=true&or_age=27&or_zip=08724&or_gender=m&or_householdincome=57000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "155.23",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "7uzku69vpa8hqtk1",
        "Q41r1": "0",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "rk8uhtgb2d8juwcd",
        "Q22_9c2": "3",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/12/2026 10:01",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "894afea5e63d43f984950a6eb6e89d45",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "6",
        "Q22_1c1": "9",
        "record": "498",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v213,/Education/edu3,/Income/inc2",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "213",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "6",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "It means using energy from the sun, wind, and other natural sources that don't pollute as much.",
        "sectionLOIr4": "2.57953333333",
        "sectionLOIr1": "2.57953333333",
        "sectionLOIr3": "2.27293333333",
        "sectionLOIr2": "0.222883333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "3",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1957",
        "Q3": "16",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "1",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b384b13a-8721-49a0-99a6-c0c59a87769c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "6",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:04",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=894afea5e63d43f984950a6eb6e89d45&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b384b13a-8721-49a0-99a6-c0c59a87769c&isSynthetic=true&or_age=68&or_zip=52761&or_gender=m&or_householdincome=32000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "122.476",
        "Q14r9": "14",
        "Q14r8": "2",
        "session": "bq67xvszh3ptbxu3",
        "Q41r1": "0",
        "Q14r1": "33",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "4",
        "Q14r7": "2",
        "Q14r6": "4",
        "uuid": "n6d104z0rncr9gp7",
        "Q22_9c2": "3",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "3",
        "Q21r5": "4",
        "Q21r4": "1",
        "Q21r7": "2",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 10:01",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "30d0959a0a394a93a6cd427427bfb98b",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "2",
        "Q22_1c1": "5",
        "record": "499",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Education/edu2,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v210,/Gender/gen1,/Income/inc2",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "210",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "7",
        "Q22_6c2": "3",
        "Q22_4c2": "4",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "3",
        "Q24": "It means using energy from the sun, wind, or other natural sources that don't pollute as much.",
        "sectionLOIr4": "2.03688333333",
        "sectionLOIr1": "2.03688333333",
        "sectionLOIr3": "1.71968333333",
        "sectionLOIr2": "0.2248",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1999",
        "Q3": "23",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "1",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "2048362e-52ab-4814-a7e2-3f512a84342c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "6",
        "Q22_3c2": "1",
        "Q8r5": "6",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/12/2026 10:03",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=30d0959a0a394a93a6cd427427bfb98b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=2048362e-52ab-4814-a7e2-3f512a84342c&isSynthetic=true&or_age=20&or_zip=49525&or_gender=m&or_householdincome=28000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "133.189",
        "Q14r9": "18",
        "Q14r8": "4",
        "session": "w01zxrzwggpd6xr4",
        "Q41r1": "0",
        "Q14r1": "13",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "13",
        "Q14r5": "18",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "kxbnjnf0cmkxusu8",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "2",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "1",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/12/2026 10:01",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "bffd7d3fd0fe4fb6adf48c9130242f6f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "500",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu3,/de_maxdiff/Q22/v98",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "98",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "5",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "4",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, but I'm not sure how much of a difference they really make in the big picture.",
        "sectionLOIr4": "2.21733333333",
        "sectionLOIr1": "2.21733333333",
        "sectionLOIr3": "1.89368333333",
        "sectionLOIr2": "0.259833333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "0",
        "Q22_scorer4": "12.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1995",
        "Q3": "5",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c2062f03-ba35-4b8c-9084-23e53ba62005",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "6",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:04",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bffd7d3fd0fe4fb6adf48c9130242f6f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c2062f03-ba35-4b8c-9084-23e53ba62005&isSynthetic=true&or_age=30&or_zip=95006&or_gender=f&or_householdincome=83000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "125.982",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "13z3rpr0pac8she5",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "y1sqrh11jyjq1m8t",
        "Q22_9c2": "9",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "6",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 10:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "1e4e710067e4455bbca1c57b1a31a465",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "6",
        "record": "501",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Region/reg4,/Vote/vote4,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v117,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,/Age/age6,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "117",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "5",
        "Q22_6c1": "2",
        "Q22_6c2": "8",
        "Q22_4c2": "4",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, like solar or wind, but I'm not sure how much of a difference it really makes in the big picture.",
        "sectionLOIr4": "2.09776666667",
        "sectionLOIr1": "2.09776666667",
        "sectionLOIr3": "1.69948333333",
        "sectionLOIr2": "0.2261",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "0",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "5",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1957",
        "Q3": "38",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "685d10b2-aab2-4813-888a-3ada885aa146",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "6",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:05",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1e4e710067e4455bbca1c57b1a31a465&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=685d10b2-aab2-4813-888a-3ada885aa146&isSynthetic=true&or_age=68&or_zip=97232&or_gender=f&or_householdincome=42108",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "133.462",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "wrbdqa59n441n19w",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "28sv71ve3tvt8uy1",
        "Q22_9c2": "5",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "7",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/12/2026 10:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6ad2ff17227d45ffb3605ce1f832d25b",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "8",
        "record": "502",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v148,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "148",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "8",
        "Q22_6c2": "1",
        "Q22_4c2": "2",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "75",
        "Q23": "2",
        "Q24": "It means using energy from the sun, wind, or other natural sources that don’t pollute the air or water.",
        "sectionLOIr4": "2.22066666667",
        "sectionLOIr1": "2.22066666667",
        "sectionLOIr3": "1.86165",
        "sectionLOIr2": "0.171283333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "87.5",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "0",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1999",
        "Q3": "24",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "2",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6469926b-0cf8-4958-99f1-f511074f71bc",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:06",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6ad2ff17227d45ffb3605ce1f832d25b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6469926b-0cf8-4958-99f1-f511074f71bc&isSynthetic=true&or_age=26&or_zip=56082&or_gender=m&or_householdincome=52500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "121.284",
        "Q14r9": "18",
        "Q14r8": "4",
        "session": "07g71j8g9w9xj3uv",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "18",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "jgc6yajdh0d70g69",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "3",
        "Q21r4": "2",
        "Q21r7": "5",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 10:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "188cac5d893c4af395afdc74ea48c03c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "503",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v23,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Vote/vote4,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "23",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "5",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "6",
        "Q22_6c2": "9",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "It means using energy that doesn't pollute as much, like solar or wind, but I don't know much about the details.",
        "sectionLOIr4": "2.01953333333",
        "sectionLOIr1": "2.01953333333",
        "sectionLOIr3": "1.73626666667",
        "sectionLOIr2": "0.216916666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "5",
        "Q22_scorer5": "0",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "1",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1970",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "0ed04fd8-f44b-4efd-a00a-4808d447b602",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:06",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=188cac5d893c4af395afdc74ea48c03c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0ed04fd8-f44b-4efd-a00a-4808d447b602&isSynthetic=true&or_age=55&or_zip=77018&or_gender=m&or_householdincome=34000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "119.182",
        "Q14r9": "14",
        "Q14r8": "4",
        "session": "96hpx7fde7674zf1",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "zxr794q4t332mkjn",
        "Q22_9c2": "4",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "4",
        "Q21r5": "3",
        "Q21r4": "2",
        "Q21r7": "1",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/12/2026 10:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "fe920d6c32ef4353b097dd64b7eb800a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "504",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Income/inc4,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/de_maxdiff/Q22/v119",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "119",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "4",
        "Q22_4c2": "8",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "It means using energy that doesn't pollute, like solar or wind, but I'm not sure how much it really helps in the long run.",
        "sectionLOIr4": "1.98416666667",
        "sectionLOIr1": "1.98416666667",
        "sectionLOIr3": "1.74185",
        "sectionLOIr2": "0.252966666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "12.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1978",
        "Q3": "6",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3cae5247-6cd9-440d-81ae-ed45d145c92a",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/12/2026 10:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=fe920d6c32ef4353b097dd64b7eb800a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3cae5247-6cd9-440d-81ae-ed45d145c92a&isSynthetic=true&or_age=47&or_zip=80013&or_gender=f&or_householdincome=92200",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "28",
        "vbrowser": "10",
        "qtime": "142.669",
        "Q14r9": "13",
        "Q14r8": "4",
        "session": "swu345j8dsc4tub1",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "cg4n7rnsuyq8vtx0",
        "Q22_9c2": "5",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "5",
        "Q21r5": "3",
        "Q21r4": "2",
        "Q21r7": "1",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/13/2026 08:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1011d5a9eafd4cebac0fd8dbc4b0fb8a",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "3",
        "Q22_1c1": "7",
        "record": "529",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,/de_maxdiff/Q22/v246,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "246",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "3",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, but I'm not sure how much of a difference it really makes in the big picture.",
        "sectionLOIr4": "2.37503333333",
        "sectionLOIr1": "2.37503333333",
        "sectionLOIr3": "2.02326666667",
        "sectionLOIr2": "0.303916666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "7",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1997",
        "Q3": "19",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "4",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "797053d6-9263-4cd1-a902-fbf2846d3c05",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/13/2026 08:43",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1011d5a9eafd4cebac0fd8dbc4b0fb8a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=797053d6-9263-4cd1-a902-fbf2846d3c05&isSynthetic=true&or_age=28&or_zip=70739&or_gender=m&or_householdincome=78000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "74",
        "vbrowser": "10",
        "qtime": "163.126",
        "Q14r9": "19",
        "Q14r8": "2",
        "session": "cg2s1e5cjjzr384t",
        "Q41r1": "0",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "15",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "2",
        "Q14r6": "2",
        "uuid": "73zz18mx78aaw5qk",
        "Q22_9c2": "5",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/13/2026 08:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "22f0088d8a4849c3b3e4ac95c64783f7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "7",
        "record": "530",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v202,/Ethnicity/eth1,/Income/inc7,/Age/age6,/Education/edu4",
        "Q33": "1",
        "Q32": "3",
        "Q31": "3",
        "Q22_version": "202",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "5",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "62.5",
        "Q23": "2",
        "Q24": "It means using energy that doesn't pollute the air as much, but I'm not sure how much it really helps long-term.",
        "sectionLOIr4": "2.7164",
        "sectionLOIr1": "2.7164",
        "sectionLOIr3": "2.33041666667",
        "sectionLOIr2": "0.284766666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "12.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "4",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "6",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1951",
        "Q3": "45",
        "Q2": "2",
        "Q5": "5",
        "Q4": "7",
        "Q6": "9",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "114a6c41-258f-4eae-9a1e-7584e3e79e17",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "8",
        "Q22_3c2": "4",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/13/2026 08:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=22f0088d8a4849c3b3e4ac95c64783f7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=114a6c41-258f-4eae-9a1e-7584e3e79e17&isSynthetic=true&or_age=74&or_zip=84025&or_gender=f&or_householdincome=42000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "59",
        "vbrowser": "10",
        "qtime": "148.267",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "6g54yg041gb92t26",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "g4yd0q9hka2tahby",
        "Q22_9c2": "5",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/13/2026 08:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7b1bebb7f2ac4ac1b8cf36552ebc306e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "531",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Income/inc6,/Region/reg4,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v83,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "83",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "5",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, like solar or wind, but I'm not sure how much they really help in the long run.",
        "sectionLOIr4": "2.4676",
        "sectionLOIr1": "2.4676",
        "sectionLOIr3": "2.09631666667",
        "sectionLOIr2": "0.30585",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "5",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "12.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "7",
        "Q22_2c2": "4",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1966",
        "Q3": "5",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "1",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7d31c7c6-fac4-4b4f-8477-d496b57bebf6",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/13/2026 08:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7b1bebb7f2ac4ac1b8cf36552ebc306e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7d31c7c6-fac4-4b4f-8477-d496b57bebf6&isSynthetic=true&or_age=59&or_zip=92841&or_gender=f&or_householdincome=62800",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "34",
        "vbrowser": "10",
        "qtime": "126.388",
        "Q14r9": "14",
        "Q14r8": "2",
        "session": "gc8jn96jx82xc7nz",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "19",
        "Q14r5": "10",
        "Q14r4": "5",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "6pd2u9hgn21vprej",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "5",
        "Q21r5": "4",
        "Q21r4": "2",
        "Q21r7": "3",
        "Q21r6": "1",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/13/2026 08:41",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "57ba59b7f3494a728adfcecb0a4abae4",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "7",
        "record": "532",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v254,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "254",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "1",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It means using energy from the sun, wind, or other sources that don't pollute as much.",
        "sectionLOIr4": "2.09915",
        "sectionLOIr1": "2.09915",
        "sectionLOIr3": "1.76685",
        "sectionLOIr2": "0.281116666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "5",
        "Q15r8": "9",
        "Q15r9": "9",
        "Q1": "1991",
        "Q3": "17",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5c1e0cdb-b386-4de4-850a-0f2ce5fbeeb5",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/13/2026 08:43",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=57ba59b7f3494a728adfcecb0a4abae4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5c1e0cdb-b386-4de4-850a-0f2ce5fbeeb5&isSynthetic=true&or_age=34&or_zip=66020&or_gender=m&or_householdincome=48000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "38",
        "vbrowser": "10",
        "qtime": "123.833",
        "Q14r9": "10",
        "Q14r8": "2",
        "session": "y46e4th64tnwjxv5",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "19",
        "Q14r5": "14",
        "Q14r4": "5",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "p93qcy51hufre70r",
        "Q22_9c2": "5",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "1",
        "start_date": "01/13/2026 08:43",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "95c2ae5872c1406ebfe13e61ce5b941c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "9",
        "record": "533",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v278,/Vote/vote1,/Region/reg2,/Income/inc6,/Ethnicity/eth1,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "278",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "2",
        "Q22_6c1": "1",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "It means using energy sources that don't pollute as much, but I'm not too worried about the specifics.",
        "sectionLOIr4": "2.05983333333",
        "sectionLOIr1": "2.05983333333",
        "sectionLOIr3": "1.6759",
        "sectionLOIr2": "0.173483333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "0",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "4",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1987",
        "Q3": "50",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "4",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3aac30f8-4f60-43b5-bb46-e0205c8e260b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/13/2026 08:45",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=95c2ae5872c1406ebfe13e61ce5b941c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3aac30f8-4f60-43b5-bb46-e0205c8e260b&isSynthetic=true&or_age=38&or_zip=54901&or_gender=f&or_householdincome=152800",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "28",
        "vbrowser": "10",
        "qtime": "127.13",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "cp5mx3pr3zm24272",
        "Q41r1": "0",
        "Q14r1": "32",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "23",
        "Q14r5": "9",
        "Q14r4": "4",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "8aukx3zbhfy02y72",
        "Q22_9c2": "5",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "8",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/13/2026 08:43",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c3a377d33d4c44eaacf79656ad24b4eb",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "6",
        "Q22_1c1": "9",
        "record": "534",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,/de_maxdiff/Q22/v138,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,/Education/edu4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "138",
        "Q35": "3",
        "Q22_7c1": "8",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "4",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "87.5",
        "Q23": "3",
        "Q24": "It means using energy sources that don't pollute as much, like solar or wind, but I don't get too political about it.",
        "sectionLOIr4": "2.11593333333",
        "sectionLOIr1": "2.11593333333",
        "sectionLOIr3": "1.79628333333",
        "sectionLOIr2": "0.236266666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "12.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1997",
        "Q3": "10",
        "Q2": "1",
        "Q5": "5",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "3",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "53e9d4d6-936b-4f98-bddc-b506c4baea99",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "4",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/13/2026 08:46",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c3a377d33d4c44eaacf79656ad24b4eb&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=53e9d4d6-936b-4f98-bddc-b506c4baea99&isSynthetic=true&or_age=28&or_zip=33610&or_gender=m&or_householdincome=103500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "126.865",
        "Q14r9": "1",
        "Q14r8": "1",
        "session": "pqw9kk1zh0nc6rmn",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "25",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "2s4d7ufqwv1gt6z2",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/13/2026 08:44",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b8e776a640584b09b4378cbd60a5df59",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "3",
        "Q22_1c1": "8",
        "record": "535",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v277,/Income/inc7,/Gender/gen2,/Education/edu4",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "277",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "9",
        "Q22_4c2": "3",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "It means reliable and affordable energy that doesn't hurt my budget or my family's daily life.",
        "sectionLOIr4": "2.11168333333",
        "sectionLOIr1": "2.11168333333",
        "sectionLOIr3": "1.78198333333",
        "sectionLOIr2": "0.211566666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "9",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1998",
        "Q3": "23",
        "Q2": "2",
        "Q5": "5",
        "Q4": "7",
        "Q6": "7",
        "Q22_8c2": "5",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "1",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "193b9454-14b1-47e9-a56e-d79d018b9aa9",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "4",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/13/2026 08:46",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b8e776a640584b09b4378cbd60a5df59&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=193b9454-14b1-47e9-a56e-d79d018b9aa9&isSynthetic=true&or_age=26&or_zip=49002&or_gender=f&or_householdincome=240000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "59",
        "vbrowser": "10",
        "qtime": "116.759",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "7ap52g8e67896h6p",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "18",
        "Q14r4": "4",
        "Q14r7": "5",
        "Q14r6": "4",
        "uuid": "mjv9j25drakr9eja",
        "Q22_9c2": "5",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "8",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "1",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/13/2026 08:44",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4953cead5a0543e68eac9059a868d8f7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "8",
        "record": "536",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v53,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,/Education/edu4",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "53",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "4",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "100",
        "Q23": "2",
        "Q24": "It means using energy sources that don't pollute as much, like solar or wind, but I'm not too worried about the politics around it.",
        "sectionLOIr4": "1.94388333333",
        "sectionLOIr1": "1.94388333333",
        "sectionLOIr3": "1.67753333333",
        "sectionLOIr2": "0.215266666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "5",
        "Q22_scorer5": "0",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "10",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1966",
        "Q3": "44",
        "Q2": "1",
        "Q5": "5",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e94d213a-6a6a-43d4-a3ba-0e1539189a34",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/13/2026 08:46",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4953cead5a0543e68eac9059a868d8f7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e94d213a-6a6a-43d4-a3ba-0e1539189a34&isSynthetic=true&or_age=59&or_zip=75204&or_gender=m&or_householdincome=146000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "104.712",
        "Q14r9": "29",
        "Q14r8": "5",
        "session": "q4kdzc1kwpaf14ba",
        "Q41r1": "0",
        "Q14r1": "9",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "10",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "8z8cwwhwa6bwjzpr",
        "Q22_9c2": "1",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/13/2026 08:46",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b7d0f4aefa5d40b09afdbb94765d3b0c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "537",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth5,/Region/reg3,/Vote/vote4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v275,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Age/age3,/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "275",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "It means using energy that doesn't pollute, like solar or wind, but I'm not sure how much it really affects things on the ground.",
        "sectionLOIr4": "1.74245",
        "sectionLOIr1": "1.74245",
        "sectionLOIr3": "1.42988333333",
        "sectionLOIr2": "0.1797",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "3",
        "Q22_scorer5": "0",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "1",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "5",
        "Q15r2": "6",
        "Q15r3": "5",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1981",
        "Q3": "11",
        "Q2": "1",
        "Q5": "2",
        "Q4": "8",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a5f95eb6-cc62-4928-bfa7-cd33bfd5339b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "7",
        "Q22_3c2": "9",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/13/2026 08:48",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b7d0f4aefa5d40b09afdbb94765d3b0c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a5f95eb6-cc62-4928-bfa7-cd33bfd5339b&isSynthetic=true&or_age=43&or_zip=30642&or_gender=m&or_householdincome=70000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "97.459",
        "Q14r9": "14",
        "Q14r8": "2",
        "session": "khqj3b247pcf0hbn",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/143.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "hjcpkdczmt9emcj8",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "7",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "1",
        "Q43": "4",
        "start_date": "01/13/2026 08:46",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "32ad9b7b52f2404fa516a3a37a63f9ab",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "538",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v299,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "299",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "2",
        "Q22_6c1": "2",
        "Q22_6c2": "9",
        "Q22_4c2": "3",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "It means energy that doesn't cost too much and keeps the country running without too many surprises.",
        "sectionLOIr4": "1.62215",
        "sectionLOIr1": "1.62215",
        "sectionLOIr3": "1.39863333333",
        "sectionLOIr2": "0.180816666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "5",
        "Q22_scorer5": "50",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "5",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1964",
        "Q3": "33",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e8d53e70-35e3-4cba-be31-3efbd42c2e61",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "2",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "4",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/13/2026 08:48",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=32ad9b7b52f2404fa516a3a37a63f9ab&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e8d53e70-35e3-4cba-be31-3efbd42c2e61&isSynthetic=true&or_age=59&or_zip=11221&or_gender=m&or_householdincome=95000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "428.054",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "5hzt3kbqec99sv8f",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "tces1ugz1jz3n86q",
        "Q22_9c2": "6",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "3",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/15/2026 13:54",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e5765aa47fd04ef4a867442698dfc29a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "567",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v82,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "82",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "6",
        "Q22_4c2": "3",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "1",
        "Q24": "It means using power from the sun, wind, and water, which doesn't pollute the air or harm the environment.",
        "sectionLOIr4": "7.13266666667",
        "sectionLOIr1": "7.13266666667",
        "sectionLOIr3": "6.4646",
        "sectionLOIr2": "0.239783333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "100",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "1",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "9",
        "Q15r5": "10",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1959",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "100",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/15/2026 14:01",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e5765aa47fd04ef4a867442698dfc29a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "254.68",
        "Q14r9": "5",
        "Q14r8": "3",
        "session": "74313fk3qqsm3py9",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "15",
        "Q14r5": "15",
        "Q14r4": "10",
        "Q14r7": "2",
        "Q14r6": "0",
        "uuid": "uhfmbuzbwa4az4cj",
        "Q22_9c2": "2",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "7",
        "Q21r2": "1",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "1",
        "start_date": "01/15/2026 14:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d5329d05d321414ebfbbbb8f93add894",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "3",
        "record": "568",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote1,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v287,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "287",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "9",
        "Q22_4c2": "6",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "It means using energy sources that don’t pollute the air or water, like solar or wind, so our communities stay healthy.",
        "sectionLOIr4": "4.24261666667",
        "sectionLOIr1": "4.24261666667",
        "sectionLOIr3": "3.59758333333",
        "sectionLOIr2": "0.237983333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "4",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "6",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1959",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "3",
        "Q22_3c2": "6",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/15/2026 14:10",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d5329d05d321414ebfbbbb8f93add894&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "229.679",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "44a699qnaa40kxu7",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "5",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "780vv4uj7eyhzeqs",
        "Q22_9c2": "6",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/15/2026 15:20",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1a4f7aa1775c4a45ae2abb921c58343e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "2",
        "record": "569",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v295,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "295",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "It means using energy from sources like solar and wind that are reliable and help keep things running without relying too much on foreign oil.",
        "sectionLOIr4": "3.82666666667",
        "sectionLOIr1": "3.82666666667",
        "sectionLOIr3": "3.40856666667",
        "sectionLOIr2": "0.188566666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1959",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/15/2026 15:24",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1a4f7aa1775c4a45ae2abb921c58343e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "628.461",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "8gksvtum9umh8qdc",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "tzz38u16z1hff2d5",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/16/2026 11:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "7bb78931d13c43fb94465b5b1eda873e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "9",
        "record": "596",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v245,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "245",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "It means using energy from the sun, wind, and water, which never run out and keep my bills stable.",
        "sectionLOIr4": "10.4729333333",
        "sectionLOIr1": "10.4729333333",
        "sectionLOIr3": "9.3137",
        "sectionLOIr2": "0.620816666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "8",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "8",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1959",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "100",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/16/2026 11:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7bb78931d13c43fb94465b5b1eda873e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "863.836",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "z3fm7epv64qz5nrx",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "3sg5hyhtdwp8058h",
        "Q22_9c2": "1",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "01/16/2026 11:39",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d0887d5441a14d9f8c239e96667f11cc",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "7",
        "record": "599",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote3,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v158,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "158",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "6",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "It means using power from the sun, wind, and water, which are always here and won't run out.",
        "sectionLOIr4": "14.3944333333",
        "sectionLOIr1": "14.3944333333",
        "sectionLOIr3": "12.5128",
        "sectionLOIr2": "0.656766666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "1",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "6",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1959",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "2",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "100",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "7",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/16/2026 11:53",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d0887d5441a14d9f8c239e96667f11cc&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "864.749",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "gekaj4wjpbteyt2z",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "jduv7h50c554gxky",
        "Q22_9c2": "5",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/16/2026 11:39",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ba73e0ffebd8413b9341817bcb9d388a",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "9",
        "Q22_1c1": "7",
        "record": "600",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v7,/Region/reg1,/Education/edu2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "7",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "5",
        "Q22_4c2": "1",
        "Q22_4c1": "8",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "1",
        "Q24": "It means using renewable sources like solar and wind to power our home and community, even if it's not perfect, it's the future.",
        "sectionLOIr4": "14.4096333333",
        "sectionLOIr1": "14.4096333333",
        "sectionLOIr3": "11.9812166667",
        "sectionLOIr2": "0.653433333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "10",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "2000",
        "Q3": "22",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "100",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/16/2026 11:53",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ba73e0ffebd8413b9341817bcb9d388a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c&isSynthetic=true&or_age=25&or_zip=01604&or_gender=m&or_householdincome=69400",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "303.996",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "f61g9shv7gd49xpq",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "euc5hj6mee92cs87",
        "Q22_9c2": "3",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "start_date": "01/16/2026 11:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "626167a1eebd4a219f86f8d6267e26dd",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "1",
        "Q22_1c1": "4",
        "record": "601",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote1,/Region/reg1,/Education/edu2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/de_maxdiff/Q22/v95,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "95",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "4",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "It means energy that's good for the environment and helps keep our family's air clean, which is important for my kid's health.",
        "sectionLOIr4": "5.06383333333",
        "sectionLOIr1": "5.06383333333",
        "sectionLOIr3": "4.55833333333",
        "sectionLOIr2": "0.211183333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "2",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "5",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "2000",
        "Q3": "22",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "100",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "6",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/16/2026 12:01",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=626167a1eebd4a219f86f8d6267e26dd&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c&isSynthetic=true&or_age=25&or_zip=01604&or_gender=m&or_householdincome=69400",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "229.295",
        "Q14r9": "15",
        "Q14r8": "5",
        "session": "8p7390ka5831te3h",
        "Q41r1": "0",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "15",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "40",
        "Q14r6": "0",
        "uuid": "fy8zpp22zcjk8cu9",
        "Q22_9c2": "2",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/16/2026 11:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "3d230085a91546dfb16491f76c022db9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "record": "602",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,/de_maxdiff/Q22/v267,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "267",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "2",
        "Q22_4c2": "1",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "It means energy that doesn't pollute the air and keeps our neighborhoods safer.",
        "sectionLOIr4": "3.8192",
        "sectionLOIr1": "3.8192",
        "sectionLOIr3": "3.33476666667",
        "sectionLOIr2": "0.212916666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1959",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "5",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/16/2026 12:00",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3d230085a91546dfb16491f76c022db9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "272.01",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "3zpns6c0d2xmfpse",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "j0s9gdns5tbv3qzf",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "01/16/2026 12:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ef59929d0b5944ae9fd6fe704eb569af",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "609",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v113,/Ethnicity/eth4,/Vote/vote3,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "113",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "1",
        "Q22_4c2": "2",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "It means reliable and affordable energy that doesn't pollute, but I'm not sure how it's funded or regulated.",
        "sectionLOIr4": "4.53045",
        "sectionLOIr1": "4.53045",
        "sectionLOIr3": "3.9634",
        "sectionLOIr2": "0.20285",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "1",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "6",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1959",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "100",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/16/2026 13:00",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ef59929d0b5944ae9fd6fe704eb569af&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d9fa81a8-2c1a-4d78-8c75-58cf8adcdc4b&isSynthetic=true&or_age=66&or_zip=95003&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "288.467",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "e3kzw66bup5nxg0r",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "100",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "65xb1bguwk2rzt5m",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "8",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "start_date": "01/16/2026 12:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1d65e7c256384752813bbf62cf4acde6",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "9",
        "Q22_1c1": "7",
        "record": "610",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote1,/Region/reg1,/de_maxdiff/Q22/v24,/Education/edu2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "24",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "2",
        "Q22_6c1": "5",
        "Q22_6c2": "1",
        "Q22_4c2": "4",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "62.5",
        "Q23": "1",
        "Q24": "It means using renewable sources like solar and wind to power our home and reduce reliance on fossil fuels, even if it's not always reliable or affordable.",
        "sectionLOIr4": "4.80535",
        "sectionLOIr1": "4.80535",
        "sectionLOIr3": "4.37528333333",
        "sectionLOIr2": "0.204533333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "75",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "8",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "10",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "2000",
        "Q3": "22",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "2",
        "Q22_8c1": "7",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "7",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/16/2026 13:01",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1d65e7c256384752813bbf62cf4acde6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fb419d9-6d3f-4c21-9aee-6a46d4e8d98c&isSynthetic=true&or_age=25&or_zip=01604&or_gender=m&or_householdincome=69400",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "109.11",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "6dr27jj577krtuyp",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "fgaa75825f4a6ysx",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/19/2026 09:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "db332ec26d074fa9b04d0feb234c9a9f",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "4",
        "Q22_1c1": "9",
        "record": "663",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v159,/Gender/gen1,/Ethnicity/eth1,/Income/inc5,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "159",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute and are reliable for my family and the country.",
        "sectionLOIr4": "1.81636666667",
        "sectionLOIr1": "1.81636666667",
        "sectionLOIr3": "1.56296666667",
        "sectionLOIr2": "0.192466666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1999",
        "Q3": "13",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5051995b-5842-474a-866f-9049301ae09b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "2",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/19/2026 09:28",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=db332ec26d074fa9b04d0feb234c9a9f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5051995b-5842-474a-866f-9049301ae09b&isSynthetic=true&or_age=26&or_zip=34135&or_gender=m&or_householdincome=80000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "AN",
        "GeoIP_Detailsr5": "Andalusia",
        "GeoIP_Detailsr2": "Spain",
        "Q34r2": "0",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "es"
    },
    {
        "HIDAge": "52",
        "vbrowser": "10",
        "qtime": "148.605",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "6ajy1gqwu6ts723f",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "t3djb7wbdkfb33xf",
        "Q22_9c2": "2",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/19/2026 10:17",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2047d396da3c479ea09778b392e13b2e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "665",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v234,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "234",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't harm the environment, like solar or wind. It also means finding ways to keep costs stable for my community and business.",
        "sectionLOIr4": "2.47446666667",
        "sectionLOIr1": "2.47446666667",
        "sectionLOIr3": "2.12611666667",
        "sectionLOIr2": "0.287616666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1973",
        "Q3": "5",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "dc2691a1-48ca-49c9-a033-f68e183ddac3",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/19/2026 10:20",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2047d396da3c479ea09778b392e13b2e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=dc2691a1-48ca-49c9-a033-f68e183ddac3&isSynthetic=true&or_age=52&or_zip=92025&or_gender=f&or_householdincome=70800",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "165.678",
        "Q14r9": "18",
        "Q14r8": "5",
        "session": "2ndssbrkwvbhvkcr",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ak1mkw6b8urpm33u",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "6",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/19/2026 10:17",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "3153fdcbc94b4fffbd95adf6c391f249",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "2",
        "record": "666",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v261,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "261",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "4",
        "Q24": "Clean energy means stuff that don't pollute the air, I guess. I heard it on the radio a few times, but I don't know much about it. It sounds good, but I'm not sure how it works in real life.",
        "sectionLOIr4": "2.75911666667",
        "sectionLOIr1": "2.75911666667",
        "sectionLOIr3": "2.36986666667",
        "sectionLOIr2": "0.320133333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "4",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1969",
        "Q3": "44",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3bd8b740-806d-4a57-aa18-a9c66c8767a2",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "5",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "01/19/2026 10:20",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3153fdcbc94b4fffbd95adf6c391f249&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3bd8b740-806d-4a57-aa18-a9c66c8767a2&isSynthetic=true&or_age=55&or_zip=77372&or_gender=m&or_householdincome=31000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "38",
        "vbrowser": "10",
        "qtime": "144.598",
        "Q14r9": "4",
        "Q14r8": "13",
        "session": "xgmun8xsnm4nh3sf",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ccdk973ekshgw7ne",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/19/2026 10:17",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "117ab105b1114bafb9cd6922174e8c1d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "6",
        "record": "667",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,/de_maxdiff/Q22/v273,/Education/edu1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6,sawterm:(dvfail.r1),/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "273",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "5",
        "Q39r1": "2",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the air or water and are sustainable for the long term.",
        "sectionLOIr4": "2.40486666667",
        "sectionLOIr1": "2.40486666667",
        "sectionLOIr3": "1.94963333333",
        "sectionLOIr2": "0.266483333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "6",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1987",
        "Q3": "31",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "1",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1f2257f8-b5b4-45d4-afce-5797d2bfa93c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/19/2026 10:20",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=117ab105b1114bafb9cd6922174e8c1d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1f2257f8-b5b4-45d4-afce-5797d2bfa93c&isSynthetic=true&or_age=38&or_zip=08558&or_gender=m&or_householdincome=170747",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "173.299",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "sm6c50f05y7grz3v",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "t8h51yae7bxmmrvn",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/19/2026 10:17",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "c47eaddfb0954a289e756e62b21d094c",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "4",
        "record": "668",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,/de_maxdiff/Q22/v8,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Education/edu3,/Gender/gen3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "3",
        "Q22_version": "8",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "clean energy means stuff that doesn't pollute and keeps my kid safe. it's about having power that's healthy for the dogs and the air we breathe. i think it's good for the future but not sure how fast it'll get there.",
        "sectionLOIr4": "2.88298333333",
        "sectionLOIr1": "2.88298333333",
        "sectionLOIr3": "2.55376666667",
        "sectionLOIr2": "0.329683333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1999",
        "Q3": "28",
        "Q2": "4",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3efbe47c-e22d-4dfb-b40a-b19907264e36",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/19/2026 10:20",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c47eaddfb0954a289e756e62b21d094c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3efbe47c-e22d-4dfb-b40a-b19907264e36&isSynthetic=true&or_age=24&or_zip=68128&or_gender=m&or_householdincome=69489",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "84",
        "vbrowser": "10",
        "qtime": "142.907",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "uk96huphn8ygehvu",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "yetzvgxbzq63uem2",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/19/2026 10:21",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "691ccd37c64043158e1743da5e084d79",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "5",
        "record": "669",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth5,/Region/reg1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v242,/Gender/gen1,/Income/inc4,Top_to_Bottom,/Education/edu4",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "242",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the air or water, like solar or wind, so the environment stays healthy for things I care about, such as my dog and the local community.",
        "sectionLOIr4": "2.37978333333",
        "sectionLOIr1": "2.37978333333",
        "sectionLOIr3": "2.01653333333",
        "sectionLOIr2": "0.21625",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1941",
        "Q3": "30",
        "Q2": "1",
        "Q5": "5",
        "Q4": "1",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "545ebf87-c73b-4e57-9a2a-0aec0d8661a5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/19/2026 10:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=691ccd37c64043158e1743da5e084d79&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=545ebf87-c73b-4e57-9a2a-0aec0d8661a5&isSynthetic=true&or_age=84&or_zip=60647&or_gender=m&or_householdincome=32000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "143.382",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "7za4upmhpez4fv3p",
        "Q41r1": "1",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "7uxspzd27xt8z747",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/19/2026 10:21",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6c5eaee359744c2fb87d5cd2dc1c8032",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "670",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/de_maxdiff/Q22/v61,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "61",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy refers to sources of power that are sustainable, environmentally responsible, and provide reliable energy solutions without harmful emissions.",
        "sectionLOIr4": "2.38376666667",
        "sectionLOIr1": "2.38376666667",
        "sectionLOIr3": "1.98781666667",
        "sectionLOIr2": "0.202566666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "6",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "9",
        "Q15r9": "7",
        "Q1": "1980",
        "Q3": "34",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "2f40f72f-9e59-4c90-81b3-86f9f39525f0",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "6",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/19/2026 10:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6c5eaee359744c2fb87d5cd2dc1c8032&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=2f40f72f-9e59-4c90-81b3-86f9f39525f0&isSynthetic=true&or_age=45&or_zip=27262&or_gender=m&or_householdincome=174000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "156.94",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "kycqudvuzvj06bn4",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "2k2h2qjb2d29b78y",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/19/2026 10:21",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "c8e3d5a09e974142b4e869a3c392be49",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "671",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Education/edu3,/de_maxdiff/Q22/v66,/Gender/gen3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "66",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means a mix of renewable and traditional sources that provide reliable power while supporting local jobs and economic stability.",
        "sectionLOIr4": "2.60731666667",
        "sectionLOIr1": "2.60731666667",
        "sectionLOIr3": "2.23595",
        "sectionLOIr2": "0.260983333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "5",
        "Q15r6": "7",
        "Q15r7": "5",
        "Q15r1": "7",
        "Q15r2": "7",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1979",
        "Q3": "14",
        "Q2": "3",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "0e0c0e05-6d6d-4d11-8217-37dfd38a7c6e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "6",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/19/2026 10:24",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c8e3d5a09e974142b4e869a3c392be49&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0e0c0e05-6d6d-4d11-8217-37dfd38a7c6e&isSynthetic=true&or_age=44&or_zip=61525&or_gender=f&or_householdincome=107000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "84",
        "vbrowser": "10",
        "qtime": "137.225",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "kgpvwff7c9bkupg1",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "zw9qc82ka0pgf7fc",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "7",
        "Q21r7": "6",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/19/2026 10:21",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "6a1f7b6f4c594e1b9bb439fa51f08c53",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "672",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),/de_maxdiff/Q22/v39,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Region/reg3,sawterm:Q1.ival gt 2007,/Age/age6,/Vote/vote2,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "39",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power that doesn't pollute the air or water. It's something I've heard about but I'm not sure how it works exactly.",
        "sectionLOIr4": "2.28218333333",
        "sectionLOIr1": "2.28218333333",
        "sectionLOIr3": "1.98878333333",
        "sectionLOIr2": "0.235533333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1941",
        "Q3": "34",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c3b229eb-4b18-4328-af3e-55f5b9ec7175",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/19/2026 10:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6a1f7b6f4c594e1b9bb439fa51f08c53&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c3b229eb-4b18-4328-af3e-55f5b9ec7175&isSynthetic=true&or_age=84&or_zip=28602&or_gender=f&or_householdincome=29000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "126.763",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "67nybjav3chr2aj1",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ta6t9s69wkv0why4",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/19/2026 10:24",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "4046e605cb0a4f8fb924f4cf4e9cae73",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "673",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v17,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "17",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don’t pollute the air or water, like solar panels or wind turbines. It also means having reliable electricity without worrying about rising costs or blackouts.",
        "sectionLOIr4": "2.10921666667",
        "sectionLOIr1": "2.10921666667",
        "sectionLOIr3": "1.75071666667",
        "sectionLOIr2": "0.237033333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1986",
        "Q3": "28",
        "Q2": "2",
        "Q5": "2",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "5",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "97242070-ae5e-480c-830a-54c2a01d0474",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "6",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/19/2026 10:26",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4046e605cb0a4f8fb924f4cf4e9cae73&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=97242070-ae5e-480c-830a-54c2a01d0474&isSynthetic=true&or_age=39&or_zip=68818&or_gender=f&or_householdincome=34200",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "49",
        "vbrowser": "10",
        "qtime": "130.418",
        "Q14r9": "13",
        "Q14r8": "4",
        "session": "93dsq2ap1tc7nzy2",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "9",
        "Q14r5": "18",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "utkz0jd8umwr759f",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/19/2026 10:24",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "cd0db69ff46e446caff66d920543ac59",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "674",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,/de_maxdiff/Q22/v41,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "41",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don’t pollute the air or water. I think it’s important for the environment, but I also care about reliability and cost.",
        "sectionLOIr4": "2.1715",
        "sectionLOIr1": "2.1715",
        "sectionLOIr3": "1.89408333333",
        "sectionLOIr2": "0.2188",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "2",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "7",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1976",
        "Q3": "45",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "37f16062-29e0-40b4-b757-3fd95ff4cc8b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "5",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/19/2026 10:26",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=cd0db69ff46e446caff66d920543ac59&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=37f16062-29e0-40b4-b757-3fd95ff4cc8b&isSynthetic=true&or_age=48&or_zip=84770&or_gender=f&or_householdincome=134600",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "141.367",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "mdemm9zc0qkqpynu",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "j4gxjjawb3ca549d",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 02:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "c3a2a62865cd45ecac0cdc078f0bd285",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "694",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Education/edu2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,/de_maxdiff/Q22/v160,/Gender/gen2,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "160",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "3",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the air or water, like solar or wind, but I'm not sure how much it's actually making a difference yet.",
        "sectionLOIr4": "2.35411666667",
        "sectionLOIr1": "2.35411666667",
        "sectionLOIr3": "2.02948333333",
        "sectionLOIr2": "0.283466666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1972",
        "Q3": "32",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "6286f1b3-4fc0-4d75-97e5-1b3333f10d85",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "5",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 02:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c3a2a62865cd45ecac0cdc078f0bd285&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6286f1b3-4fc0-4d75-97e5-1b3333f10d85&isSynthetic=true&or_age=53&or_zip=88045&or_gender=f&or_householdincome=47700",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "152.048",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "kyvdhpgupyb6fxqp",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "18",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "96j24aq4xeqgmn3n",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/20/2026 02:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "14eecc7a38464c548c3076d597a2fc2b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "695",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v203,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "203",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the air or water, like solar or wind, but I also think it's important to have reliable options that work well in our area.",
        "sectionLOIr4": "2.53166666667",
        "sectionLOIr1": "2.53166666667",
        "sectionLOIr3": "2.15901666667",
        "sectionLOIr2": "0.31965",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1978",
        "Q3": "37",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "19a71804-823d-4cb8-81b0-a788a0324c13",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 02:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=14eecc7a38464c548c3076d597a2fc2b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=19a71804-823d-4cb8-81b0-a788a0324c13&isSynthetic=true&or_age=47&or_zip=74445&or_gender=m&or_householdincome=130300",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "82",
        "vbrowser": "10",
        "qtime": "148.595",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "hpbcafshp4mxt6ep",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "dph7u4w0j4cyp4nh",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "6",
        "Q21r2": "1",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 02:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "91db0cfc420a4323a31eab7fe2ea20bf",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "696",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v49,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "49",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "4",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power that doesn't pollute the air or water, like solar or wind. It's about keeping the environment healthy for my kids and grandkids. I think it's important but not sure how much it'll change things for now.",
        "sectionLOIr4": "2.47278333333",
        "sectionLOIr1": "2.47278333333",
        "sectionLOIr3": "2.12596666667",
        "sectionLOIr2": "0.276616666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1943",
        "Q3": "43",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "d7427445-9e69-4615-9f98-51578c476fc8",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 02:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=91db0cfc420a4323a31eab7fe2ea20bf&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d7427445-9e69-4615-9f98-51578c476fc8&isSynthetic=true&or_age=82&or_zip=38104&or_gender=m&or_householdincome=30000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "150.905",
        "Q14r9": "4",
        "Q14r8": "13",
        "session": "tme4s3qh74u9khcc",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "t5cebd8mcqub383e",
        "Q22_9c2": "7",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "6",
        "Q21r5": "2",
        "Q21r4": "3",
        "Q21r7": "1",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7ef2b596c5ce4b509e792054bd90c3ee",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "697",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/de_maxdiff/Q22/v59,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "59",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "7",
        "Q22_4c2": "3",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the air or water. It also means keeping costs low so I can afford to pay my bills without stress.",
        "sectionLOIr4": "2.51305",
        "sectionLOIr1": "2.51305",
        "sectionLOIr3": "2.2",
        "sectionLOIr2": "0.302216666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "1",
        "Q12": "3",
        "Q22_scorer7": "0",
        "HIDAge2": "4",
        "Q22_scorer5": "100",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "4",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "4",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "5",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1972",
        "Q3": "29",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e327ecc2-7d6c-413c-90dd-6c0a01536a97",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 02:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7ef2b596c5ce4b509e792054bd90c3ee&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e327ecc2-7d6c-413c-90dd-6c0a01536a97&isSynthetic=true&or_age=52&or_zip=89128&or_gender=f&or_householdincome=15500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "31",
        "vbrowser": "10",
        "qtime": "150.358",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "as9ju1w9t4bzr4p3",
        "Q41r1": "1",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "gu3bcjrjuymh7s3n",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d4e170ca6dd44f7681e880ef4516f719",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "698",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Education/edu2,/Ethnicity/eth1,/de_maxdiff/Q22/v131,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "131",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy is just another way to say electricity that doesn't smell like gas or make the air feel yucky.",
        "sectionLOIr4": "2.50346666667",
        "sectionLOIr1": "2.50346666667",
        "sectionLOIr3": "2.0909",
        "sectionLOIr2": "0.280133333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1994",
        "Q3": "22",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "fdefc444-06f4-4ef7-88af-97fa2001f176",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d4e170ca6dd44f7681e880ef4516f719&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=fdefc444-06f4-4ef7-88af-97fa2001f176&isSynthetic=true&or_age=31&or_zip=01746&or_gender=f&or_householdincome=48000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "24",
        "vbrowser": "10",
        "qtime": "135.172",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "67ncxkd4573jq1d7",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "zgmhx9qfjcm88133",
        "Q22_9c2": "5",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "1",
        "Q21r4": "6",
        "Q21r7": "5",
        "Q21r6": "2",
        "Q38": "3",
        "Q43": "3",
        "start_date": "01/20/2026 02:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "871b943d88384e56bfc91244b89d4a3d",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "699",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg3,Bottom_to_Top,/Ethnicity/eth2,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc1,/de_maxdiff/Q22/v142,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "142",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don’t pollute the air or water, like solar panels or wind turbines. It also means being able to afford reliable electricity without worrying about rising costs or blackouts.",
        "sectionLOIr4": "2.25076666667",
        "sectionLOIr1": "2.25076666667",
        "sectionLOIr3": "1.94326666667",
        "sectionLOIr2": "0.2509",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "1",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2001",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "0bc48668-0e0d-45d7-9350-344e21212978",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "6",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 02:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=871b943d88384e56bfc91244b89d4a3d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0bc48668-0e0d-45d7-9350-344e21212978&isSynthetic=true&or_age=22&or_zip=79119&or_gender=m&or_householdincome=18000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "24",
        "vbrowser": "10",
        "qtime": "180.819",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "jjgbb4brm2c23buj",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "18",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "pwgyzuu3ted6eyr1",
        "Q22_9c2": "5",
        "Q22_9c1": "2",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 02:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b1312af6c04646699ee2524065d4a76b",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "700",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,sawterm:(dvfail.r1),/Education/edu3,/Income/inc3,/de_maxdiff/Q22/v165",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "165",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "1",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Clean energy means using power sources that don't pollute the environment, like solar or wind. It also makes me think about how we can keep things running without harming the planet too much.",
        "sectionLOIr4": "3.0114",
        "sectionLOIr1": "3.0114",
        "sectionLOIr3": "2.57166666667",
        "sectionLOIr2": "0.220766666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "25",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "7",
        "Q15r2": "7",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "2001",
        "Q3": "1",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9da419f6-1b01-4ccf-900a-3f7b27bd7417",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "6",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 02:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b1312af6c04646699ee2524065d4a76b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9da419f6-1b01-4ccf-900a-3f7b27bd7417&isSynthetic=true&or_age=24&or_zip=35601&or_gender=m&or_householdincome=39000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "147.524",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "a8nj5y6xqm4tpv04",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ht19qph2e90sftrh",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1159c4738e9c478da0cd94b5973c1857",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "701",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Income/inc5,/de_maxdiff/Q22/v153,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "153",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy refers to sources of power that do not produce harmful emissions or pollutants. It means relying on renewable options like solar or wind to meet our energy needs sustainably.",
        "sectionLOIr4": "2.45623333333",
        "sectionLOIr1": "2.45623333333",
        "sectionLOIr3": "2.05188333333",
        "sectionLOIr2": "0.245333333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1999",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "2",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "936f5775-02e4-4a2a-badc-1df9eb2848e2",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "1",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "6",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "6",
        "date": "01/20/2026 02:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1159c4738e9c478da0cd94b5973c1857&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=936f5775-02e4-4a2a-badc-1df9eb2848e2&isSynthetic=true&or_age=26&or_zip=92313&or_gender=m&or_householdincome=85000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "129.726",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "zk64amvrh1mkjv1f",
        "Q41r1": "1",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "2ydgehuyfc32uyr0",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/20/2026 02:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "76d6a3aa03b048a7a485a0994c71ef7b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "702",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth3,Bottom_to_Top,sawterm:(dvfail.r1),/de_maxdiff/Q22/v130,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Education/edu2,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "130",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the air or water, like solar or wind. It also means supporting a future where communities stay healthy and the environment is protected.",
        "sectionLOIr4": "2.1593",
        "sectionLOIr1": "2.1593",
        "sectionLOIr3": "1.7272",
        "sectionLOIr2": "0.24595",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1996",
        "Q3": "21",
        "Q2": "1",
        "Q5": "3",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "794eeabf-78a7-409a-b97f-04e7c0d410fd",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 02:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=76d6a3aa03b048a7a485a0994c71ef7b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=794eeabf-78a7-409a-b97f-04e7c0d410fd&isSynthetic=true&or_age=29&or_zip=21244&or_gender=m&or_householdincome=108000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "54",
        "vbrowser": "10",
        "qtime": "117.899",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "me4uk5c8jfqpv4wt",
        "Q41r1": "0",
        "Q14r1": "9",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "24",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "10",
        "uuid": "q34v5a1kchgvgfyz",
        "Q22_9c2": "9",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "7",
        "Q21r7": "6",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 02:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "8e4345ed7d6b4f22ade00c7b7fdded30",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "7",
        "record": "703",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/de_maxdiff/Q22/v222,/Ethnicity/eth3,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "222",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means something that's good for the country and doesn't cost too much more than what we're used to.",
        "sectionLOIr4": "1.9629",
        "sectionLOIr1": "1.9629",
        "sectionLOIr3": "1.67896666667",
        "sectionLOIr2": "0.217683333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "100",
        "HIDAge2": "4",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1971",
        "Q3": "36",
        "Q2": "2",
        "Q5": "2",
        "Q4": "2",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "58cdd4d8-26ad-405e-9c1a-bf5a26824526",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 02:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8e4345ed7d6b4f22ade00c7b7fdded30&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=58cdd4d8-26ad-405e-9c1a-bf5a26824526&isSynthetic=true&or_age=54&or_zip=44133&or_gender=f&or_householdincome=34000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "132.042",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "j5emf74gm0zb4mxf",
        "Q41r1": "1",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "nps1f2xzn2pqspn9",
        "Q22_9c2": "5",
        "Q22_9c1": "7",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "f3ca71b0684e4ae1877e03f5b7d9ea2e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "704",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v109,/Income/inc7,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "109",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "3",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Clean energy means reliable and affordable power solutions that benefit both the environment and local communities. It also represents a mix of proven technologies and emerging trends that can support long-term sustainability without compromising everyday needs.",
        "sectionLOIr4": "2.19941666667",
        "sectionLOIr1": "2.19941666667",
        "sectionLOIr3": "1.834",
        "sectionLOIr2": "0.264683333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "4",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1979",
        "Q3": "5",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "7",
        "Q22_8c2": "2",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "8a7faab6-4d04-43de-bdab-41b1c14079c3",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "7",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:37",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f3ca71b0684e4ae1877e03f5b7d9ea2e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8a7faab6-4d04-43de-bdab-41b1c14079c3&isSynthetic=true&or_age=45&or_zip=95023&or_gender=f&or_householdincome=210000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "28",
        "vbrowser": "10",
        "qtime": "130.59",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "n05s6sgbzbfpy16t",
        "Q41r1": "1",
        "Q14r1": "32",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "jgj4j7xaze868e4z",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "7",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "f204763f72c64729a938a7d2469c156e",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "705",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Education/edu2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v264,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "264",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "2",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the environment, like solar or wind. It also feels like a way to support reliable and sustainable options that make sense for everyday life.",
        "sectionLOIr4": "2.17515",
        "sectionLOIr1": "2.17515",
        "sectionLOIr3": "1.75515",
        "sectionLOIr2": "0.235516666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1997",
        "Q3": "39",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d96d64ad-29a3-4622-9ddb-c1d16495b95e",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 02:37",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f204763f72c64729a938a7d2469c156e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d96d64ad-29a3-4622-9ddb-c1d16495b95e&isSynthetic=true&or_age=28&or_zip=19464&or_gender=m&or_householdincome=32000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "40",
        "vbrowser": "10",
        "qtime": "122.803",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "txvtq6w6m4ebcbdb",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "44jyt6vw7vma8vgb",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 02:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "75839b22ef8e47ddba7b5687ab6d4de7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "706",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/de_maxdiff/Q22/v32,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Education/edu4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "32",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable and proven sources of power that ensure stability for my household and community. It also includes efforts to reduce pollution and support local initiatives that align with my values of responsibility and long-term planning.",
        "sectionLOIr4": "2.04536666667",
        "sectionLOIr1": "2.04536666667",
        "sectionLOIr3": "1.73",
        "sectionLOIr2": "0.261483333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "75",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1985",
        "Q3": "16",
        "Q2": "2",
        "Q5": "6",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "4a086143-25b4-4853-b5a4-4456c221f0b8",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "5",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 02:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=75839b22ef8e47ddba7b5687ab6d4de7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4a086143-25b4-4853-b5a4-4456c221f0b8&isSynthetic=true&or_age=40&or_zip=51301&or_gender=f&or_householdincome=128920",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "34",
        "vbrowser": "10",
        "qtime": "125.973",
        "Q14r9": "13",
        "Q14r8": "4",
        "session": "h3chshrdyggsgjbr",
        "Q41r1": "1",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "13",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "jev8tt2899be3qbq",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:35",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "44563122af82434689ae5ad4c1dbe8d1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "707",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,sawterm:(dvfail.r1),/de_maxdiff/Q22/v29",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "29",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable power that doesn't mess up the environment, but I also know it's not always the cheapest option.",
        "sectionLOIr4": "2.09816666667",
        "sectionLOIr1": "2.09816666667",
        "sectionLOIr3": "1.81291666667",
        "sectionLOIr2": "0.209366666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "4",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1991",
        "Q3": "5",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "cf191a8f-daff-4601-a4da-174560f76ced",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:37",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=44563122af82434689ae5ad4c1dbe8d1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cf191a8f-daff-4601-a4da-174560f76ced&isSynthetic=true&or_age=34&or_zip=92009&or_gender=m&or_householdincome=103000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "67",
        "vbrowser": "10",
        "qtime": "153.582",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "qjy2cmxapkrvu5ap",
        "Q41r1": "0",
        "Q14r1": "18",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "np0gxp35krv7crj6",
        "Q22_9c2": "1",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "4",
        "Q21r7": "1",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "21ab2ca0d5de44e18b350e1b63adfa4a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "708",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,/de_maxdiff/Q22/v170,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Income/inc1,/Education/edu4",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "170",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "5",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don’t pollute the air or water, but I’m careful about how new technologies fit into my routine.",
        "sectionLOIr4": "2.55828333333",
        "sectionLOIr1": "2.55828333333",
        "sectionLOIr3": "2.16211666667",
        "sectionLOIr2": "0.239883333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "7",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1958",
        "Q3": "5",
        "Q2": "1",
        "Q5": "5",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "eac0e178-9516-4a6d-b526-d9a619799a6e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "5",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=21ab2ca0d5de44e18b350e1b63adfa4a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=eac0e178-9516-4a6d-b526-d9a619799a6e&isSynthetic=true&or_age=65&or_zip=95838&or_gender=m&or_householdincome=22000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "40",
        "vbrowser": "10",
        "qtime": "140.506",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "du3p09ex3n12pej6",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "4k3a9hph29magcbb",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "7",
        "Q21r7": "6",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 02:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "edbedbcd6ddf4b0ea748271de47af368",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "6",
        "record": "709",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,/de_maxdiff/Q22/v68,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "68",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means stuff that don't pollute and works reliable, like solar or wind, but I'm still cautious 'cause I don't know how much it really costs or if it's dependable enough.",
        "sectionLOIr4": "2.3404",
        "sectionLOIr1": "2.3404",
        "sectionLOIr3": "1.93336666667",
        "sectionLOIr2": "0.23335",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "5",
        "Q15r9": "4",
        "Q1": "1985",
        "Q3": "30",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "6fb9f9bc-3f1b-4062-97f3-c0b566be1d8f",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=edbedbcd6ddf4b0ea748271de47af368&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6fb9f9bc-3f1b-4062-97f3-c0b566be1d8f&isSynthetic=true&or_age=40&or_zip=03842&or_gender=m&or_householdincome=34000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "139.872",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "tn6vy8pnyrp5ee2u",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "10",
        "Q14r4": "14",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "4ubx3512nv4nn9w3",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "7",
        "Q21r7": "6",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "50f368539c8e4981a1477542b85acdc5",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "710",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v221,/Region/reg3,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "221",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means stuff that doesn't pollute and helps the planet, but I also think it's about keeping costs down so I can afford to pay my bills without stressing too much.",
        "sectionLOIr4": "2.32986666667",
        "sectionLOIr1": "2.32986666667",
        "sectionLOIr3": "1.85776666667",
        "sectionLOIr2": "0.228466666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1998",
        "Q3": "47",
        "Q2": "2",
        "Q5": "2",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f3fb8716-f1d9-40cb-9d11-6ff2fc8d312a",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=50f368539c8e4981a1477542b85acdc5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f3fb8716-f1d9-40cb-9d11-6ff2fc8d312a&isSynthetic=true&or_age=27&or_zip=23832&or_gender=f&or_householdincome=34000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "127.097",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "41ktguhv5bccfncz",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "y0s1fxxus18ruxhs",
        "Q22_9c2": "3",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "3",
        "start_date": "01/20/2026 02:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "f29b53ed898f4d51a7caae21028b75c7",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "2",
        "Q22_1c1": "8",
        "record": "711",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote3,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/de_maxdiff/Q22/v195,/Rotate Selection/Bottom_to_Top,qual,/Education/edu2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "195",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the air or water, like solar or wind, but I also think it's about making sure there's enough of it for the future without relying too much on anything that's not proven yet.",
        "sectionLOIr4": "2.11603333333",
        "sectionLOIr1": "2.11603333333",
        "sectionLOIr3": "1.81945",
        "sectionLOIr2": "0.187383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1999",
        "Q3": "47",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "81250add-3360-41a1-8360-ea3eb08ae7b8",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f29b53ed898f4d51a7caae21028b75c7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=81250add-3360-41a1-8360-ea3eb08ae7b8&isSynthetic=true&or_age=20&or_zip=22802&or_gender=m&or_householdincome=20280",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "117.534",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "vnvkr35xk3ha9e98",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "10",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "kexaywunhv5ycc84",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 02:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b99f8a36c6b0497ebc67264fd5a2bade",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "712",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Income/inc5,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/de_maxdiff/Q22/v214,/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "214",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "9",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute as much, but I'm not sure how much of a difference they really make in the long run.",
        "sectionLOIr4": "1.9575",
        "sectionLOIr1": "1.9575",
        "sectionLOIr3": "1.65705",
        "sectionLOIr2": "0.189983333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1983",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "10",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "84aa4687-420f-4bf5-8417-02cd78eac8f5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:42",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b99f8a36c6b0497ebc67264fd5a2bade&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=84aa4687-420f-4bf5-8417-02cd78eac8f5&isSynthetic=true&or_age=42&or_zip=33067&or_gender=m&or_householdincome=103560",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "119.549",
        "Q14r9": "13",
        "Q14r8": "4",
        "session": "hmnqupdqhtngjgen",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "rmqjyax03671d60r",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "7",
        "Q21r7": "5",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 02:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2406de5c4b0a40fe85f2f1ebc4522507",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "6",
        "record": "713",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc6,/Gender/gen2,/de_maxdiff/Q22/v258,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "258",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "1",
        "Q39r3": "3",
        "Q39r1": "1",
        "Q22_6c1": "5",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute the environment, like solar or wind, but I'm not sure if they're reliable enough yet. Maybe they'll become more dependable as technology improves, but I'd prefer something I know works consistently.",
        "sectionLOIr4": "1.99113333333",
        "sectionLOIr1": "1.99113333333",
        "sectionLOIr3": "1.55556666667",
        "sectionLOIr2": "0.22725",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "6",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "8",
        "Q15r5": "5",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "6",
        "Q15r8": "8",
        "Q15r9": "5",
        "Q1": "1986",
        "Q3": "43",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "6",
        "Q22_8c2": "2",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a70875a4-cae8-4b04-a49d-9b44066b3f99",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "5",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 02:42",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2406de5c4b0a40fe85f2f1ebc4522507&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a70875a4-cae8-4b04-a49d-9b44066b3f99&isSynthetic=true&or_age=39&or_zip=37160&or_gender=f&or_householdincome=165000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "82",
        "vbrowser": "10",
        "qtime": "142.418",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "r88pcnhd354kzau5",
        "Q41r1": "1",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "8hmrczqyk3dfm00k",
        "Q22_9c2": "9",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 03:48",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "532b23d82f5744019ca1a0330d9e49ed",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "714",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v253,/Gender/gen1,/Income/inc5,/Age/age6,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "253",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means stuff that don't pollute and helps the planet, but I'm not sure how much it really changes things. I guess it's good for the air and water, but I worry about if it's reliable enough for everyone.",
        "sectionLOIr4": "2.37168333333",
        "sectionLOIr1": "2.37168333333",
        "sectionLOIr3": "2.04443333333",
        "sectionLOIr2": "0.287816666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "9",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1943",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "6f8eb1ee-f0d3-4569-9782-c2fb2610cd0e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 03:51",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=532b23d82f5744019ca1a0330d9e49ed&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6f8eb1ee-f0d3-4569-9782-c2fb2610cd0e&isSynthetic=true&or_age=82&or_zip=33062&or_gender=m&or_householdincome=67300",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "148.485",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "fsn6s9h93mtf7396",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "nyq3rmu5tk16gze6",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/20/2026 03:48",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6151c5e5685e4d268671e76639951d3e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "715",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v156,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "156",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy sounds like it's about using power from the sun or wind, but I'm not sure how much it really helps. Maybe it's better for the environment, but I'm cautious about the cost and how reliable it is.",
        "sectionLOIr4": "2.4728",
        "sectionLOIr1": "2.4728",
        "sectionLOIr3": "2.17898333333",
        "sectionLOIr2": "0.312016666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "6",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1959",
        "Q3": "1",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "47a2dfc0-57e9-4ce2-95b9-db292f6834fb",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/20/2026 03:51",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6151c5e5685e4d268671e76639951d3e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=47a2dfc0-57e9-4ce2-95b9-db292f6834fb&isSynthetic=true&or_age=66&or_zip=36602&or_gender=m&or_householdincome=32000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "33",
        "vbrowser": "10",
        "qtime": "147.649",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "s82gbnbsdc23fpua",
        "Q41r1": "1",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "cr87y2t1y804qx0d",
        "Q22_9c2": "8",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "3",
        "start_date": "01/20/2026 03:48",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "bb799e447f0b4cd0b8a23bcf9784dbde",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "716",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/de_maxdiff/Q22/v87,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "87",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "3",
        "Q22_6c1": "7",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means something that's reliable and futuristic, like solar panels or wind turbines. It's cool to see how tech is pushing things forward, but I also know it's not perfect yet.",
        "sectionLOIr4": "2.45748333333",
        "sectionLOIr1": "2.45748333333",
        "sectionLOIr3": "2.06041666667",
        "sectionLOIr2": "0.298966666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "100",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "6",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1992",
        "Q3": "41",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "4",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "1394c975-17ec-4cb2-adb9-b2f23dd21ca2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "7",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 03:51",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bb799e447f0b4cd0b8a23bcf9784dbde&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1394c975-17ec-4cb2-adb9-b2f23dd21ca2&isSynthetic=true&or_age=33&or_zip=29927&or_gender=m&or_householdincome=65000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "90",
        "vbrowser": "10",
        "qtime": "138.839",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "30g8udfj0xtec2tq",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "6z9ut5gvcazraa0a",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 03:48",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "95b7fab9604a4219a92a18f7d826a31d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "717",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Gender/gen2,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/de_maxdiff/Q22/v238,/Rotate Selection/Bottom_to_Top,qual,/Region/reg3,sawterm:Q1.ival gt 2007,/Age/age6,/Vote/vote2,/Education/edu4,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "238",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "9",
        "Q22_6c2": "1",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power that doesn't pollute the air or water. It's good for the environment but I need to see it work reliably before I get too excited.",
        "sectionLOIr4": "2.31176666667",
        "sectionLOIr1": "2.31176666667",
        "sectionLOIr3": "1.99796666667",
        "sectionLOIr2": "0.268983333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1935",
        "Q3": "44",
        "Q2": "2",
        "Q5": "5",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fa2e356-4165-4ca0-8ca3-39d8ca5c812e",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "01/20/2026 03:51",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=95b7fab9604a4219a92a18f7d826a31d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fa2e356-4165-4ca0-8ca3-39d8ca5c812e&isSynthetic=true&or_age=90&or_zip=76014&or_gender=f&or_householdincome=25200",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "54",
        "vbrowser": "10",
        "qtime": "145.12",
        "Q14r9": "1",
        "Q14r8": "5",
        "session": "7yxbfn14yfz0upjp",
        "Q41r1": "1",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "25",
        "Q14r5": "10",
        "Q14r4": "15",
        "Q14r7": "2",
        "Q14r6": "2",
        "uuid": "1em9n5kn7d1401zt",
        "Q22_9c2": "5",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 03:51",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e1472fa7e7394c9e972f4af642ac84a8",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "6",
        "Q22_1c1": "3",
        "record": "718",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v90,/Gender/gen1,/Income/inc5,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "90",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable power that doesn't mess with the grid too much. I like things that work steady, not too fancy or complicated.",
        "sectionLOIr4": "2.41301666667",
        "sectionLOIr1": "2.41301666667",
        "sectionLOIr3": "1.95571666667",
        "sectionLOIr2": "0.244016666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1971",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "ccd97abc-db7b-4326-83a5-30f53d32668c",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 03:54",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e1472fa7e7394c9e972f4af642ac84a8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ccd97abc-db7b-4326-83a5-30f53d32668c&isSynthetic=true&or_age=53&or_zip=91768&or_gender=m&or_householdincome=100000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "153.208",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "644595vr32b94av9",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "0kxtu4n7hjdayyn4",
        "Q22_9c2": "2",
        "Q22_9c1": "9",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 03:51",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b1f899cbf2e4481bbd7534b52536f619",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "3",
        "Q22_1c1": "6",
        "record": "719",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/de_maxdiff/Q22/v118,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Education/edu2,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "118",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "5",
        "Q39r3": "5",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "Clean energy means using power that doesn't pollute and helps the planet but I also think it's about making sure it's reliable and affordable for everyone",
        "sectionLOIr4": "2.5512",
        "sectionLOIr1": "2.5512",
        "sectionLOIr3": "2.10205",
        "sectionLOIr2": "0.25375",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "0",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "7",
        "Q22_2c2": "1",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1998",
        "Q3": "43",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "dbbadb6d-20e4-4fac-97c9-94caeb087f1b",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 03:54",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b1f899cbf2e4481bbd7534b52536f619&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=dbbadb6d-20e4-4fac-97c9-94caeb087f1b&isSynthetic=true&or_age=27&or_zip=37174&or_gender=m&or_householdincome=78000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "28",
        "vbrowser": "10",
        "qtime": "156.013",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "74s1znupr9jxr96c",
        "Q41r1": "1",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "d0kg9vek4m90w1kp",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 03:51",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ed68a46271284c02a5ef32a2c58b30ca",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "6",
        "Q22_1c1": "9",
        "record": "720",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,/Education/edu4,qual,/de_maxdiff/Q22/v208,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "208",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "1",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "6",
        "Q22_4c2": "5",
        "Q22_4c1": "8",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "3",
        "Q24": "Clean energy means using power sources that don't pollute, like solar or wind, but I also think it's about creating jobs and opportunities for people. It's a smart move for the future, even if it's not perfect yet.",
        "sectionLOIr4": "2.59761666667",
        "sectionLOIr1": "2.59761666667",
        "sectionLOIr3": "2.18496666667",
        "sectionLOIr2": "0.2688",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "12.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "10",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1997",
        "Q3": "5",
        "Q2": "1",
        "Q5": "6",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "5b68db28-3d0c-4316-8a16-40b3f6b1b8e9",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 03:54",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ed68a46271284c02a5ef32a2c58b30ca&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5b68db28-3d0c-4316-8a16-40b3f6b1b8e9&isSynthetic=true&or_age=28&or_zip=95355&or_gender=m&or_householdincome=118000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "144.022",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "xu63z7b4pnpay089",
        "Q41r1": "1",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "p7sf5351811e6jz7",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 03:51",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7bdfa8acd19348a8bb90f46407d6414b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "9",
        "record": "721",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Income/inc6,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v77,/Vote/vote2,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "77",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable power sources that don’t harm the environment, but I also think about how they fit into our daily lives and budgets.",
        "sectionLOIr4": "2.39533333333",
        "sectionLOIr1": "2.39533333333",
        "sectionLOIr3": "2.06653333333",
        "sectionLOIr2": "0.207416666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1972",
        "Q3": "5",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e130993a-e362-4711-ae66-5e1637cd3276",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 03:54",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7bdfa8acd19348a8bb90f46407d6414b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e130993a-e362-4711-ae66-5e1637cd3276&isSynthetic=true&or_age=52&or_zip=90274&or_gender=f&or_householdincome=155000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "131.208",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "cpw0s9gredj8nfuf",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "stuaansje5w2kysk",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 03:54",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "cad06f110b7747109035bd06d72b283b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "722",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,/Income/inc5,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/de_maxdiff/Q22/v185,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "185",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means using power that doesn't pollute the air, which is good for the kids and the house. It's something I've heard about, and I think it's important for the environment, but I also know we need reliable sources right now.",
        "sectionLOIr4": "2.18475",
        "sectionLOIr1": "2.18475",
        "sectionLOIr3": "1.86075",
        "sectionLOIr2": "0.2082",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1981",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e700948b-5ca8-4658-a3f7-de3185494ca4",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 03:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=cad06f110b7747109035bd06d72b283b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e700948b-5ca8-4658-a3f7-de3185494ca4&isSynthetic=true&or_age=44&or_zip=90280&or_gender=m&or_householdincome=206500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "51",
        "vbrowser": "10",
        "qtime": "117.389",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "7kt8baauvjdk9xgd",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "18",
        "Q14r2": "13",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "gdxeqa40mw8dfrvw",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "1",
        "Q21r4": "6",
        "Q21r7": "5",
        "Q21r6": "2",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 03:54",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "e09bf2e940254b3ea93e78e8de8bdbb6",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "723",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/de_maxdiff/Q22/v116,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,/Education/edu4,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "116",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means stuff that don't pollute and helps us save money, but tbh I'm not too sure about all the hype. It's good for the planet, but rn I'm more worried about what's affordable and reliable for our family.",
        "sectionLOIr4": "1.9535",
        "sectionLOIr1": "1.9535",
        "sectionLOIr3": "1.6564",
        "sectionLOIr2": "0.2034",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "6",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1974",
        "Q3": "45",
        "Q2": "2",
        "Q5": "5",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9312a73e-b973-46b7-a9cf-d7a6ae4f2005",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 03:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e09bf2e940254b3ea93e78e8de8bdbb6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9312a73e-b973-46b7-a9cf-d7a6ae4f2005&isSynthetic=true&or_age=51&or_zip=84029&or_gender=f&or_householdincome=77200",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "136.655",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "ps844z7fh42npydf",
        "Q41r1": "0",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "beffw57w486nryej",
        "Q22_9c2": "2",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "4",
        "Q21r7": "5",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 04:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "c717c53260f64306a092fd1022e44cd5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "6",
        "Q22_1c1": "4",
        "record": "726",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Vote/vote4,/Ethnicity/eth3,/de_maxdiff/Q22/v196,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "196",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "For me, clean energy means reliable power sources that don't mess with the grid too much, like solar and wind, but I'm not crazy about the hype around it.",
        "sectionLOIr4": "2.27498333333",
        "sectionLOIr1": "2.27498333333",
        "sectionLOIr3": "1.95456666667",
        "sectionLOIr2": "0.2942",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "75",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "6",
        "Q22_scorer6": "12.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1978",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "6",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b0cc35a9-37be-412c-b059-7495fdcfd667",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 04:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c717c53260f64306a092fd1022e44cd5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b0cc35a9-37be-412c-b059-7495fdcfd667&isSynthetic=true&or_age=47&or_zip=77316&or_gender=f&or_householdincome=100500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "153.674",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "2h7em7pv4zz1v1pp",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "wqa40cpdhy11j3sn",
        "Q22_9c2": "9",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 04:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7fb9fa9c864b4da4927df1c47a598ff7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "727",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,Bottom_to_Top,/Education/edu1,/de_maxdiff/Q22/v38,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "38",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "For me, clean energy means using power that doesn't pollute the air and keeps our community safe, but I'm still not sure how much it really helps with the everyday stuff like keeping the lights on and the fridge running.",
        "sectionLOIr4": "2.55813333333",
        "sectionLOIr1": "2.55813333333",
        "sectionLOIr3": "2.19271666667",
        "sectionLOIr2": "0.336766666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1986",
        "Q3": "15",
        "Q2": "2",
        "Q5": "2",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "2",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9d106e66-ef8e-4526-9c46-153d23fac897",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/20/2026 04:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7fb9fa9c864b4da4927df1c47a598ff7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9d106e66-ef8e-4526-9c46-153d23fac897&isSynthetic=true&or_age=39&or_zip=46062&or_gender=f&or_householdincome=52400",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "94",
        "vbrowser": "10",
        "qtime": "164.331",
        "Q14r9": "0",
        "Q14r8": "11",
        "session": "0f0fbwykdwgbkayb",
        "Q41r1": "0",
        "Q14r1": "33",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "6",
        "Q14r2": "28",
        "Q14r5": "5",
        "Q14r4": "17",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "hun1awmhxsjcb99v",
        "Q22_9c2": "3",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "3",
        "start_date": "01/20/2026 04:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "4976e2793b954d40b5df16adfead1296",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "5",
        "record": "728",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v54,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2,/Income/inc1,/Education/edu3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "54",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "For me it's about getting power without messing up the planet and keeping things simple with what works",
        "sectionLOIr4": "2.73541666667",
        "sectionLOIr1": "2.73541666667",
        "sectionLOIr3": "2.41256666667",
        "sectionLOIr2": "0.313633333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "100",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1931",
        "Q3": "6",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "2",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "0698ee23-c057-4404-8d99-484e595a99ac",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 04:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4976e2793b954d40b5df16adfead1296&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0698ee23-c057-4404-8d99-484e595a99ac&isSynthetic=true&or_age=94&or_zip=81008&or_gender=f&or_householdincome=12630",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "99",
        "vbrowser": "10",
        "qtime": "152.317",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "qm2amte8g47t6xez",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "dh4ezz9y2htkhvw6",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/20/2026 04:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d2e5a870419446f880f60d62fc473a4c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "729",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth5,/Gender/gen2,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v76,sawterm:Q1.ival gt 2007,/Age/age6,/Income/inc1,/Education/edu4",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "76",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "For me, clean energy means using power that doesn't pollute the air or water, but I'm not sure how much it's actually helping yet.",
        "sectionLOIr4": "2.53616666667",
        "sectionLOIr1": "2.53616666667",
        "sectionLOIr3": "2.20066666667",
        "sectionLOIr2": "0.361416666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "6",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "4",
        "Q15r3": "6",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1926",
        "Q3": "51",
        "Q2": "2",
        "Q5": "5",
        "Q4": "6",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "db72310a-e19c-473a-ae68-02a07bfc6266",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/20/2026 04:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d2e5a870419446f880f60d62fc473a4c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=db72310a-e19c-473a-ae68-02a07bfc6266&isSynthetic=true&or_age=99&or_zip=82601&or_gender=f&or_householdincome=15704",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "144.287",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "p9kemazh2zh6en8c",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "18",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "dp3qvv0352v8qkjv",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 04:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b6ae9f4c354649c1b0b70a068d0fa650",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "3",
        "record": "730",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),/de_maxdiff/Q22/v133,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "133",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "For me it means using power sources that don't pollute the air and keep the community safe.",
        "sectionLOIr4": "2.39716666667",
        "sectionLOIr1": "2.39716666667",
        "sectionLOIr3": "2.02303333333",
        "sectionLOIr2": "0.218333333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "6",
        "Q1": "1989",
        "Q3": "48",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "882e442d-2216-4a29-b63f-69d4e5e4f18c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 04:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b6ae9f4c354649c1b0b70a068d0fa650&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=882e442d-2216-4a29-b63f-69d4e5e4f18c&isSynthetic=true&or_age=36&or_zip=98031&or_gender=m&or_householdincome=52000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "64",
        "vbrowser": "10",
        "qtime": "146.659",
        "Q14r9": "6",
        "Q14r8": "6",
        "session": "0xf5w9c26665g29b",
        "Q41r1": "1",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "12",
        "Q14r2": "17",
        "Q14r5": "12",
        "Q14r4": "12",
        "Q14r7": "6",
        "Q14r6": "6",
        "uuid": "76jrv8uxu2w4duwz",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 04:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "135b4c4281a643ec9631b25b20b7136e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "731",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/de_maxdiff/Q22/v86,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "86",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "For me, clean energy means using power sources that don't pollute the air or water, like solar or wind, but I'm still cautious about how fast they're being pushed because I like things that work reliably.",
        "sectionLOIr4": "2.44165",
        "sectionLOIr1": "2.44165",
        "sectionLOIr3": "2.11551666667",
        "sectionLOIr2": "0.265283333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1961",
        "Q3": "34",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "6",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "190fa8a3-34a9-46e2-8f08-79ca001c012c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "5",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 04:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=135b4c4281a643ec9631b25b20b7136e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=190fa8a3-34a9-46e2-8f08-79ca001c012c&isSynthetic=true&or_age=64&or_zip=27513&or_gender=m&or_householdincome=72000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "73",
        "vbrowser": "10",
        "qtime": "142.618",
        "Q14r9": "4",
        "Q14r8": "13",
        "session": "hrnaef9zjtebc5hz",
        "Q41r1": "0",
        "Q14r1": "13",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "13",
        "Q14r5": "13",
        "Q14r4": "18",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "2cvjg8mm13qpuf5r",
        "Q22_9c2": "2",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/20/2026 04:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "4b4956fbfb6240208e22570b498ed737",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "732",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v220,/Gender/gen2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "220",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "For me, clean energy means using power that doesn't pollute the air or water, like solar or wind. It's about keeping our environment safe and healthy for the future, but I also think we need to be careful with the promises and make sure it's reliable.",
        "sectionLOIr4": "2.37456666667",
        "sectionLOIr1": "2.37456666667",
        "sectionLOIr3": "2.03418333333",
        "sectionLOIr2": "0.27865",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "1",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1952",
        "Q3": "13",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a6593513-ad17-4f97-a5f7-50f0052d3b00",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 04:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4b4956fbfb6240208e22570b498ed737&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a6593513-ad17-4f97-a5f7-50f0052d3b00&isSynthetic=true&or_age=73&or_zip=83404&or_gender=f&or_householdincome=52294",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "32",
        "vbrowser": "10",
        "qtime": "146.923",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "uhjs6vw6rzxs84n2",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "vzxz1eb6e9mt9v7x",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 04:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1cc417d5ee8241e39eeb27fd205ebbb4",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "733",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v132,/Region/reg4,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "132",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "9",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "For me it means electricity that doesn't pollute the air or water but I'm not sure how much it actually helps yet",
        "sectionLOIr4": "2.44505",
        "sectionLOIr1": "2.44505",
        "sectionLOIr3": "2.116",
        "sectionLOIr2": "0.247333333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1993",
        "Q3": "6",
        "Q2": "1",
        "Q5": "2",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b2cfc66b-bcc5-4ed9-be88-457a5eb1bace",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 04:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1cc417d5ee8241e39eeb27fd205ebbb4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b2cfc66b-bcc5-4ed9-be88-457a5eb1bace&isSynthetic=true&or_age=30&or_zip=80214&or_gender=m&or_householdincome=66000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "132.914",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "vmp5xx76hfdeqn6s",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "tj6e1g9tyr8kd0x0",
        "Q22_9c2": "9",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 04:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ff4c38da53a04ce3a9b9e337830cc447",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "1",
        "record": "734",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/de_maxdiff/Q22/v201",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "201",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "9",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "For me it means reliable power that doesn't cost too much and keeps the lights on without messing up the budget.",
        "sectionLOIr4": "2.21033333333",
        "sectionLOIr1": "2.21033333333",
        "sectionLOIr3": "1.91841666667",
        "sectionLOIr2": "0.20795",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1979",
        "Q3": "39",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "73845e3a-0cbc-433f-98be-bac55e415434",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 05:01",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ff4c38da53a04ce3a9b9e337830cc447&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=73845e3a-0cbc-433f-98be-bac55e415434&isSynthetic=true&or_age=48&or_zip=15221&or_gender=m&or_householdincome=57200",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "31",
        "vbrowser": "10",
        "qtime": "126.603",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "2v1r4wh144qq9r3a",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "v1jx325vjsq70at5",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/20/2026 04:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4a00ec41f3f34ce2be7822cd4c0b2465",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "735",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6,sawterm:(dvfail.r1),/de_maxdiff/Q22/v215",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "215",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "For me it means using power sources that don't pollute the air and keep my community safe but I also know some of them are still new and not as reliable as the old ones",
        "sectionLOIr4": "2.10763333333",
        "sectionLOIr1": "2.10763333333",
        "sectionLOIr3": "1.80908333333",
        "sectionLOIr2": "0.230716666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "2",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1994",
        "Q3": "44",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "cbaabc1c-0014-471f-b41a-8248dc0bd27d",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/20/2026 05:02",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4a00ec41f3f34ce2be7822cd4c0b2465&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cbaabc1c-0014-471f-b41a-8248dc0bd27d&isSynthetic=true&or_age=31&or_zip=79416&or_gender=m&or_householdincome=19200",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "37",
        "vbrowser": "10",
        "qtime": "124.398",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "6ek3w7qywhgdnp2k",
        "Q41r1": "0",
        "Q14r1": "29",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "17",
        "Q14r5": "8",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "repfdnhrwwbxyptu",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 05:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e183f6c22e9e4c00b8d76d06cf3d73e0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "736",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,/Income/inc5,/de_maxdiff/Q22/v180,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,sawterm:(dvfail.r1),/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "180",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "9",
        "Q22_4c2": "2",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "For me, clean energy means using power that doesn't pollute the air or water, like solar or wind. It's about keeping things safe for my kid and the community, but I also know it's not perfect yet.",
        "sectionLOIr4": "2.07111666667",
        "sectionLOIr1": "2.07111666667",
        "sectionLOIr3": "1.74886666667",
        "sectionLOIr2": "0.2138",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "3",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1988",
        "Q3": "23",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "50fc4410-59c7-4f25-b8b8-482fe05a55f6",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 05:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e183f6c22e9e4c00b8d76d06cf3d73e0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=50fc4410-59c7-4f25-b8b8-482fe05a55f6&isSynthetic=true&or_age=37&or_zip=48197&or_gender=m&or_householdincome=95000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "AN",
        "GeoIP_Detailsr5": "Andalusia",
        "GeoIP_Detailsr2": "Spain",
        "Q34r2": "0",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "es"
    },
    {
        "HIDAge": "81",
        "vbrowser": "10",
        "qtime": "169.438",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "vewqeeun7vr79qg4",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "d3p1xs5tcy3e4n77",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/20/2026 05:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "0ffa901871ba4f5ca9aedcaa95be16bb",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "738",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/de_maxdiff/Q22/v171,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Income/inc1",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "171",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "I think it's about getting power without messing up the air or water",
        "sectionLOIr4": "2.82163333333",
        "sectionLOIr1": "2.82163333333",
        "sectionLOIr3": "2.40393333333",
        "sectionLOIr2": "0.3168",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1944",
        "Q3": "34",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "1",
        "Q22_8c2": "5",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "0ef37f24-1f11-4929-81f3-3a11c3e422e0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 05:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0ffa901871ba4f5ca9aedcaa95be16bb&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0ef37f24-1f11-4929-81f3-3a11c3e422e0&isSynthetic=true&or_age=81&or_zip=28571&or_gender=m&or_householdincome=23000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "59",
        "vbrowser": "10",
        "qtime": "183.357",
        "Q14r9": "14",
        "Q14r8": "4",
        "session": "c2sxe40uhvq61qb4",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "18",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "91f94j0jcykmmdkh",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "6",
        "Q21r5": "2",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "3",
        "start_date": "01/20/2026 05:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "7287686d98ad4d7591e46525109668ee",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "2",
        "record": "739",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "1",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "4",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Honestly, not much",
        "sectionLOIr4": "3.05403333333",
        "sectionLOIr1": "3.05403333333",
        "sectionLOIr3": "2.67893333333",
        "sectionLOIr2": "0.336766666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1966",
        "Q3": "41",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "be2d1617-998b-427f-8032-b35aed2dca17",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/20/2026 05:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7287686d98ad4d7591e46525109668ee&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=be2d1617-998b-427f-8032-b35aed2dca17&isSynthetic=true&or_age=59&or_zip=29801&or_gender=m&or_householdincome=62000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "57",
        "vbrowser": "10",
        "qtime": "166.352",
        "Q14r9": "9",
        "Q14r8": "14",
        "session": "p648dm8epw02hs3w",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "z95490ctjrhv51jf",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 05:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "c4826290841f47ebae8e7777883ea0b4",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "740",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Education/edu3,/Income/inc3,/de_maxdiff/Q22/v217",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "217",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "9",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means good for the planet, but rn I'm still figuring out how it all ties into my work and daily life.",
        "sectionLOIr4": "2.768",
        "sectionLOIr1": "2.768",
        "sectionLOIr3": "2.38666666667",
        "sectionLOIr2": "0.320433333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1968",
        "Q3": "17",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "87ce5338-1aac-45be-8852-e877b745fc7e",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/20/2026 05:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c4826290841f47ebae8e7777883ea0b4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=87ce5338-1aac-45be-8852-e877b745fc7e&isSynthetic=true&or_age=57&or_zip=66012&or_gender=f&or_householdincome=63600",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "24",
        "vbrowser": "10",
        "qtime": "169.423",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "um7m7gtp34wxce76",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "23",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "13rre5752hg199sf",
        "Q22_9c2": "3",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 05:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7282cebbcdf64a8a9beb7ad192bd7866",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "9",
        "Q22_1c1": "5",
        "record": "741",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,Bottom_to_Top,/Ethnicity/eth2,/Age/age1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v152,/Gender/gen2,sawterm:(dvfail.r1),/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "152",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "2",
        "Q22_7c2": "3",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "8",
        "Q22_6c2": "2",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "87.5",
        "Q23": "3",
        "Q24": "Clean energy means using sunlight and wind to power our home and school because it's better for the environment and helps us save money on bills. I think it's important for the future but we need to make sure it's reliable and affordable for everyone.",
        "sectionLOIr4": "2.82035",
        "sectionLOIr1": "2.82035",
        "sectionLOIr3": "2.37606666667",
        "sectionLOIr2": "0.3259",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "1",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "9",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2001",
        "Q3": "10",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d3e2a6d5-58f1-4fc3-87df-69660d3c3fd7",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "9",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 05:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7282cebbcdf64a8a9beb7ad192bd7866&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d3e2a6d5-58f1-4fc3-87df-69660d3c3fd7&isSynthetic=true&or_age=24&or_zip=32712&or_gender=f&or_householdincome=77850",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "154.479",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "sy9bs4yg7zevvsny",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "18",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "caqwv8s56xb6mxmf",
        "Q22_9c2": "9",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 05:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "20ef173d6e314f889df5e54ea09faf40",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "3",
        "record": "742",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/de_maxdiff/Q22/v269,/Gender/gen2,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "269",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "1",
        "Q22_6c2": "9",
        "Q22_4c2": "2",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Honestly, not much",
        "sectionLOIr4": "2.56778333333",
        "sectionLOIr1": "2.56778333333",
        "sectionLOIr3": "2.17113333333",
        "sectionLOIr2": "0.3178",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "0",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "4",
        "Q15r2": "3",
        "Q15r3": "6",
        "Q15r8": "5",
        "Q15r9": "4",
        "Q1": "1989",
        "Q3": "14",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "096c0cc8-1aed-494e-8a1e-dbf55225638c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/20/2026 05:59",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=20ef173d6e314f889df5e54ea09faf40&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=096c0cc8-1aed-494e-8a1e-dbf55225638c&isSynthetic=true&or_age=36&or_zip=61434&or_gender=f&or_householdincome=86000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "62",
        "vbrowser": "10",
        "qtime": "161.126",
        "Q14r9": "4",
        "Q14r8": "8",
        "session": "6t3y5j81g8ey3pzc",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "8",
        "Q14r2": "17",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "e8acq7wefttgpgct",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 05:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7f89356a5af54b74997b8a9303f3dc48",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "6",
        "record": "743",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,Bottom_to_Top,sawterm:(dvfail.r1),/de_maxdiff/Q22/v135,20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc4,/Gender/gen2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "135",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "5",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means having reliable power that doesn't harm the planet and allows me to feel good about the future, especially when it comes from solar or wind that's been around long enough to trust.",
        "sectionLOIr4": "2.683",
        "sectionLOIr1": "2.683",
        "sectionLOIr3": "2.1946",
        "sectionLOIr2": "0.307383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "0",
        "HIDAge2": "5",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "7",
        "Q15r9": "9",
        "Q1": "1963",
        "Q3": "24",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "706771c7-5f21-4ce8-b590-2088ab1b1441",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 05:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7f89356a5af54b74997b8a9303f3dc48&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=706771c7-5f21-4ce8-b590-2088ab1b1441&isSynthetic=true&or_age=61&or_zip=56327&or_gender=f&or_householdincome=68000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "156.465",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "mgavry5xkrk56brk",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "3pgmam3c9zn74tt3",
        "Q22_9c2": "7",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "6",
        "vlist": "2",
        "Q30r6oe": "ABCDEFG",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "01/20/2026 05:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "0603a59756cf4b9495bcd8b72539c1d5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "744",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/Ethnicity/eth4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,/de_maxdiff/Q22/v257,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc6,sawterm:(dvfail.r1),/Age/age3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "257",
        "Q35": "6",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means something that's reliable but not cheap, and I'm not sure if it's worth the gamble yet.",
        "sectionLOIr4": "2.6057",
        "sectionLOIr1": "2.6057",
        "sectionLOIr3": "2.24861666667",
        "sectionLOIr2": "0.27315",
        "vctq1c21": "0",
        "Q35r6oe": "ABCDEFG",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1981",
        "Q3": "33",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "1",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b95c47a0-5868-4973-84e3-9ed933623d44",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 05:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0603a59756cf4b9495bcd8b72539c1d5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b95c47a0-5868-4973-84e3-9ed933623d44&isSynthetic=true&or_age=44&or_zip=11953&or_gender=m&or_householdincome=133484",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "69",
        "vbrowser": "10",
        "qtime": "163.981",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "y1bzj1kewtxdzpyh",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "3chf2yhmzzuy4ahk",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "3",
        "Q21r2": "1",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 05:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "852beaff56d840e985f43b12a9fa20a8",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "745",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v288,qual,/Region/reg3,sawterm:Q1.ival gt 2007,/Age/age6,/Vote/vote2,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "288",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q39r2": "5",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "8",
        "Q22_4c2": "4",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "I think it's about using energy that doesn't pollute the air or water, but I also know it's not all clear-cut",
        "sectionLOIr4": "2.72831666667",
        "sectionLOIr1": "2.72831666667",
        "sectionLOIr3": "2.30091666667",
        "sectionLOIr2": "0.244183333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "0",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1956",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c2c4a66a-2a32-4b6f-91e3-696d11b64180",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 05:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=852beaff56d840e985f43b12a9fa20a8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c2c4a66a-2a32-4b6f-91e3-696d11b64180&isSynthetic=true&or_age=69&or_zip=77401&or_gender=f&or_householdincome=36000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "65",
        "vbrowser": "10",
        "qtime": "161.62",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "2mewfsdzuuyw26cp",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "k0mhe38qaa88c7g4",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 05:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2962b5e8687547fda39174628573b5ce",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "record": "746",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v294,Top_to_Bottom,/Gender/gen2,/Income/inc1,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "294",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Honestly, it's like a mixed bag rn. I know it's good for the planet, but I also worry about the cost and how reliable it is, especially with my budget and my Buick's needs.",
        "sectionLOIr4": "2.69018333333",
        "sectionLOIr1": "2.69018333333",
        "sectionLOIr3": "2.2836",
        "sectionLOIr2": "0.265266666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1960",
        "Q3": "22",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "71cc2866-8c9d-46ce-941b-666b6cb70322",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/20/2026 06:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2962b5e8687547fda39174628573b5ce&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=71cc2866-8c9d-46ce-941b-666b6cb70322&isSynthetic=true&or_age=65&or_zip=01028&or_gender=f&or_householdincome=23500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "154.371",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "xz3ywhdr8ytxcps3",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "6j631sdamjjsnq8m",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 05:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4454a00f53b143c0a564045ef8819800",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "747",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc4,/de_maxdiff/Q22/v167",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "167",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means reliable power with less harm, but it’s not just about the environment. It’s about keeping things running smoothly and having options that make sense for the long haul.",
        "sectionLOIr4": "2.56826666667",
        "sectionLOIr1": "2.56826666667",
        "sectionLOIr3": "2.19623333333",
        "sectionLOIr2": "0.261266666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1964",
        "Q3": "31",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "85534751-4686-492f-8a55-6f76cf321864",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 06:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4454a00f53b143c0a564045ef8819800&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=85534751-4686-492f-8a55-6f76cf321864&isSynthetic=true&or_age=61&or_zip=08034&or_gender=m&or_householdincome=76500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "156.119",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "d733zst3xjsybz5b",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "jnm1kbdcwcq88cyt",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 06:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c694dd60b450471885097c3739c24471",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "748",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc4,Top_to_Bottom,/de_maxdiff/Q22/v58,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "58",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "4",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Solar panels on rooftops",
        "sectionLOIr4": "2.59936666667",
        "sectionLOIr1": "2.59936666667",
        "sectionLOIr3": "2.24225",
        "sectionLOIr2": "0.270016666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "0",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "2000",
        "Q3": "26",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "89f929d7-79bf-4610-b692-0376e08178b6",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 06:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c694dd60b450471885097c3739c24471&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=89f929d7-79bf-4610-b692-0376e08178b6&isSynthetic=true&or_age=25&or_zip=65706&or_gender=m&or_householdincome=78000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "152.534",
        "Q14r9": "4",
        "Q14r8": "13",
        "session": "qj6pegnbhrpwrtcj",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "k1yu85ymqd87b0bq",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "1",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "975d2edefd044a8c93b73061de511caf",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "749",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v272,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "272",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "2",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means safer air for the kids and less noise at home, but I also think we need to make sure it's reliable and affordable for everyone",
        "sectionLOIr4": "2.53921666667",
        "sectionLOIr1": "2.53921666667",
        "sectionLOIr3": "2.21775",
        "sectionLOIr2": "0.28285",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1996",
        "Q3": "10",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "97f647c1-8df4-458d-9344-e4183237ea00",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 06:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=975d2edefd044a8c93b73061de511caf&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=97f647c1-8df4-458d-9344-e4183237ea00&isSynthetic=true&or_age=28&or_zip=34683&or_gender=m&or_householdincome=83500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "162.792",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "gsw3235xyee6cahz",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "8tsv45rpd1ptzz1b",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "69db88ed611e463a8271bbfcd2a227fd",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "2",
        "record": "750",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/de_maxdiff/Q22/v271,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "271",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "5",
        "Q39r3": "4",
        "Q39r1": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable power that doesn't pollute the air or water. It's about using sunlight and wind instead of oil or gas, which keeps the environment safer for everyone. I think it's important but need to balance it with what works best for my budget and daily needs.",
        "sectionLOIr4": "2.70525",
        "sectionLOIr1": "2.70525",
        "sectionLOIr3": "2.24663333333",
        "sectionLOIr2": "0.290083333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "1",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1964",
        "Q3": "5",
        "Q2": "2",
        "Q5": "2",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b37ab683-c9ef-415f-b8e6-aff684256f28",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 06:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=69db88ed611e463a8271bbfcd2a227fd&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b37ab683-c9ef-415f-b8e6-aff684256f28&isSynthetic=true&or_age=61&or_zip=94577&or_gender=f&or_householdincome=34600",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "156.046",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "91gg8w0ptxbtfvdz",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "w5sgf586hkr9u13h",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "3744886fd30440a59a316b1a31406584",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "751",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/de_maxdiff/Q22/v183,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "183",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable power that doesn't cost a fortune. It's about keeping things stable without sacrificing what's practical.",
        "sectionLOIr4": "2.59365",
        "sectionLOIr1": "2.59365",
        "sectionLOIr3": "2.16928333333",
        "sectionLOIr2": "0.249266666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1964",
        "Q3": "23",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "14cda01d-772c-4b25-bc7c-aaa22e931bf4",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 06:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3744886fd30440a59a316b1a31406584&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=14cda01d-772c-4b25-bc7c-aaa22e931bf4&isSynthetic=true&or_age=61&or_zip=48146&or_gender=m&or_householdincome=159500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "72",
        "vbrowser": "10",
        "qtime": "158.683",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "y464xq8n0pgbjbgk",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "g8yyzgu4wg7jqm7w",
        "Q22_9c2": "5",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 06:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "125da3dea6794587b301ad2ef281182d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "752",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Education/edu4,/de_maxdiff/Q22/v249",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "249",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Clean energy means using power from the sun and wind that's reliable and doesn't run out. I'm not sure if it's better than what we've always had, but it feels like something new that might not be as dependable. I guess it's a good idea, but I'd want to make sure it works well with our usual way of doing things.",
        "sectionLOIr4": "2.64235",
        "sectionLOIr1": "2.64235",
        "sectionLOIr3": "2.20741666667",
        "sectionLOIr2": "0.28295",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "2",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "4",
        "Q15r5": "3",
        "Q15r6": "8",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "4",
        "Q1": "1953",
        "Q3": "44",
        "Q2": "1",
        "Q5": "5",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5bc45d44-23ad-4767-86bc-ccd8fe7b4ad5",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "01/20/2026 06:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=125da3dea6794587b301ad2ef281182d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5bc45d44-23ad-4767-86bc-ccd8fe7b4ad5&isSynthetic=true&or_age=72&or_zip=76108&or_gender=m&or_householdincome=60000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "33",
        "vbrowser": "10",
        "qtime": "157.372",
        "Q14r9": "8",
        "Q14r8": "4",
        "session": "exzskx0zyaev85s3",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "17",
        "Q14r5": "8",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "smfyykng406wur4w",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 06:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4861505a3fc04fa387555a62a3df164c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "1",
        "record": "753",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6,sawterm:(dvfail.r1),/de_maxdiff/Q22/v64",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "64",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Clean energy means renewable sources like solar or wind, but I'm not sure how reliable they are. It's a good idea in theory, but I worry about consistency and cost. I trust established options more, like natural gas or nuclear, because they're proven and dependable.",
        "sectionLOIr4": "2.61936666667",
        "sectionLOIr1": "2.61936666667",
        "sectionLOIr3": "2.25526666667",
        "sectionLOIr2": "0.288733333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "8",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "7",
        "Q1": "1992",
        "Q3": "23",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "5",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "81c76349-9bb7-4029-ac7f-6b8f7b9ec002",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 06:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4861505a3fc04fa387555a62a3df164c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=81c76349-9bb7-4029-ac7f-6b8f7b9ec002&isSynthetic=true&or_age=33&or_zip=49686&or_gender=m&or_householdincome=156200",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "149.35",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "gmsu3z4g979r6nc7",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ranu6pxzsc6sp6nt",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/20/2026 06:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "113866a769c148bfa0745bda65eba972",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "9",
        "record": "754",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v92,Top_to_Bottom,/Gender/gen2,/Income/inc1,/Education/edu3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "92",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means stuff that don't pollute the air and keeps the lights on without breaking the bank. I don't care much about fancy terms or big plans, just want power that works reliably and doesn't cost a fortune.",
        "sectionLOIr4": "2.48615",
        "sectionLOIr1": "2.48615",
        "sectionLOIr3": "2.11775",
        "sectionLOIr2": "0.2497",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "9",
        "Q15r5": "8",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1959",
        "Q3": "43",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "5",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d8b33a41-a58d-4e4b-b1d4-0b9638bf76a0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 06:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=113866a769c148bfa0745bda65eba972&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d8b33a41-a58d-4e4b-b1d4-0b9638bf76a0&isSynthetic=true&or_age=65&or_zip=37042&or_gender=f&or_householdincome=22000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "62",
        "vbrowser": "10",
        "qtime": "156.674",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "44b34mze3t5apcw8",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "kc9vbzx2vt3q82zc",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "834ad53736d442e582a5dd12d17aba59",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "755",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,/de_maxdiff/Q22/v283,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "283",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy sounds like it's about keeping things simple and dependable. I know it's something people talk about a lot, but I'm not sure how much it really changes the way things work for folks like me. It probably means using power that doesn't pollute, but I'd rather stick with what I know works reliably.",
        "sectionLOIr4": "2.60921666667",
        "sectionLOIr1": "2.60921666667",
        "sectionLOIr3": "2.25263333333",
        "sectionLOIr2": "0.250383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "7",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1963",
        "Q3": "23",
        "Q2": "2",
        "Q5": "2",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6380802e-c91f-488d-9128-fae123d1af0f",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "9",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 06:09",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=834ad53736d442e582a5dd12d17aba59&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6380802e-c91f-488d-9128-fae123d1af0f&isSynthetic=true&or_age=62&or_zip=49503&or_gender=f&or_householdincome=107800",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "57",
        "vbrowser": "10",
        "qtime": "152.631",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "3gyzcrgpsemxs57f",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "4",
        "uuid": "c12c9yuz0sfbp1hs",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 06:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "66b1b9b89c5d4504a331ded9495be9bf",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "756",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v285,/Gender/gen1,/Income/inc5",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "285",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "Solar panels and wind turbines. Yeah, clean energy is about getting power from the sun and wind, which don’t pollute like gas or coal. It’s a smart move for the future, but I still think we gotta keep some of the old ways around for reliability.",
        "sectionLOIr4": "2.54126666667",
        "sectionLOIr1": "2.54126666667",
        "sectionLOIr3": "2.18885",
        "sectionLOIr2": "0.298233333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "0",
        "Q22_scorer4": "12.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1968",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "4",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "fc0a75d1-a3a6-43fd-b1e9-521a6e36636e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "4",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/20/2026 06:09",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=66b1b9b89c5d4504a331ded9495be9bf&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=fc0a75d1-a3a6-43fd-b1e9-521a6e36636e&isSynthetic=true&or_age=57&or_zip=77657&or_gender=m&or_householdincome=108000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "60",
        "vbrowser": "10",
        "qtime": "158.334",
        "Q14r9": "1",
        "Q14r8": "10",
        "session": "kc54fhjrawh6407k",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "15",
        "Q14r7": "5",
        "Q14r6": "2",
        "uuid": "yuaz7yhrqgv8nm3y",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 06:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4b46c342290b4b25af3a1ae78e05c314",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "757",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,/de_maxdiff/Q22/v6,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "6",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "1",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Clean energy means fresh power for our homes and jobs, but I'd love to see more local projects that let us build and grow together, rn",
        "sectionLOIr4": "2.63568333333",
        "sectionLOIr1": "2.63568333333",
        "sectionLOIr3": "2.31795",
        "sectionLOIr2": "0.311216666667",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "3",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "1",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "10",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1965",
        "Q3": "16",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "2",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "c4e92cc5-a6f9-4429-9e96-488564cfa425",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 06:09",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4b46c342290b4b25af3a1ae78e05c314&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c4e92cc5-a6f9-4429-9e96-488564cfa425&isSynthetic=true&or_age=60&or_zip=52601&or_gender=m&or_householdincome=95200",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "84",
        "vbrowser": "10",
        "qtime": "165.556",
        "Q14r9": "2",
        "Q14r8": "10",
        "session": "jv4u3acfm0jqmujm",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "15",
        "Q14r7": "2",
        "Q14r6": "5",
        "uuid": "mffrxg3y9w654xk9",
        "Q22_9c2": "2",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "6",
        "vlist": "2",
        "Q30r6oe": "ABCDEFG",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "3",
        "start_date": "01/20/2026 06:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ac4909a4f1b545f98b440b2ac9a73da9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "9",
        "record": "758",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg3,/Ethnicity/eth3,Bottom_to_Top,/de_maxdiff/Q22/v52,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "52",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "2",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "1",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "reliable power for the future",
        "sectionLOIr4": "2.7542",
        "sectionLOIr1": "2.7542",
        "sectionLOIr3": "2.36798333333",
        "sectionLOIr2": "0.342916666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1941",
        "Q3": "34",
        "Q2": "1",
        "Q5": "3",
        "Q4": "2",
        "Q6": "2",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "1",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "d553255d-5bbe-4f2d-a3f3-a4f82fee3007",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 06:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ac4909a4f1b545f98b440b2ac9a73da9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d553255d-5bbe-4f2d-a3f3-a4f82fee3007&isSynthetic=true&or_age=84&or_zip=28715&or_gender=m&or_householdincome=42000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "41",
        "vbrowser": "10",
        "qtime": "183.979",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "mz1udpdt2w4nh55j",
        "Q41r1": "1",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "sswkeraz8yzvueap",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "3a71a22a37e54d98b1b322946e991917",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "759",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v42,/Vote/vote2,sawterm:Q1.ival gt 2007,/Education/edu3,/Gender/gen2,/Age/age3,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "42",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Renewable resources like solar and wind that power my home and help keep things running smoothly. It also means supporting local businesses that are moving toward greener practices.",
        "sectionLOIr4": "3.06391666667",
        "sectionLOIr1": "3.06391666667",
        "sectionLOIr3": "2.7636",
        "sectionLOIr2": "0.351016666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "9",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "5",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1984",
        "Q3": "4",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "470f4a80-eff9-44b7-aea0-e54d7fc15c22",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 06:30",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3a71a22a37e54d98b1b322946e991917&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=470f4a80-eff9-44b7-aea0-e54d7fc15c22&isSynthetic=true&or_age=39&or_zip=72120&or_gender=f&or_householdincome=39500",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "162.273",
        "Q14r9": "9",
        "Q14r8": "13",
        "session": "h1gfbpvzfuxa9x7f",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "htnb458amefzrmtm",
        "Q22_9c2": "4",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "5",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "4",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "360037abeb4a44939382dcd7b7079ae0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "760",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/de_maxdiff/Q22/v120,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc7",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "120",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Renewable power sources that support both the economy and long-term energy security.",
        "sectionLOIr4": "2.7021",
        "sectionLOIr1": "2.7021",
        "sectionLOIr3": "2.36213333333",
        "sectionLOIr2": "0.331116666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1978",
        "Q3": "33",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "7",
        "Q22_8c2": "4",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "be707f60-c3d1-4327-8eb5-d5a5ac86bdb9",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 06:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=360037abeb4a44939382dcd7b7079ae0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=be707f60-c3d1-4327-8eb5-d5a5ac86bdb9&isSynthetic=true&or_age=46&or_zip=10465&or_gender=m&or_householdincome=215000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "172.394",
        "Q14r9": "5",
        "Q14r8": "4",
        "session": "wywuk8vvs62yup1j",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "22",
        "Q14r5": "4",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "wanvnywadxczxfpg",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 06:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "13e86807d267479b803459826759c1e2",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "761",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc3,/de_maxdiff/Q22/v60,/Gender/gen2,sawterm:(dvfail.r1),/Education/edu1",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "60",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "2",
        "Q22_6c1": "2",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Renewable sources like solar and wind",
        "sectionLOIr4": "2.87068333333",
        "sectionLOIr1": "2.87068333333",
        "sectionLOIr3": "2.49433333333",
        "sectionLOIr2": "0.338583333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "2002",
        "Q3": "1",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "46fabdcb-ea8e-4f7f-81ff-c8fc587eec86",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 06:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=13e86807d267479b803459826759c1e2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=46fabdcb-ea8e-4f7f-81ff-c8fc587eec86&isSynthetic=true&or_age=23&or_zip=36303&or_gender=f&or_householdincome=51000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "173.283",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "wr648u6sgkqc8ed8",
        "Q41r1": "1",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "16",
        "Q14r2": "16",
        "Q14r5": "11",
        "Q14r4": "11",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "jcp8mxmhvw9dr3nr",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "1",
        "Q43": "2",
        "start_date": "01/20/2026 06:30",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d824cd7a2d25492cb42cc7d4e79e6e86",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "762",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/de_maxdiff/Q22/v300,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "300",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q39r2": "5",
        "Q39r3": "4",
        "Q39r1": "5",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Solar panels on rooftops",
        "sectionLOIr4": "2.8859",
        "sectionLOIr1": "2.8859",
        "sectionLOIr3": "2.41598333333",
        "sectionLOIr2": "0.262716666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "2000",
        "Q3": "14",
        "Q2": "1",
        "Q5": "2",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "4",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b87cced8-c1fe-4937-a188-73cba487da68",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d824cd7a2d25492cb42cc7d4e79e6e86&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b87cced8-c1fe-4937-a188-73cba487da68&isSynthetic=true&or_age=25&or_zip=60618&or_gender=m&or_householdincome=45000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "174.696",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "9ykpjuq0uzt45h4h",
        "Q41r1": "0",
        "Q14r1": "34",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "17",
        "Q14r5": "8",
        "Q14r4": "8",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "0aeqcxhh68ktmmaz",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "2",
        "Q21r4": "3",
        "Q21r7": "4",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 06:30",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4292e4dc500046d6abf6cf1eb5f55405",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "763",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Education/edu2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v268,/Gender/gen1,Top_to_Bottom,/Income/inc1",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "268",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means renewable sources like solar or wind that don't pollute. It's good for the environment, but I'm not sure how reliable it is yet.",
        "sectionLOIr4": "2.90928333333",
        "sectionLOIr1": "2.90928333333",
        "sectionLOIr3": "2.56765",
        "sectionLOIr2": "0.26205",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "0",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q15r5": "1",
        "Q15r6": "5",
        "Q15r7": "7",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "4",
        "Q1": "1996",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "4c720511-4c6a-4899-b46d-596ea286d9fd",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "5",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4292e4dc500046d6abf6cf1eb5f55405&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4c720511-4c6a-4899-b46d-596ea286d9fd&isSynthetic=true&or_age=28&or_zip=77083&or_gender=m&or_householdincome=23500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "157.857",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "ux3tzc8q2v0w0a3p",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "13",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "brxrh8jmvgxy5d1r",
        "Q22_9c2": "4",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 06:30",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "89c8e5ed7311480fa400f8a84543d0d4",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "764",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v84,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "84",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Renewable sources that work reliably",
        "sectionLOIr4": "2.6223",
        "sectionLOIr1": "2.6223",
        "sectionLOIr3": "2.24583333333",
        "sectionLOIr2": "0.2846",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1998",
        "Q3": "5",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "2",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5a0a618a-7a56-44cc-b1ca-f25a3ab814a3",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "5",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=89c8e5ed7311480fa400f8a84543d0d4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5a0a618a-7a56-44cc-b1ca-f25a3ab814a3&isSynthetic=true&or_age=27&or_zip=95023&or_gender=f&or_householdincome=111000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "67",
        "vbrowser": "10",
        "qtime": "149.218",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "phjaw5exp0fcyzxq",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "tb1ueu56jx2xmwzy",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "5",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:30",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ce92bc3d7ff240d99a31d959a2016500",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "765",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v136,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "136",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Solar panels on rooftops and wind turbines in open fields",
        "sectionLOIr4": "2.48476666667",
        "sectionLOIr1": "2.48476666667",
        "sectionLOIr3": "2.12698333333",
        "sectionLOIr2": "0.287266666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1958",
        "Q3": "5",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "74e3b131-5f49-4a54-b4a7-deb5b8151c2b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ce92bc3d7ff240d99a31d959a2016500&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=74e3b131-5f49-4a54-b4a7-deb5b8151c2b&isSynthetic=true&or_age=67&or_zip=92627&or_gender=m&or_householdincome=42000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "87",
        "vbrowser": "10",
        "qtime": "148.757",
        "Q14r9": "5",
        "Q14r8": "4",
        "session": "d0188dex9cy77mr9",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "v1auuwbfu7ghxduk",
        "Q22_9c2": "1",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "3",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 06:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d94ea9b4ef094756b654c90351e7a657",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "9",
        "record": "766",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v144,/Age/age6,/Education/edu4,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "144",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Reliable power that doesn't pollute the air or water. It means using sources like solar or wind that are proven and safe for the environment. I think it's important but need to make sure it's cost-effective and dependable for our household.",
        "sectionLOIr4": "2.47571666667",
        "sectionLOIr1": "2.47571666667",
        "sectionLOIr3": "2.08868333333",
        "sectionLOIr2": "0.245466666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "9",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1938",
        "Q3": "15",
        "Q2": "2",
        "Q5": "5",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "612606f8-d253-40b2-a225-7430b067cad0",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/20/2026 06:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d94ea9b4ef094756b654c90351e7a657&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=612606f8-d253-40b2-a225-7430b067cad0&isSynthetic=true&or_age=87&or_zip=47150&or_gender=f&or_householdincome=32160",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "71",
        "vbrowser": "10",
        "qtime": "154.127",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "q3vcuu8kc5fmnq33",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "mtdxw4dxfe22295y",
        "Q22_9c2": "5",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "9169928af192487e9c12464ebc0bba21",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "767",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v149,/Gender/gen1,/Income/inc4,/Age/age6,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "149",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "2",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable power that supports the community and doesn't disrupt the way things have always worked.",
        "sectionLOIr4": "2.56458333333",
        "sectionLOIr1": "2.56458333333",
        "sectionLOIr3": "2.15173333333",
        "sectionLOIr2": "0.278133333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "2",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1954",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "2",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f25ce844-c7f4-4d73-96cd-c8dd4f9aef23",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 06:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=9169928af192487e9c12464ebc0bba21&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f25ce844-c7f4-4d73-96cd-c8dd4f9aef23&isSynthetic=true&or_age=71&or_zip=79705&or_gender=m&or_householdincome=71000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "62",
        "vbrowser": "10",
        "qtime": "154.999",
        "Q14r9": "5",
        "Q14r8": "14",
        "session": "fyvp15ea8ugt0xhh",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "10",
        "Q14r4": "14",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "mqs2vxyznq6e2ca7",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 06:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "39468611759d4b989efa9b8c89734a60",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "5",
        "record": "768",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth5,/de_maxdiff/Q22/v200,/Region/reg4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "200",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Reducing air pollution and keeping our community healthy",
        "sectionLOIr4": "2.5775",
        "sectionLOIr1": "2.5775",
        "sectionLOIr3": "2.23023333333",
        "sectionLOIr2": "0.253283333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1963",
        "Q3": "12",
        "Q2": "1",
        "Q5": "2",
        "Q4": "6",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "347b3594-225b-4057-99f3-9b26cce52525",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 06:36",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=39468611759d4b989efa9b8c89734a60&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=347b3594-225b-4057-99f3-9b26cce52525&isSynthetic=true&or_age=61&or_zip=96734&or_gender=m&or_householdincome=103000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "154.054",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "1u34jfkzepgfmcjv",
        "Q41r1": "0",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "kpea5y83tt7n56nv",
        "Q22_9c2": "5",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2ec67ad1dde747f084ceb75ae196085f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "4",
        "record": "769",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v97,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "97",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Reliable power that keeps our home running smoothly and helps us take care of our family and neighbors.",
        "sectionLOIr4": "2.56535",
        "sectionLOIr1": "2.56535",
        "sectionLOIr3": "2.22223333333",
        "sectionLOIr2": "0.250216666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1979",
        "Q3": "10",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7349a768-cd43-4153-930c-3ca28caad3b4",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 06:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2ec67ad1dde747f084ceb75ae196085f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7349a768-cd43-4153-930c-3ca28caad3b4&isSynthetic=true&or_age=45&or_zip=33713&or_gender=m&or_householdincome=150000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "76",
        "vbrowser": "10",
        "qtime": "151.751",
        "Q14r9": "0",
        "Q14r8": "9",
        "session": "s1dagq1f57t6v9un",
        "Q41r1": "0",
        "Q14r1": "32",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "0",
        "uuid": "s605p99g8v11rurz",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "3",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:36",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b2607f012cbf4813b94808b763e192dd",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "770",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,/de_maxdiff/Q22/v293,sawterm:Q1.ival gt 2007,/Income/inc4,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2,/Education/edu4",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "293",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Renewable resources that help the environment but need more reliable backup. I think it's important for the future, but I'm cautious about how fast things are changing. It means using energy in a way that's better for the planet, even if it's not perfect yet.",
        "sectionLOIr4": "2.52643333333",
        "sectionLOIr1": "2.52643333333",
        "sectionLOIr3": "2.16248333333",
        "sectionLOIr2": "0.2657",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1949",
        "Q3": "5",
        "Q2": "2",
        "Q5": "6",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9a1f1b04-0d52-424b-bdd1-6089d9d6d4f8",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 06:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b2607f012cbf4813b94808b763e192dd&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9a1f1b04-0d52-424b-bdd1-6089d9d6d4f8&isSynthetic=true&or_age=76&or_zip=92029&or_gender=f&or_householdincome=89000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "38",
        "vbrowser": "10",
        "qtime": "176.913",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "rzqs840c4cdtpuzn",
        "Q41r1": "0",
        "Q14r1": "29",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "wsuukek55tjdtgvp",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "c89c5704110b4855911a374aff458c98",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "771",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,Bottom_to_Top,/Ethnicity/eth4,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v204,/Education/edu3,/Gender/gen2,/Age/age3,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "204",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Energy that doesn't pollute the air and helps keep my neighborhood safe",
        "sectionLOIr4": "2.94486666667",
        "sectionLOIr1": "2.94486666667",
        "sectionLOIr3": "2.50538333333",
        "sectionLOIr2": "0.255466666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "5",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1987",
        "Q3": "31",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "97080dbd-4a74-4f1f-95df-b831585bb93a",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "1",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/20/2026 06:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c89c5704110b4855911a374aff458c98&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=97080dbd-4a74-4f1f-95df-b831585bb93a&isSynthetic=true&or_age=38&or_zip=07836&or_gender=f&or_householdincome=40000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "50",
        "vbrowser": "10",
        "qtime": "165.866",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "ghxta3yt3nnk4gfp",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "uxmgrnj99w06grzr",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "01/20/2026 06:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d39eef36132b47bba164d5be4cc3332e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "772",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote3,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/de_maxdiff/Q22/v43,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu4",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "43",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means maybe a mix of solar and wind, but I'm not sure if it's reliable enough for everyone yet.",
        "sectionLOIr4": "2.76198333333",
        "sectionLOIr1": "2.76198333333",
        "sectionLOIr3": "2.35266666667",
        "sectionLOIr2": "0.28355",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1975",
        "Q3": "5",
        "Q2": "2",
        "Q5": "6",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "ba2309fc-46b9-4ff2-ba96-8e2806c10210",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "6",
        "date": "01/20/2026 06:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d39eef36132b47bba164d5be4cc3332e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ba2309fc-46b9-4ff2-ba96-8e2806c10210&isSynthetic=true&or_age=50&or_zip=92584&or_gender=f&or_householdincome=115000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "77",
        "vbrowser": "10",
        "qtime": "150.044",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "s15bhns9b7tkmcvs",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "h0drsqeuyukgm08u",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/20/2026 06:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "876dd74e34cb49a78dc802605f4ff0a4",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "773",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v80,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "80",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Renewable sources that help keep costs stable and the community strong",
        "sectionLOIr4": "2.49808333333",
        "sectionLOIr1": "2.49808333333",
        "sectionLOIr3": "2.14601666667",
        "sectionLOIr2": "0.283733333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1948",
        "Q3": "36",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9f05b5c3-d7b3-40bc-b180-7d6d8f2be746",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/20/2026 06:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=876dd74e34cb49a78dc802605f4ff0a4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9f05b5c3-d7b3-40bc-b180-7d6d8f2be746&isSynthetic=true&or_age=77&or_zip=45176&or_gender=f&or_householdincome=18000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "135.759",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "x4vdbb9j255vh45r",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "gdgvq0tpyt831636",
        "Q22_9c2": "7",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/20/2026 06:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "36212873bd184000b2dff83b543fcc4e",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "774",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth3,sawterm:(dvfail.r1),/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/de_maxdiff/Q22/v126,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "126",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "clean energy means reliable power from the sun, wind, and water that keeps my home safe and my budget stable",
        "sectionLOIr4": "2.25945",
        "sectionLOIr1": "2.25945",
        "sectionLOIr3": "1.9397",
        "sectionLOIr2": "0.2208",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2002",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "2",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7e841eea-d0ed-4cfd-8f91-ee19ad0a718a",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/20/2026 06:42",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=36212873bd184000b2dff83b543fcc4e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7e841eea-d0ed-4cfd-8f91-ee19ad0a718a&isSynthetic=true&or_age=23&or_zip=10940&or_gender=f&or_householdincome=64650",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "145.267",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "qqhq30uf3hzrhuau",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "2g590z7tvncm2t4g",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 06:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d8e78da318d147f9bec348ff9a5c1c02",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "775",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Education/edu2,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v4,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,/Gender/gen2,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "4",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Renewable sources like solar and wind that are growing but still face challenges",
        "sectionLOIr4": "2.41691666667",
        "sectionLOIr1": "2.41691666667",
        "sectionLOIr3": "1.98803333333",
        "sectionLOIr2": "0.2712",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "7",
        "Q1": "1999",
        "Q3": "5",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7fd282e8-cba8-4860-990b-b7bef7f62a40",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "1",
        "Q8r5": "6",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 06:42",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d8e78da318d147f9bec348ff9a5c1c02&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7fd282e8-cba8-4860-990b-b7bef7f62a40&isSynthetic=true&or_age=20&or_zip=94597&or_gender=f&or_householdincome=40000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "133.154",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "7c4e45f01dqq5sad",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "4cttwu3rf6xsjqyj",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/20/2026 06:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "8d2f477e2dd941f588056d1987e64e46",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "776",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Education/edu2,/Region/reg4,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/de_maxdiff/Q22/v292,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "292",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "reliable power without the smoke",
        "sectionLOIr4": "2.2166",
        "sectionLOIr1": "2.2166",
        "sectionLOIr3": "1.90995",
        "sectionLOIr2": "0.2633",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1998",
        "Q3": "48",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b9568764-0fe9-4f3a-b037-ef2451329c81",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/20/2026 06:42",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8d2f477e2dd941f588056d1987e64e46&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b9568764-0fe9-4f3a-b037-ef2451329c81&isSynthetic=true&or_age=27&or_zip=98682&or_gender=m&or_householdincome=34000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "178.595",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "ssgz30kcj10213wq",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "4tetrzxg341n3nny",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "92c9b147a9f44bc1b8e05adf747dbb71",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "793",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v276,/Income/inc6,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "276",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "1",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "reliable clean power, but...",
        "sectionLOIr4": "2.97523333333",
        "sectionLOIr1": "2.97523333333",
        "sectionLOIr3": "2.65131666667",
        "sectionLOIr2": "0.271166666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "3",
        "Q15r9": "4",
        "Q1": "1978",
        "Q3": "33",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e424c4b2-fc00-4622-bcea-d39cbfa80fac",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 04:37",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=92c9b147a9f44bc1b8e05adf747dbb71&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e424c4b2-fc00-4622-bcea-d39cbfa80fac&isSynthetic=true&or_age=47&or_zip=11418&or_gender=m&or_householdincome=210000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "164.088",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "a994jw5f8najh86a",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "qc1n4h88e8f8ghj3",
        "Q22_9c2": "7",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "4",
        "Q21r7": "5",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 04:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "c4a8f4e3b7754423aa871114e602beb5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "794",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Income/inc6,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,/Education/edu4,qual,/de_maxdiff/Q22/v168,/Vote/vote2,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "168",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy = solar, wind, and smart grids. Mix of old & new for steady power.",
        "sectionLOIr4": "2.73356666667",
        "sectionLOIr1": "2.73356666667",
        "sectionLOIr3": "2.31421666667",
        "sectionLOIr2": "0.291533333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1967",
        "Q3": "38",
        "Q2": "2",
        "Q5": "6",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "38b8fadf-eaf9-432e-90f9-2504ffc91126",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/21/2026 04:36",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c4a8f4e3b7754423aa871114e602beb5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=38b8fadf-eaf9-432e-90f9-2504ffc91126&isSynthetic=true&or_age=58&or_zip=97914&or_gender=f&or_householdincome=151000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "49",
        "vbrowser": "10",
        "qtime": "173.518",
        "Q14r9": "13",
        "Q14r8": "4",
        "session": "m5nvkkxckpcxzbp4",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "13",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "c2nnw33mgfuggtnz",
        "Q22_9c2": "9",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/21/2026 04:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "31d1938a107c42db84c2dcc9a9e65627",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "795",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v199,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "199",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "1",
        "Q39r2": "5",
        "Q39r3": "5",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "1",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means safer power for the environment, but I'm not sure if it's fully reliable yet. Maybe a mix of proven sources like natural gas and some new options like solar, as long as they don't disrupt my routine.",
        "sectionLOIr4": "2.88931666667",
        "sectionLOIr1": "2.88931666667",
        "sectionLOIr3": "2.43565",
        "sectionLOIr2": "0.3457",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "75",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "5",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1976",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f99a76ec-2b9d-4f2e-94a7-13d7fb05134f",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/21/2026 04:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=31d1938a107c42db84c2dcc9a9e65627&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f99a76ec-2b9d-4f2e-94a7-13d7fb05134f&isSynthetic=true&or_age=49&or_zip=33319&or_gender=m&or_householdincome=51600",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "33",
        "vbrowser": "10",
        "qtime": "189.476",
        "Q41r2": "0",
        "Q14r9": "21",
        "Q14r8": "5",
        "session": "x8jpnrfzjyb9m9sj",
        "Q41r1": "0",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "16",
        "Q14r2": "5",
        "Q14r5": "16",
        "Q14r4": "11",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "6t2b52s2z8awg2ba",
        "Q22_9c2": "1",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q22_version": "162",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "01/21/2026 04:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "35e91c0483d44047adb005d1cc167bc9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v162,/Gender/gen1,/Income/inc5,/Education/edu4,/Vote/vote4",
        "Q33": "1",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "4",
        "Q36": "2",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "5",
        "Q22_7c2": "4",
        "Q30": "2",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "1",
        "Q24": "Clean energy? I'm not sure. Sounds like buzzword. Maybe it's not reliable. Fossil fuels work, but I'm not sure if they're clean.",
        "sectionLOIr4": "3.15663333333",
        "sectionLOIr1": "3.15663333333",
        "sectionLOIr3": "2.763",
        "sectionLOIr2": "0.338483333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "6",
        "Q12": "4",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "record": "796",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "4",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "2",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1992",
        "Q3": "36",
        "Q2": "1",
        "Q5": "5",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "11",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c485de6c-e966-45ac-8190-e9659147f81d",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "2",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/21/2026 04:37",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=35e91c0483d44047adb005d1cc167bc9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c485de6c-e966-45ac-8190-e9659147f81d&isSynthetic=true&or_age=33&or_zip=45231&or_gender=m&or_householdincome=119000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "175.307",
        "Q14r9": "18",
        "Q14r8": "4",
        "session": "3ppcwhteag1yzwrh",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "9",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ndjmq6rzrgybhua5",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/21/2026 04:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "22fa86efef554b16924a0f5d2f7fc8b2",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "8",
        "record": "797",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v169,sawterm:Q1.ival gt 2007,/Gender/gen1,/Education/edu3,/Income/inc5,/Age/age3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q22_version": "169",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "Clean energy? Just a fancy term for greenwashing.",
        "sectionLOIr4": "2.91975",
        "sectionLOIr1": "2.91975",
        "sectionLOIr3": "2.32451666667",
        "sectionLOIr2": "0.2075",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "6",
        "Q12": "4",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "7",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q15r5": "0",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1983",
        "Q3": "39",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b6c44c5b-d7e2-4329-a0d9-84a3797b9a9e",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "7",
        "Q22_3c2": "4",
        "Q8r5": "6",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "6",
        "date": "01/21/2026 04:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=22fa86efef554b16924a0f5d2f7fc8b2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b6c44c5b-d7e2-4329-a0d9-84a3797b9a9e&isSynthetic=true&or_age=42&or_zip=15037&or_gender=m&or_householdincome=104000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "32",
        "vbrowser": "10",
        "qtime": "157.744",
        "Q41r2": "0",
        "Q14r9": "23",
        "Q14r8": "5",
        "session": "97h95dj521meqxpk",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "4",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "rprqu94vm7c3u9vf",
        "Q22_9c2": "9",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q22_version": "197",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "Q39r2": "4",
        "start_date": "01/21/2026 04:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "878122a5b4e1470495f7ec736babc016",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Vote/vote1,/Region/reg3,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/de_maxdiff/Q22/v197,/Overall/qual,qual,/Education/edu2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "4",
        "Q36": "4",
        "Q35": "1",
        "Q22_7c1": "4",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "6",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "0",
        "Q23": "1",
        "Q24": "Overhyped, no real help.",
        "sectionLOIr4": "2.62773333333",
        "sectionLOIr1": "2.62773333333",
        "sectionLOIr3": "2.26435",
        "sectionLOIr2": "0.266233333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "75",
        "record": "798",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1993",
        "Q3": "18",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "cd2832e3-5c55-4cb3-973f-e7e98422a078",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/21/2026 04:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=878122a5b4e1470495f7ec736babc016&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cd2832e3-5c55-4cb3-973f-e7e98422a078&isSynthetic=true&or_age=32&or_zip=40207&or_gender=m&or_householdincome=62000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "37",
        "vbrowser": "10",
        "qtime": "164.824",
        "Q41r2": "0",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "tzkdbfye81a49k76",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "10",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "2xctwrp8z39wa8c4",
        "Q22_9c2": "2",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q22_version": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "2",
        "Q21r4": "4",
        "Q21r7": "3",
        "Q21r6": "1",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/21/2026 04:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "Q39r1": "5",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "f8a98feea79d401fa20e1aecbe11ff38",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "4",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg4,/de_maxdiff/Q22/v2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3,/Vote/vote4",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "5",
        "Q35": "6",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q30": "2",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "Clean energy? Overhyped, unreliable. No real backup, just promises. My job needs steady power, not flaky solar panels.",
        "sectionLOIr4": "2.74551666667",
        "sectionLOIr1": "2.74551666667",
        "sectionLOIr3": "2.37008333333",
        "sectionLOIr2": "0.27255",
        "vctq1c21": "0",
        "Q35r6oe": "ABCDEFG",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "record": "799",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "2",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "0",
        "Q15r4": "0",
        "Q9r1": "4",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1988",
        "Q3": "5",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "0da69723-43b6-40b2-98b5-0e7b8e8803e1",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/21/2026 04:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f8a98feea79d401fa20e1aecbe11ff38&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0da69723-43b6-40b2-98b5-0e7b8e8803e1&isSynthetic=true&or_age=37&or_zip=91505&or_gender=f&or_householdincome=85000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "154.513",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "0b8m3zgg8jseya2t",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ym5zq9271jjt2a8c",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/21/2026 04:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "95f4a0103c344b0c827766465125cde0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "800",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,/de_maxdiff/Q22/v227,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "227",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Reliable safe power for my home and community",
        "sectionLOIr4": "2.57393333333",
        "sectionLOIr1": "2.57393333333",
        "sectionLOIr3": "2.23481666667",
        "sectionLOIr2": "0.276816666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "1",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1959",
        "Q3": "30",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "5ebeda7a-c2a2-4b02-8b52-28943d992c91",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 04:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=95f4a0103c344b0c827766465125cde0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5ebeda7a-c2a2-4b02-8b52-28943d992c91&isSynthetic=true&or_age=66&or_zip=03840&or_gender=m&or_householdincome=38000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "63",
        "vbrowser": "10",
        "qtime": "163.991",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "dpsgwg6nc18jv6d3",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "f52r734uktd82h9q",
        "Q22_9c2": "8",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "efccb066393e448c822e5c02a2b87ab7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "7",
        "record": "801",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v16,/Vote/vote2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc4,/Gender/gen1,/Ethnicity/eth1,/Education/edu3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "2",
        "Q22_version": "16",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means more sun & wind power for my home, which is cool! It cuts costs & keeps things running. I'm not sure about reliability yet, but hopeful it'll improve. Plus, it's good for the planet—makes me feel positive about the future!",
        "sectionLOIr4": "2.73195",
        "sectionLOIr1": "2.73195",
        "sectionLOIr3": "2.41583333333",
        "sectionLOIr2": "0.233283333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1962",
        "Q3": "48",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3f6522ff-bf2f-4c39-b519-62d74208a8bc",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "1",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/21/2026 04:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=efccb066393e448c822e5c02a2b87ab7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3f6522ff-bf2f-4c39-b519-62d74208a8bc&isSynthetic=true&or_age=63&or_zip=98059&or_gender=m&or_householdincome=76650",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "169.438",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "4rpvtp21vy68cf46",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "16",
        "Q14r2": "16",
        "Q14r5": "11",
        "Q14r4": "11",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "p1wae3rayk8wzyyb",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/21/2026 04:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "8d3c540ef4b146e0ba34047acdbde6f7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "802",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Education/edu2,/Region/reg4,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,/de_maxdiff/Q22/v28,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "28",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means solar panels and wind turbines, but I worry about costs and how it affects my budget. It's good for the future, but I need a balance with reliable sources like natural gas.",
        "sectionLOIr4": "2.82258333333",
        "sectionLOIr1": "2.82258333333",
        "sectionLOIr3": "2.41395",
        "sectionLOIr2": "0.281616666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "2",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1996",
        "Q3": "29",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "46076ed5-2b8c-4397-aa23-54b6142a89cb",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 04:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8d3c540ef4b146e0ba34047acdbde6f7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=46076ed5-2b8c-4397-aa23-54b6142a89cb&isSynthetic=true&or_age=29&or_zip=89139&or_gender=m&or_householdincome=48800",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "164.777",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "s1q45errjv6padu5",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "16",
        "Q14r2": "16",
        "Q14r5": "11",
        "Q14r4": "11",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "qpcbztx09ujwva7c",
        "Q22_9c2": "5",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/21/2026 04:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "40dc01aa7b2d4f1894843cbed29c810e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "804",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v207,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "207",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "4",
        "Q39r1": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Clean energy sounds like solar or wind, but I'm not sure about the costs. Maybe better for the air, but I worry about reliabilty.",
        "sectionLOIr4": "2.74495",
        "sectionLOIr1": "2.74495",
        "sectionLOIr3": "2.28725",
        "sectionLOIr2": "0.2771",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1978",
        "Q3": "36",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f6d06b6e-a7c1-4c35-a331-1b2b001de475",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "2",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 04:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=40dc01aa7b2d4f1894843cbed29c810e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f6d06b6e-a7c1-4c35-a331-1b2b001de475&isSynthetic=true&or_age=47&or_zip=43950&or_gender=m&or_householdincome=71300",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "169.048",
        "Q14r9": "0",
        "Q14r8": "6",
        "session": "y49kgygz290sxyrb",
        "Q41r1": "1",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "22",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "mzbr8rufsru7tn90",
        "Q22_9c2": "3",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:42",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d328517a056f4e9b9a67b81231766b62",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "805",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Education/edu4,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v163,/Income/inc5,/Ethnicity/eth1,/Gender/gen2,/Age/age3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "163",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "3",
        "Q22_4c2": "7",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "clean energy means using sun wind and water to power ur home work its good for planet and creates jobs tbh im hopeful for future progress and reliable solutions",
        "sectionLOIr4": "2.8156",
        "sectionLOIr1": "2.8156",
        "sectionLOIr3": "2.43765",
        "sectionLOIr2": "0.268116666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1983",
        "Q3": "48",
        "Q2": "2",
        "Q5": "5",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "745820f7-f352-457b-9b42-35ee4c26d2ba",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/21/2026 04:44",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d328517a056f4e9b9a67b81231766b62&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=745820f7-f352-457b-9b42-35ee4c26d2ba&isSynthetic=true&or_age=42&or_zip=98229&or_gender=f&or_householdincome=129000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "84",
        "vbrowser": "10",
        "qtime": "164.178",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "z2vwqy3xnpt5rnxe",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "91usgzntyy419vrq",
        "Q22_9c2": "5",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:43",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e7d5e9999fe443f7be6ce166ac056943",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "9",
        "record": "806",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/de_maxdiff/Q22/v34,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Income/inc4,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Education/edu3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "2",
        "Q22_version": "34",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "Sustainable adventures and reliable power!",
        "sectionLOIr4": "2.735",
        "sectionLOIr1": "2.735",
        "sectionLOIr3": "2.3888",
        "sectionLOIr2": "0.250016666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "6",
        "Q22_scorer5": "0",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1941",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "26327816-163e-4b6c-af98-20c4609fac5e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "7",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 04:46",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e7d5e9999fe443f7be6ce166ac056943&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=26327816-163e-4b6c-af98-20c4609fac5e&isSynthetic=true&or_age=84&or_zip=95682&or_gender=m&or_householdincome=87800",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "81",
        "vbrowser": "10",
        "qtime": "153.217",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "rqvkbfqzm1gzumt5",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "23",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "vc0dcxk6k5gfdwsk",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:44",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d91036ea5cc1469da3889a08413e7b56",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "807",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,/de_maxdiff/Q22/v270,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "270",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means safer air and reliable power. It's part of the mix with traditional sources for steady bills.",
        "sectionLOIr4": "2.5522",
        "sectionLOIr1": "2.5522",
        "sectionLOIr3": "2.22883333333",
        "sectionLOIr2": "0.2583",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1944",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "61c20f6a-8701-4b35-aac5-85dd8e772a97",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 04:46",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d91036ea5cc1469da3889a08413e7b56&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=61c20f6a-8701-4b35-aac5-85dd8e772a97&isSynthetic=true&or_age=81&or_zip=77384&or_gender=m&or_householdincome=41000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "172.268",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "gm5xu6p8q5s6vjfh",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "w8kr6ep68nyebbdv",
        "Q22_9c2": "5",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 04:44",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "0b8d3ac9c1484c5ca3e1241cede62b45",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "808",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth5,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v73,/Gender/gen1,/Income/inc6,/Education/edu4",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "73",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "1",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means sun wind and water power u know? Partner and I chat about it big for our community Brands like Tesla lead but I like old-school too Exciting for future growth and stability!",
        "sectionLOIr4": "2.86963333333",
        "sectionLOIr1": "2.86963333333",
        "sectionLOIr3": "2.51733333333",
        "sectionLOIr2": "0.291716666667",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "87.5",
        "HIDAge2": "4",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1979",
        "Q3": "1",
        "Q2": "1",
        "Q5": "5",
        "Q4": "1",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d93d733a-f9cb-473c-b548-cb6037c072af",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "5",
        "date": "01/21/2026 04:47",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0b8d3ac9c1484c5ca3e1241cede62b45&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d93d733a-f9cb-473c-b548-cb6037c072af&isSynthetic=true&or_age=45&or_zip=36867&or_gender=m&or_householdincome=155000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "40",
        "vbrowser": "10",
        "qtime": "184.873",
        "Q41r2": "0",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "p3fk36wq5jaecrpv",
        "Q41r1": "0",
        "Q14r1": "63",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "4",
        "Q14r2": "4",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "r4xp8cuvevv240m3",
        "Q22_9c2": "1",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q22_version": "35",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "8",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "01/21/2026 04:45",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2400a9fabea444c7a2321013421a7f94",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/de_maxdiff/Q22/v35,/Vote/vote4,/Income/inc5,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Age/age3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "2",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "4",
        "Q24": "clean energy is overhyped and unreliable, maybe not sustainable",
        "sectionLOIr4": "3.07986666667",
        "sectionLOIr1": "3.07986666667",
        "sectionLOIr3": "2.64998333333",
        "sectionLOIr2": "0.33555",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "4",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "record": "809",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1985",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "226f71bd-8922-48a0-9bd6-e812d22ca160",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/21/2026 04:48",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2400a9fabea444c7a2321013421a7f94&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=226f71bd-8922-48a0-9bd6-e812d22ca160&isSynthetic=true&or_age=40&or_zip=76103&or_gender=m&or_householdincome=60000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "96",
        "vbrowser": "10",
        "qtime": "163.942",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "m1ey4a593nbvqszz",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "vqyv5qq65bg5hat4",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 04:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2c35728219a74edbb62a2234f7263674",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "810",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Gender/gen2,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v123,/Region/reg3,sawterm:Q1.ival gt 2007,/Age/age6,/Vote/vote2,/Education/edu3,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "123",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means safer air for ur neighborhood. Maybe it's about less pollution, but I'm not sure if it's reliable yet. I trust traditional sources more, but I'm open to trying new ones if they work well.",
        "sectionLOIr4": "2.73111666667",
        "sectionLOIr1": "2.73111666667",
        "sectionLOIr3": "2.38006666667",
        "sectionLOIr2": "0.274916666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1929",
        "Q3": "41",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "7729afc3-0a27-4fab-87e6-147ae3ee513d",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/21/2026 04:49",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2c35728219a74edbb62a2234f7263674&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7729afc3-0a27-4fab-87e6-147ae3ee513d&isSynthetic=true&or_age=96&or_zip=29210&or_gender=f&or_householdincome=47000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "148.358",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "z83yx71ku96njy42",
        "Q41r1": "0",
        "Q14r1": "31",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ens54p1ayjm8f453",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 04:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "267e1d68807e41db8c470de747576b07",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "811",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v134,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "134",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "2",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means reliable, affordable power for my family. I know solar n wind are options, but I'm cautious about costs n how they fit our needs.",
        "sectionLOIr4": "2.47015",
        "sectionLOIr1": "2.47015",
        "sectionLOIr3": "2.13655",
        "sectionLOIr2": "0.244816666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1969",
        "Q3": "39",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "2",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "af4a22a2-b5c0-49c3-b683-75340eed23e9",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/21/2026 04:49",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=267e1d68807e41db8c470de747576b07&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=af4a22a2-b5c0-49c3-b683-75340eed23e9&isSynthetic=true&or_age=55&or_zip=18407&or_gender=f&or_householdincome=144350",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "147.178",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "d56vw7yyzxw2y42j",
        "Q41r1": "1",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "951phymph0ckjm4j",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "6",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "884cc3ef1f8b40179a4b1b2cb30bf4ab",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "812",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Education/edu3,/de_maxdiff/Q22/v11",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "11",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable power that's better for the planet, but tbh I'm cautious about the costs and if it's actually dependable. U know, like how it affects my bills and the stability of my home's electricity. It's a good goal, but I wanna see real results before fully trusting it.",
        "sectionLOIr4": "2.45176666667",
        "sectionLOIr1": "2.45176666667",
        "sectionLOIr3": "2.13393333333",
        "sectionLOIr2": "0.2448",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "75",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1980",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c813f281-365d-4aea-bca4-ba6675b49117",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/21/2026 04:50",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=884cc3ef1f8b40179a4b1b2cb30bf4ab&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c813f281-365d-4aea-bca4-ba6675b49117&isSynthetic=true&or_age=45&or_zip=75104&or_gender=m&or_householdincome=90000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "70",
        "vbrowser": "10",
        "qtime": "166.255",
        "Q14r9": "5",
        "Q14r8": "4",
        "session": "1papp734w24q0fwv",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "23",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "bynvnx8cmhv1grdd",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:49",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "ec955071c06c4083b658b6f73830a228",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "813",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Region/reg4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/de_maxdiff/Q22/v114,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc5,/Age/age6,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "114",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "tbh, clean energy means less pollution, but i'm careful how its done. its about reliable power that dont mess up environment. i trust established methods, so think of it as steady way keep things running without risks new stuff.",
        "sectionLOIr4": "2.76963333333",
        "sectionLOIr1": "2.76963333333",
        "sectionLOIr3": "2.29495",
        "sectionLOIr2": "0.23975",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1955",
        "Q3": "48",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "cd2a469e-3d95-4e80-8f85-a055c274cac7",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "6",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 04:51",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ec955071c06c4083b658b6f73830a228&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cd2a469e-3d95-4e80-8f85-a055c274cac7&isSynthetic=true&or_age=68&or_zip=98030&or_gender=f&or_householdincome=128186",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "165.204",
        "Q14r9": "0",
        "Q14r8": "6",
        "session": "cuv8m149uyb2dknj",
        "Q41r1": "1",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "22",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "pq16fyhf8q9bzk44",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 04:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "4c36dc54fafc40679c860a6afa8567a9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "7",
        "record": "814",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth5,/Region/reg3,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/de_maxdiff/Q22/v141,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "141",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable, safe power for our family and community! Solar panels on the roof are fresh, endless, and good for the planet. It supports jobs and keeps things stable. A win for the environment and our future!",
        "sectionLOIr4": "2.75151666667",
        "sectionLOIr1": "2.75151666667",
        "sectionLOIr3": "2.37441666667",
        "sectionLOIr2": "0.270566666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "6",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1981",
        "Q3": "18",
        "Q2": "2",
        "Q5": "2",
        "Q4": "5",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "eb6c4448-5749-4db5-bc22-1abfcc5cbaa6",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/21/2026 04:52",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4c36dc54fafc40679c860a6afa8567a9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=eb6c4448-5749-4db5-bc22-1abfcc5cbaa6&isSynthetic=true&or_age=42&or_zip=40175&or_gender=f&or_householdincome=112000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "164.896",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "4wy7rrsjd6c239vx",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "2nxpq032wveu12m2",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/21/2026 04:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "9e7bb505d70e410c996b9cc61ecae4d2",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "815",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Education/edu2,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v263,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "263",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "2",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means reliable, affordable power without the risks of fossil fuels. It’s about keeping costs down and ensuring my kids’ safety.",
        "sectionLOIr4": "2.74698333333",
        "sectionLOIr1": "2.74698333333",
        "sectionLOIr3": "2.3985",
        "sectionLOIr2": "0.277033333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1999",
        "Q3": "22",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "542a5c1e-6ecb-499c-8b5f-0119c66e90ea",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "4",
        "Q22_3c2": "1",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "01/21/2026 04:53",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=9e7bb505d70e410c996b9cc61ecae4d2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=542a5c1e-6ecb-499c-8b5f-0119c66e90ea&isSynthetic=true&or_age=20&or_zip=02189&or_gender=m&or_householdincome=45000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "24",
        "vbrowser": "10",
        "qtime": "166.991",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "xsvjjd065ga03jp5",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "pkm71wm2ymg5yx0n",
        "Q22_9c2": "2",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/21/2026 04:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "6efbe338cfd14c329238fb198ba37bfb",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "816",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,/de_maxdiff/Q22/v85,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Education/edu1",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "85",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy is reliable power for my fleet. Practical, like my Ford Bronco, but I'm open to solar if cost eff. tbh, I value sustainability but prefer proven methods.",
        "sectionLOIr4": "2.78191666667",
        "sectionLOIr1": "2.78191666667",
        "sectionLOIr3": "2.46026666667",
        "sectionLOIr2": "0.27845",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2001",
        "Q3": "14",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "0540f061-1b78-4686-9b0f-5bac43b2ebc5",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "6",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "01/21/2026 04:53",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6efbe338cfd14c329238fb198ba37bfb&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0540f061-1b78-4686-9b0f-5bac43b2ebc5&isSynthetic=true&or_age=24&or_zip=60110&or_gender=f&or_householdincome=111000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "162.298",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "vfgbhy8u1vhp16n3",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "16",
        "Q14r5": "16",
        "Q14r4": "11",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "qpya3mmdxutz07wx",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 04:52",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "3f592d6402c04fb0b5c1a0d6d76fb2a0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "817",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc1,/de_maxdiff/Q22/v248",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "248",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "5",
        "Q39r1": "5",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means power that's safe for the planet. I think it's good but want it to be reliable and not too pricey, like my Mazda.",
        "sectionLOIr4": "2.7035",
        "sectionLOIr1": "2.7035",
        "sectionLOIr3": "2.22441666667",
        "sectionLOIr2": "0.22915",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1969",
        "Q3": "1",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d8de1e1f-239c-4fa9-8762-a0193ed6ad45",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "5",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 04:55",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3f592d6402c04fb0b5c1a0d6d76fb2a0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d8de1e1f-239c-4fa9-8762-a0193ed6ad45&isSynthetic=true&or_age=54&or_zip=36608&or_gender=m&or_householdincome=16100",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "159.789",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "tb314qk23mumjcm2",
        "Q41r1": "1",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "t3s01v09sfmw9wk5",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "4",
        "Q21r7": "5",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "5a6956ed94494dd1b1901d6bbcc278e1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "818",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v174,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc7,/Gender/gen2,/Education/edu4",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "174",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "2",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "1",
        "Q22_4c2": "3",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable, sustainable power that supports our community's future while balancing practical needs with innovation.",
        "sectionLOIr4": "2.66196666667",
        "sectionLOIr1": "2.66196666667",
        "sectionLOIr3": "2.24003333333",
        "sectionLOIr2": "0.264083333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "9",
        "Q1": "1969",
        "Q3": "21",
        "Q2": "2",
        "Q5": "6",
        "Q4": "7",
        "Q6": "9",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "42e37521-957d-48db-95b3-d1ed4d360c49",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 04:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5a6956ed94494dd1b1901d6bbcc278e1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=42e37521-957d-48db-95b3-d1ed4d360c49&isSynthetic=true&or_age=55&or_zip=21722&or_gender=f&or_householdincome=238500",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "74",
        "vbrowser": "10",
        "qtime": "168.08",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "y2sczth2329y06n2",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "cm35e1rc2v07pb5f",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 04:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "a64322b0d5f9441883c64e5293cb70ea",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "819",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/de_maxdiff/Q22/v146,/Income/inc3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "2",
        "Q22_version": "146",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means fresh air for my dog's walks and safer communities for us to enjoy our time together! It's about reliable power that doesn't harm the planet, and I'm excited to see how solar and wind can keep things affordable and efficient for retirees like me!",
        "sectionLOIr4": "2.79976666667",
        "sectionLOIr1": "2.79976666667",
        "sectionLOIr3": "2.4602",
        "sectionLOIr2": "0.276583333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "2",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1951",
        "Q3": "23",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "14",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "cd2003ed-72cd-4467-b4c6-4c86d241b37b",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "5",
        "date": "01/21/2026 04:56",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a64322b0d5f9441883c64e5293cb70ea&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cd2003ed-72cd-4467-b4c6-4c86d241b37b&isSynthetic=true&or_age=74&or_zip=48021&or_gender=f&or_householdincome=36000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "171.123",
        "Q41r2": "0",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "acresasmb34snu6u",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "23",
        "Q14r2": "9",
        "Q14r5": "9",
        "Q14r4": "4",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "qwv16u946qxkm4xy",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q22_version": "100",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/21/2026 04:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b2c2d1af346b472f8e717cdb12289576",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "2",
        "Q22_1c1": "9",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/de_maxdiff/Q22/v100,/Region/reg1,/Education/edu2,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth4,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,/Income/inc2",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "3",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "5",
        "Q22_7c2": "4",
        "Q30": "2",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "4",
        "Q22_4c2": "4",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "37.5",
        "Q23": "1",
        "Q24": "clean energy sounds like a buzzword for greenwashing, maybe? i'm not sure, but it feels overhyped and not really fixing the real issues like costs and reliability",
        "sectionLOIr4": "2.84876666667",
        "sectionLOIr1": "2.84876666667",
        "sectionLOIr3": "2.34005",
        "sectionLOIr2": "0.251016666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "6",
        "Q12": "4",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "0",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "record": "820",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "2",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "0",
        "Q9r1": "2",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1998",
        "Q3": "31",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "4",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9988a048-2a86-445e-8b2e-76247e2d0b0e",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "6",
        "Q8r4": "1",
        "Q8r6": "6",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/21/2026 04:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b2c2d1af346b472f8e717cdb12289576&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9988a048-2a86-445e-8b2e-76247e2d0b0e&isSynthetic=true&or_age=26&or_zip=07092&or_gender=f&or_householdincome=48000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "136.462",
        "Q41r2": "0",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "gt5fkfdk7trryzcm",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "w4dp2vdcnnuzebbd",
        "Q22_9c2": "4",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q22_version": "230",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "1",
        "start_date": "01/21/2026 04:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "Q39r1": "5",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "73baebfcd4a84b548821646582aa26cd",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Region/reg2,/Education/edu2,/Ethnicity/eth1,/Vote/vote4,/de_maxdiff/Q22/v230,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "5",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q30": "3",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "1",
        "Q24": "Clean energy? Sounds like a fancy term for things that don't work. Maybe it's just hype without real solutions. I'm not sure how it helps when costs keep rising.",
        "sectionLOIr4": "2.27298333333",
        "sectionLOIr1": "2.27298333333",
        "sectionLOIr3": "1.87893333333",
        "sectionLOIr2": "0.286066666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "4",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "record": "822",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "4",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "2000",
        "Q3": "15",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8fe115f3-6002-480f-94fa-1381f658d534",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "5",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/21/2026 04:58",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=73baebfcd4a84b548821646582aa26cd&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fe115f3-6002-480f-94fa-1381f658d534&isSynthetic=true&or_age=25&or_zip=46703&or_gender=f&or_householdincome=34000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "72",
        "vbrowser": "10",
        "qtime": "181.591",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "2x24j9f7yz3smdm7",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "zuyvgbbun06v8dw6",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "dc3cf08e6bfb4dd2a100fd7d52b453bb",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "823",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Region/reg3,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v78,/Age/age6,/Vote/vote2,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "78",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "reduces pollution but maybe not reliable enough. I trust nuclear or natural gas more because they're dependable and I'm not sure about the costs of renewables. It's better for the environment but I worry about consistency and how it affects our budget.",
        "sectionLOIr4": "3.02435",
        "sectionLOIr1": "3.02435",
        "sectionLOIr3": "2.62876666667",
        "sectionLOIr2": "0.32095",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "2",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "5",
        "Q15r9": "6",
        "Q1": "1953",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8af1a89a-92f7-4ab4-ad55-35c5a9542dcf",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/21/2026 06:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=dc3cf08e6bfb4dd2a100fd7d52b453bb&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8af1a89a-92f7-4ab4-ad55-35c5a9542dcf&isSynthetic=true&or_age=72&or_zip=76028&or_gender=f&or_householdincome=14459",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "54",
        "vbrowser": "10",
        "qtime": "184.311",
        "Q14r9": "9",
        "Q14r8": "13",
        "session": "082tmv9h90ccqpdd",
        "Q41r1": "0",
        "Q14r1": "9",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "17",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ubkb5fetmmg12buq",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "4",
        "Q21r7": "6",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "58410e79c0d340a9808b1b29b6e7dd5a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "824",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Education/edu2,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6,/de_maxdiff/Q22/v79",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "79",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "1",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "3",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Reliable power from new sources like solar, but I still trust big companies for stability.",
        "sectionLOIr4": "3.06646666667",
        "sectionLOIr1": "3.06646666667",
        "sectionLOIr3": "2.66698333333",
        "sectionLOIr2": "0.38405",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "4",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1971",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "3",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "5901dce1-5053-424f-af9a-22a5f88263a5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/21/2026 06:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=58410e79c0d340a9808b1b29b6e7dd5a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5901dce1-5053-424f-af9a-22a5f88263a5&isSynthetic=true&or_age=53&or_zip=77099&or_gender=m&or_householdincome=158300",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "173.384",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "f08vw646675009hd",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "6wqkkpdswgtr7wtm",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d8b943fae58249baab08df4fea8e3989",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "825",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v198,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "198",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Reliable, proven sources like solar and wind that keep the lights on without surprises. Maybe some risks, but I trust the big companies more than new ideas.",
        "sectionLOIr4": "2.88628333333",
        "sectionLOIr1": "2.88628333333",
        "sectionLOIr3": "2.55356666667",
        "sectionLOIr2": "0.30875",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1957",
        "Q3": "45",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "95d277be-4c68-4ee1-9f03-7dd4af4b3d67",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 06:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d8b943fae58249baab08df4fea8e3989&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=95d277be-4c68-4ee1-9f03-7dd4af4b3d67&isSynthetic=true&or_age=68&or_zip=84003&or_gender=m&or_householdincome=112788",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "35",
        "vbrowser": "10",
        "qtime": "208.563",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "dywhuwa212e7yre3",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "uwq2e6avgkh7qydn",
        "Q22_9c2": "1",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q30": "5",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/21/2026 06:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "18878eac05c1427bb55b24ffe630049e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "6",
        "Q22_1c1": "9",
        "record": "826",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Education/edu4,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v81,/Gender/gen1,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "81",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "5",
        "Q39r4": "1",
        "Q22_7c2": "2",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "6",
        "Q22_4c2": "6",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "Solar and wind mean bold steps toward a sustainable future!",
        "sectionLOIr4": "3.47171666667",
        "sectionLOIr1": "3.47171666667",
        "sectionLOIr3": "3.11448333333",
        "sectionLOIr2": "0.3689",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "3",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "3",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "7",
        "Q22_scorer6": "0",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "10",
        "Q15r5": "10",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1990",
        "Q3": "10",
        "Q2": "1",
        "Q5": "5",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "6",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "3a4c3789-6f72-4121-8805-a2c084f47c14",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=18878eac05c1427bb55b24ffe630049e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3a4c3789-6f72-4121-8805-a2c084f47c14&isSynthetic=true&or_age=35&or_zip=34223&or_gender=m&or_householdincome=58000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "188.646",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "t3qsr8yfz293qs6p",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "rq0hak09j6kgsgd5",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e6c2267bde454ecda46fdb6e334131fe",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "827",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v20,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "20",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "2",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "something dependable, but I'm careful about how it's implemented",
        "sectionLOIr4": "3.13823333333",
        "sectionLOIr1": "3.13823333333",
        "sectionLOIr3": "2.75398333333",
        "sectionLOIr2": "0.24705",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "2",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "5",
        "Q15r5": "0",
        "Q15r6": "1",
        "Q15r7": "7",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "4",
        "Q1": "1967",
        "Q3": "21",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8c927d6d-8907-46e8-85c7-24486bc35698",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:12",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e6c2267bde454ecda46fdb6e334131fe&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8c927d6d-8907-46e8-85c7-24486bc35698&isSynthetic=true&or_age=58&or_zip=20707&or_gender=m&or_householdincome=135000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "34",
        "vbrowser": "10",
        "qtime": "172.273",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "adzhnq8gr8s4xpfd",
        "Q41r1": "1",
        "Q14r1": "18",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "fdwwha5xnm1gsxac",
        "Q22_9c2": "5",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "3",
        "Q21r7": "6",
        "Q21r6": "5",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/21/2026 06:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "0b367c53c3ac4b6f90b2cb160e55a07b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "828",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v218,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "218",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Reduces pollution, supports local jobs.",
        "sectionLOIr4": "2.86455",
        "sectionLOIr1": "2.86455",
        "sectionLOIr3": "2.45738333333",
        "sectionLOIr2": "0.26755",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "9",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1991",
        "Q3": "35",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e61fe2c6-b335-4080-a9ad-2d694b272c1f",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:11",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0b367c53c3ac4b6f90b2cb160e55a07b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e61fe2c6-b335-4080-a9ad-2d694b272c1f&isSynthetic=true&or_age=34&or_zip=58078&or_gender=f&or_householdincome=116000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "191.803",
        "Q14r9": "9",
        "Q14r8": "13",
        "session": "cxgh3tpmwd1p93g3",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "cdt67vhp4zz14x2z",
        "Q22_9c2": "3",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "7847532b620248b08d2ecbab17d12ae1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "829",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v181,/Gender/gen1,/Income/inc4,Top_to_Bottom,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "181",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means less pollution, but I need it to be dependable for my job and home.",
        "sectionLOIr4": "3.19261666667",
        "sectionLOIr1": "3.19261666667",
        "sectionLOIr3": "2.82076666667",
        "sectionLOIr2": "0.31365",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "0",
        "HIDAge2": "2",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1995",
        "Q3": "36",
        "Q2": "1",
        "Q5": "2",
        "Q4": "3",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "2f931b66-884b-4c23-baab-742e868bff34",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:12",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7847532b620248b08d2ecbab17d12ae1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=2f931b66-884b-4c23-baab-742e868bff34&isSynthetic=true&or_age=30&or_zip=44055&or_gender=m&or_householdincome=81300",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "168.614",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "4u52frss80u5mj1g",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "19hx458yx3pxwr4m",
        "Q22_9c2": "7",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/21/2026 06:09",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "1a47aad9e1af4acfb012805915108cd5",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "830",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v290,qual,sawterm:Q1.ival gt 2007,/Income/inc4,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "290",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Reliable power that's good for the environment, but I'm not sure how fast the shift will happen.",
        "sectionLOIr4": "2.80635",
        "sectionLOIr1": "2.80635",
        "sectionLOIr3": "2.33765",
        "sectionLOIr2": "0.289",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "2",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "2",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "6",
        "Q1": "2000",
        "Q3": "8",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c25ffae3-a65c-4993-8ace-943629a9483d",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 06:12",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1a47aad9e1af4acfb012805915108cd5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c25ffae3-a65c-4993-8ace-943629a9483d&isSynthetic=true&or_age=25&or_zip=19945&or_gender=f&or_householdincome=73000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "24",
        "vbrowser": "10",
        "qtime": "186.013",
        "Q41r2": "0",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "8gmu6ecrdcpf2g42",
        "Q41r1": "0",
        "Q14r1": "29",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "85vx3h6g59j639wu",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q22_version": "186",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "1",
        "Q21r7": "4",
        "Q21r6": "2",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/21/2026 06:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "5a4f3a0d26dd4a45a6c563742e736e77",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "4",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Ethnicity/eth5,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/de_maxdiff/Q22/v186,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "5",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "9",
        "Q39r4": "5",
        "Q22_7c2": "1",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "4",
        "Q22_4c2": "5",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "1",
        "Q24": "Clean energy means another way for politicians to spend money while the real problem is rising bills and unstable grids. It's a buzzword that doesn't solve anything for people like me who need reliable power.",
        "sectionLOIr4": "3.09575",
        "sectionLOIr1": "3.09575",
        "sectionLOIr3": "2.56198333333",
        "sectionLOIr2": "0.25625",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "37.5",
        "record": "831",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "8",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "2001",
        "Q3": "47",
        "Q2": "1",
        "Q5": "3",
        "Q4": "5",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "beb44d02-09e9-41e9-9615-74320bff7a5b",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/21/2026 06:15",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5a4f3a0d26dd4a45a6c563742e736e77&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=beb44d02-09e9-41e9-9615-74320bff7a5b&isSynthetic=true&or_age=24&or_zip=23061&or_gender=m&or_householdincome=101600",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "170.494",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "ayc190puye8c49tv",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "13",
        "Q14r5": "18",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "gwsfdue14s5xbzus",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "1",
        "Q43": "2",
        "start_date": "01/21/2026 06:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "cbdb01524bfe437792ab0c38c281931b",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "832",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v297,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "297",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Reliable, affordable power that keeps our lights on and our kid's toys running without breaking the bank.",
        "sectionLOIr4": "2.83901666667",
        "sectionLOIr1": "2.83901666667",
        "sectionLOIr3": "2.41358333333",
        "sectionLOIr2": "0.291",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2003",
        "Q3": "33",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "943b5821-a2cd-4661-89a7-807870e811ac",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "6",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "6",
        "date": "01/21/2026 06:15",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=cbdb01524bfe437792ab0c38c281931b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=943b5821-a2cd-4661-89a7-807870e811ac&isSynthetic=true&or_age=22&or_zip=10003&or_gender=m&or_householdincome=61000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "165.81",
        "Q14r9": "4",
        "Q14r8": "13",
        "session": "t83y03y9k5avzedq",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "dp2fb93ehzr5xrtx",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "6",
        "Q21r7": "5",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b1c5b6cec3074b668f736d9d90a348a1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "833",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,Bottom_to_Top,/Ethnicity/eth4,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v280,sawterm:Q1.ival gt 2007,/Gender/gen1,/Education/edu3,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "280",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Stable power for my gadgets and home. Solar for the dogs’ walks, natural gas for basics, but I’m cautious about claims that ignore real-world reliability.",
        "sectionLOIr4": "2.76033333333",
        "sectionLOIr1": "2.76033333333",
        "sectionLOIr3": "2.38156666667",
        "sectionLOIr2": "0.277516666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "0",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1983",
        "Q3": "39",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5a4ba84a-cee6-44a9-a7e3-e16a54cddc6b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/21/2026 06:15",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b1c5b6cec3074b668f736d9d90a348a1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5a4ba84a-cee6-44a9-a7e3-e16a54cddc6b&isSynthetic=true&or_age=42&or_zip=16502&or_gender=m&or_householdincome=74700",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "170.832",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "rqkab12nms3c7pjm",
        "Q41r1": "1",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "fhgy6fdupfnyuq0d",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "fa86428114c7492e90cce83a273e00e2",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "6",
        "record": "834",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Education/edu4,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v212,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "212",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "4",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable, established sources that support long-term stability and community growth, but I'm cautious about newer tech's reliability and costs.",
        "sectionLOIr4": "2.8451",
        "sectionLOIr1": "2.8451",
        "sectionLOIr3": "2.49216666667",
        "sectionLOIr2": "0.265633333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1989",
        "Q3": "36",
        "Q2": "1",
        "Q5": "6",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "9d719232-dfa6-4c89-8e84-f2f75e1ac271",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "6",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/21/2026 06:15",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=fa86428114c7492e90cce83a273e00e2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9d719232-dfa6-4c89-8e84-f2f75e1ac271&isSynthetic=true&or_age=36&or_zip=45402&or_gender=m&or_householdincome=109000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "35",
        "vbrowser": "10",
        "qtime": "172.077",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "w3ex0vmb4uwq4mzd",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "pfk0z17wwvaf9965",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:15",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "929abb779a984140a8b554afbbf8e58b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "835",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v252,/Income/inc4,/Gender/gen1,/Ethnicity/eth1,/Education/edu3,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "252",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Reliable, cost-effective power that supports my work and lifestyle without risky overhauls.",
        "sectionLOIr4": "2.86556666667",
        "sectionLOIr1": "2.86556666667",
        "sectionLOIr3": "2.52686666667",
        "sectionLOIr2": "0.27035",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "0",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1990",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "297e2d32-bc8f-46c5-a4d9-67f4f5b32d99",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "2",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/21/2026 06:18",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=929abb779a984140a8b554afbbf8e58b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=297e2d32-bc8f-46c5-a4d9-67f4f5b32d99&isSynthetic=true&or_age=35&or_zip=95320&or_gender=m&or_householdincome=95000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "64",
        "vbrowser": "10",
        "qtime": "218.679",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "1xyzr705wsnk9nct",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "axya5c0aq9qa60m4",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "78e2d68336d3473a9231acc9aa1915b7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "836",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/de_maxdiff/Q22/v209,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "209",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "5",
        "Q22_6c1": "9",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Safer communities, but I'm cautious about costs and if it's dependable.",
        "sectionLOIr4": "3.64233333333",
        "sectionLOIr1": "3.64233333333",
        "sectionLOIr3": "3.12821666667",
        "sectionLOIr2": "0.273616666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1961",
        "Q3": "14",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8dccd58e-d5ec-4f87-a25a-a3b8b7e2fff9",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "5",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "1",
        "date": "01/21/2026 06:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=78e2d68336d3473a9231acc9aa1915b7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8dccd58e-d5ec-4f87-a25a-a3b8b7e2fff9&isSynthetic=true&or_age=62&or_zip=60106&or_gender=m&or_householdincome=38000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "180.135",
        "Q14r9": "2",
        "Q14r8": "10",
        "session": "tpsh1z3y3rekz9kb",
        "Q41r1": "1",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "yattmg6dhvakb7ht",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4ebf0e7ec3be4ef79edf24fff4e0efd9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "6",
        "record": "837",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Education/edu2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v45,/Gender/gen1,/Ethnicity/eth1,/Income/inc5",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "45",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "3",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means solar panels on my roof, but I worry about if they work well in California's weather. It's good for the kids' health and the planet, but I want it to be dependable.",
        "sectionLOIr4": "3.00011666667",
        "sectionLOIr1": "3.00011666667",
        "sectionLOIr3": "2.60595",
        "sectionLOIr2": "0.313716666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1972",
        "Q3": "5",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "3",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "713d24e4-f57f-4fe6-862a-ca6b13ad11f9",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4ebf0e7ec3be4ef79edf24fff4e0efd9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=713d24e4-f57f-4fe6-862a-ca6b13ad11f9&isSynthetic=true&or_age=52&or_zip=94555&or_gender=m&or_householdincome=107500",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "163.344",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "3rkyxxcsjamatbsk",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "20y2bdzbw6xnm4mg",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "5",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "046b5d81669c45089cc4294ae7433a41",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "838",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/Ethnicity/eth3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Age/age3,/de_maxdiff/Q22/v151",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "151",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Energy that's good for the planet but I stick to trusted, stable sources.",
        "sectionLOIr4": "2.72025",
        "sectionLOIr1": "2.72025",
        "sectionLOIr3": "2.3782",
        "sectionLOIr2": "0.24385",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1989",
        "Q3": "3",
        "Q2": "1",
        "Q5": "3",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "db68cc02-8845-4b94-8b8d-28a23232c750",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=046b5d81669c45089cc4294ae7433a41&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=db68cc02-8845-4b94-8b8d-28a23232c750&isSynthetic=true&or_age=36&or_zip=85022&or_gender=m&or_householdincome=97500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "48",
        "vbrowser": "10",
        "qtime": "162.256",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "aqpwhhjvby1yjtu3",
        "Q41r1": "0",
        "Q14r1": "42",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "8",
        "Q14r2": "13",
        "Q14r5": "9",
        "Q14r4": "8",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ed4qbzd1crfy1xzw",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/21/2026 06:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "cfe6fb8b062d423f84b8b7f544e6d2e1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "839",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,/Education/edu3,/de_maxdiff/Q22/v216",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "216",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "solar panels and dependable power. Maybe it's a good step, but I'm not sure about the risks.",
        "sectionLOIr4": "2.70185",
        "sectionLOIr1": "2.70185",
        "sectionLOIr3": "2.27976666667",
        "sectionLOIr2": "0.243366666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "6",
        "Q1": "1977",
        "Q3": "45",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "56f4f55b-59de-4cf6-b1cc-453caed7ccc6",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "6",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/21/2026 06:22",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=cfe6fb8b062d423f84b8b7f544e6d2e1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=56f4f55b-59de-4cf6-b1cc-453caed7ccc6&isSynthetic=true&or_age=47&or_zip=84020&or_gender=f&or_householdincome=125600",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "24",
        "vbrowser": "10",
        "qtime": "177.383",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "k9cd2zau940exy85",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "z4ywpxt2rurvgn5c",
        "Q22_9c2": "6",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 06:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "916ec65675734ba1a4e9ebc571ee42a3",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "840",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v30,/Region/reg3,/Ethnicity/eth1,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,sawterm:(dvfail.r1),/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "30",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "clean energy means safer air and reliable power but i prefer trusted methods",
        "sectionLOIr4": "2.95301666667",
        "sectionLOIr1": "2.95301666667",
        "sectionLOIr3": "2.57505",
        "sectionLOIr2": "0.23895",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "2001",
        "Q3": "18",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c8ae21d7-508a-40f0-909f-726ece8718a1",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/21/2026 06:22",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=916ec65675734ba1a4e9ebc571ee42a3&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c8ae21d7-508a-40f0-909f-726ece8718a1&isSynthetic=true&or_age=24&or_zip=42101&or_gender=m&or_householdincome=56000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "79",
        "vbrowser": "10",
        "qtime": "168.711",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "22pjs27x32hb984z",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "g180yvf2a6s0af3b",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 06:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "5a3c005a1e374fd89aa87a0cb61a30b4",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "841",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Ethnicity/eth3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Region/reg3,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v239,/Income/inc5,/Age/age6,/Vote/vote2,/Education/edu4",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "239",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "reliable power for schools and homes safer air for kids steady support for local jobs",
        "sectionLOIr4": "2.80851666667",
        "sectionLOIr1": "2.80851666667",
        "sectionLOIr3": "2.46255",
        "sectionLOIr2": "0.265966666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1946",
        "Q3": "37",
        "Q2": "2",
        "Q5": "5",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "98a37e58-9d0f-40f8-aba9-c8cd762f8264",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "5",
        "date": "01/21/2026 06:22",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5a3c005a1e374fd89aa87a0cb61a30b4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=98a37e58-9d0f-40f8-aba9-c8cd762f8264&isSynthetic=true&or_age=79&or_zip=73701&or_gender=f&or_householdincome=36000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "41",
        "vbrowser": "10",
        "qtime": "179.301",
        "Q14r9": "0",
        "Q14r8": "6",
        "session": "61md38nzyp6f2h2y",
        "Q41r1": "0",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "22",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "sv71ezfrqk2g4n0w",
        "Q22_9c2": "2",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:20",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "9333c2abe2784bfdae1734f1725fb363",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "842",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v96,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "96",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means a bright future for my community and economy. Solar and wind power are exciting, but natural gas keeps things stable. It supports jobs and keeps costs down. A smart step forward that works for everyone!",
        "sectionLOIr4": "2.9853",
        "sectionLOIr1": "2.9853",
        "sectionLOIr3": "2.57323333333",
        "sectionLOIr2": "0.30795",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1984",
        "Q3": "41",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d5e56c9d-3968-4d16-82dc-9963da08f24f",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 06:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=9333c2abe2784bfdae1734f1725fb363&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d5e56c9d-3968-4d16-82dc-9963da08f24f&isSynthetic=true&or_age=41&or_zip=29588&or_gender=f&or_householdincome=33000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "166.886",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "2dhqwhaccpp99ju0",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "gttetx82jyd6cje1",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "5",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/21/2026 06:22",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "8ac22c8e651d4869a0ffc1d6a98e6944",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "3",
        "record": "843",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth4,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v145,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "145",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Reliable power that doesn't cost too much. Maybe solar or wind but I'm not sure if they're steady enough. I prefer proven methods but open to alternatives.",
        "sectionLOIr4": "2.77878333333",
        "sectionLOIr1": "2.77878333333",
        "sectionLOIr3": "2.42143333333",
        "sectionLOIr2": "0.255283333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "0",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "4",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1959",
        "Q3": "39",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "4",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "228714d3-3342-447d-bf79-8c1de54eddfd",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/21/2026 06:25",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8ac22c8e651d4869a0ffc1d6a98e6944&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=228714d3-3342-447d-bf79-8c1de54eddfd&isSynthetic=true&or_age=65&or_zip=17111&or_gender=m&or_householdincome=32000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "57",
        "vbrowser": "10",
        "qtime": "156.818",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "xjam5wq4tuxnb3e0",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "z99g10cbd85c8jsf",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/21/2026 06:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2779c5ba64c6474cb924a08be711d882",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "844",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc3,/de_maxdiff/Q22/v108",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "108",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Stable power for work and living",
        "sectionLOIr4": "2.61016666667",
        "sectionLOIr1": "2.61016666667",
        "sectionLOIr3": "2.26001666667",
        "sectionLOIr2": "0.250316666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1968",
        "Q3": "47",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "de1ad0e2-4047-47dd-be69-ce13b7557b06",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:25",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2779c5ba64c6474cb924a08be711d882&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=de1ad0e2-4047-47dd-be69-ce13b7557b06&isSynthetic=true&or_age=57&or_zip=20147&or_gender=m&or_householdincome=55000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "192.658",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "8zbvqdv77yzhjhun",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "bqx81tpm1mb67377",
        "Q22_9c2": "1",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 06:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "53ad30eac1fb45bfb20a43ed178f499c",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "845",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Education/edu2,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v72,/Gender/gen1,/Income/inc4",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "72",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Solar panels on the roof but worried about upfront costs and reliability",
        "sectionLOIr4": "3.20856666667",
        "sectionLOIr1": "3.20856666667",
        "sectionLOIr3": "2.87231666667",
        "sectionLOIr2": "0.246116666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "100",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1998",
        "Q3": "39",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "4812c68b-a2c5-41b1-8fc7-23b4e77a7414",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 06:26",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=53ad30eac1fb45bfb20a43ed178f499c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4812c68b-a2c5-41b1-8fc7-23b4e77a7414&isSynthetic=true&or_age=27&or_zip=18334&or_gender=m&or_householdincome=83000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "179.722",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "5xpjjb2nz0syvmaz",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "18",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "enq02y19883re291",
        "Q22_9c2": "2",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 06:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "80ba65e852464a16a8f46f61492b1011",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "846",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v157,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "157",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "reliable power and safer air",
        "sectionLOIr4": "2.99311666667",
        "sectionLOIr1": "2.99311666667",
        "sectionLOIr3": "2.63143333333",
        "sectionLOIr2": "0.263216666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1967",
        "Q3": "45",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "27a1f0df-64be-44fb-9c7a-ad408c0dfd43",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 06:26",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=80ba65e852464a16a8f46f61492b1011&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=27a1f0df-64be-44fb-9c7a-ad408c0dfd43&isSynthetic=true&or_age=58&or_zip=84103&or_gender=f&or_householdincome=70400",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "63",
        "vbrowser": "10",
        "qtime": "199.331",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "6uzbjdw88k0um3te",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "a5w0xct96ppp4xuk",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 06:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "8e477e08212642fba00ad814ca2e44c0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "9",
        "record": "847",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v228,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Income/inc5,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "228",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "solar panels and wind farms. It means cleaner air for my family and a way to use nature's power. I like the innovation but think costs need to drop for it to be fully reliable.",
        "sectionLOIr4": "3.3181",
        "sectionLOIr1": "3.3181",
        "sectionLOIr3": "2.95683333333",
        "sectionLOIr2": "0.312833333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "3",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1962",
        "Q3": "48",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "58894c85-c07f-4138-9f27-41cba5738341",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8e477e08212642fba00ad814ca2e44c0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=58894c85-c07f-4138-9f27-41cba5738341&isSynthetic=true&or_age=63&or_zip=98226&or_gender=m&or_householdincome=126000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "156.076",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "eeq7hes9e55dfuq5",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "cch4uuk2z71jpguw",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/21/2026 06:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "df1410f7e47e45c1ba224040bbe91f6d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "848",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v175,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "175",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "4",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means using solar or wind, but I worry about reliability. Nuclear and hydropower feel more dependable for my needs.",
        "sectionLOIr4": "2.5963",
        "sectionLOIr1": "2.5963",
        "sectionLOIr3": "2.22863333333",
        "sectionLOIr2": "0.266333333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1957",
        "Q3": "46",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f06bf076-bd4d-4daa-a0c8-ecc67d2e020f",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/21/2026 06:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=df1410f7e47e45c1ba224040bbe91f6d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f06bf076-bd4d-4daa-a0c8-ecc67d2e020f&isSynthetic=true&or_age=68&or_zip=05641&or_gender=m&or_householdincome=54481",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "69",
        "vbrowser": "10",
        "qtime": "160.871",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "ycx1wztumxsynz5r",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "zny864cmsknzjr9w",
        "Q22_9c2": "1",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "5",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/21/2026 06:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "ebc9500495d24b49869c5e06211aa366",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "9",
        "record": "849",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,/de_maxdiff/Q22/v37,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "37",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "Power that's reliable and cuts pollution.",
        "sectionLOIr4": "2.67635",
        "sectionLOIr1": "2.67635",
        "sectionLOIr3": "2.34745",
        "sectionLOIr2": "0.223866666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "1",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "6",
        "Q1": "1956",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "2",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d0983db5-751d-481b-ae22-6fbfeb973d55",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "6",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/21/2026 06:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ebc9500495d24b49869c5e06211aa366&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d0983db5-751d-481b-ae22-6fbfeb973d55&isSynthetic=true&or_age=69&or_zip=14534&or_gender=f&or_householdincome=45000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "171.558",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "hcwbw4y9j6jybr5r",
        "Q41r1": "0",
        "Q14r1": "39",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "13",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "r9gpf2yb81hrn730",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/21/2026 06:27",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "1c5b0ab46f0a4794b29a15392c4d377f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "850",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v188,/Ethnicity/eth4,/Region/reg2,/Gender/gen2,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc7,/Age/age6,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "188",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "6",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Solar and wind power that's dependable and keeps costs steady. My dogs and I need reliable energy so I stick to what's proven.",
        "sectionLOIr4": "2.85368333333",
        "sectionLOIr1": "2.85368333333",
        "sectionLOIr3": "2.47213333333",
        "sectionLOIr2": "0.286166666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1959",
        "Q3": "36",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "8",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "bdddbc82-09ee-4feb-adbe-58c07d77653c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/21/2026 06:30",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1c5b0ab46f0a4794b29a15392c4d377f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=bdddbc82-09ee-4feb-adbe-58c07d77653c&isSynthetic=true&or_age=66&or_zip=45042&or_gender=f&or_householdincome=30000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "145.086",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "m8y6py5daevvvhrb",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "b8g0trwkyk727bpb",
        "Q22_9c2": "9",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 06:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c93c569080cc4d62a4ce6058dd02c947",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "4",
        "Q22_1c1": "3",
        "record": "851",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v250,Top_to_Bottom,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "250",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "Reliable power with some sustainable future, but I'm cautious about costs and infrastructure needs.",
        "sectionLOIr4": "2.41541666667",
        "sectionLOIr1": "2.41541666667",
        "sectionLOIr3": "2.07206666667",
        "sectionLOIr2": "0.274983333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "2",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "12.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1999",
        "Q3": "11",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "25b771bb-5c55-4a1d-8b90-43ef944bff03",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 06:32",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c93c569080cc4d62a4ce6058dd02c947&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=25b771bb-5c55-4a1d-8b90-43ef944bff03&isSynthetic=true&or_age=26&or_zip=30642&or_gender=m&or_householdincome=85000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "183.356",
        "Q41r2": "0",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "98jdt2f5xaac9k8w",
        "Q41r1": "0",
        "Q14r1": "45",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "9",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "9tdjvwzhd9b34ve6",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q22_version": "255",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "4",
        "Q21r7": "1",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "1",
        "Q39r2": "3",
        "start_date": "01/21/2026 06:30",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d6a72b89681641ea906b32d82dbdb349",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "1",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "5",
        "markers": "qualified,/Vote/vote1,/Region/reg4,Bottom_to_Top,/de_maxdiff/Q22/v255,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,/Income/inc7,/Education/edu3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "5",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "2",
        "Q39r4": "5",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "4",
        "Q22_4c2": "9",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "Overhyped and unreliable",
        "sectionLOIr4": "3.0534",
        "sectionLOIr1": "3.0534",
        "sectionLOIr3": "2.68993333333",
        "sectionLOIr2": "0.255216666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "4",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "75",
        "record": "852",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "0",
        "Q9r1": "2",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1996",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "7",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "34b0432c-ad4a-430f-b78e-d2fec233de1c",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/21/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d6a72b89681641ea906b32d82dbdb349&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=34b0432c-ad4a-430f-b78e-d2fec233de1c&isSynthetic=true&or_age=28&or_zip=95616&or_gender=m&or_householdincome=225400",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "25",
        "vbrowser": "10",
        "qtime": "157.22",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "8qyqh68k5c71g5uz",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "0kc80fvpgrnc4dgd",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "3",
        "Q21r2": "1",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "6",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 07:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "9050a503dc4b4a7fb608b0313b24f070",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "853",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v240,/Gender/gen2,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "240",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Reliable, affordable power for our community. I trust government-led solar and wind projects to keep costs stable and support local jobs. It’s about sustainability without sacrificing everyday needs.",
        "sectionLOIr4": "2.61903333333",
        "sectionLOIr1": "2.61903333333",
        "sectionLOIr3": "2.24491666667",
        "sectionLOIr2": "0.2785",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "75",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "2000",
        "Q3": "19",
        "Q2": "2",
        "Q5": "4",
        "Q4": "2",
        "Q6": "3",
        "Q22_8c2": "6",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "eb6d809f-bd78-413f-932c-900c8cd808ec",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 07:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=9050a503dc4b4a7fb608b0313b24f070&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=eb6d809f-bd78-413f-932c-900c8cd808ec&isSynthetic=true&or_age=25&or_zip=70460&or_gender=f&or_householdincome=73000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "79",
        "vbrowser": "10",
        "qtime": "162.303",
        "Q14r9": "9",
        "Q14r8": "13",
        "session": "548mg4v9snkcgd8c",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "c3dk411jxtn9qz8c",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "01/21/2026 07:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "199bd3f52eb24bc9a8262f25799479f4",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "9",
        "record": "854",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/de_maxdiff/Q22/v103,/Ethnicity/eth4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "103",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "tbh clean energy means less smog for my walks but i'm not sold on the hype. it's a start but i still need reliable stuff. my smartwatch tracks steps not emissions. i see value but worry about costs and if it's actually better than what we've got",
        "sectionLOIr4": "2.70385",
        "sectionLOIr1": "2.70385",
        "sectionLOIr3": "2.3871",
        "sectionLOIr2": "0.3191",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1946",
        "Q3": "33",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "fc9b00f7-05e9-4a80-84ff-a8c02d692ed7",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "8",
        "Q22_3c2": "1",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 07:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=199bd3f52eb24bc9a8262f25799479f4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=fc9b00f7-05e9-4a80-84ff-a8c02d692ed7&isSynthetic=true&or_age=79&or_zip=11378&or_gender=f&or_householdincome=21141",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "144.61",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "rz6dhakq2tna1fee",
        "Q41r1": "0",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "hcd777mqx2dapa4n",
        "Q22_9c2": "5",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "3",
        "Q21r7": "6",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "df4c487c897f4d8ba10c74b224d8528c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "855",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Income/inc6,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v251,/Gender/gen2,/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "251",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "Clean energy means reliable, affordable power for everyday needs and safer communities.",
        "sectionLOIr4": "2.4088",
        "sectionLOIr1": "2.4088",
        "sectionLOIr3": "2.09065",
        "sectionLOIr2": "0.279566666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "2",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "0",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1983",
        "Q3": "36",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a659e418-c5c0-4fdf-9389-1271f299241e",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/21/2026 07:18",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=df4c487c897f4d8ba10c74b224d8528c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a659e418-c5c0-4fdf-9389-1271f299241e&isSynthetic=true&or_age=41&or_zip=43522&or_gender=f&or_householdincome=170500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "161.08",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "nyxhtae8v4ckz092",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "kxqjxpzyuf4p4498",
        "Q22_9c2": "2",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 07:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "ba728e145f894732b75309b632505df1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "856",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v63,/Income/inc4,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "63",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "2",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "tbh clean energy means safer air for my students and community but i worry about reliability. it's good for the planet but sometimes feels like a buzzword. i think a mix of old and new works best, like solar with backup. ur spouse and i talk about how it affects our bills and the environment. need to balance costs and benefits without overpromising.",
        "sectionLOIr4": "2.68331666667",
        "sectionLOIr1": "2.68331666667",
        "sectionLOIr3": "2.36635",
        "sectionLOIr2": "0.268683333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1978",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "2",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "783c76d1-636f-480c-b9ab-335011621288",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 07:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ba728e145f894732b75309b632505df1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=783c76d1-636f-480c-b9ab-335011621288&isSynthetic=true&or_age=47&or_zip=76131&or_gender=f&or_householdincome=89000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "187.445",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "21rzk8hjr1cnkn0v",
        "Q41r1": "1",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "x8mvbc2nq05k22ua",
        "Q22_9c2": "3",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "7",
        "Q21r7": "4",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c9f52415098b47738b357a7c0370d80d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "7",
        "record": "857",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/de_maxdiff/Q22/v122,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc7,/Gender/gen1,/Education/edu3,/Age/age3",
        "Q33": "1",
        "Q32": "1",
        "Q31": "2",
        "Q22_version": "122",
        "Q35": "6",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "1",
        "Q39r1": "2",
        "Q22_6c1": "5",
        "Q22_6c2": "3",
        "Q22_4c2": "8",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "to me it's about future-proofing the industry with solar and wind plus smart grids. it's a mix of innovation and reliability which fits my risk-tolerant style and tech love",
        "sectionLOIr4": "3.1229",
        "sectionLOIr1": "3.1229",
        "sectionLOIr3": "2.72676666667",
        "sectionLOIr2": "0.24295",
        "vctq1c21": "0",
        "Q35r6oe": "ABCDEFG",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "1",
        "Q13": "1",
        "Q12": "1",
        "Q22_scorer7": "100",
        "HIDAge2": "3",
        "Q22_scorer5": "75",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "10",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1983",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "7",
        "Q22_8c2": "6",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b21d1b40-5b29-4f92-94b7-a69f2cc18f2b",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "7",
        "Q22_3c2": "4",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 07:22",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c9f52415098b47738b357a7c0370d80d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=b21d1b40-5b29-4f92-94b7-a69f2cc18f2b&isSynthetic=true&or_age=42&or_zip=76133&or_gender=m&or_householdincome=335000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "31",
        "vbrowser": "10",
        "qtime": "161.636",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "ytpzuz6wznu0fnrw",
        "Q41r1": "1",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "18",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "pv0tb7r93h14dnss",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/21/2026 07:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "5136158d08c04c46869bc56156675165",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "858",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,/de_maxdiff/Q22/v247,qual,sawterm:Q1.ival gt 2007,/Income/inc7,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "247",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "1",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "2",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "local jobs and tax support",
        "sectionLOIr4": "2.68988333333",
        "sectionLOIr1": "2.68988333333",
        "sectionLOIr3": "2.23863333333",
        "sectionLOIr2": "0.2283",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "2",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "9",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "9",
        "Q1": "1994",
        "Q3": "2",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "7",
        "Q22_8c2": "9",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e9553c2f-f37d-4619-9757-e26ed3f1f9a8",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:22",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5136158d08c04c46869bc56156675165&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e9553c2f-f37d-4619-9757-e26ed3f1f9a8&isSynthetic=true&or_age=30&or_zip=99701&or_gender=f&or_householdincome=204710",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "149.928",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "5m4nx69kdg49g31c",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "1xyq4300qtqh5bmc",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/21/2026 07:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "6fb2a9e32f2e4ef99ce2c1457a8e15a6",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "859",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,Bottom_to_Top,/de_maxdiff/Q22/v112,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "112",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "9",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "cheaper bills and safer air for my kid",
        "sectionLOIr4": "2.49698333333",
        "sectionLOIr1": "2.49698333333",
        "sectionLOIr3": "2.13635",
        "sectionLOIr2": "0.2607",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "9",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1999",
        "Q3": "38",
        "Q2": "2",
        "Q5": "2",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f0f39882-150e-4fd7-92f6-ecb90153bc21",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "6",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/21/2026 07:22",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6fb2a9e32f2e4ef99ce2c1457a8e15a6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f0f39882-150e-4fd7-92f6-ecb90153bc21&isSynthetic=true&or_age=26&or_zip=97501&or_gender=f&or_householdincome=21000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "156.009",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "jb7y904fdd7zaqkx",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "2w3pq4gdbsmz6563",
        "Q22_9c2": "4",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 07:20",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "0a6b2a0dfe084db4be0d76828e4c21fb",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "860",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v232,Top_to_Bottom,/Income/inc6,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "232",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "1",
        "Q39r1": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means reliable power sources that boost the economy and tech growth. I see it as a mix of solar and wind but cautious about over-reliance on unproven options. It's about balancing innovation with family needs.",
        "sectionLOIr4": "2.5982",
        "sectionLOIr1": "2.5982",
        "sectionLOIr3": "2.28783333333",
        "sectionLOIr2": "0.237666666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "0",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1967",
        "Q3": "30",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "4",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d61d2e8f-b53e-43ad-9bbd-2995c2d5a6a7",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "2",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/21/2026 07:22",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0a6b2a0dfe084db4be0d76828e4c21fb&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d61d2e8f-b53e-43ad-9bbd-2995c2d5a6a7&isSynthetic=true&or_age=58&or_zip=03249&or_gender=m&or_householdincome=170600",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "67",
        "vbrowser": "10",
        "qtime": "155.369",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "rma6w7wr4x8c6fea",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "hscq4z8rcvu1e2uz",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/21/2026 07:22",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "304bdf47bf57446180f97507cc013515",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "3",
        "record": "861",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Education/edu3,/de_maxdiff/Q22/v164,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "164",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Means reliable, affordable power that's better for the planet. I like it but worry about reliability and costs.",
        "sectionLOIr4": "2.58806666667",
        "sectionLOIr1": "2.58806666667",
        "sectionLOIr3": "2.19901666667",
        "sectionLOIr2": "0.193783333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "1",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1958",
        "Q3": "27",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "2dac7978-bee4-4196-ac75-9bdb10735a6c",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "3",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:25",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=304bdf47bf57446180f97507cc013515&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=2dac7978-bee4-4196-ac75-9bdb10735a6c&isSynthetic=true&or_age=67&or_zip=59401&or_gender=f&or_householdincome=45000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "71",
        "vbrowser": "10",
        "qtime": "161.776",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "8xpxrrmbe9few5sq",
        "Q41r1": "0",
        "Q14r1": "29",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "8",
        "Q14r2": "17",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "cxhndgarxb4cwb7q",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 07:22",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c70e2b2ff9374f508ded9ef97695cb1f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "862",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,Bottom_to_Top,/Ethnicity/eth2,/Education/edu1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v44,/Age/age6,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "44",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "9",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Means safer air for the neighborhood and lower bills if it works reliably",
        "sectionLOIr4": "2.69503333333",
        "sectionLOIr1": "2.69503333333",
        "sectionLOIr3": "2.35478333333",
        "sectionLOIr2": "0.213",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1954",
        "Q3": "23",
        "Q2": "1",
        "Q5": "2",
        "Q4": "3",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a971d78c-036f-4dbc-ac03-32550846898d",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:25",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c70e2b2ff9374f508ded9ef97695cb1f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a971d78c-036f-4dbc-ac03-32550846898d&isSynthetic=true&or_age=71&or_zip=49442&or_gender=m&or_householdincome=24000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "64",
        "vbrowser": "10",
        "qtime": "160.936",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "bru9awzf80rk401q",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "cu2kdtdjsmjgq4zm",
        "Q22_9c2": "2",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "a3b5a95411fe4439bfc289a7e231ffbf",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "863",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,/de_maxdiff/Q22/v128,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "128",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Reliable power for my home and work. It cuts pollution, which is good. I’m cautious about new sources since they can be uncertain. My electric car uses it, but I stick to proven options for stability.",
        "sectionLOIr4": "2.67981666667",
        "sectionLOIr1": "2.67981666667",
        "sectionLOIr3": "2.33651666667",
        "sectionLOIr2": "0.2432",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1961",
        "Q3": "39",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "bfbdb994-a1da-498a-8023-b173eb889405",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/21/2026 07:25",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a3b5a95411fe4439bfc289a7e231ffbf&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=bfbdb994-a1da-498a-8023-b173eb889405&isSynthetic=true&or_age=64&or_zip=16505&or_gender=m&or_householdincome=125800",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "163.428",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "9arc76hjyhces0vq",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "hvh1gq8uv1086sbk",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "1",
        "Q43": "3",
        "start_date": "01/21/2026 07:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "0074ac826d634741a968ed485762b0ec",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "864",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth5,/Region/reg1,/Vote/vote3,/de_maxdiff/Q22/v36,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "36",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "reliable and affordable power for my apartment and dog walks",
        "sectionLOIr4": "2.72226666667",
        "sectionLOIr1": "2.72226666667",
        "sectionLOIr3": "2.4396",
        "sectionLOIr2": "0.243033333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1957",
        "Q3": "33",
        "Q2": "1",
        "Q5": "4",
        "Q4": "8",
        "Q6": "3",
        "Q22_8c2": "1",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "eeca1b8b-c8c5-4e29-9720-2676068bcd87",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "2",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "6",
        "date": "01/21/2026 07:25",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0074ac826d634741a968ed485762b0ec&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=eeca1b8b-c8c5-4e29-9720-2676068bcd87&isSynthetic=true&or_age=68&or_zip=11422&or_gender=m&or_householdincome=29000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "171.007",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "fenzv98a4sb6u4zn",
        "Q41r1": "1",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "t49gx3cxqwgarw32",
        "Q22_9c2": "5",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 07:25",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "71b29c2fe87942ab8ece378b8115df7b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "7",
        "record": "865",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v139,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "139",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "4",
        "Q22_4c2": "4",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "75",
        "Q23": "3",
        "Q24": "Sustainable, but I prioritize reliability. My EV9 and efficient home systems show I’m open to innovation, yet I stick with proven tech for stability.",
        "sectionLOIr4": "2.8457",
        "sectionLOIr1": "2.8457",
        "sectionLOIr3": "2.46668333333",
        "sectionLOIr2": "0.238416666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "0",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "8",
        "Q22_2c2": "2",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1970",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5dfd80ba-0f9d-40a9-acb5-7754f004f2c7",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:28",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=71b29c2fe87942ab8ece378b8115df7b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5dfd80ba-0f9d-40a9-acb5-7754f004f2c7&isSynthetic=true&or_age=54&or_zip=77070&or_gender=f&or_householdincome=141000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "172.753",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "hnmdqszv7tv31bzg",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "16",
        "Q14r2": "16",
        "Q14r5": "11",
        "Q14r4": "11",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "u1t603hs0z20z538",
        "Q22_9c2": "2",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 07:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1cff20a301c24fe9b66896c27e2c2a17",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "6",
        "record": "866",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,/Income/inc5,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/de_maxdiff/Q22/v107,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "107",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy is reliable power good for the planet and my bills. Mix solar and traditional sources that work together without hassle.",
        "sectionLOIr4": "2.8779",
        "sectionLOIr1": "2.8779",
        "sectionLOIr3": "2.54661666667",
        "sectionLOIr2": "0.250183333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1989",
        "Q3": "15",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1426de79-aba3-4980-8927-2667fb571789",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 07:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1cff20a301c24fe9b66896c27e2c2a17&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1426de79-aba3-4980-8927-2667fb571789&isSynthetic=true&or_age=36&or_zip=46143&or_gender=m&or_householdincome=90900",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "62",
        "vbrowser": "10",
        "qtime": "178.76",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "pcvtu4kg9gpagu00",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "whyttx3djc7vydua",
        "Q22_9c2": "7",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "4",
        "start_date": "01/21/2026 07:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d32a15c519b9422fb7f2eb172c45fc89",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "867",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v111,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,/Income/inc7,/Education/edu3",
        "Q33": "2",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "111",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It’s about running my gadgets and keeping the air clear for my dogs’ walks. Practical stuff—like solar or wind—so I can enjoy Utah’s trails without guilt. I trust industry leaders, but I’m not sold on every claim.",
        "sectionLOIr4": "2.97793333333",
        "sectionLOIr1": "2.97793333333",
        "sectionLOIr3": "2.65633333333",
        "sectionLOIr2": "0.2629",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "75",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1963",
        "Q3": "45",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "8",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "276c7cb9-3bdd-4602-b74d-a28b62f22701",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "6",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 07:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d32a15c519b9422fb7f2eb172c45fc89&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=276c7cb9-3bdd-4602-b74d-a28b62f22701&isSynthetic=true&or_age=62&or_zip=84025&or_gender=m&or_householdincome=30000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "173.506",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "6ttppvde4s5k3639",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "18",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "j4zym9sf7dkpgm79",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "481131358c8b46b395896f7bdc6aa21c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "868",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/de_maxdiff/Q22/v9,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "9",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Reliable sustainable power that supports the environment and economy",
        "sectionLOIr4": "2.89043333333",
        "sectionLOIr1": "2.89043333333",
        "sectionLOIr3": "2.41356666667",
        "sectionLOIr2": "0.22925",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1979",
        "Q3": "24",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6c41c9db-8942-46c6-bc76-123237415be5",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 07:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=481131358c8b46b395896f7bdc6aa21c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6c41c9db-8942-46c6-bc76-123237415be5&isSynthetic=true&or_age=46&or_zip=55441&or_gender=m&or_householdincome=68700",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "154.28",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "5uaedm300w3grxz5",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "18",
        "Q14r7": "9",
        "Q14r6": "4",
        "uuid": "263mcx6q76pcn2e0",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 07:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "bea48eb9d3f54c73801c46de47f42f1a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "869",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/Ethnicity/eth3,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v286,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "286",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means safer air for my dog's walks and reliable power for my home.",
        "sectionLOIr4": "2.56991666667",
        "sectionLOIr1": "2.56991666667",
        "sectionLOIr3": "2.24525",
        "sectionLOIr2": "0.229333333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1979",
        "Q3": "38",
        "Q2": "1",
        "Q5": "2",
        "Q4": "2",
        "Q6": "2",
        "Q22_8c2": "2",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e8e28382-1cf5-44c8-8848-3760409721b2",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "6",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:31",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bea48eb9d3f54c73801c46de47f42f1a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e8e28382-1cf5-44c8-8848-3760409721b2&isSynthetic=true&or_age=46&or_zip=97402&or_gender=m&or_householdincome=48000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "35",
        "vbrowser": "10",
        "qtime": "148.479",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "dn2paaep3cpsnrnt",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "0e4d2cd2ap3z7gb8",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "1a2a577086d441c9a51d00ef7ce6d89e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "870",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v19,/Income/inc5,/Education/edu3,/Gender/gen2,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "19",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Homegrown power that's reliable and keeps costs predictable",
        "sectionLOIr4": "2.47276666667",
        "sectionLOIr1": "2.47276666667",
        "sectionLOIr3": "2.15516666667",
        "sectionLOIr2": "0.220633333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1990",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e4def366-b6a8-45e0-815b-bca7359fc657",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:32",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1a2a577086d441c9a51d00ef7ce6d89e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e4def366-b6a8-45e0-815b-bca7359fc657&isSynthetic=true&or_age=34&or_zip=77095&or_gender=f&or_householdincome=106000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "63",
        "vbrowser": "10",
        "qtime": "166.368",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "xpk5vue1wvdwn2ez",
        "Q41r1": "0",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "wnsqyfz9pb32a1xy",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "63f71e764b014e8c97e6b69dc84d0e1f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "871",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,sawterm:(dvfail.r1),qual,/Vote/vote2,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/de_maxdiff/Q22/v166,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "166",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means safer air for my kids and reliable power for my home. I’ve seen how pollution affects health, so it’s about protecting our community.",
        "sectionLOIr4": "2.77146666667",
        "sectionLOIr1": "2.77146666667",
        "sectionLOIr3": "2.43575",
        "sectionLOIr2": "0.2233",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "9",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1962",
        "Q3": "47",
        "Q2": "2",
        "Q5": "2",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "ea99fabb-a544-457e-afef-da6cb4f115c0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "5",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/21/2026 07:32",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=63f71e764b014e8c97e6b69dc84d0e1f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ea99fabb-a544-457e-afef-da6cb4f115c0&isSynthetic=true&or_age=61&or_zip=22407&or_gender=f&or_householdincome=49000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "51",
        "vbrowser": "10",
        "qtime": "151.36",
        "Q14r9": "9",
        "Q14r8": "14",
        "session": "jeeauytpzqgvkja7",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "4087uy5ysm2xy2t5",
        "Q22_9c2": "1",
        "Q22_9c1": "2",
        "Q34r4": "1",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/21/2026 07:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "27e9e7da8802431ab50e2d1d478b5cbd",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "872",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/de_maxdiff/Q22/v105,Bottom_to_Top,/Education/edu1,/Vote/vote4,20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "105",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy’s reliable power without the mess. Solar panels on my roof cut costs, but I still need backup. Balance is key.",
        "sectionLOIr4": "2.52128333333",
        "sectionLOIr1": "2.52128333333",
        "sectionLOIr3": "2.2333",
        "sectionLOIr2": "0.22805",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "0",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1974",
        "Q3": "36",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "97150c5b-e752-4259-8ed0-736c00f1fc60",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:32",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=27e9e7da8802431ab50e2d1d478b5cbd&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=97150c5b-e752-4259-8ed0-736c00f1fc60&isSynthetic=true&or_age=51&or_zip=43607&or_gender=m&or_householdincome=48000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "161.037",
        "Q14r9": "0",
        "Q14r8": "6",
        "session": "xp5xdd05b9yj4m65",
        "Q41r1": "1",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "22",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "qxvwkx7hxe7yvbqw",
        "Q22_9c2": "7",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:32",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "846cf9b95fa248f9bad16874f7624a08",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "873",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/de_maxdiff/Q22/v3,Bottom_to_Top,/Ethnicity/eth4,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Education/edu3,/Gender/gen2,/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "3",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Clean energy means sustainable power for my tech life. I love renewables like solar/wind for innovation, but reliable backups matter. It's a balance of progress & practicality, like my work/home routines. Hopeful but realistic.",
        "sectionLOIr4": "2.6817",
        "sectionLOIr1": "2.6817",
        "sectionLOIr3": "2.3169",
        "sectionLOIr2": "0.27735",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "75",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "9",
        "Q1": "1981",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "4af7be48-75ae-408d-8e9a-6e2d5c6749c4",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/21/2026 07:35",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=846cf9b95fa248f9bad16874f7624a08&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4af7be48-75ae-408d-8e9a-6e2d5c6749c4&isSynthetic=true&or_age=44&or_zip=14094&or_gender=f&or_householdincome=167700",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "40",
        "vbrowser": "10",
        "qtime": "163.115",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "xvrsdmehe516a44a",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "4w4b6j2cakg2fhx5",
        "Q22_9c2": "5",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/21/2026 07:32",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "185807f75f4046a1b1bc4700ca6a2b8a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "6",
        "record": "874",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/de_maxdiff/Q22/v187,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "187",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "1",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "87.5",
        "Q23": "3",
        "Q24": "Reliable power for our community, mixing tradition with new ideas. Supports my job and my partner’s work without sacrificing stability.",
        "sectionLOIr4": "2.71723333333",
        "sectionLOIr1": "2.71723333333",
        "sectionLOIr3": "2.40006666667",
        "sectionLOIr2": "0.221633333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "0",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "8",
        "Q22_2c2": "1",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1985",
        "Q3": "16",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "2",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6e17130d-5822-4035-947d-eff545eaf8a1",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:35",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=185807f75f4046a1b1bc4700ca6a2b8a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6e17130d-5822-4035-947d-eff545eaf8a1&isSynthetic=true&or_age=40&or_zip=52565&or_gender=f&or_householdincome=71900",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "21",
        "vbrowser": "10",
        "qtime": "162.383",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "j12av9gu228hkk4h",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "15",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "drkyn2ajpmnxy4rw",
        "Q22_9c2": "7",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:32",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "01f77aeed61d48a395ec7150e6981c4e",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "875",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v189,/Vote/vote2,/Region/reg4,/Ethnicity/eth2,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Education/edu1,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "189",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "2",
        "Q39r2": "4",
        "Q39r3": "1",
        "Q39r1": "5",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "1",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Clean energy is about safer air for my community. I know it's growing but still worry about reliability and costs. My partner and I use soler when we can but it's not always easy.",
        "sectionLOIr4": "2.70518333333",
        "sectionLOIr1": "2.70518333333",
        "sectionLOIr3": "2.341",
        "sectionLOIr2": "0.2879",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "2004",
        "Q3": "5",
        "Q2": "2",
        "Q5": "2",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "156a7a08-1bd5-4124-a413-e0c69411f787",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "6",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/21/2026 07:35",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=01f77aeed61d48a395ec7150e6981c4e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=156a7a08-1bd5-4124-a413-e0c69411f787&isSynthetic=true&or_age=21&or_zip=92509&or_gender=f&or_householdincome=43600",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "62",
        "vbrowser": "10",
        "qtime": "148.885",
        "Q14r9": "5",
        "Q14r8": "6",
        "session": "bxqew8fdpxektb3n",
        "Q41r1": "1",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "17",
        "Q14r5": "11",
        "Q14r4": "11",
        "Q14r7": "6",
        "Q14r6": "6",
        "uuid": "xyw1avrky9bvrw03",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/21/2026 07:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1d0a05ab6d4f4cb8850ce1a922454181",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "877",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v50,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc7,/Vote/vote2,/Education/edu4",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "50",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "1",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "solar panels and wind farms are good for the planet but need reliable backup",
        "sectionLOIr4": "2.4774",
        "sectionLOIr1": "2.4774",
        "sectionLOIr3": "2.11515",
        "sectionLOIr2": "0.298",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "5",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "12.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "4",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1963",
        "Q3": "34",
        "Q2": "1",
        "Q5": "6",
        "Q4": "7",
        "Q6": "7",
        "Q22_8c2": "4",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7e4d6803-a520-4428-9aff-02dbd5ee2ed2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1d0a05ab6d4f4cb8850ce1a922454181&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7e4d6803-a520-4428-9aff-02dbd5ee2ed2&isSynthetic=true&or_age=62&or_zip=27540&or_gender=m&or_householdincome=250000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1989",
        "vctq1c22": "0",
        "HIDAge": "36",
        "Q2": "1",
        "Q4": "8",
        "vctq1c24": "1",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "9.771",
        "Q3": "34",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "awutka66ednkrgj2",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "or1": "1f1dee73f4444214bd170cc749e5f7aa",
        "vlist": "2",
        "uuid": "b9qh2zgryt4h6sex",
        "vmobiledevice": "5",
        "s2": "4c7a5173-6e43-43bc-a826-c913b7fff024",
        "vctq1c25": "0",
        "markers": "bad:/Rotate Selection/Top_to_Bottom,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Region/reg3,bad:/Gender/gen1,Top_to_Bottom,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "01/21/2026 07:35",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "5",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "3",
        "date": "01/21/2026 07:35",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1f1dee73f4444214bd170cc749e5f7aa&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4c7a5173-6e43-43bc-a826-c913b7fff024&isSynthetic=true&or_age=35&or_zip=27707&or_gender=m&or_householdincome=125000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "878",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "180.208",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "xpj0c4pc0yjyqe8b",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "uhe0kdrmb8n55hvm",
        "Q22_9c2": "1",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "01/21/2026 07:35",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7ca6b1ed386c49f0aa62b483f7762e16",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "879",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/Ethnicity/eth3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu3,/de_maxdiff/Q22/v262",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "262",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "Sustainable power for my tech life and travel",
        "sectionLOIr4": "3.00211666667",
        "sectionLOIr1": "3.00211666667",
        "sectionLOIr3": "2.64446666667",
        "sectionLOIr2": "0.274083333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "8",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1999",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "1447d458-674c-478a-969e-9a72248fe810",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "7",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "5",
        "date": "01/21/2026 07:38",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7ca6b1ed386c49f0aa62b483f7762e16&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1447d458-674c-478a-969e-9a72248fe810&isSynthetic=true&or_age=26&or_zip=13760&or_gender=f&or_householdincome=70000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "74",
        "vbrowser": "10",
        "qtime": "164.667",
        "Q14r9": "4",
        "Q14r8": "13",
        "session": "9zr5400141wk70je",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "7d312k6deg8mh9ym",
        "Q22_9c2": "9",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/21/2026 07:36",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "53df7de70c07480fbcd141286d1200e8",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "880",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Region/reg4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v47,/Age/age6,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "47",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means safe and green power for Hawaii. Solar and wind protect the environment and help us all. It's a team effort between government and companies to keep things affordable. I'm excited about the future even if there are challenges. It feels like a win for the community and the planet.",
        "sectionLOIr4": "2.74316666667",
        "sectionLOIr1": "2.74316666667",
        "sectionLOIr3": "2.45195",
        "sectionLOIr2": "0.292366666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1951",
        "Q3": "12",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "2",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "6898dc3b-dffb-4d64-b6d5-56fb1c81a492",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "6",
        "date": "01/21/2026 07:38",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=53df7de70c07480fbcd141286d1200e8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6898dc3b-dffb-4d64-b6d5-56fb1c81a492&isSynthetic=true&or_age=74&or_zip=96707&or_gender=f&or_householdincome=35000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "153.97",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "cpd2ne5pr9kk4tsr",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "09k1zxh8bvzg4hej",
        "Q22_9c2": "7",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/21/2026 07:36",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "98886b14c9074abd99ed5df33f386e13",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "5",
        "record": "881",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote4,/Ethnicity/eth4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v18,Top_to_Bottom,/Education/edu3,/Income/inc1,/Gender/gen3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "18",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "clean energy = solar/wind that boost local areas but struggle with storage and cost. it's a mix of hope and practicality for me.",
        "sectionLOIr4": "2.56461666667",
        "sectionLOIr1": "2.56461666667",
        "sectionLOIr3": "2.22375",
        "sectionLOIr2": "0.257316666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "2",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "7",
        "Q22_2c2": "1",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1996",
        "Q3": "7",
        "Q2": "4",
        "Q5": "4",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "052a6dba-8b96-4a23-8467-9815311fa173",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/21/2026 07:38",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=98886b14c9074abd99ed5df33f386e13&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=052a6dba-8b96-4a23-8467-9815311fa173&isSynthetic=true&or_age=29&or_zip=06019&or_gender=f&or_householdincome=18200",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "151.802",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "9tesk1cjzz6yrqqe",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "21",
        "Q14r5": "11",
        "Q14r4": "16",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "qs9g02wbhw0sw5ea",
        "Q22_9c2": "2",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "7",
        "Q21r7": "5",
        "Q21r6": "3",
        "Q38": "1",
        "Q43": "2",
        "start_date": "01/23/2026 05:22",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "5bda7383d9604f4e94fdf7b022d757f0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "925",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Education/edu2,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),/de_maxdiff/Q22/v192,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc4",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "192",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means the grid runs smoother without flickering lights or weird smells from old plants",
        "sectionLOIr4": "2.5232",
        "sectionLOIr1": "2.5232",
        "sectionLOIr3": "2.19606666667",
        "sectionLOIr2": "0.235666666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1996",
        "Q3": "33",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "4",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "eca56ecd-fd71-4f57-b949-f2bd03699fcc",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 05:24",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5bda7383d9604f4e94fdf7b022d757f0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=eca56ecd-fd71-4f57-b949-f2bd03699fcc&isSynthetic=true&or_age=29&or_zip=11357&or_gender=m&or_householdincome=90000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "20",
        "vbrowser": "10",
        "qtime": "186.847",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "gxd8g46a3jn8e2bg",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "d1rnsecaep10tfr6",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 05:22",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2ae8de6b6a584395b061b6060efc4f8d",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "926",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/de_maxdiff/Q22/v235,/Vote/vote4,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "235",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means cheaper bills and not relying on the gri too much. My car's elecric, so it's a win for the wallet and the planet. Plus, it's good for the environment.",
        "sectionLOIr4": "3.1111",
        "sectionLOIr1": "3.1111",
        "sectionLOIr3": "2.83081666667",
        "sectionLOIr2": "0.277316666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "10",
        "Q15r5": "8",
        "Q15r6": "10",
        "Q15r7": "5",
        "Q15r1": "8",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "5",
        "Q15r9": "10",
        "Q1": "2005",
        "Q3": "26",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "2086d58b-a647-430f-8821-f5c440dbecb7",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 05:25",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2ae8de6b6a584395b061b6060efc4f8d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=2086d58b-a647-430f-8821-f5c440dbecb7&isSynthetic=true&or_age=20&or_zip=65018&or_gender=m&or_householdincome=20000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "84",
        "vbrowser": "10",
        "qtime": "168.13",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "yxuhpvsmkvn5wtmt",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "t9bm5pkrh4h3dptf",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:22",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "7fbc6f2d098c4c4096d713a2444809ae",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "927",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v102,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "102",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means cheaper bills and less pollution. I’ve seen solar panels help neighbors save money, but they’re not always reliable. My Honda’s fuel costs keep rising, so I hope clean energy gets better at balancing savings and consistency.",
        "sectionLOIr4": "2.80005",
        "sectionLOIr1": "2.80005",
        "sectionLOIr3": "2.4932",
        "sectionLOIr2": "0.260566666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1941",
        "Q3": "48",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "610494ea-83e9-413f-b8df-f6354c5fc988",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "6",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 05:25",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7fbc6f2d098c4c4096d713a2444809ae&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=610494ea-83e9-413f-b8df-f6354c5fc988&isSynthetic=true&or_age=82&or_zip=98107&or_gender=m&or_householdincome=32000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "170.564",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "bn6h79xm7ndxe8ek",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ww5rhfpb77ndp35z",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:22",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d5878e2afe1d424a99f8edd68410aee1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "928",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/de_maxdiff/Q22/v184,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc4,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "184",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "4",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Maybe it means a mix of reliable and new sources. I think job creation is important but worry about costs.",
        "sectionLOIr4": "2.84018333333",
        "sectionLOIr1": "2.84018333333",
        "sectionLOIr3": "2.50176666667",
        "sectionLOIr2": "0.245716666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "4",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1980",
        "Q3": "47",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "4",
        "Q22_8c2": "5",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1c781897-33c9-42b6-b0bf-195f221b09bd",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 05:25",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d5878e2afe1d424a99f8edd68410aee1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1c781897-33c9-42b6-b0bf-195f221b09bd&isSynthetic=true&or_age=46&or_zip=20164&or_gender=f&or_householdincome=161000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "49",
        "vbrowser": "10",
        "qtime": "184.297",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "fkx7fdmva04tat4q",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "0nbby2ffkp4pnrmf",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:25",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "83390586d24d499798f900a97f9ad711",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "929",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Education/edu2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v150,/Gender/gen2,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "150",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "9",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "9",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It's about energy that works reliably and stays within budget I prefer proven methods that help the planet",
        "sectionLOIr4": "3.06913333333",
        "sectionLOIr1": "3.06913333333",
        "sectionLOIr3": "2.77081666667",
        "sectionLOIr2": "0.182783333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "75",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1976",
        "Q3": "14",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "70c6ad1c-a7eb-462f-9a5f-a55c4876f03e",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/23/2026 05:28",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=83390586d24d499798f900a97f9ad711&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=70c6ad1c-a7eb-462f-9a5f-a55c4876f03e&isSynthetic=true&or_age=48&or_zip=60134&or_gender=f&or_householdincome=32000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "38",
        "vbrowser": "10",
        "qtime": "150.835",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "xrgp77rrep7cnjhy",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "g36wgj4817f0f8pz",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/23/2026 05:25",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7c92757415c74843951310af823825d6",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "930",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/de_maxdiff/Q22/v179,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "179",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means the solar panels on my dad's roof that keep the lights on during storms",
        "sectionLOIr4": "2.5115",
        "sectionLOIr1": "2.5115",
        "sectionLOIr3": "2.19471666667",
        "sectionLOIr2": "0.2156",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1987",
        "Q3": "10",
        "Q2": "2",
        "Q5": "2",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "309fc0eb-27c0-4a39-9431-74bfd9062184",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 05:28",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7c92757415c74843951310af823825d6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=309fc0eb-27c0-4a39-9431-74bfd9062184&isSynthetic=true&or_age=37&or_zip=34209&or_gender=f&or_householdincome=52000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "43",
        "vbrowser": "10",
        "qtime": "214.293",
        "Q14r9": "4",
        "Q14r8": "8",
        "session": "kk5ju3648nq6pgdt",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "12",
        "Q14r2": "17",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "86mjw2ga3wncsrnp",
        "Q22_9c2": "1",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:25",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "cd6d6bd7c6d14ad8af59cf387e1df84c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "931",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Ethnicity/eth1,/de_maxdiff/Q22/v155,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "155",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "1",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "5",
        "Q22_6c2": "2",
        "Q22_4c2": "2",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "cleaner air for my child but higher costs",
        "sectionLOIr4": "3.56526666667",
        "sectionLOIr1": "3.56526666667",
        "sectionLOIr3": "3.09636666667",
        "sectionLOIr2": "0.260783333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "100",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "0",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1982",
        "Q3": "5",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "cd926826-f8e4-4d82-a287-f44a518c2e6b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/23/2026 05:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=cd6d6bd7c6d14ad8af59cf387e1df84c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cd926826-f8e4-4d82-a287-f44a518c2e6b&isSynthetic=true&or_age=44&or_zip=91950&or_gender=f&or_householdincome=62000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "37",
        "vbrowser": "10",
        "qtime": "178.832",
        "Q14r9": "4",
        "Q14r8": "13",
        "session": "d6tz4ejhn349cgzt",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ymsbrgy9ju3nx3at",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/23/2026 05:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "a960b5b2c6674366bc1b36f55c7c39e2",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "932",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v244,sawterm:Q1.ival gt 2007,/Income/inc5,/Ethnicity/eth1,/Gender/gen2,/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "244",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means balancing eco-friendly goals with the need for reliable power but I'm not sure if solar panels can handle cloudy days",
        "sectionLOIr4": "2.97718333333",
        "sectionLOIr1": "2.97718333333",
        "sectionLOIr3": "2.588",
        "sectionLOIr2": "0.311216666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1988",
        "Q3": "5",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "65c43e91-4a21-42ee-86a0-53401cdbb637",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "6",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 05:29",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a960b5b2c6674366bc1b36f55c7c39e2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=65c43e91-4a21-42ee-86a0-53401cdbb637&isSynthetic=true&or_age=36&or_zip=94536&or_gender=f&or_householdincome=100000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "37",
        "vbrowser": "10",
        "qtime": "151.942",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "m18c8fpbys61t0sr",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "50p6e47hxcydnvb0",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/23/2026 05:28",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "fcd670d2c88c4cb484a68a8ca441e314",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "933",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v57,Top_to_Bottom,/Education/edu3,/Age/age3,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "57",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power that doesn't harm the environment but I worry about costs and how much it depends on new tech",
        "sectionLOIr4": "2.52876666667",
        "sectionLOIr1": "2.52876666667",
        "sectionLOIr3": "2.17691666667",
        "sectionLOIr2": "0.254066666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "9",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1988",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "71a044c2-1481-472e-9b99-d86a06943ae4",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "1",
        "date": "01/23/2026 05:31",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=fcd670d2c88c4cb484a68a8ca441e314&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=71a044c2-1481-472e-9b99-d86a06943ae4&isSynthetic=true&or_age=36&or_zip=33131&or_gender=m&or_householdincome=45600",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "67",
        "vbrowser": "10",
        "qtime": "150.89",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "n3rekx88v0drsyq3",
        "Q41r1": "0",
        "Q14r1": "34",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "17",
        "Q14r5": "8",
        "Q14r4": "8",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "jgq4y2m9csygur1g",
        "Q22_9c2": "9",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "6",
        "Q21r6": "5",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/23/2026 05:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "347bb649cb454f078303bb61828f1250",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "934",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/de_maxdiff/Q22/v279,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "279",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means using solar panels to save money and keep things running smoothly for our trips and meals",
        "sectionLOIr4": "2.51181666667",
        "sectionLOIr1": "2.51181666667",
        "sectionLOIr3": "2.13635",
        "sectionLOIr2": "0.212233333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "9",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1958",
        "Q3": "1",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "77746b66-b106-45eb-9efd-baee49b20a55",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 05:31",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=347bb649cb454f078303bb61828f1250&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=77746b66-b106-45eb-9efd-baee49b20a55&isSynthetic=true&or_age=68&or_zip=36767&or_gender=m&or_householdincome=33269",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "20",
        "vbrowser": "10",
        "qtime": "156.99",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "gp6jbaqmaz3zkrcp",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "q77e67x83zjj70vq",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "4",
        "Q21r7": "1",
        "Q21r6": "2",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 05:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "ebb13e29623f4e25abe9f03fadb1c95b",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "935",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v236,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Income/inc1",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "236",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means cheaper bills for my kids' future, but I worry about upfront costs. They’re a promise, not a guarantee.",
        "sectionLOIr4": "2.61393333333",
        "sectionLOIr1": "2.61393333333",
        "sectionLOIr3": "2.32071666667",
        "sectionLOIr2": "0.22405",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "1",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "1",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "9",
        "Q1": "2005",
        "Q3": "39",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f298fd97-1a43-467b-b943-175c61029ff4",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "6",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "1",
        "Q8r6": "2",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 05:32",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ebb13e29623f4e25abe9f03fadb1c95b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f298fd97-1a43-467b-b943-175c61029ff4&isSynthetic=true&or_age=20&or_zip=18018&or_gender=f&or_householdincome=25000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "41",
        "vbrowser": "10",
        "qtime": "155.347",
        "Q41r2": "0",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "278h3mmwfjj0dnuf",
        "Q41r1": "0",
        "Q14r1": "29",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "5",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "rha14sntvk9mk1p1",
        "Q22_9c2": "9",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q22_version": "298",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "4",
        "Q21r7": "1",
        "Q21r6": "2",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/23/2026 05:30",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "bc6b3a42e9144211a22383bacd8efd2d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "1",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v298,/Education/edu3,/Gender/gen2,/Income/inc1,/Age/age3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "4",
        "Q35": "6",
        "Q22_7c1": "9",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q30": "1",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "9",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "1",
        "Q24": "it's a fancy term for costly unreliable power",
        "sectionLOIr4": "2.58011666667",
        "sectionLOIr1": "2.58011666667",
        "sectionLOIr3": "2.19546666667",
        "sectionLOIr2": "0.287483333333",
        "vctq1c21": "0",
        "Q35r6oe": "A pragmatic problem-solver with a focus on reliability and affordability in everyday life",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "4",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "75",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "record": "936",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1984",
        "Q3": "2",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "59564e14-f911-41ed-a61b-82d36783b11b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "1",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/23/2026 05:32",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bc6b3a42e9144211a22383bacd8efd2d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=59564e14-f911-41ed-a61b-82d36783b11b&isSynthetic=true&or_age=42&or_zip=99504&or_gender=f&or_householdincome=34520",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "205.956",
        "Q14r9": "1",
        "Q14r8": "5",
        "session": "rpb2t73unh31vpzb",
        "Q41r1": "1",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "25",
        "Q14r5": "10",
        "Q14r4": "15",
        "Q14r7": "3",
        "Q14r6": "1",
        "uuid": "nes76rqhsd5s6nk8",
        "Q22_9c2": "1",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:31",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "f3e870e634054bc59e6bfc27f50fb58e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "937",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/de_maxdiff/Q22/v233,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "233",
        "Q35": "6",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "it means safer energy for my home and car and less stress on my budget",
        "sectionLOIr4": "3.43013333333",
        "sectionLOIr1": "3.43013333333",
        "sectionLOIr3": "3.03056666667",
        "sectionLOIr2": "0.228966666667",
        "vctq1c21": "0",
        "Q35r6oe": "A pragmatic advocate for balanced energy solutions that prioritize reliability and community impact.",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1995",
        "Q3": "11",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "42c1e253-1f15-40be-a439-c8f7c878adc5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/23/2026 05:35",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f3e870e634054bc59e6bfc27f50fb58e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=42c1e253-1f15-40be-a439-c8f7c878adc5&isSynthetic=true&or_age=29&or_zip=31909&or_gender=f&or_householdincome=100000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "175.02",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "k588ghgf1vuy6gx6",
        "Q41r1": "0",
        "Q14r1": "41",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "5",
        "Q14r6": "4",
        "uuid": "u7bjj9qdwpe41raz",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q22_version": "94",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "1",
        "Q39r2": "3",
        "start_date": "01/23/2026 05:32",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "1339fd7de89844f3810a5381868bd43a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "1",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Vote/vote1,/Region/reg2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,qual,/de_maxdiff/Q22/v94,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Income/inc2",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "2",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "6",
        "Q39r4": "5",
        "Q22_7c2": "9",
        "Q30": "2",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "it means fancy talk about tax money while the grid stays broke and bills keep rising",
        "sectionLOIr4": "2.91473333333",
        "sectionLOIr1": "2.91473333333",
        "sectionLOIr3": "2.54278333333",
        "sectionLOIr2": "0.266133333333",
        "vctq1c21": "1",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "4",
        "Q13": "3",
        "Q12": "4",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "record": "938",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1970",
        "Q3": "15",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d8454056-40a3-4104-8517-393d0462a0e0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/23/2026 05:35",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1339fd7de89844f3810a5381868bd43a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d8454056-40a3-4104-8517-393d0462a0e0&isSynthetic=true&or_age=56&or_zip=46319&or_gender=f&or_householdincome=46900",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "41",
        "vbrowser": "10",
        "qtime": "199.891",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "gvbgh84anby82fr2",
        "Q41r1": "0",
        "Q14r1": "59",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "4",
        "Q14r2": "4",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "tuw4scp6g4bqe9ts",
        "Q22_9c2": "4",
        "Q22_9c1": "8",
        "Q34r4": "1",
        "Q22_version": "89",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "1",
        "Q21r7": "4",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/23/2026 05:32",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "5",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "3",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2b924000750a42bebbdd3ba3961c2240",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "5",
        "markers": "qualified,/Region/reg1,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth4,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Education/edu3,/Gender/gen2,/Income/inc1,/Age/age3,/de_maxdiff/Q22/v89",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "5",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "5",
        "Q9r6": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "6",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "1",
        "Q24": "it's a buzzword for Democrats and corporate scams",
        "sectionLOIr4": "3.32756666667",
        "sectionLOIr1": "3.32756666667",
        "sectionLOIr3": "2.94601666667",
        "sectionLOIr2": "0.222266666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "4",
        "Q10": "4",
        "Q13": "3",
        "Q12": "4",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "37.5",
        "record": "939",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "12.5",
        "dvflagr2": "1",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "5",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "5",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1984",
        "Q3": "39",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "6",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3998717e-826c-4218-8430-6fe5112ad6cc",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/23/2026 05:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2b924000750a42bebbdd3ba3961c2240&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3998717e-826c-4218-8430-6fe5112ad6cc&isSynthetic=true&or_age=40&or_zip=15236&or_gender=f&or_householdincome=26520",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "77",
        "vbrowser": "10",
        "qtime": "185.508",
        "Q14r9": "0",
        "Q14r8": "6",
        "session": "jfrrwrzy6amn32w6",
        "Q41r1": "0",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "22",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "xqsxqe52cbzepuzs",
        "Q22_9c2": "3",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "be6f28d1d329459e86689c8485523ae2",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "940",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v211,Top_to_Bottom,/Gender/gen2,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "211",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "3",
        "Q22_4c2": "4",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "It means having power that doesn't cost too much and keeps the air clear for my dog.",
        "sectionLOIr4": "3.08971666667",
        "sectionLOIr1": "3.08971666667",
        "sectionLOIr3": "2.75485",
        "sectionLOIr2": "0.211366666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "4",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q15r1": "10",
        "Q15r2": "8",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1948",
        "Q3": "11",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "493867bd-8e87-4c56-8f8c-0dd5866ffed2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/23/2026 05:36",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=be6f28d1d329459e86689c8485523ae2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=493867bd-8e87-4c56-8f8c-0dd5866ffed2&isSynthetic=true&or_age=76&or_zip=31407&or_gender=f&or_householdincome=64090",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "69",
        "vbrowser": "10",
        "qtime": "175.372",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "qdp38kfe2wsq38uy",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "jjny38xqu3u3jn7q",
        "Q22_9c2": "7",
        "Q22_9c1": "2",
        "Q34r4": "1",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:35",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "847d45d57de84f0c98002fdfebb94d76",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "941",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Gender/gen2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v51,/Vote/vote2,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,/Age/age6,/Education/edu3,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "51",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Solar panels and wind for lower costs, but I worry about reliability.",
        "sectionLOIr4": "2.92076666667",
        "sectionLOIr1": "2.92076666667",
        "sectionLOIr3": "2.59623333333",
        "sectionLOIr2": "0.247033333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1956",
        "Q3": "3",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "5",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "8671a384-f740-4fc2-8998-65191e7d9e17",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 05:38",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=847d45d57de84f0c98002fdfebb94d76&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8671a384-f740-4fc2-8998-65191e7d9e17&isSynthetic=true&or_age=69&or_zip=85338&or_gender=f&or_householdincome=25990",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "162.053",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "54uj98wpxb201wmd",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ba083mqsct92xatp",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "5",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "1",
        "Q21r6": "7",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:35",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "22039163335c45b08025bc2fa300a660",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "942",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v67,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "67",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "1",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means dependable power that doesn't break the bank. I've seen solar panels on neighbors' roofs, but I'm still cautious about switching entirely. Keeps things steady, which is important for my budget and the community.",
        "sectionLOIr4": "2.69878333333",
        "sectionLOIr1": "2.69878333333",
        "sectionLOIr3": "2.35716666667",
        "sectionLOIr2": "0.230333333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1979",
        "Q3": "15",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "ab1c21d4-8ed6-4a2d-b609-b180026d84e9",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 05:38",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=22039163335c45b08025bc2fa300a660&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ab1c21d4-8ed6-4a2d-b609-b180026d84e9&isSynthetic=true&or_age=47&or_zip=46241&or_gender=m&or_householdincome=36200",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "32",
        "vbrowser": "10",
        "qtime": "162.613",
        "Q41r2": "0",
        "Q14r9": "18",
        "Q14r8": "4",
        "session": "014unn3h8hkujarq",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "9",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "9gnpk016sjuy4qx0",
        "Q22_9c2": "7",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q22_version": "31",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "Q39r2": "4",
        "start_date": "01/23/2026 05:36",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "fff598f2bacc442e9ab48ffc3785615f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/de_maxdiff/Q22/v31,/Vote/vote1,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc4,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "5",
        "Q36": "4",
        "Q35": "1",
        "Q22_7c1": "3",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q30": "2",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "1",
        "Q24": "it means another way to waste money on fak solutions that don't fix the real problems",
        "sectionLOIr4": "2.70773333333",
        "sectionLOIr1": "2.70773333333",
        "sectionLOIr3": "2.3138",
        "sectionLOIr2": "0.26605",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "0",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "75",
        "record": "943",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "4",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1993",
        "Q3": "44",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5a896dd9-d99e-4f34-a2dd-784a16d241f7",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/23/2026 05:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=fff598f2bacc442e9ab48ffc3785615f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5a896dd9-d99e-4f34-a2dd-784a16d241f7&isSynthetic=true&or_age=31&or_zip=75227&or_gender=m&or_householdincome=75500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "73",
        "vbrowser": "10",
        "qtime": "159.7",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "f5ceu9haagymhed7",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "0e9nefnz1eywuu36",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 05:37",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "59941bbce06b427484b7d8a61ca674f6",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "944",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v259,/Gender/gen2,/Region/reg4,/Ethnicity/eth3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Age/age6,/Education/edu3,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "259",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "1",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means power that doesn't cost too much and works reliably",
        "sectionLOIr4": "2.65951666667",
        "sectionLOIr1": "2.65951666667",
        "sectionLOIr3": "2.38001666667",
        "sectionLOIr2": "0.233133333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1952",
        "Q3": "32",
        "Q2": "2",
        "Q5": "4",
        "Q4": "2",
        "Q6": "2",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "98f263cc-b9a1-4d17-86f9-605dbbb4f100",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 05:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=59941bbce06b427484b7d8a61ca674f6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=98f263cc-b9a1-4d17-86f9-605dbbb4f100&isSynthetic=true&or_age=74&or_zip=87401&or_gender=f&or_householdincome=27113",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "158.75",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "yysby6jtac5mq7wx",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "kmt6hfsuzg585bdm",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:39",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "72f7ccc1e68b4111b49dcb17dd4799dd",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "945",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,/Income/inc5,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,sawterm:(dvfail.r1),/Age/age3,/de_maxdiff/Q22/v65",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "65",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "6",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means reliable power for our home maybe with some eco benefits but I'm not sure how much it helps us directly",
        "sectionLOIr4": "2.64318333333",
        "sectionLOIr1": "2.64318333333",
        "sectionLOIr3": "2.2905",
        "sectionLOIr2": "0.260216666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "8",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "7",
        "Q1": "1989",
        "Q3": "43",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6c62087a-4226-4535-8f5e-5c617079a307",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/23/2026 05:41",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=72f7ccc1e68b4111b49dcb17dd4799dd&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6c62087a-4226-4535-8f5e-5c617079a307&isSynthetic=true&or_age=37&or_zip=37863&or_gender=m&or_householdincome=137900",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1957",
        "vctq1c22": "1",
        "HIDAge": "68",
        "Q2": "1",
        "Q4": "5",
        "vctq1c24": "1",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "9.346",
        "Q3": "34",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "fkstm4yer715ac9z",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "or1": "ea8540dd60e54a7b9c4a7710050335cc",
        "vlist": "2",
        "uuid": "essyw6s7ebgsqa8t",
        "vmobiledevice": "5",
        "s2": "86c6ea76-5f79-413a-8d50-d82bc2c21dc1",
        "vctq1c25": "0",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,bad:/Age/age6,qual,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "6",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "01/23/2026 05:39",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "5",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "3",
        "date": "01/23/2026 05:39",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ea8540dd60e54a7b9c4a7710050335cc&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=86c6ea76-5f79-413a-8d50-d82bc2c21dc1&isSynthetic=true&or_age=69&or_zip=27870&or_gender=m&or_householdincome=185000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "946",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "182.937",
        "Q14r9": "0",
        "Q14r8": "6",
        "session": "809bknvj0mbmhhw4",
        "Q41r1": "0",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "17",
        "Q14r2": "22",
        "Q14r5": "11",
        "Q14r4": "11",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "qymgzz6pjbfyxhfg",
        "Q22_9c2": "6",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:39",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "3d69f417b98b4b689a831f94e4a39bd5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "1",
        "record": "947",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v46,/Gender/gen1,Top_to_Bottom,/Income/inc5,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "46",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means dependable power without the rising costs I've seen with fossil fuels",
        "sectionLOIr4": "3.04426666667",
        "sectionLOIr1": "3.04426666667",
        "sectionLOIr3": "2.71926666667",
        "sectionLOIr2": "0.211333333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "5",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "5",
        "Q1": "1980",
        "Q3": "10",
        "Q2": "1",
        "Q5": "2",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "ca6a4fcc-d6ee-451f-ab68-48590986c0a0",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 05:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3d69f417b98b4b689a831f94e4a39bd5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ca6a4fcc-d6ee-451f-ab68-48590986c0a0&isSynthetic=true&or_age=44&or_zip=33414&or_gender=m&or_householdincome=60000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "72",
        "vbrowser": "10",
        "qtime": "166.152",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "3rwwf7babaswgbqb",
        "Q41r1": "0",
        "Q14r1": "65",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "4",
        "Q14r2": "3",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "dwwqf3j0hwqbqvnq",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "89695db409d94cfeab1ccfe2182025a3",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "948",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,Bottom_to_Top,/de_maxdiff/Q22/v226,/Education/edu1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "226",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "2",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It means dependable power for my daily needs.",
        "sectionLOIr4": "2.76395",
        "sectionLOIr1": "2.76395",
        "sectionLOIr3": "2.42975",
        "sectionLOIr2": "0.214983333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "5",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1953",
        "Q3": "23",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6d242562-b4ac-4427-af29-24e44ca1d788",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "6",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 05:42",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=89695db409d94cfeab1ccfe2182025a3&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6d242562-b4ac-4427-af29-24e44ca1d788&isSynthetic=true&or_age=72&or_zip=48126&or_gender=m&or_householdincome=20500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "168.138",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "8jv5dhvwk3h33mru",
        "Q41r1": "0",
        "Q14r1": "65",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "4",
        "Q14r2": "3",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "n6wepgpqjfrzg6jm",
        "Q22_9c2": "2",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2195a819585d4a3ab8046e07bc9a281c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "record": "949",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v69,sawterm:Q1.ival gt 2007,/Education/edu3,/Gender/gen2,/Age/age3,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "69",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "It's about safer air and helping our community, but I'm not sure how it'll work with our budget.",
        "sectionLOIr4": "2.7987",
        "sectionLOIr1": "2.7987",
        "sectionLOIr3": "2.47826666667",
        "sectionLOIr2": "0.2542",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "6",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1981",
        "Q3": "5",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "36590631-5b21-4d5a-a673-12267bd617e4",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "7",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/23/2026 05:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2195a819585d4a3ab8046e07bc9a281c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=36590631-5b21-4d5a-a673-12267bd617e4&isSynthetic=true&or_age=43&or_zip=95670&or_gender=f&or_householdincome=45120",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "38",
        "vbrowser": "10",
        "qtime": "149.375",
        "Q14r9": "0",
        "Q14r8": "9",
        "session": "39pzk7yfbr4r8e27",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "0",
        "uuid": "e6hvs3ebzsw05usv",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 05:42",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "dd957b266ba6485b9b766110439e0a14",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "950",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg4,/Vote/vote4,/de_maxdiff/Q22/v106,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,Top_to_Bottom,/Gender/gen2,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "106",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means not worrying about gas prices for my kids carpool runs and keeping the lights on at home without flickering",
        "sectionLOIr4": "2.48658333333",
        "sectionLOIr1": "2.48658333333",
        "sectionLOIr3": "2.15886666667",
        "sectionLOIr2": "0.204733333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1987",
        "Q3": "48",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "5eb820f5-54a9-48ca-a5a4-14cfc7fbbc71",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 05:45",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=dd957b266ba6485b9b766110439e0a14&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5eb820f5-54a9-48ca-a5a4-14cfc7fbbc71&isSynthetic=true&or_age=37&or_zip=99026&or_gender=f&or_householdincome=52000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "51",
        "vbrowser": "10",
        "qtime": "197.179",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "7crubqras7288h9f",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "9xfxymku7trkn086",
        "Q22_9c2": "5",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:43",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2451ecd88cdb4a9ca4a28bcb9daa8f20",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "951",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),/de_maxdiff/Q22/v147,20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6,/Education/edu4",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "147",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It's energy that's eco-friendly but still works when the grid's down, so my home stays stable.",
        "sectionLOIr4": "3.28255",
        "sectionLOIr1": "3.28255",
        "sectionLOIr3": "2.95678333333",
        "sectionLOIr2": "0.23895",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1974",
        "Q3": "43",
        "Q2": "1",
        "Q5": "5",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "e799568a-09db-4aff-899b-77db94242ad4",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 05:46",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2451ecd88cdb4a9ca4a28bcb9daa8f20&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e799568a-09db-4aff-899b-77db94242ad4&isSynthetic=true&or_age=52&or_zip=37167&or_gender=m&or_householdincome=164120",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "51",
        "vbrowser": "10",
        "qtime": "166.45",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "13eev5b7njxdds1p",
        "Q41r1": "1",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "18",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "h9uw24sp4q6gs97y",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/23/2026 05:43",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "090739e3f88d4653974a47c66b9e1800",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "952",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Income/inc7,Top_to_Bottom,/Gender/gen2,/de_maxdiff/Q22/v178,/Education/edu4",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "178",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It means safer air for my kids, maybe. But I'm not sure how reliable it is yet.",
        "sectionLOIr4": "2.77021666667",
        "sectionLOIr1": "2.77021666667",
        "sectionLOIr3": "2.37621666667",
        "sectionLOIr2": "0.290166666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1974",
        "Q3": "6",
        "Q2": "2",
        "Q5": "6",
        "Q4": "4",
        "Q6": "7",
        "Q22_8c2": "2",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "df06dccb-7dc8-4e13-aab9-7ba2b8fd76a0",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 05:46",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=090739e3f88d4653974a47c66b9e1800&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=df06dccb-7dc8-4e13-aab9-7ba2b8fd76a0&isSynthetic=true&or_age=49&or_zip=80015&or_gender=f&or_householdincome=228000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "31",
        "vbrowser": "10",
        "qtime": "178.967",
        "Q14r9": "5",
        "Q14r8": "10",
        "session": "411yz6rdwectqze4",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "234wupz7kx9hgdd5",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 05:43",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "501900df97114c5a959a4468f2afc3f7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "953",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Education/edu2,/Ethnicity/eth3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v223,Top_to_Bottom,/Gender/gen2,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "223",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means dependable power that doesn't cost too much.",
        "sectionLOIr4": "2.97748333333",
        "sectionLOIr1": "2.97748333333",
        "sectionLOIr3": "2.64486666667",
        "sectionLOIr2": "0.243",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1994",
        "Q3": "36",
        "Q2": "2",
        "Q5": "3",
        "Q4": "2",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "ed0c2fd9-7d32-4f39-8cf3-77cc2ec630be",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/23/2026 05:46",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=501900df97114c5a959a4468f2afc3f7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ed0c2fd9-7d32-4f39-8cf3-77cc2ec630be&isSynthetic=true&or_age=31&or_zip=44241&or_gender=f&or_householdincome=20100",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "76",
        "vbrowser": "10",
        "qtime": "162.731",
        "Q14r9": "5",
        "Q14r8": "10",
        "session": "mh7hhsrw0yh0hje8",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "5",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "15",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "ws9shgwra20g20wk",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "1",
        "Q43": "2",
        "start_date": "01/23/2026 05:45",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "fadb249a448748ecb0de457f977a126c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "9",
        "record": "954",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/de_maxdiff/Q22/v33,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "33",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "2",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "It means having reliable power for my cat's cozy corner and the city's green initiatives that let us explore without guilt",
        "sectionLOIr4": "2.70985",
        "sectionLOIr1": "2.70985",
        "sectionLOIr3": "2.42411666667",
        "sectionLOIr2": "0.276183333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "10",
        "Q15r5": "7",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1949",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "c8ea09e0-098a-4338-8c7f-3bd096ea98b7",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "5",
        "date": "01/23/2026 05:48",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=fadb249a448748ecb0de457f977a126c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c8ea09e0-098a-4338-8c7f-3bd096ea98b7&isSynthetic=true&or_age=75&or_zip=10011&or_gender=f&or_householdincome=30000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "20",
        "vbrowser": "10",
        "qtime": "178.533",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "ubqvsrf8cye5vshf",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "bgyyk6vxp5k1k8ss",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 06:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b377e0e2bfd44e609436a503362694b6",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "955",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v15,/Gender/gen2,/Income/inc1,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "15",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means less pollution and stable costs for our home.",
        "sectionLOIr4": "2.97341666667",
        "sectionLOIr1": "2.97341666667",
        "sectionLOIr3": "2.62385",
        "sectionLOIr2": "0.29785",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "1",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2005",
        "Q3": "19",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "1",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "d575cd6c-d9b4-4c9b-946e-65775d099144",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "5",
        "Q22_3c2": "1",
        "Q8r5": "6",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "1",
        "date": "01/23/2026 06:03",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b377e0e2bfd44e609436a503362694b6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d575cd6c-d9b4-4c9b-946e-65775d099144&isSynthetic=true&or_age=20&or_zip=70563&or_gender=f&or_householdincome=19000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "83",
        "vbrowser": "10",
        "qtime": "187.619",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "yjd6dnya8hk27vwv",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "0bkun1bey37hxxdz",
        "Q22_9c2": "1",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7312f581de834ff89f094926c71d1be6",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "956",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v115,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Education/edu3,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "115",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Dependable power for my home, like keeping the fridge running. Reduces pollution, which is good for the air and the dog.",
        "sectionLOIr4": "3.12465",
        "sectionLOIr1": "3.12465",
        "sectionLOIr3": "2.85801666667",
        "sectionLOIr2": "0.3379",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "8",
        "Q1": "1942",
        "Q3": "11",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "e976e689-f438-4586-9145-0cde79526271",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 06:03",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7312f581de834ff89f094926c71d1be6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e976e689-f438-4586-9145-0cde79526271&isSynthetic=true&or_age=83&or_zip=35652&or_gender=f&or_householdincome=22491",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "165.579",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "gszv3kjjfujcd3w4",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ma5ppxk06ck4zap8",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "5285d90476d443428deeca192f5fb0d8",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "957",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,/de_maxdiff/Q22/v193,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "193",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Steady power without big surprises",
        "sectionLOIr4": "2.75773333333",
        "sectionLOIr1": "2.75773333333",
        "sectionLOIr3": "2.36645",
        "sectionLOIr2": "0.304466666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "5",
        "Q15r9": "4",
        "Q1": "1959",
        "Q3": "26",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "bb87d63c-94ad-4036-ad4d-6b1c57455aa3",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/23/2026 06:03",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5285d90476d443428deeca192f5fb0d8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=bb87d63c-94ad-4036-ad4d-6b1c57455aa3&isSynthetic=true&or_age=66&or_zip=64128&or_gender=m&or_householdincome=43200",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "84",
        "vbrowser": "10",
        "qtime": "185.514",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "y5ccvvkukv3duxxd",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "1ztt9vnvhfzu0eg9",
        "Q22_9c2": "3",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "3c3fc19e17424865a2696115735d82be",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "958",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v182,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Education/edu4,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "182",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "2",
        "Q22_4c2": "3",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "It means cleaner air for my town, but I need it to be reliable.",
        "sectionLOIr4": "3.08936666667",
        "sectionLOIr1": "3.08936666667",
        "sectionLOIr3": "2.78555",
        "sectionLOIr2": "0.318383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1941",
        "Q3": "47",
        "Q2": "2",
        "Q5": "5",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "2",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "2ee7322c-3bf1-4c47-955b-e6fb3a1b5ce8",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/23/2026 06:03",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3c3fc19e17424865a2696115735d82be&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=2ee7322c-3bf1-4c47-955b-e6fb3a1b5ce8&isSynthetic=true&or_age=84&or_zip=24541&or_gender=f&or_householdincome=33000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "147.167",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "8tty0255dcsbk7x5",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "gkbbqjskc7bqbw5k",
        "Q22_9c2": "2",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:03",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6ba11ac6e34346239f5e310b0e2994c7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "959",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v70,/Gender/gen1,/Education/edu3,/Income/inc5,/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "70",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power for my home, like how my car runs smoothly.",
        "sectionLOIr4": "2.4501",
        "sectionLOIr1": "2.4501",
        "sectionLOIr3": "2.10806666667",
        "sectionLOIr2": "0.218166666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1981",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "68e31b23-e82a-456c-bda8-f875592d9ef4",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 06:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6ba11ac6e34346239f5e310b0e2994c7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=68e31b23-e82a-456c-bda8-f875592d9ef4&isSynthetic=true&or_age=45&or_zip=93307&or_gender=m&or_householdincome=114000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1996",
        "vctq1c22": "0",
        "HIDAge": "29",
        "Q2": "2",
        "Q4": "5",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "9.92",
        "Q3": "3",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "z2tjphrcgkm08pka",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "or1": "331f981ddfcc41a0ade2c2fa123d96c1",
        "vlist": "2",
        "uuid": "dqk4wf3ztg8ent1k",
        "vmobiledevice": "5",
        "s2": "8c233be9-4d06-417f-b523-c61352999474",
        "vctq1c25": "1",
        "markers": "bad:/Rotate Selection/Top_to_Bottom,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,sawterm:Q1.ival gt 2007,OQ,bad:/Region/reg4,bad:/Age/age2,Top_to_Bottom,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "2",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "01/23/2026 06:03",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "8",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "4",
        "date": "01/23/2026 06:04",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=331f981ddfcc41a0ade2c2fa123d96c1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8c233be9-4d06-417f-b523-c61352999474&isSynthetic=true&or_age=30&or_zip=85029&or_gender=f&or_householdincome=81500",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "960",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "160.692",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "026z2mgvufdthm2g",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "13",
        "Q14r5": "13",
        "Q14r4": "18",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "sjvqz3a05vhnsejv",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "37a0eb31c4c4444d9edec162ca8e6ade",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "961",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,/Education/edu4,qual,/de_maxdiff/Q22/v177,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "177",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable electric heating in my home and knowing my bills are stable",
        "sectionLOIr4": "2.6759",
        "sectionLOIr1": "2.6759",
        "sectionLOIr3": "2.29926666667",
        "sectionLOIr2": "0.20785",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1967",
        "Q3": "24",
        "Q2": "2",
        "Q5": "6",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "a49bb497-e00f-4cc7-aa1c-fe7a4573d835",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/23/2026 06:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=37a0eb31c4c4444d9edec162ca8e6ade&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a49bb497-e00f-4cc7-aa1c-fe7a4573d835&isSynthetic=true&or_age=58&or_zip=55379&or_gender=f&or_householdincome=110000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "160.075",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "x20vzkvfeswsw123",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "mmuazrjde16ysksh",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "566e38c9450b4f29804aaee8fa158033",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "3",
        "record": "962",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),/Education/edu1,20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,/de_maxdiff/Q22/v13,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "13",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "6",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means safer air for my town and reliable power for my home",
        "sectionLOIr4": "2.66535",
        "sectionLOIr1": "2.66535",
        "sectionLOIr3": "2.36713333333",
        "sectionLOIr2": "0.212233333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1980",
        "Q3": "39",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "2",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c081fc85-9742-40a6-b21f-ae0ecffa6694",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/23/2026 06:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=566e38c9450b4f29804aaee8fa158033&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c081fc85-9742-40a6-b21f-ae0ecffa6694&isSynthetic=true&or_age=45&or_zip=15683&or_gender=f&or_householdincome=42000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "33",
        "vbrowser": "10",
        "qtime": "173.61",
        "Q41r2": "0",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "1ank2urj1vbvmmuj",
        "Q41r1": "0",
        "Q14r1": "29",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "9",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "4weh9x7wx6fjyqqn",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "1",
        "Q22_version": "137",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "01/23/2026 06:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "17abc337c3b64cf58d1bb81e2e344cf2",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,/de_maxdiff/Q22/v137,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc6,/Education/edu3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "3",
        "Q35": "6",
        "Q22_7c1": "3",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q30": "2",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "1",
        "Q24": "It's a label for unproven tech that can't keep the lights on.",
        "sectionLOIr4": "2.88846666667",
        "sectionLOIr1": "2.88846666667",
        "sectionLOIr3": "2.50388333333",
        "sectionLOIr2": "0.2242",
        "vctq1c21": "0",
        "Q35r6oe": "Other",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "0",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "record": "963",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "0",
        "Q9r1": "2",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1992",
        "Q3": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "91ba7bfa-34b8-452c-8535-54216cc1ca90",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/23/2026 06:07",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=17abc337c3b64cf58d1bb81e2e344cf2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=91ba7bfa-34b8-452c-8535-54216cc1ca90&isSynthetic=true&or_age=33&or_zip=97128&or_gender=m&or_householdincome=135000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "37",
        "vbrowser": "10",
        "qtime": "167.183",
        "Q14r9": "9",
        "Q14r8": "14",
        "session": "3yghwvzw9a8rvw3n",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "27qs64pvxkqpa9tr",
        "Q22_9c2": "4",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4be2afed8b3d4e3f87b43af31c212dfa",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "964",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Income/inc5,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/de_maxdiff/Q22/v75,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Age/age3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "75",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "100",
        "Q23": "3",
        "Q24": "It’s about reliable power for my kids’ homework and the fridge, but I’m not sold on the switch yet.",
        "sectionLOIr4": "2.77971666667",
        "sectionLOIr1": "2.77971666667",
        "sectionLOIr3": "2.46398333333",
        "sectionLOIr2": "0.2155",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "62.5",
        "HIDAge2": "3",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "8",
        "Q22_2c2": "3",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1988",
        "Q3": "11",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "6",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "e6b70543-2224-4b09-8e9f-3115940aeda1",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "8",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/23/2026 06:09",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4be2afed8b3d4e3f87b43af31c212dfa&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e6b70543-2224-4b09-8e9f-3115940aeda1&isSynthetic=true&or_age=38&or_zip=30642&or_gender=m&or_householdincome=107000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "57",
        "vbrowser": "10",
        "qtime": "165.679",
        "Q14r9": "1",
        "Q14r8": "5",
        "session": "7bs7p7mv212589qw",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "25",
        "Q14r5": "10",
        "Q14r4": "15",
        "Q14r7": "3",
        "Q14r6": "1",
        "uuid": "mctgbvzjeb4k1hnt",
        "Q22_9c2": "8",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:07",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "aa04d390e38842bab3bbb659d7ec124f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "965",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v40,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,/Income/inc5",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "40",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "1",
        "Q39r1": "2",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "It means lower bills and a cleaner environment, but I worry about weather affecting solar and wind. I’d rather have a mix with reliable backups.",
        "sectionLOIr4": "2.7576",
        "sectionLOIr1": "2.7576",
        "sectionLOIr3": "2.41965",
        "sectionLOIr2": "0.2712",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "5",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1968",
        "Q3": "48",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1744f7be-e4e8-43d6-83ab-f73d6c896e43",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "1",
        "Q8r2": "2",
        "date": "01/23/2026 06:10",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=aa04d390e38842bab3bbb659d7ec124f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1744f7be-e4e8-43d6-83ab-f73d6c896e43&isSynthetic=true&or_age=57&or_zip=98271&or_gender=m&or_householdincome=110000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "79",
        "vbrowser": "10",
        "qtime": "190.262",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "nmgu5y8r6ejhu2gx",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "x22knyazgvaex6hb",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:07",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c4934a07b1ac4ef2923ce8c20c55967f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "1",
        "record": "966",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/de_maxdiff/Q22/v172,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "172",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means having power that's reliable and not too pricey, so I can keep things simple.",
        "sectionLOIr4": "3.16826666667",
        "sectionLOIr1": "3.16826666667",
        "sectionLOIr3": "2.81233333333",
        "sectionLOIr2": "0.240383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1946",
        "Q3": "11",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "37397592-cdfa-43ea-bee8-a9f7b9acf8fd",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 06:10",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c4934a07b1ac4ef2923ce8c20c55967f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=37397592-cdfa-43ea-bee8-a9f7b9acf8fd&isSynthetic=true&or_age=80&or_zip=30062&or_gender=m&or_householdincome=49736",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "96",
        "vbrowser": "10",
        "qtime": "168.319",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "q5pyvc2jca7gsxuj",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "htevbugfvdsreyvb",
        "Q22_9c2": "1",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "9fcdbbffe15f424888ac0110e2563949",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "1",
        "record": "967",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v296,Top_to_Bottom,/Gender/gen2,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "296",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means safer air, but I’m cautious. Proven solutions feel more reliable than new terms.",
        "sectionLOIr4": "2.7991",
        "sectionLOIr1": "2.7991",
        "sectionLOIr3": "2.47736666667",
        "sectionLOIr2": "0.25315",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1929",
        "Q3": "10",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "553c5eae-9105-4fde-b86c-82c5bd0e7bc5",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/23/2026 06:10",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=9fcdbbffe15f424888ac0110e2563949&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=553c5eae-9105-4fde-b86c-82c5bd0e7bc5&isSynthetic=true&or_age=96&or_zip=32117&or_gender=f&or_householdincome=20000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "169.891",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "x1h3juu97nkqzh1m",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "5",
        "Q14r5": "15",
        "Q14r4": "15",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "msjkpjqus3rtk62v",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "1",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 06:10",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "6b211732a5724e619f394a757710395f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "3",
        "record": "968",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v143,/Region/reg4,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,/Education/edu4,/Income/inc2",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q22_version": "143",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "3",
        "Q39r4": "5",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "9",
        "Q22_4c2": "8",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "0",
        "Q23": "1",
        "Q24": "clean energy is just another system that promises a lot but delivers nothing real. it's all hype without the actual stability i need",
        "sectionLOIr4": "2.82953333333",
        "sectionLOIr1": "2.82953333333",
        "sectionLOIr3": "2.41758333333",
        "sectionLOIr2": "0.246233333333",
        "vctq1c21": "1",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "4",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "0",
        "Q15r5": "0",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1967",
        "Q3": "5",
        "Q2": "2",
        "Q5": "5",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "26b3dd25-b371-46f0-bb50-187a68cc2bfd",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 06:13",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6b211732a5724e619f394a757710395f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=26b3dd25-b371-46f0-bb50-187a68cc2bfd&isSynthetic=true&or_age=58&or_zip=93257&or_gender=f&or_householdincome=29640",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "159.65",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "apqmh5hrjz5aqs3e",
        "Q41r1": "1",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "8tps0t54gbbjp0un",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:10",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b631dbcae2974c2abe6bd695da7cc210",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "969",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v14,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Income/inc5,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "14",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means reliable power that doesn't harm the environment but i'm cautious about costs and dependability",
        "sectionLOIr4": "2.65648333333",
        "sectionLOIr1": "2.65648333333",
        "sectionLOIr3": "2.27323333333",
        "sectionLOIr2": "0.21545",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1978",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "7cad87d9-18e6-4674-bee2-4bcbeeedd4fa",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 06:13",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b631dbcae2974c2abe6bd695da7cc210&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7cad87d9-18e6-4674-bee2-4bcbeeedd4fa&isSynthetic=true&or_age=46&or_zip=93906&or_gender=m&or_householdincome=215000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "64",
        "vbrowser": "10",
        "qtime": "192.376",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "g05wum78r8rnuq5y",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "153p6dfn4qrp1g3m",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 06:11",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "22b7930545a04fa5bdc50c11f3588bb1",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "970",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v274,Top_to_Bottom,/Gender/gen2,/Income/inc1,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "274",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it's a step in the right direction but the reliability and cost are still problems",
        "sectionLOIr4": "3.20405",
        "sectionLOIr1": "3.20405",
        "sectionLOIr3": "2.926",
        "sectionLOIr2": "0.211166666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "9",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "5",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1961",
        "Q3": "43",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "1",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "ac56a86c-fdbc-441d-a383-d20ba030e5e0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "3",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 06:14",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=22b7930545a04fa5bdc50c11f3588bb1&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ac56a86c-fdbc-441d-a383-d20ba030e5e0&isSynthetic=true&or_age=62&or_zip=37620&or_gender=f&or_householdincome=22100",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "51",
        "vbrowser": "10",
        "qtime": "158.627",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "fpeq58qut4exzyy4",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "v2r5btzjcb6n36he",
        "Q22_9c2": "9",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:11",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "fbd6ea5576494b57a8cd841716bad8ca",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "1",
        "record": "971",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v26,/Region/reg3,/Ethnicity/eth3,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "26",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means dependable power for my home and work without unexpected costs",
        "sectionLOIr4": "2.63876666667",
        "sectionLOIr1": "2.63876666667",
        "sectionLOIr3": "2.2812",
        "sectionLOIr2": "0.220133333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1974",
        "Q3": "34",
        "Q2": "2",
        "Q5": "2",
        "Q4": "2",
        "Q6": "3",
        "Q22_8c2": "6",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "cdbe9e9d-1e9c-468d-a72c-794ee6a95254",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 06:14",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=fbd6ea5576494b57a8cd841716bad8ca&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cdbe9e9d-1e9c-468d-a72c-794ee6a95254&isSynthetic=true&or_age=51&or_zip=27613&or_gender=f&or_householdincome=36000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "41",
        "vbrowser": "10",
        "qtime": "187.113",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "gmx9kb0zg768tzph",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "b0ezfhtdp6h5mgjn",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:13",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e48a5f46c0fc4fd4b8b7877b56bd801c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "972",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v224,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Age/age3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "224",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "9",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "solar panels and lower bills but I still need backup",
        "sectionLOIr4": "3.11565",
        "sectionLOIr1": "3.11565",
        "sectionLOIr3": "2.80851666667",
        "sectionLOIr2": "0.224783333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "100",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1984",
        "Q3": "19",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1ce02079-7160-4147-a34a-6e5fe7adc904",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/23/2026 06:16",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e48a5f46c0fc4fd4b8b7877b56bd801c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1ce02079-7160-4147-a34a-6e5fe7adc904&isSynthetic=true&or_age=41&or_zip=70343&or_gender=m&or_householdincome=65600",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "60",
        "vbrowser": "10",
        "qtime": "176.259",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "y4zex9we13c50nje",
        "Q41r1": "0",
        "Q14r1": "18",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "a4wautp5vc1yqp0b",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:13",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "37fe7c996fb240f08ae1c98228569886",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "1",
        "record": "973",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/de_maxdiff/Q22/v106,Bottom_to_Top,/Ethnicity/eth4,/Education/edu1,20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "106",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means energy that doesn’t pollute, like solar or wind. Helps keep things running without harming the air, which is good for my health and the community. But I’m still cautious about costs and how well it works in our climate.",
        "sectionLOIr4": "2.93516666667",
        "sectionLOIr1": "2.93516666667",
        "sectionLOIr3": "2.60468333333",
        "sectionLOIr2": "0.224433333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1965",
        "Q3": "33",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "4964d78f-b410-4c77-9194-82d0df457e74",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/23/2026 06:17",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=37fe7c996fb240f08ae1c98228569886&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4964d78f-b410-4c77-9194-82d0df457e74&isSynthetic=true&or_age=60&or_zip=10701&or_gender=m&or_householdincome=42000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "163.573",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "594035nsw5vjpd9d",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "1jvc43crx46pr6rj",
        "Q22_9c2": "5",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:14",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "9d5ec00023f64a8fbe3097513b632566",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "974",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v72,/Income/inc5,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "72",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means safer air for my family and reliable power for my garden.",
        "sectionLOIr4": "2.71698333333",
        "sectionLOIr1": "2.71698333333",
        "sectionLOIr3": "2.35445",
        "sectionLOIr2": "0.2473",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "9",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1969",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "8b074f50-0378-40de-9bf0-9e00825ceecc",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 06:17",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=9d5ec00023f64a8fbe3097513b632566&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8b074f50-0378-40de-9bf0-9e00825ceecc&isSynthetic=true&or_age=57&or_zip=77407&or_gender=f&or_householdincome=86304",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "70",
        "vbrowser": "10",
        "qtime": "172.971",
        "Q14r9": "5",
        "Q14r8": "4",
        "session": "g75p7jcep39jt7t3",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "23",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "up12h3zc77cj8eqf",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:14",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "8028f338322c44a1831ee03565eb17ca",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "975",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu3,/de_maxdiff/Q22/v205",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "205",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means power that doesn't mess up my budget",
        "sectionLOIr4": "2.87843333333",
        "sectionLOIr1": "2.87843333333",
        "sectionLOIr3": "2.5405",
        "sectionLOIr2": "0.24655",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1955",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8470d6e0-12b5-4173-a574-e6ca7a5972b9",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "01/23/2026 06:17",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8028f338322c44a1831ee03565eb17ca&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8470d6e0-12b5-4173-a574-e6ca7a5972b9&isSynthetic=true&or_age=70&or_zip=75010&or_gender=f&or_householdincome=35000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "172.178",
        "Q14r9": "5",
        "Q14r8": "10",
        "session": "yp38qt0uhs4p88vc",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "kqxuc7ne8h7vpqey",
        "Q22_9c2": "8",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:17",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "4d270b84893e4218bdac1e33667aa99a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "9",
        "record": "976",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Ethnicity/eth1,/Gender/gen2,/de_maxdiff/Q22/v79,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "79",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It means stable electricity for my laptop and smartwatch without unexpected costs.",
        "sectionLOIr4": "2.8667",
        "sectionLOIr1": "2.8667",
        "sectionLOIr3": "2.47573333333",
        "sectionLOIr2": "0.239933333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "0",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1995",
        "Q3": "29",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "c88d660b-fb45-4319-8fdb-cf06f3bad885",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "6",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 06:20",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4d270b84893e4218bdac1e33667aa99a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c88d660b-fb45-4319-8fdb-cf06f3bad885&isSynthetic=true&or_age=28&or_zip=89506&or_gender=f&or_householdincome=54000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "49",
        "vbrowser": "10",
        "qtime": "160.479",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "uecnnp3gkwzx5cht",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "b7780fjetq6dj2f2",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:17",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "dff9cd6817564afe88473252b5e4ae02",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "977",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v82,/Gender/gen1,Top_to_Bottom,/Income/inc6,/Education/edu4",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "82",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "it means less smog for our weekend hikes and more stable power for my gaming setup",
        "sectionLOIr4": "2.67266666667",
        "sectionLOIr1": "2.67266666667",
        "sectionLOIr3": "2.30506666667",
        "sectionLOIr2": "0.203966666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "4",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1976",
        "Q3": "14",
        "Q2": "1",
        "Q5": "5",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "8fffd801-b258-4645-b534-d108a313d60f",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/23/2026 06:20",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=dff9cd6817564afe88473252b5e4ae02&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8fffd801-b258-4645-b534-d108a313d60f&isSynthetic=true&or_age=49&or_zip=60504&or_gender=m&or_householdincome=169272",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "151.514",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "rcd1jyrrxerr27ym",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "71ndqxf2j5kdk4em",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:18",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "6a8469d615af4582bae4f1a80b9b5e16",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "4",
        "record": "978",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu3,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v298,Top_to_Bottom,/Gender/gen2,/Age/age3,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "298",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power that’s better for the environment, but I know it’s not perfect yet.",
        "sectionLOIr4": "2.52041666667",
        "sectionLOIr1": "2.52041666667",
        "sectionLOIr3": "2.19208333333",
        "sectionLOIr2": "0.21825",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1986",
        "Q3": "36",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "bc49ba7a-f8c8-4b9b-8618-810ed8e5261b",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "5",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 06:20",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6a8469d615af4582bae4f1a80b9b5e16&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=bc49ba7a-f8c8-4b9b-8618-810ed8e5261b&isSynthetic=true&or_age=37&or_zip=45013&or_gender=f&or_householdincome=46000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "157.244",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "kqyxm1cpumv987vq",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "jvzp79ezwuwq2g23",
        "Q22_9c2": "2",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "2",
        "Q21r7": "1",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:18",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "a8107798db1044dc884ad39702b33411",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "979",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Education/edu2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc4,/Gender/gen2,/de_maxdiff/Q22/v262",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "262",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power that doesn’t drain my budget, like my Prius cutting gas costs. It also feels like a safer future for my kid, balancing tech progress with real-world needs.",
        "sectionLOIr4": "2.61746666667",
        "sectionLOIr1": "2.61746666667",
        "sectionLOIr3": "2.26793333333",
        "sectionLOIr2": "0.235666666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "75",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "10",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1996",
        "Q3": "5",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "eb4e0d0d-c5a7-4790-abbb-3ce72e259934",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "7",
        "Q22_3c2": "3",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 06:21",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a8107798db1044dc884ad39702b33411&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=eb4e0d0d-c5a7-4790-abbb-3ce72e259934&isSynthetic=true&or_age=28&or_zip=94531&or_gender=f&or_householdincome=77000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "43",
        "vbrowser": "10",
        "qtime": "180.388",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "8x9e6trnrehuh0wq",
        "Q41r1": "1",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "hds7k0yyy45hw0an",
        "Q22_9c2": "6",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:20",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6ef031b4bd734e4ca09a5d0b3f281017",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "980",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/Ethnicity/eth3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/de_maxdiff/Q22/v218,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Age/age3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "218",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "3",
        "Q22_4c2": "1",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "Reliable power that doesn’t harm the planet, but I also think we need to balance it with what’s practical right now.",
        "sectionLOIr4": "3.0045",
        "sectionLOIr1": "3.0045",
        "sectionLOIr3": "2.68151666667",
        "sectionLOIr2": "0.208433333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "5",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1982",
        "Q3": "5",
        "Q2": "1",
        "Q5": "3",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "2b9288ea-f687-42a3-a657-5d10b3c3f2bc",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "6",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 06:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6ef031b4bd734e4ca09a5d0b3f281017&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=2b9288ea-f687-42a3-a657-5d10b3c3f2bc&isSynthetic=true&or_age=43&or_zip=15236&or_gender=m&or_householdincome=92000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "177.66",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "gfqmpzbq4xcuu443",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "1qke92gc520qpcbs",
        "Q22_9c2": "1",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:20",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "58568b4fb5db478c9f8b416ab27a913a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "981",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,Bottom_to_Top,/Ethnicity/eth2,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v222,sawterm:Q1.ival gt 2007,/Gender/gen2,/Vote/vote2,/Income/inc3,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "222",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It's about safer air for my dog and the neighborhood. I think it's important but I'm not sure how much it's actually making a difference yet.",
        "sectionLOIr4": "2.95863333333",
        "sectionLOIr1": "2.95863333333",
        "sectionLOIr3": "2.65483333333",
        "sectionLOIr2": "0.22995",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "5",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1996",
        "Q3": "44",
        "Q2": "2",
        "Q5": "2",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6ac0216f-eabf-4aa9-a67b-c155a054c349",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "6",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 06:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=58568b4fb5db478c9f8b416ab27a913a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6ac0216f-eabf-4aa9-a67b-c155a054c349&isSynthetic=true&or_age=29&or_zip=77573&or_gender=f&or_householdincome=74000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "73",
        "vbrowser": "10",
        "qtime": "196.185",
        "Q14r9": "0",
        "Q14r8": "9",
        "session": "2jbv9ttmndjeppjw",
        "Q41r1": "0",
        "Q14r1": "31",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "17",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "0",
        "uuid": "9smft0ynrpr7g4h5",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 06:21",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "a1224af86ed048a4bca4bb712f95d432",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "982",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v247,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "247",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "1",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means no hiccups on my setup and a stable budget",
        "sectionLOIr4": "3.26593333333",
        "sectionLOIr1": "3.26593333333",
        "sectionLOIr3": "2.94333333333",
        "sectionLOIr2": "0.219483333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "1",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1952",
        "Q3": "26",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6b38235b-cfcc-475d-b874-fd0a7fda3bf0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/23/2026 06:24",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a1224af86ed048a4bca4bb712f95d432&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6b38235b-cfcc-475d-b874-fd0a7fda3bf0&isSynthetic=true&or_age=72&or_zip=64078&or_gender=m&or_householdincome=62400",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "173.441",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "zbkbdn87hars86rv",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "25",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "v9v58dxc30ef86dr",
        "Q22_9c2": "4",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/23/2026 06:21",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "3bf6cd3769c640599e04267c86087efc",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "7",
        "record": "983",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v55,/Income/inc5,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "55",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "4",
        "Q39r2": "2",
        "Q39r3": "1",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "3",
        "Q24": "it means reliable power for our family and community especially with the new solar farms around here i love how it's creating jobs and keeping things affordable the future feels brighter when we invest in clean tech!",
        "sectionLOIr4": "2.88831666667",
        "sectionLOIr1": "2.88831666667",
        "sectionLOIr3": "2.5202",
        "sectionLOIr2": "0.271516666667",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "87.5",
        "HIDAge2": "5",
        "Q22_scorer5": "0",
        "Q22_scorer4": "12.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "8",
        "Q22_2c2": "5",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1967",
        "Q3": "16",
        "Q2": "2",
        "Q5": "2",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "201c948b-4e92-4401-9e22-65d710ac1822",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "1",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "5",
        "date": "01/23/2026 06:24",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3bf6cd3769c640599e04267c86087efc&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=201c948b-4e92-4401-9e22-65d710ac1822&isSynthetic=true&or_age=59&or_zip=52641&or_gender=f&or_householdincome=109600",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "81",
        "vbrowser": "10",
        "qtime": "135.106",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "h72p0hxxkkrt8v20",
        "Q41r1": "0",
        "Q14r1": "32",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "2he281awhnzb0g8a",
        "Q22_9c2": "1",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 06:24",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c8f196fa26e64588a736b0458f675b0c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "984",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/Ethnicity/eth3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v155,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "155",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "1",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "reliable power that doesn't cost too much",
        "sectionLOIr4": "2.24985",
        "sectionLOIr1": "2.24985",
        "sectionLOIr3": "1.95423333333",
        "sectionLOIr2": "0.213566666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1944",
        "Q3": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "2",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a360555f-79b6-46ee-9610-2a5124f1aeed",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/23/2026 06:26",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c8f196fa26e64588a736b0458f675b0c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a360555f-79b6-46ee-9610-2a5124f1aeed&isSynthetic=true&or_age=81&or_zip=97230&or_gender=m&or_householdincome=19624",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "191.759",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "zg4ztc3ue35b4tdv",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "jkzy8d0uec88svud",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 07:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "7f35c83438244ff3a93d18f71e58d2f8",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "985",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v274,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "274",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It's about reliable power for my family and community, with some future benefits. I'm not sure how fast it'll replace traditional sources, but I trust established methods more.",
        "sectionLOIr4": "3.1933",
        "sectionLOIr1": "3.1933",
        "sectionLOIr3": "2.82661666667",
        "sectionLOIr2": "0.339866666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "2",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1969",
        "Q3": "10",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "8a62ed78-16f3-40b4-b22a-3b0bac17ff0d",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "01/23/2026 07:58",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7f35c83438244ff3a93d18f71e58d2f8&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8a62ed78-16f3-40b4-b22a-3b0bac17ff0d&isSynthetic=true&or_age=54&or_zip=33012&or_gender=f&or_householdincome=108000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "33",
        "vbrowser": "10",
        "qtime": "187.827",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "629ag2h9etyhv10m",
        "Q41r1": "0",
        "Q14r1": "32",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "v6abq3y7qk0bshma",
        "Q22_9c2": "7",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 07:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d9ad1b58fd07478bbe393f757a8c2615",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "986",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v16,/Gender/gen2,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "16",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "It means using solar or wind to power my home and car. I care about reducing pollution, but I also think about costs and how it fits my budget.",
        "sectionLOIr4": "3.128",
        "sectionLOIr1": "3.128",
        "sectionLOIr3": "2.767",
        "sectionLOIr2": "0.301666666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "0",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "10",
        "Q15r7": "0",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1992",
        "Q3": "10",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "f734b76c-f9f1-4354-a541-6a930ee9d867",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/23/2026 07:58",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d9ad1b58fd07478bbe393f757a8c2615&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f734b76c-f9f1-4354-a541-6a930ee9d867&isSynthetic=true&or_age=34&or_zip=33016&or_gender=f&or_householdincome=69000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "84",
        "vbrowser": "10",
        "qtime": "192.229",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "sk65m7ftyy9efqwe",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "wae3t5dsq29npv9f",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 07:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "550c64ea10744447aa1e154c3afe338d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "987",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,/de_maxdiff/Q22/v272,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "272",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "9",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means less smog for my walks and better bills for our apartment",
        "sectionLOIr4": "3.20015",
        "sectionLOIr1": "3.20015",
        "sectionLOIr3": "2.88038333333",
        "sectionLOIr2": "0.336733333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1941",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "412eef9d-1863-4fd1-9b73-bc2ef8fdbd2c",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/23/2026 07:58",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=550c64ea10744447aa1e154c3afe338d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=412eef9d-1863-4fd1-9b73-bc2ef8fdbd2c&isSynthetic=true&or_age=85&or_zip=75231&or_gender=m&or_householdincome=21512",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "181.335",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "dr5xf4jba0hzxg9h",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "s1umz04s7kqayb1p",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 07:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ea8c5efa8d5646d685f6ed5e9d5dc115",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "5",
        "record": "988",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Education/edu2,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,/de_maxdiff/Q22/v78",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "78",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "9",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "reliable power for our home",
        "sectionLOIr4": "3.01593333333",
        "sectionLOIr1": "3.01593333333",
        "sectionLOIr3": "2.69591666667",
        "sectionLOIr2": "0.340016666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "9",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1996",
        "Q3": "10",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "3e33546b-040e-4b72-b6ae-b00c77453875",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/23/2026 07:58",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ea8c5efa8d5646d685f6ed5e9d5dc115&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3e33546b-040e-4b72-b6ae-b00c77453875&isSynthetic=true&or_age=30&or_zip=33467&or_gender=m&or_householdincome=84500",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "184.431",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "ym7d7x48utk2t30e",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "kayzxw198n17bj14",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 07:58",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "185f40f4eaeb42579ba25df92b0a795a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "3",
        "record": "989",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,qual,/de_maxdiff/Q22/v69,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Vote/vote2,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "69",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means power that's safe and steady",
        "sectionLOIr4": "3.06928333333",
        "sectionLOIr1": "3.06928333333",
        "sectionLOIr3": "2.75766666667",
        "sectionLOIr2": "0.214633333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1970",
        "Q3": "19",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "301dab4c-b4e3-4698-93b9-f56f06d00c5d",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 08:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=185f40f4eaeb42579ba25df92b0a795a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=301dab4c-b4e3-4698-93b9-f56f06d00c5d&isSynthetic=true&or_age=56&or_zip=71019&or_gender=f&or_householdincome=59000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "180.919",
        "Q14r9": "13",
        "Q14r8": "4",
        "session": "1qu81uxfqg1h66r8",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "6x8hjbkp0jm3qp1w",
        "Q22_9c2": "5",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 07:58",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "944e390e4a384976ab2f27aacdb9856d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "990",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v83,/Gender/gen1,Top_to_Bottom,/Age/age3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "83",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "1",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means steady power for my tools and home, like solar or wind that's reliable and proven.",
        "sectionLOIr4": "3.01238333333",
        "sectionLOIr1": "3.01238333333",
        "sectionLOIr3": "2.60536666667",
        "sectionLOIr2": "0.2626",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1989",
        "Q3": "44",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "ff4fddf9-4214-4e27-9fc6-2abb13dfbc20",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 08:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=944e390e4a384976ab2f27aacdb9856d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ff4fddf9-4214-4e27-9fc6-2abb13dfbc20&isSynthetic=true&or_age=35&or_zip=77068&or_gender=m&or_householdincome=52000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "33",
        "vbrowser": "10",
        "qtime": "161.693",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "5ccnvn8101zk1jr7",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "npvp26vmq27afwzj",
        "Q22_9c2": "2",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 07:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "3b1f79cfb326416b9e9c6a2a4e9b1863",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "991",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/de_maxdiff/Q22/v9,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "9",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "1",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "it means reliable power for my house and the environment but i also know we gotta balance it with what works for our community",
        "sectionLOIr4": "2.69251666667",
        "sectionLOIr1": "2.69251666667",
        "sectionLOIr3": "2.3322",
        "sectionLOIr2": "0.267233333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1992",
        "Q3": "34",
        "Q2": "2",
        "Q5": "2",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "a726f6df-44e4-4818-8e76-eb3dc6a96bf7",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/23/2026 08:01",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3b1f79cfb326416b9e9c6a2a4e9b1863&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a726f6df-44e4-4818-8e76-eb3dc6a96bf7&isSynthetic=true&or_age=34&or_zip=28306&or_gender=f&or_householdincome=83000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "147.726",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "060ntx0ch7mk7r6b",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "pdpar66nsfs6ym64",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 07:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "108aadedfec84ad7af3bd15f8dd1047e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "1",
        "Q22_1c1": "9",
        "record": "992",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/de_maxdiff/Q22/v4,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,/Education/edu4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "4",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means reliable power for my garden and home without harming the environment",
        "sectionLOIr4": "2.45883333333",
        "sectionLOIr1": "2.45883333333",
        "sectionLOIr3": "2.08255",
        "sectionLOIr2": "0.227316666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "3",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "0",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1969",
        "Q3": "38",
        "Q2": "1",
        "Q5": "5",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "dbc47948-a47a-4b06-babf-13baad643926",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 08:01",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=108aadedfec84ad7af3bd15f8dd1047e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=dbc47948-a47a-4b06-babf-13baad643926&isSynthetic=true&or_age=55&or_zip=97206&or_gender=m&or_householdincome=146000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "57",
        "vbrowser": "10",
        "qtime": "168.295",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "1tqznbcg6xh0xnt5",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "14",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "4hu07a6cgf3xsdnr",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:02",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "91202b7554f847d0994438fdafabbbde",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "993",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v19,/Gender/gen1,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "19",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it sounds like a good idea but i'm not sure about the long term",
        "sectionLOIr4": "2.79603333333",
        "sectionLOIr1": "2.79603333333",
        "sectionLOIr3": "2.41288333333",
        "sectionLOIr2": "0.200083333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "5",
        "Q15r5": "3",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "6",
        "Q15r2": "4",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1968",
        "Q3": "5",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "554d8a8b-0d25-4ba4-bed0-f34ea615ec5c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/23/2026 08:04",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=91202b7554f847d0994438fdafabbbde&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=554d8a8b-0d25-4ba4-bed0-f34ea615ec5c&isSynthetic=true&or_age=57&or_zip=94609&or_gender=m&or_householdincome=35000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "52",
        "vbrowser": "10",
        "qtime": "173.777",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "8arv80v01nxvw7k0",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "sqjgnhfy49ucgw43",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "3",
        "Q21r5": "1",
        "Q21r4": "4",
        "Q21r7": "5",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:02",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b60603547aa94815ad1e1a1a17ed40a0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "9",
        "record": "994",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/de_maxdiff/Q22/v39,20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Education/edu2,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "39",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "reliable power for the kids' toys and the classroom",
        "sectionLOIr4": "2.89366666667",
        "sectionLOIr1": "2.89366666667",
        "sectionLOIr3": "2.59465",
        "sectionLOIr2": "0.211133333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1973",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "4",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "423a6598-11af-4db6-8b7b-a1424cc427a2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/23/2026 08:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b60603547aa94815ad1e1a1a17ed40a0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=423a6598-11af-4db6-8b7b-a1424cc427a2&isSynthetic=true&or_age=52&or_zip=77095&or_gender=f&or_householdincome=73000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "74",
        "vbrowser": "10",
        "qtime": "145.002",
        "Q14r9": "0",
        "Q14r8": "9",
        "session": "0g2fgsf1pbu5x7r1",
        "Q41r1": "0",
        "Q14r1": "31",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "17",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "0",
        "uuid": "cg6rum3ehwa7c35s",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 08:02",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "ba509ba8a9a54f0590e1c7b8446603d4",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "995",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v276,Top_to_Bottom,/Gender/gen2,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "276",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "4",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means staying warm without worrying about gas prices. Solar and wind keep my bills steady.",
        "sectionLOIr4": "2.4146",
        "sectionLOIr1": "2.4146",
        "sectionLOIr3": "2.06355",
        "sectionLOIr2": "0.209966666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "9",
        "Q1": "1951",
        "Q3": "39",
        "Q2": "2",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9ca9a54d-7de9-423e-86dc-f69a6c3a023c",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 08:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ba509ba8a9a54f0590e1c7b8446603d4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9ca9a54d-7de9-423e-86dc-f69a6c3a023c&isSynthetic=true&or_age=74&or_zip=15425&or_gender=f&or_householdincome=22000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "76",
        "vbrowser": "10",
        "qtime": "158.794",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "bqwsm4h0nssu6d5u",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "sh7704c94vsx1pzn",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:02",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "9b9aac9dea6a45ba999e158feb41a8c7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "996",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc4,/Age/age6,/Education/edu3,/de_maxdiff/Q22/v154",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "154",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "8",
        "Q22_4c2": "1",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "I think it means safer air for our community and lower bills when the sun shines",
        "sectionLOIr4": "2.64423333333",
        "sectionLOIr1": "2.64423333333",
        "sectionLOIr3": "2.27603333333",
        "sectionLOIr2": "0.264566666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1949",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7f77b70e-10a0-4823-95b2-c97096e27b48",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/23/2026 08:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=9b9aac9dea6a45ba999e158feb41a8c7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7f77b70e-10a0-4823-95b2-c97096e27b48&isSynthetic=true&or_age=75&or_zip=32712&or_gender=m&or_householdincome=85000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "174.87",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "wjex84e9f6apry6g",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "2vdjvw3d8p7avqh0",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4195966554394c29b26a32b4f7796c07",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "997",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5,/Age/age3,/de_maxdiff/Q22/v204",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "204",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power that doesn't rely on old systems, but I know it's not perfect. Balance is key for my work.",
        "sectionLOIr4": "2.91063333333",
        "sectionLOIr1": "2.91063333333",
        "sectionLOIr3": "2.56886666667",
        "sectionLOIr2": "0.205533333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "8",
        "Q15r3": "8",
        "Q15r8": "5",
        "Q15r9": "7",
        "Q1": "1986",
        "Q3": "31",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9b74ae8b-5b75-4f98-a721-894af78fc67f",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 08:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4195966554394c29b26a32b4f7796c07&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9b74ae8b-5b75-4f98-a721-894af78fc67f&isSynthetic=true&or_age=39&or_zip=08036&or_gender=m&or_householdincome=64000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "57",
        "vbrowser": "10",
        "qtime": "194.581",
        "Q14r9": "4",
        "Q14r8": "13",
        "session": "01x0rssr5zhu5g69",
        "Q41r1": "1",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "55p5suekxyyhytny",
        "Q22_9c2": "9",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ad21df807e4045008844d0230234d63c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "998",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v71,Top_to_Bottom,/Income/inc6,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "71",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "9",
        "Q22_4c2": "3",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power for my gaming rig and electric car. I value its role in job growth but stay wary of claims that ignore real-world challenges.",
        "sectionLOIr4": "3.2395",
        "sectionLOIr1": "3.2395",
        "sectionLOIr3": "2.89035",
        "sectionLOIr2": "0.231666666667",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1968",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e1d32a3d-2c0d-4ac0-893e-88a3c4875c33",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "01/23/2026 08:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ad21df807e4045008844d0230234d63c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e1d32a3d-2c0d-4ac0-893e-88a3c4875c33&isSynthetic=true&or_age=57&or_zip=77070&or_gender=m&or_householdincome=165000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "184.813",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "4165wn22kkbfzb6p",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "13",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "m559204qcxykg1yn",
        "Q22_9c2": "1",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 08:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "71dea5ac487e40928491ee80f07b39bf",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "999",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v70,/Gender/gen2,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "70",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means power that doesn't pollute the air but I'm not sure about the costs",
        "sectionLOIr4": "3.07508333333",
        "sectionLOIr1": "3.07508333333",
        "sectionLOIr3": "2.76058333333",
        "sectionLOIr2": "0.216733333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1964",
        "Q3": "39",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "52bdb38e-5939-479c-bfca-1f8e27175ba2",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "6",
        "date": "01/23/2026 08:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=71dea5ac487e40928491ee80f07b39bf&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=52bdb38e-5939-479c-bfca-1f8e27175ba2&isSynthetic=true&or_age=61&or_zip=18951&or_gender=f&or_householdincome=48400",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "32",
        "vbrowser": "10",
        "qtime": "172.629",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "dj1x77m4rs6fbfca",
        "Q41r1": "1",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "p0gp5umrq3bwmcpt",
        "Q22_9c2": "1",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "0f1c01eea728438180e70d4ecefb04c5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "1000",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,/Ethnicity/eth3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/de_maxdiff/Q22/v137,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc7,/Education/edu4",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "137",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "1",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "It's the future, but not without hiccups. Solar and wind are great, but need backup. Cleaner air is a win, even if costs are a concern.",
        "sectionLOIr4": "2.87218333333",
        "sectionLOIr1": "2.87218333333",
        "sectionLOIr3": "2.47993333333",
        "sectionLOIr2": "0.233866666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "100",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1993",
        "Q3": "5",
        "Q2": "1",
        "Q5": "6",
        "Q4": "2",
        "Q6": "8",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "6cd2fcea-5a3e-4fc8-9c71-dcfa02f3347a",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 08:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0f1c01eea728438180e70d4ecefb04c5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6cd2fcea-5a3e-4fc8-9c71-dcfa02f3347a&isSynthetic=true&or_age=31&or_zip=92025&or_gender=m&or_householdincome=323000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "51",
        "vbrowser": "10",
        "qtime": "171.46",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "r95a41gd7p9xnte6",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "5s5bdfp9pd29ran7",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 08:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1fa1b8b2c01d424486e6b4b793a60bb0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "3",
        "record": "1001",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v294,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "294",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means reliable power for my home and job",
        "sectionLOIr4": "2.85441666667",
        "sectionLOIr1": "2.85441666667",
        "sectionLOIr3": "2.5151",
        "sectionLOIr2": "0.180516666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1974",
        "Q3": "19",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7df4bd90-936c-40b5-9a8f-46b29b0d2598",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "2",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 08:11",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1fa1b8b2c01d424486e6b4b793a60bb0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7df4bd90-936c-40b5-9a8f-46b29b0d2598&isSynthetic=true&or_age=51&or_zip=70631&or_gender=m&or_householdincome=37000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "62",
        "vbrowser": "10",
        "qtime": "168.113",
        "Q14r9": "4",
        "Q14r8": "8",
        "session": "nxvrd0yzjppd0hm2",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "12",
        "Q14r5": "13",
        "Q14r4": "17",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ctaz8vqqrq01zy26",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:09",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "e44d4ff972cf4e80b03cd0ee745840a2",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1002",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/de_maxdiff/Q22/v235,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "235",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means energy that doesn't pollute and keeps things running smoothly. I think about how it helps my community stay safe and reliable. Solar and wind are good but need backup.",
        "sectionLOIr4": "2.79876666667",
        "sectionLOIr1": "2.79876666667",
        "sectionLOIr3": "2.32635",
        "sectionLOIr2": "0.257066666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1963",
        "Q3": "36",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7bf7be82-da12-4019-bcb6-76a69e734e12",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 08:12",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e44d4ff972cf4e80b03cd0ee745840a2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7bf7be82-da12-4019-bcb6-76a69e734e12&isSynthetic=true&or_age=60&or_zip=45248&or_gender=f&or_householdincome=88000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "73",
        "vbrowser": "10",
        "qtime": "170.297",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "xnpxz73367fm8gze",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "me6qaps0njcsvw6q",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:09",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "cf23962d5e864cd9968aa2138d240949",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "1003",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,/de_maxdiff/Q22/v110,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Vote/vote2,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "110",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "2",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means cheaper power for my devices and cleaner air for my walks",
        "sectionLOIr4": "2.83426666667",
        "sectionLOIr1": "2.83426666667",
        "sectionLOIr3": "2.52846666667",
        "sectionLOIr2": "0.249783333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1952",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "0a73b1ce-f642-4ef6-9f06-76c9fcd43ce0",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 08:12",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=cf23962d5e864cd9968aa2138d240949&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0a73b1ce-f642-4ef6-9f06-76c9fcd43ce0&isSynthetic=true&or_age=72&or_zip=77845&or_gender=f&or_householdincome=26000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "169.623",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "840z3ajyr4636u80",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "3gvnb59tw8spkrta",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 08:09",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "a9081f0638e041ddba1a1272797f3a3c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "1004",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/de_maxdiff/Q22/v178,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "178",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It feels like reliable power for my home and work, balancing costs with sustainability. I see it as part of everyday life, not just big changes.",
        "sectionLOIr4": "2.82406666667",
        "sectionLOIr1": "2.82406666667",
        "sectionLOIr3": "2.41893333333",
        "sectionLOIr2": "0.240766666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1980",
        "Q3": "34",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "2",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "ac1f83a3-2753-4fef-a94a-0980c99687b0",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 08:12",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a9081f0638e041ddba1a1272797f3a3c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ac1f83a3-2753-4fef-a94a-0980c99687b0&isSynthetic=true&or_age=44&or_zip=28120&or_gender=f&or_householdincome=34500",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "20",
        "vbrowser": "10",
        "qtime": "188.459",
        "Q14r9": "0",
        "Q14r8": "6",
        "session": "svhpevhrpx1g9uwn",
        "Q41r1": "0",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "22",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "e4gew3ramfg3zbvm",
        "Q22_9c2": "3",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "74bd9d78afa14e5596c071be5cc77b83",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "4",
        "Q22_1c1": "9",
        "record": "1005",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote2,/Region/reg4,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc3,/de_maxdiff/Q22/v159,/Gender/gen1,/Ethnicity/eth1,sawterm:(dvfail.r1),/Education/edu1",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "159",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "4",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "it's a big shift for the planet but with two kids and a car the costs worry me",
        "sectionLOIr4": "3.13538333333",
        "sectionLOIr1": "3.13538333333",
        "sectionLOIr3": "2.74586666667",
        "sectionLOIr2": "0.223383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "1",
        "Q12": "1",
        "Q22_scorer7": "87.5",
        "HIDAge2": "1",
        "Q22_scorer5": "25",
        "Q22_scorer4": "12.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "2005",
        "Q3": "48",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "f2e0fb7e-cd9b-4538-9635-7d0dc09f4615",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "4",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/23/2026 08:15",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=74bd9d78afa14e5596c071be5cc77b83&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f2e0fb7e-cd9b-4538-9635-7d0dc09f4615&isSynthetic=true&or_age=20&or_zip=98409&or_gender=m&or_householdincome=36000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "172.806",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "8bt1nc6csahypvyr",
        "Q41r1": "1",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "zsg7t6sm6dgqk790",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/23/2026 08:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6598ee3db88c497e9535c226b4f7f42b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "1006",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,/Education/edu4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v44,Top_to_Bottom,/Income/inc6",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "44",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It's energy that's dependable and eco-friendly, but I stay wary of quick fixes.",
        "sectionLOIr4": "2.87805",
        "sectionLOIr1": "2.87805",
        "sectionLOIr3": "2.54751666667",
        "sectionLOIr2": "0.254683333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "100",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "7",
        "Q1": "1964",
        "Q3": "47",
        "Q2": "1",
        "Q5": "5",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "28a7ee27-5e33-430b-9c83-a55583d9b29b",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "5",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/23/2026 08:15",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6598ee3db88c497e9535c226b4f7f42b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=28a7ee27-5e33-430b-9c83-a55583d9b29b&isSynthetic=true&or_age=61&or_zip=23503&or_gender=m&or_householdincome=153000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "30",
        "vbrowser": "10",
        "qtime": "177.493",
        "Q14r9": "5",
        "Q14r8": "6",
        "session": "q96bqudd3k8t56cy",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "17",
        "Q14r5": "11",
        "Q14r4": "11",
        "Q14r7": "6",
        "Q14r6": "6",
        "uuid": "8c4pa9x59aenkbjp",
        "Q22_9c2": "7",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "4",
        "Q43": "3",
        "start_date": "01/23/2026 08:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "f45567e055e842c9917badce7af4d559",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1007",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v27,/Region/reg2,/Ethnicity/eth1,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,sawterm:(dvfail.r1),/Vote/vote3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "27",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "3",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means cheaper power and less pollution for my family",
        "sectionLOIr4": "2.9562",
        "sectionLOIr1": "2.9562",
        "sectionLOIr3": "2.6601",
        "sectionLOIr2": "0.224033333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1995",
        "Q3": "23",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f5ee9406-44fb-402f-8bd7-bcc9da5b25db",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/23/2026 08:15",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f45567e055e842c9917badce7af4d559&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f5ee9406-44fb-402f-8bd7-bcc9da5b25db&isSynthetic=true&or_age=30&or_zip=48120&or_gender=f&or_householdincome=40800",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "174.228",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "74cbzqdjxzpcs7jg",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "23",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "cz3cq86ux4gesqes",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/23/2026 08:12",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "8ac96b1689e94b2ba4f3fbed4fd85182",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1008",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,/Education/edu2,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v10,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "10",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "2",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "5",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means less smog when I run and cheaper bills for my family",
        "sectionLOIr4": "2.9014",
        "sectionLOIr1": "2.9014",
        "sectionLOIr3": "2.45726666667",
        "sectionLOIr2": "0.239383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1999",
        "Q3": "25",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "dd692cbd-6643-42ad-8225-ef76056a42bd",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/23/2026 08:15",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8ac96b1689e94b2ba4f3fbed4fd85182&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=dd692cbd-6643-42ad-8225-ef76056a42bd&isSynthetic=true&or_age=20&or_zip=39532&or_gender=m&or_householdincome=45000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "216.241",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "d37vbqfaz0394yk2",
        "Q41r1": "0",
        "Q14r1": "50",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "9",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "5",
        "Q14r6": "4",
        "uuid": "75uts9jr3qnb74t9",
        "Q22_9c2": "1",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q22_version": "165",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/23/2026 08:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "40eb8deaf27e4337ac708dcfd474bf48",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "5",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age3,/Income/inc3,/de_maxdiff/Q22/v165",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "5",
        "Q35": "6",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q30": "2",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "Clean energy means another way for big companies to profit while people struggle with rising bills",
        "sectionLOIr4": "3.59975",
        "sectionLOIr1": "3.59975",
        "sectionLOIr3": "2.39195",
        "sectionLOIr2": "0.228366666667",
        "vctq1c21": "0",
        "Q35r6oe": "Pragmatic Neutral",
        "Q17": "1",
        "Q16": "2",
        "Q11": "4",
        "Q10": "4",
        "Q13": "6",
        "Q12": "4",
        "Q22_scorer7": "0",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "1009",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "0",
        "Q9r1": "4",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "3",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1989",
        "Q3": "36",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "833b3a8d-1285-484c-bc37-98619fd514b7",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/23/2026 08:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=40eb8deaf27e4337ac708dcfd474bf48&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=833b3a8d-1285-484c-bc37-98619fd514b7&isSynthetic=true&or_age=34&or_zip=44601&or_gender=m&or_householdincome=69300",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "63",
        "vbrowser": "10",
        "qtime": "172.692",
        "Q14r9": "9",
        "Q14r8": "4",
        "session": "5stw8xb01j2gg2gh",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "spf7sps332w5kfyc",
        "Q22_9c2": "8",
        "Q22_9c1": "6",
        "Q34r4": "1",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/23/2026 08:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "738c7c51563f4c59acbfa17a4527651d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "1010",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/de_maxdiff/Q22/v50,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "50",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "7",
        "Q22_4c2": "9",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means lower bills and cleaner air, but I’ve seen solar panels fail in storms.",
        "sectionLOIr4": "2.8733",
        "sectionLOIr1": "2.8733",
        "sectionLOIr3": "2.549",
        "sectionLOIr2": "0.241083333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1962",
        "Q3": "25",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c175ad2e-ac77-473d-b19b-045f9e628b21",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/23/2026 08:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=738c7c51563f4c59acbfa17a4527651d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c175ad2e-ac77-473d-b19b-045f9e628b21&isSynthetic=true&or_age=63&or_zip=39440&or_gender=m&or_householdincome=25920",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "149.583",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "jdgag8vpesytg2e9",
        "Q41r1": "0",
        "Q14r1": "39",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "13",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "7buhq9r6gkfj34jz",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 08:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "8d0d26208fc2441eb1539fd0dda8c7fa",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "2",
        "record": "1011",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,/Education/edu3,/de_maxdiff/Q22/v143",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "143",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power sources that create good-paying jobs and support local communities.",
        "sectionLOIr4": "2.49051666667",
        "sectionLOIr1": "2.49051666667",
        "sectionLOIr3": "2.19985",
        "sectionLOIr2": "0.261983333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1964",
        "Q3": "1",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "2252ab1e-9737-4a7b-a228-ff952af67eec",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/23/2026 08:18",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8d0d26208fc2441eb1539fd0dda8c7fa&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=2252ab1e-9737-4a7b-a228-ff952af67eec&isSynthetic=true&or_age=62&or_zip=35404&or_gender=m&or_householdincome=90700",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "31",
        "vbrowser": "10",
        "qtime": "157.686",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "a3xm3je0zgwez6z7",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "qt75t2ryh0v79s6b",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 08:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "1b26eeeb8d5d4627b5f9da255d3d01aa",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "6",
        "record": "1012",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,/Education/edu4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc6,Top_to_Bottom,/Gender/gen2,/de_maxdiff/Q22/v152",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "152",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It means steady power that helps local jobs and keeps the neighborhood safe, but I’d rather not gamble on new tech just yet.",
        "sectionLOIr4": "2.62483333333",
        "sectionLOIr1": "2.62483333333",
        "sectionLOIr3": "2.27026666667",
        "sectionLOIr2": "0.246033333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "9",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1994",
        "Q3": "4",
        "Q2": "2",
        "Q5": "5",
        "Q4": "3",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3e564072-e46f-4e17-ac46-de3523f49a36",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/23/2026 08:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1b26eeeb8d5d4627b5f9da255d3d01aa&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3e564072-e46f-4e17-ac46-de3523f49a36&isSynthetic=true&or_age=30&or_zip=72650&or_gender=f&or_householdincome=174000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "24",
        "vbrowser": "10",
        "qtime": "142.385",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "qus4ntc68mcqqu3n",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "44qahh74z0qpsw9e",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/23/2026 08:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "c5aa7da95a47425da5e1c143c8eb49cd",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1013",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v84,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen2,sawterm:(dvfail.r1),/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "84",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "7",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power that keeps my home safe. Cleaner air and less pollution make me feel better about the future.",
        "sectionLOIr4": "2.36718333333",
        "sectionLOIr1": "2.36718333333",
        "sectionLOIr3": "1.99281666667",
        "sectionLOIr2": "0.23755",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2001",
        "Q3": "44",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "69810c57-12ac-47ae-817a-231d91e93ab5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/23/2026 08:21",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c5aa7da95a47425da5e1c143c8eb49cd&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=69810c57-12ac-47ae-817a-231d91e93ab5&isSynthetic=true&or_age=25&or_zip=75771&or_gender=f&or_householdincome=52000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "33",
        "vbrowser": "10",
        "qtime": "134.747",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "j5hvzmunuwbjz3q0",
        "Q41r1": "1",
        "Q14r1": "32",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "npq9jamdacgm65n9",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/23/2026 08:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "5863dcde288a4d2fae67052bfa67e8a7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1014",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v102,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc5,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "102",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable, cost-effective power that's better for the environment but needs more proven solutions.",
        "sectionLOIr4": "2.2427",
        "sectionLOIr1": "2.2427",
        "sectionLOIr3": "1.9749",
        "sectionLOIr2": "0.207383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1992",
        "Q3": "34",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "7069cfaf-da81-49aa-8b95-62db4ff457e0",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/23/2026 08:21",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5863dcde288a4d2fae67052bfa67e8a7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7069cfaf-da81-49aa-8b95-62db4ff457e0&isSynthetic=true&or_age=33&or_zip=28411&or_gender=m&or_householdincome=106500",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1976",
        "vctq1c22": "0",
        "HIDAge": "49",
        "Q2": "4",
        "Q4": "5",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "13.707",
        "Q3": "23",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "q6bq5psbg9vd0095",
        "s5": "TEST_VALUEjsgu5a",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36",
        "or1": "TC_05_0001",
        "vlist": "2",
        "uuid": "x2jdv8k6aamasv38",
        "vmobiledevice": "5",
        "s2": "TEST_VALUEv9r8k",
        "vctq1c25": "0",
        "markers": "bad:/Rotate Selection/Top_to_Bottom,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,OQ,Top_to_Bottom,bad:/Gender/gen3,bad:/Overall/qual,bad:/Region/reg2",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "4",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "01/23/2026 14:48",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "3",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "2",
        "date": "01/23/2026 14:49",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_05_0001&s5=TEST_VALUEjsgu5a&s2=TEST_VALUEv9r8k&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1015",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "65",
        "vbrowser": "10",
        "qtime": "46.735",
        "Q14r9": "5",
        "Q14r8": "8",
        "session": "d4ecmgfj4n4pv8x1",
        "Q41r1": "0",
        "Q14r1": "4",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "0",
        "Q14r5": "10",
        "Q14r4": "11",
        "Q14r7": "30",
        "Q14r6": "8",
        "uuid": "n06dhm5wute052w3",
        "Q22_9c2": "2",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "5",
        "Q21r5": "1",
        "Q21r4": "2",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "1",
        "start_date": "01/27/2026 13:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "TC_05_0001_JM_AT_TEST_1_27_4_19",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "3",
        "record": "1025",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "bad:/Education/edu3,bad:/Vote/vote1,bad:/de_maxdiff/Q22/v192,bad:/Income/inc2,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/Age/age6,qual,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "192",
        "Q36": "4",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "6",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "1",
        "Q22_6c1": "7",
        "Q22_6c2": "2",
        "Q22_4c2": "7",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "37.5",
        "Q23": "1",
        "Q24": "arto voluptas sono testimonium annus",
        "sectionLOIr4": "0.778916666667",
        "sectionLOIr1": "0.778916666667",
        "sectionLOIr3": "0.570283333333",
        "sectionLOIr2": "0.33545",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "3",
        "Q10": "1",
        "Q13": "5",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "2",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "5",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "9",
        "Q15r5": "2",
        "Q15r6": "3",
        "Q15r7": "0",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "2",
        "Q15r8": "4",
        "Q15r9": "4",
        "Q1": "1960",
        "Q3": "1",
        "Q2": "1",
        "Q5": "4",
        "Q4": "2",
        "Q6": "2",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "14",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "TEST_VALUEwrpbk",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "TEST_VALUEj67mzl",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "1",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "6",
        "Q22_3c1": "3",
        "Q22_3c2": "6",
        "Q8r5": "5",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "4",
        "Q8r3": "5",
        "Q8r2": "1",
        "date": "01/29/2026 01:51",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_05_0001_JM_AT_TEST_1_27_4_19&s5=TEST_VALUEj67mzl&s2=TEST_VALUEwrpbk&or_auto=1",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1962",
        "vctq1c22": "1",
        "HIDAge": "63",
        "Q2": "2",
        "Q4": "5",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "7.901",
        "Q3": "33",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "344xm4wy1y8h902g",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/144.0.0.0 Safari/537.36",
        "or1": "f62f78a378934ff4b32c07218e13cc64",
        "vlist": "2",
        "uuid": "8sh3k6jpqkqs38q6",
        "vmobiledevice": "5",
        "s2": "062a8c9b-38d0-44e2-aafb-b2c8ee7b50ff",
        "vctq1c25": "1",
        "markers": "bad:/Rotate Selection/Top_to_Bottom,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,OQ,Top_to_Bottom,bad:/Region/reg1,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "5",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "01/30/2026 02:31",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "2",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "1",
        "date": "01/30/2026 02:32",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f62f78a378934ff4b32c07218e13cc64&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=062a8c9b-38d0-44e2-aafb-b2c8ee7b50ff&isSynthetic=true&or_age=63&or_zip=13440&or_gender=f&or_householdincome=100900",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1168",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "AN",
        "GeoIP_Detailsr5": "Andalusia",
        "GeoIP_Detailsr2": "Spain",
        "GeoIP_Detailsr1": "es"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "181.717",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "utwgg82f3ykzkwxw",
        "Q41r1": "1",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "j94zm4u8dqq9vmc4",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 02:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c8f18dbf235f43d08817328c6f50f8c7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "1170",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Income/inc5,bad:/Education/edu4,Bottom_to_Top,bad:/Ethnicity/eth3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/de_maxdiff/Q22/v226,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "226",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "9",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It means reliable power for my garden, lower bills, and a safer future for my kid.",
        "sectionLOIr4": "3.02861666667",
        "sectionLOIr1": "3.02861666667",
        "sectionLOIr3": "2.64848333333",
        "sectionLOIr2": "0.29145",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "75",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "5",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "8",
        "Q15r2": "3",
        "Q15r3": "7",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1970",
        "Q3": "19",
        "Q2": "1",
        "Q5": "5",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5cf36102-7265-4dd3-807f-d1a180667d21",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "7",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/30/2026 02:50",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c8f18dbf235f43d08817328c6f50f8c7&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=5cf36102-7265-4dd3-807f-d1a180667d21",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1999",
        "vctq1c22": "0",
        "HIDAge": "26",
        "Q2": "2",
        "Q4": "5",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "12.762",
        "Q3": "26",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "4vxpdp24h0c2jbgd",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "or1": "85e3323b79d34c81a885292e1eb0e1d3",
        "vlist": "2",
        "uuid": "cw8xhs1ryc4h1e0h",
        "vmobiledevice": "5",
        "s2": "08ebc28c-6e4b-40ff-8446-fe01bdf31370",
        "vctq1c25": "1",
        "markers": "bad:/Rotate Selection/Top_to_Bottom,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,sawterm:Q1.ival gt 2007,OQ,bad:/Age/age2,Top_to_Bottom,bad:/Gender/gen2,bad:/Overall/qual,bad:/Region/reg2",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "2",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "01/30/2026 02:47",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "4",
        "vctq1c19": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "2",
        "date": "01/30/2026 02:47",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=85e3323b79d34c81a885292e1eb0e1d3&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=08ebc28c-6e4b-40ff-8446-fe01bdf31370",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1171",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "54",
        "vbrowser": "10",
        "qtime": "174.074",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "tms45f9rqnqdnu5f",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "j8uwa0zfgvmz9tpj",
        "Q22_9c2": "3",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/30/2026 02:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "7fd0620f459c484380a88ab78ff18c45",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "1172",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu3,bad:/Income/inc6,bad:/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/de_maxdiff/Q22/v199,qual,bad:/Age/age4,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Region/reg4,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "199",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It's grid power that doesn't burn through my budget, but I'm not b betting the farm on it.",
        "sectionLOIr4": "2.90123333333",
        "sectionLOIr1": "2.90123333333",
        "sectionLOIr3": "2.5718",
        "sectionLOIr2": "0.328166666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1971",
        "Q3": "29",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1faa9884-acc0-482f-8de8-db66e0257be7",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "8",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/30/2026 02:50",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7fd0620f459c484380a88ab78ff18c45&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=1faa9884-acc0-482f-8de8-db66e0257be7",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "198.161",
        "Q14r9": "9",
        "Q14r8": "13",
        "session": "3tms62buczxstszq",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "9",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ss8ec2nhzqskn325",
        "Q22_9c2": "7",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 02:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "54c45cb1da4d4587ae6f976c7e7241fc",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "1173",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu3,bad:/Income/inc6,bad:/Rotate Selection/Top_to_Bottom,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/Ethnicity/eth2,qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual,bad:/de_maxdiff/Q22/v111",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "111",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "1",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it sounds like a mix of solar and wind but i worry about reliability and storage. gardening keeps me grounded but clean energy feels like a step toward sustainability. maybe with better tech it could work but not sure yet",
        "sectionLOIr4": "3.30268333333",
        "sectionLOIr1": "3.30268333333",
        "sectionLOIr3": "2.69711666667",
        "sectionLOIr2": "0.34555",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "3",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1978",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "6",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "fa638aba-4366-4b67-b770-0f8a467888ad",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/30/2026 02:50",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=54c45cb1da4d4587ae6f976c7e7241fc&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=fa638aba-4366-4b67-b770-0f8a467888ad",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "57",
        "vbrowser": "10",
        "qtime": "162.401",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "fzvjbmx37eqnay75",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "g5dd5ve16jqx1jk1",
        "Q22_9c2": "1",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 02:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e789f0144eae4be1b59324949e5b24be",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "1174",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Vote/vote2,bad:/Income/inc6,bad:/de_maxdiff/Q22/v48,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth1,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "48",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "clean energy keeps the lights on at home and powers my car without stressing about bills",
        "sectionLOIr4": "2.70668333333",
        "sectionLOIr1": "2.70668333333",
        "sectionLOIr3": "2.31646666667",
        "sectionLOIr2": "0.191283333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1968",
        "Q3": "34",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "0d47765f-80f0-4fa1-be7b-f840f81728af",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/30/2026 02:50",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e789f0144eae4be1b59324949e5b24be&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=0d47765f-80f0-4fa1-be7b-f840f81728af",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "174.042",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "xfzuxyc7bf9c908s",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "4",
        "uuid": "8bhg5hetwfua7pxv",
        "Q22_9c2": "3",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 02:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "0",
        "or1": "1cb7fd7b9373413eafff0fa0c598344a",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "1175",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu1,Bottom_to_Top,bad:/Income/inc3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/de_maxdiff/Q22/v30,qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Ethnicity/eth4,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen3,bad:/Region/reg1,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "30",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Means power that doesn't pollute, like solar or wind. I think it's important for the environment, but I'm cautious about how dependable it is right now.",
        "sectionLOIr4": "2.9007",
        "sectionLOIr1": "2.9007",
        "sectionLOIr3": "2.54593333333",
        "sectionLOIr2": "0.221683333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "2",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "10",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "1970",
        "Q3": "7",
        "Q2": "3",
        "Q5": "2",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "486cadb8-e7f9-4c7c-b6e1-1d9753a91e46",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "1",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/30/2026 02:53",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1cb7fd7b9373413eafff0fa0c598344a&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=486cadb8-e7f9-4c7c-b6e1-1d9753a91e46",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "80",
        "vbrowser": "10",
        "qtime": "159.681",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "95dzdjgw2w7acs5g",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "16",
        "Q14r5": "11",
        "Q14r4": "16",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "qdwb765vtzpdb6ga",
        "Q22_9c2": "7",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/30/2026 02:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6e258c0dcf7b4d5d95667874204bc74c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "1176",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Vote/vote4,bad:/Income/inc2,bad:/Rotate Selection/Top_to_Bottom,sawterm:(dvfail.r1),term:(dvfail.r1),20260109_07:39_v14,bad:/de_maxdiff/Q22/v252,bad:/Age/age6,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Region/reg4,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "252",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means reliable power for my community without relying on foreign sources",
        "sectionLOIr4": "2.66135",
        "sectionLOIr1": "2.66135",
        "sectionLOIr3": "2.28906666667",
        "sectionLOIr2": "0.227133333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1945",
        "Q3": "48",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "a35ef00b-7d18-441c-8efd-b581bebe7582",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "9",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "6",
        "date": "01/30/2026 02:53",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6e258c0dcf7b4d5d95667874204bc74c&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=a35ef00b-7d18-441c-8efd-b581bebe7582",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "60",
        "vbrowser": "10",
        "qtime": "188.446",
        "Q14r9": "5",
        "Q14r8": "14",
        "session": "s5ktvw2mf0eumye2",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "18",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "0kw7vjm5r7tz0tzg",
        "Q22_9c2": "4",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "01/30/2026 02:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "31a60ba15750473ebfead0c7c8acd365",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "7",
        "record": "1177",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote3,bad:/Income/inc6,bad:/Education/edu4,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth1,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Region/reg4,bad:/Gender/gen1,Top_to_Bottom,bad:/de_maxdiff/Q22/v12,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "12",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "2",
        "Q22_7c2": "5",
        "Q39r2": "1",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means smarter homes and less waste but I still need the grid to be reliable",
        "sectionLOIr4": "3.14076666667",
        "sectionLOIr1": "3.14076666667",
        "sectionLOIr3": "2.70516666667",
        "sectionLOIr2": "0.261883333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "5",
        "Q22_scorer5": "75",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "1",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1965",
        "Q3": "5",
        "Q2": "1",
        "Q5": "5",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b34a4e0c-699a-4fbb-ac50-e0ea62b235ab",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/30/2026 02:53",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=31a60ba15750473ebfead0c7c8acd365&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=b34a4e0c-699a-4fbb-ac50-e0ea62b235ab",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "163.441",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "5sa6qw5f454ng82s",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "9",
        "Q14r5": "18",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "5s22uzqb6j9duqww",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 02:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2a1b7273a81645368d3be1ac4d9623bb",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "record": "1178",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Income/inc5,bad:/de_maxdiff/Q22/v208,bad:/Education/edu4,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "208",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Reliable power that keeps our community safe, but I'm not sure if renewables can handle everything yet.",
        "sectionLOIr4": "2.72401666667",
        "sectionLOIr1": "2.72401666667",
        "sectionLOIr3": "2.32981666667",
        "sectionLOIr2": "0.214866666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "5",
        "Q1": "1981",
        "Q3": "15",
        "Q2": "1",
        "Q5": "5",
        "Q4": "2",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "720b9f07-b545-4abb-bc41-8a7dd57eedc8",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/30/2026 02:53",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2a1b7273a81645368d3be1ac4d9623bb&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=720b9f07-b545-4abb-bc41-8a7dd57eedc8",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "59",
        "vbrowser": "10",
        "qtime": "182.197",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "ndhzparxc0kjn76g",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "re76sqrzb7r4jynm",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/30/2026 02:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "ef49c73e5c404163ad6870ef7a3249b9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "1",
        "record": "1179",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Income/inc5,bad:/Education/edu1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Ethnicity/eth4,bad:/de_maxdiff/Q22/v123,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "123",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Reliable power for my home and work. Solar helps but costs a lot. I stick to what I know.",
        "sectionLOIr4": "3.03661666667",
        "sectionLOIr1": "3.03661666667",
        "sectionLOIr3": "2.70238333333",
        "sectionLOIr2": "0.205683333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1966",
        "Q3": "15",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "362246eb-e9e8-4326-a276-59c7f16c3c91",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/30/2026 02:56",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ef49c73e5c404163ad6870ef7a3249b9&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=362246eb-e9e8-4326-a276-59c7f16c3c91",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "74",
        "vbrowser": "10",
        "qtime": "183.284",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "89curydafhwdfn2y",
        "Q41r1": "0",
        "Q14r1": "19",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "wdckrxvta6cum0js",
        "Q22_9c2": "1",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/30/2026 02:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2ed2919492644a608b19655f2f5cf3af",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1180",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/de_maxdiff/Q22/v266,bad:/Education/edu3,bad:/Income/inc1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/Age/age6,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Vote/vote2,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "266",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It's a term that's been tossed around a lot but hasn't changed much for me. I still rely on my TrailBlazer and consistent electricity bills.",
        "sectionLOIr4": "3.05473333333",
        "sectionLOIr1": "3.05473333333",
        "sectionLOIr3": "2.64305",
        "sectionLOIr2": "0.220416666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "5",
        "Q1": "1951",
        "Q3": "41",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "c6d01846-2e70-41e1-977a-dce4ba0c1b32",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/30/2026 02:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2ed2919492644a608b19655f2f5cf3af&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=c6d01846-2e70-41e1-977a-dce4ba0c1b32",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "69",
        "vbrowser": "10",
        "qtime": "199.214",
        "Q14r9": "2",
        "Q14r8": "1",
        "session": "ezhpntbf2bf323ae",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "25",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "1",
        "Q14r6": "5",
        "uuid": "p9akhh33s80dtfew",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 02:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6e4aef537de8449d9e29447be5778083",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1181",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu3,bad:/Income/inc2,bad:/Rotate Selection/Top_to_Bottom,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/Age/age6,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,Top_to_Bottom,bad:/de_maxdiff/Q22/v114,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "114",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "clean air and lower bills for the neighborhood",
        "sectionLOIr4": "3.32023333333",
        "sectionLOIr1": "3.32023333333",
        "sectionLOIr3": "2.93863333333",
        "sectionLOIr2": "0.212766666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "9",
        "Q1": "1956",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "1",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "de9a60b0-ce4e-4926-a698-de6e4ff7bced",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/30/2026 02:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6e4aef537de8449d9e29447be5778083&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=de9a60b0-ce4e-4926-a698-de6e4ff7bced",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "170.036",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "2aeew10540z060vx",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "wbhk42fjspa13mbe",
        "Q22_9c2": "9",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 02:53",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "24509235454345b4ab4f5ddbeabb4b22",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "1182",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Income/inc5,bad:/Rotate Selection/Top_to_Bottom,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/de_maxdiff/Q22/v199,qual,sawterm:Q1.ival gt 2007,bad:/Ethnicity/eth4,bad:/Gender/gen1,bad:/Vote/vote2,bad:/Age/age2,Top_to_Bottom,bad:/Region/reg1,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "199",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "it means reliable power that doesn't drain my wallet or the planet and local jobs that pay well",
        "sectionLOIr4": "2.83393333333",
        "sectionLOIr1": "2.83393333333",
        "sectionLOIr3": "2.51043333333",
        "sectionLOIr2": "0.223866666667",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1999",
        "Q3": "7",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "b15fa4c1-8d9d-4f6c-a3a0-23e8f1c38c50",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "1",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "01/30/2026 02:56",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=24509235454345b4ab4f5ddbeabb4b22&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=b15fa4c1-8d9d-4f6c-a3a0-23e8f1c38c50",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "156.069",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "z8pgxp2t0xhskdzg",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "nebeke90s1mkwxxw",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 02:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "493be9d6ef364fc18132e1bb60a1a74d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "3",
        "record": "1183",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "bad:/de_maxdiff/Q22/v164,bad:/Education/edu3,bad:/Income/inc6,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth1,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Region/reg4,bad:/Vote/vote2,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "164",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "7",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power for my gadgets on the go, like charging my phone at a café without worrying about outages.",
        "sectionLOIr4": "2.60115",
        "sectionLOIr1": "2.60115",
        "sectionLOIr3": "2.23801666667",
        "sectionLOIr2": "0.2179",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "75",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "4",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1969",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "9",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "c9a5a16c-5a58-42b1-8e62-4c6c6f9ad2a2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/30/2026 02:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=493be9d6ef364fc18132e1bb60a1a74d&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=c9a5a16c-5a58-42b1-8e62-4c6c6f9ad2a2",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "177.841",
        "Q41r2": "0",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "zcqhkapv57qjd1r2",
        "Q41r1": "0",
        "Q14r1": "45",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "9",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "ep4udycn1b7e6za5",
        "Q22_9c2": "4",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q22_version": "90",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "4",
        "Q21r7": "1",
        "Q21r6": "2",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/30/2026 02:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "5",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "64ff9833c6fe40d3bdde6292cb7506b1",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "9",
        "Q22_1c1": "3",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q9r2": "4",
        "markers": "bad:/Education/edu2,bad:/Income/inc1,Bottom_to_Top,sawterm:(dvfail.r1),term:(dvfail.r1),20260109_07:39_v14,bad:/Vote/vote4,qual,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Ethnicity/eth4,bad:/Age/age1,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/de_maxdiff/Q22/v90,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "4",
        "Q36": "4",
        "Q35": "1",
        "Q22_7c1": "6",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q30": "4",
        "Q39r3": "1",
        "Q9r5": "5",
        "Q9r6": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "1",
        "Q24": "Clean energy's overhyped. Doesn't help with my high bills or broken system.",
        "sectionLOIr4": "2.96401666667",
        "sectionLOIr1": "2.96401666667",
        "sectionLOIr3": "2.52811666667",
        "sectionLOIr2": "0.253716666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "4",
        "Q13": "3",
        "Q12": "4",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "75",
        "record": "1184",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "4",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "2003",
        "Q3": "25",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "5",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "eabe15d4-84e3-4dd5-96df-ebd839b54132",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "6",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/30/2026 02:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=64ff9833c6fe40d3bdde6292cb7506b1&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=eabe15d4-84e3-4dd5-96df-ebd839b54132",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "56",
        "vbrowser": "10",
        "qtime": "169.679",
        "Q14r9": "4",
        "Q14r8": "8",
        "session": "r39b3dw2e11cdznw",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "12",
        "Q14r2": "17",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "8hxjd207gsbhtuzs",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 02:56",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "4e2490a51f0142109f882b8a83178718",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "1",
        "record": "1185",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Income/inc5,bad:/Education/edu1,bad:/de_maxdiff/Q22/v100,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth1,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,Top_to_Bottom,bad:/Region/reg1,bad:/Gender/gen2,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "100",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "4",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "it means reliable power for the plant and home without unexpected costs",
        "sectionLOIr4": "2.82798333333",
        "sectionLOIr1": "2.82798333333",
        "sectionLOIr3": "2.46873333333",
        "sectionLOIr2": "0.217433333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1969",
        "Q3": "39",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "af4a22a2-b5c0-49c3-b683-75340eed23e9",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "2",
        "Q22_3c1": "6",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/30/2026 02:59",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4e2490a51f0142109f882b8a83178718&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=af4a22a2-b5c0-49c3-b683-75340eed23e9",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "180.988",
        "Q14r9": "9",
        "Q14r8": "13",
        "session": "rzgsrkmn9j9tvg8m",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "zve5jn6erpm4yj5s",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "01/30/2026 02:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "25cb2e48143e48c798a70bc3929a9dc3",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "1186",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu1,Bottom_to_Top,bad:/Income/inc3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Region/reg1,bad:/de_maxdiff/Q22/v288,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "288",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means local power sources that keep our lights on and the kids' games working without harming the environment.",
        "sectionLOIr4": "3.01646666667",
        "sectionLOIr1": "3.01646666667",
        "sectionLOIr3": "2.69223333333",
        "sectionLOIr2": "0.2514",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1983",
        "Q3": "33",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "d6eda8d6-f812-402a-8090-ece7162041dd",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "2",
        "Q22_3c1": "2",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/30/2026 03:00",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=25cb2e48143e48c798a70bc3929a9dc3&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=d6eda8d6-f812-402a-8090-ece7162041dd",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "230.486",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "kvw3bx908gtk190j",
        "Q41r1": "1",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "4821vmj7m7hsd02v",
        "Q22_9c2": "3",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "6",
        "vlist": "2",
        "Q30r6oe": "Fragmented energy markets and lack of unified standards",
        "Q22_5c2": "1",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 02:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "1c2725d21a964559afcb2b06651334c5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "record": "1187",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,bad:/Income/inc5,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Ethnicity/eth4,Top_to_Bottom,bad:/Region/reg1,bad:/Gender/gen2,bad:/Overall/qual,bad:/de_maxdiff/Q22/v92",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "92",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "5",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "2",
        "Q22_4c2": "1",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "It reminds me of the quiet hum of solar panels powering my home office late at night. It feels like a promise of reliable energy without the noise of old systems. I think about how it supports my tech hobbies and travels while keeping things balanced.",
        "sectionLOIr4": "3.84143333333",
        "sectionLOIr1": "3.84143333333",
        "sectionLOIr3": "3.42648333333",
        "sectionLOIr2": "0.224766666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "75",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "12.5",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1981",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "1",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "4af7be48-75ae-408d-8e9a-6e2d5c6749c4",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "2",
        "Q22_3c1": "7",
        "Q22_3c2": "2",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/30/2026 03:03",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1c2725d21a964559afcb2b06651334c5&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=4af7be48-75ae-408d-8e9a-6e2d5c6749c4",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "162.63",
        "Q41r2": "0",
        "Q14r9": "9",
        "Q14r8": "5",
        "session": "68muz7qzg88haazf",
        "Q41r1": "0",
        "Q14r1": "32",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "14",
        "Q14r5": "9",
        "Q14r4": "4",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "74fktxs05kcxmt3r",
        "Q22_9c2": "5",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q22_version": "125",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "1",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "4",
        "Q21r7": "1",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "01/30/2026 02:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "2",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "31dd4cc3af9d4087afea8b8a1e335237",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "3",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "bad:/Education/edu3,bad:/Vote/vote4,bad:/Rotate Selection/Top_to_Bottom,bad:/Income/inc3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Age/age2,Top_to_Bottom,bad:/de_maxdiff/Q22/v125,bad:/Gender/gen2,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "5",
        "Q36": "4",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "5",
        "Q22_7c2": "9",
        "Q30": "2",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "9",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "1",
        "Q24": "It's a scam to line pockets, not solve real problems.",
        "sectionLOIr4": "2.7105",
        "sectionLOIr1": "2.7105",
        "sectionLOIr3": "2.302",
        "sectionLOIr2": "0.227983333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "4",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "100",
        "record": "1188",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "9",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1996",
        "Q3": "10",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "cdbf1d55-7e12-4706-9eb9-8ef74dffc78a",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/30/2026 03:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=31dd4cc3af9d4087afea8b8a1e335237&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=cdbf1d55-7e12-4706-9eb9-8ef74dffc78a",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "178.751",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "xaf14g8dn8hv2t9b",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "1ce8ycyc8g26kjqu",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 02:59",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e8a095ed094a41ceab82b1c0de103146",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "1189",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,bad:/Income/inc5,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,bad:/Ethnicity/eth4,bad:/de_maxdiff/Q22/v88,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "88",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "4",
        "Q22_4c2": "9",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means reliable power for the citys lights and roads and jobs that build them",
        "sectionLOIr4": "2.97918333333",
        "sectionLOIr1": "2.97918333333",
        "sectionLOIr3": "2.68031666667",
        "sectionLOIr2": "0.20685",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1972",
        "Q3": "26",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "cb48161a-9d24-486a-ab99-4bbce1cbfbcd",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "4",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/30/2026 03:02",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e8a095ed094a41ceab82b1c0de103146&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=cb48161a-9d24-486a-ab99-4bbce1cbfbcd",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "73",
        "vbrowser": "10",
        "qtime": "209.779",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "j858a278cxj5bqh8",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "5yx4t9jbm20bcpdw",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 03:01",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "357c48e0587048a7bdde25195ebb7df6",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "1190",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu3,Bottom_to_Top,bad:/Income/inc3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/Age/age6,qual,bad:/de_maxdiff/Q22/v280,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Ethnicity/eth4,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "280",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means my walks feel fresher and the town's power doesn't cost a fortune.",
        "sectionLOIr4": "3.49631666667",
        "sectionLOIr1": "3.49631666667",
        "sectionLOIr3": "2.99296666667",
        "sectionLOIr2": "0.3272",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "3",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1952",
        "Q3": "21",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "ea129adc-bbad-4c19-a285-66f4d3d9a551",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/30/2026 03:04",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=357c48e0587048a7bdde25195ebb7df6&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=ea129adc-bbad-4c19-a285-66f4d3d9a551",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "185.671",
        "Q14r9": "5",
        "Q14r8": "9",
        "session": "v055j4sx3nedk8j2",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "x9ptva3yacp1gw3y",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "01/30/2026 03:01",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "63c55860375946848ded0cb4fa5f61c1",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "1",
        "Q22_1c1": "6",
        "record": "1191",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Income/inc2,Bottom_to_Top,sawterm:(dvfail.r1),term:(dvfail.r1),20260109_07:39_v14,bad:/Vote/vote4,bad:/de_maxdiff/Q22/v135,bad:/Ethnicity/eth2,qual,sawterm:Q1.ival gt 2007,bad:/Age/age2,bad:/Rotate Selection/Bottom_to_Top,bad:/Region/reg1,bad:/Gender/gen2,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "135",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It's about sustainable options that don't break the bank, like solar panels. I see it as part of the future but need reliable backup for now.",
        "sectionLOIr4": "3.09451666667",
        "sectionLOIr1": "3.09451666667",
        "sectionLOIr3": "2.72298333333",
        "sectionLOIr2": "0.316533333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "0",
        "HIDAge2": "2",
        "Q22_scorer5": "75",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "8",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1999",
        "Q3": "33",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "36b76309-a82c-4582-a258-5e2bf19d9294",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/30/2026 03:04",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=63c55860375946848ded0cb4fa5f61c1&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=36b76309-a82c-4582-a258-5e2bf19d9294",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "28",
        "vbrowser": "10",
        "qtime": "171.141",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "cxkkz5kfzbq9egnw",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "ncvgqprfjkf1nabf",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 03:01",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "cd5a52fbc6964f6996951ab98533480f",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "4",
        "Q22_1c1": "7",
        "record": "1192",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Income/inc5,bad:/Rotate Selection/Top_to_Bottom,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/Ethnicity/eth2,qual,sawterm:Q1.ival gt 2007,bad:/Region/reg4,bad:/Vote/vote2,bad:/Age/age2,Top_to_Bottom,bad:/de_maxdiff/Q22/v134,bad:/Gender/gen2,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "134",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "8",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means less worry about rising bills, but I still want dependable power for my adventures.",
        "sectionLOIr4": "2.85235",
        "sectionLOIr1": "2.85235",
        "sectionLOIr3": "2.51976666667",
        "sectionLOIr2": "0.302583333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1997",
        "Q3": "5",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "3",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "b2bd828d-5776-412b-a5d8-888b9f7b60d3",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "9",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "01/30/2026 03:04",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=cd5a52fbc6964f6996951ab98533480f&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=b2bd828d-5776-412b-a5d8-888b9f7b60d3",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "28",
        "vbrowser": "10",
        "qtime": "162.765",
        "Q14r9": "4",
        "Q14r8": "4",
        "session": "p7x6cd5k2fjqb6kx",
        "Q41r1": "0",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "qn0carb912fw9rm8",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "1",
        "Q43": "2",
        "start_date": "01/30/2026 03:01",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b675e1f77f6e4bd69feb296fca97337b",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1193",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Vote/vote2,bad:/Income/inc1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,sawterm:Q1.ival gt 2007,bad:/Ethnicity/eth4,bad:/de_maxdiff/Q22/v89,bad:/Age/age2,bad:/Rotate Selection/Bottom_to_Top,bad:/Region/reg1,bad:/Gender/gen2,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "89",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "2",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power without breaking the bank, especially with rising rent and gas costs. I hope it brings safer, cleaner air for my dog and community.",
        "sectionLOIr4": "2.71275",
        "sectionLOIr1": "2.71275",
        "sectionLOIr3": "2.37826666667",
        "sectionLOIr2": "0.288583333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "3",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1997",
        "Q3": "33",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "2",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "399a7f0b-4c1d-4f14-ab57-537de880ffb5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "2",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/30/2026 03:04",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b675e1f77f6e4bd69feb296fca97337b&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=399a7f0b-4c1d-4f14-ab57-537de880ffb5",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "185.019",
        "Q41r2": "0",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "xysz6f9501mcheeu",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "f64ux02ms3mhf2bp",
        "Q22_9c2": "1",
        "Q22_9c1": "5",
        "Q34r4": "1",
        "Q22_version": "56",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "1",
        "Q39r2": "4",
        "start_date": "01/30/2026 03:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "2",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "f0b48ef111a24fe39126ab9e6b468fd7",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "1",
        "markers": "bad:/Education/edu3,bad:/Vote/vote1,bad:/Rotate Selection/Top_to_Bottom,bad:/Income/inc5,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/de_maxdiff/Q22/v56,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,bad:/Age/age2,Top_to_Bottom,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "4",
        "Q31": "1",
        "Q9r3": "2",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "3",
        "Q39r4": "5",
        "Q22_7c2": "1",
        "Q30": "2",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "it's a scam that makes my bills go up and the grid crash when i need it most",
        "sectionLOIr4": "3.08365",
        "sectionLOIr1": "3.08365",
        "sectionLOIr3": "2.58431666667",
        "sectionLOIr2": "0.28425",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "37.5",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "12.5",
        "record": "1194",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "9",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "4",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1998",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "c1af953c-28c9-43f6-8550-40a411fb1075",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "7",
        "Q22_3c1": "3",
        "Q22_3c2": "9",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "01/30/2026 03:07",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f0b48ef111a24fe39126ab9e6b468fd7&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=c1af953c-28c9-43f6-8550-40a411fb1075",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "63",
        "vbrowser": "10",
        "qtime": "162.052",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "x8tpszskz6hva1q8",
        "Q41r1": "0",
        "Q14r1": "19",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "qjf144yxnb01n4vu",
        "Q22_9c2": "9",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "5",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 03:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e773c7913b92420c86ac1e2aad80ef1d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "1",
        "record": "1195",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "bad:/Vote/vote2,bad:/Income/inc5,bad:/de_maxdiff/Q22/v296,bad:/Education/edu4,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth1,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "296",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It means more jobs but also risks. I prefer stable sources over quick fixes.",
        "sectionLOIr4": "2.70086666667",
        "sectionLOIr1": "2.70086666667",
        "sectionLOIr3": "2.36751666667",
        "sectionLOIr2": "0.259216666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "9",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1962",
        "Q3": "21",
        "Q2": "1",
        "Q5": "5",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "4",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1138b13d-973b-46e6-8306-855fc4457992",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "01/30/2026 03:07",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e773c7913b92420c86ac1e2aad80ef1d&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=1138b13d-973b-46e6-8306-855fc4457992",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "182.73",
        "Q41r2": "0",
        "Q14r9": "5",
        "Q14r8": "4",
        "session": "d1xxes98guqucyac",
        "Q41r1": "0",
        "Q14r1": "57",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "4",
        "Q14r2": "9",
        "Q14r5": "4",
        "Q14r4": "4",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "h7d8n26rtk5gmwtw",
        "Q22_9c2": "9",
        "Q22_9c1": "7",
        "Q34r4": "1",
        "Q22_version": "263",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "1",
        "Q39r2": "3",
        "start_date": "01/30/2026 03:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "Q39r1": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "14b4a0bdc769408591c8673a7624d264",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "4",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "bad:/Education/edu3,bad:/Vote/vote1,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth1,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Income/inc5,Top_to_Bottom,bad:/de_maxdiff/Q22/v263,bad:/Gender/gen2,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "3",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "6",
        "Q39r4": "5",
        "Q22_7c2": "2",
        "Q30": "2",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "It's just another buzzword that doesn't hold up",
        "sectionLOIr4": "3.0455",
        "sectionLOIr1": "3.0455",
        "sectionLOIr3": "2.6683",
        "sectionLOIr2": "0.234533333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "4",
        "Q10": "1",
        "Q13": "1",
        "Q12": "4",
        "Q22_scorer7": "62.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "record": "1196",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "9",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "0",
        "Q9r1": "2",
        "Q15r6": "0",
        "Q15r7": "0",
        "Q9r4": "4",
        "Q15r1": "0",
        "Q15r2": "0",
        "Q15r3": "0",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1964",
        "Q3": "36",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7a71347b-0580-412d-a84f-771f16865c76",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "4",
        "Q8r2": "1",
        "date": "01/30/2026 03:07",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=14b4a0bdc769408591c8673a7624d264&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=7a71347b-0580-412d-a84f-771f16865c76",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "212.477",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "ftuc1uksezem36an",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "u216fsvhx984w3kx",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/30/2026 03:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "3de3bd5975554c118e17078c7c354e89",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "1197",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu1,bad:/Vote/vote4,Bottom_to_Top,bad:/Ethnicity/eth3,sawterm:(dvfail.r1),20260109_07:39_v14,bad:/Income/inc3,term:(dvfail.r1),qual,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Age/age1,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/de_maxdiff/Q22/v288,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "288",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "4",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "cleaner air for my kids and me, but I'm not sure how much it changes things",
        "sectionLOIr4": "3.54128333333",
        "sectionLOIr1": "3.54128333333",
        "sectionLOIr3": "3.18631666667",
        "sectionLOIr2": "0.2426",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "2002",
        "Q3": "44",
        "Q2": "1",
        "Q5": "2",
        "Q4": "2",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "da831255-661c-4727-b481-0b1dc0b1a768",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/30/2026 03:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3de3bd5975554c118e17078c7c354e89&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=da831255-661c-4727-b481-0b1dc0b1a768",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "214.674",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "198abp83z2x97xuy",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "zwycw0vwnsgw3u9x",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 03:07",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "1a6b33b83c9f47d2b9671fcffdf4f7d2",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "1198",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Income/inc5,bad:/Rotate Selection/Top_to_Bottom,bad:/de_maxdiff/Q22/v258,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,bad:/Ethnicity/eth4,bad:/Region/reg4,bad:/Vote/vote2,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "258",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Dependable power for my family and community, with local job support.",
        "sectionLOIr4": "3.5779",
        "sectionLOIr1": "3.5779",
        "sectionLOIr3": "3.26786666667",
        "sectionLOIr2": "0.204216666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "4",
        "Q22_scorer5": "0",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1978",
        "Q3": "13",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "2",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "2351e8d8-2a58-4e84-8c41-4f36207439c8",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "8",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "01/30/2026 03:10",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1a6b33b83c9f47d2b9671fcffdf4f7d2&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=2351e8d8-2a58-4e84-8c41-4f36207439c8",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "38",
        "vbrowser": "10",
        "qtime": "155.409",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "x09ncus3hrejfdz9",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "vk571w2z83hqp8f4",
        "Q22_9c2": "8",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 03:07",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "601d8b54616a484d90857a2896f978c5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "1199",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu1,bad:/Income/inc2,bad:/Rotate Selection/Top_to_Bottom,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/de_maxdiff/Q22/v292,bad:/Region/reg4,Top_to_Bottom,bad:/Gender/gen2,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "292",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "Reliable power for my job and cooking, keeping things smooth. Better for the environment, which feels hopeful for the future!",
        "sectionLOIr4": "2.59015",
        "sectionLOIr1": "2.59015",
        "sectionLOIr3": "2.25935",
        "sectionLOIr2": "0.222033333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "87.5",
        "HIDAge2": "3",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "100",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1987",
        "Q3": "5",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "2",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "dd5e8c3a-88f5-4e91-9dd2-3655b926e21b",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "01/30/2026 03:10",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=601d8b54616a484d90857a2896f978c5&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=dd5e8c3a-88f5-4e91-9dd2-3655b926e21b",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "20",
        "vbrowser": "10",
        "qtime": "167.991",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "d4d5fnqvxvawqwy5",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "y2sjfzqk5f3t9ypp",
        "Q22_9c2": "3",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/30/2026 03:07",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "bc30f55cc07c4c9682505d52f69293ce",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "1200",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Income/inc2,bad:/Rotate Selection/Top_to_Bottom,bad:/de_maxdiff/Q22/v105,sawterm:(dvfail.r1),term:(dvfail.r1),20260109_07:39_v14,bad:/Vote/vote4,qual,sawterm:Q1.ival gt 2007,bad:/Ethnicity/eth4,bad:/Age/age1,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "105",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "Clean energy means saving on bills without sacrificing reliability, like solar panels for extra savings but needing backup for now.",
        "sectionLOIr4": "2.79985",
        "sectionLOIr1": "2.79985",
        "sectionLOIr3": "2.41731666667",
        "sectionLOIr2": "0.1941",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "100",
        "HIDAge2": "1",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "2005",
        "Q3": "26",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "2086d58b-a647-430f-8821-f5c440dbecb7",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "4",
        "Q22_3c1": "7",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/30/2026 03:10",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bc30f55cc07c4c9682505d52f69293ce&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=2086d58b-a647-430f-8821-f5c440dbecb7",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "36",
        "vbrowser": "10",
        "qtime": "183.877",
        "Q14r9": "8",
        "Q14r8": "13",
        "session": "5871yu2nvs6s0335",
        "Q41r1": "0",
        "Q14r1": "17",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "12",
        "Q14r2": "17",
        "Q14r5": "8",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "4uzfdg4w2q4n9b65",
        "Q22_9c2": "2",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 03:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e40d501c8c9d484ba8d2ada8e63c7a58",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "7",
        "record": "1201",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Vote/vote2,bad:/Income/inc2,Bottom_to_Top,bad:/Ethnicity/eth3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Region/reg3,bad:/de_maxdiff/Q22/v246,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "246",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "2",
        "Q22_7c2": "4",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "3",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "It means brighter future for my community and better opportunities. I love how solar and wind can power hospitals without harming the planet!",
        "sectionLOIr4": "3.06461666667",
        "sectionLOIr1": "3.06461666667",
        "sectionLOIr3": "2.51315",
        "sectionLOIr2": "0.2422",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "100",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "100",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1989",
        "Q3": "1",
        "Q2": "1",
        "Q5": "3",
        "Q4": "2",
        "Q6": "2",
        "Q22_8c2": "2",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "ed0eed3e-5623-437d-ba19-51aaf6e8c7ea",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "6",
        "Q22_3c1": "9",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "5",
        "date": "01/30/2026 03:11",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e40d501c8c9d484ba8d2ada8e63c7a58&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=ed0eed3e-5623-437d-ba19-51aaf6e8c7ea",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "27",
        "vbrowser": "10",
        "qtime": "201.662",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "473m0hv7ea10enyk",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "tvk1j8yp7e58e305",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "4",
        "start_date": "01/30/2026 03:10",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "762544b3af49494c864481fb4fb3b658",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1202",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Vote/vote4,bad:/Rotate Selection/Top_to_Bottom,bad:/Income/inc3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/Ethnicity/eth2,qual,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,bad:/Age/age2,Top_to_Bottom,bad:/de_maxdiff/Q22/v41,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "41",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q39r2": "5",
        "Q39r3": "5",
        "Q39r1": "5",
        "Q22_6c1": "9",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power that doesn’t cost a fortune, and keeps things running without big price hikes.",
        "sectionLOIr4": "3.36103333333",
        "sectionLOIr1": "3.36103333333",
        "sectionLOIr3": "2.89191666667",
        "sectionLOIr2": "0.222266666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "8",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1998",
        "Q3": "19",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "75dac3a8-7ae3-48cb-a876-230dddb2a5d8",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/30/2026 03:13",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=762544b3af49494c864481fb4fb3b658&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=75dac3a8-7ae3-48cb-a876-230dddb2a5d8",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "35",
        "vbrowser": "10",
        "qtime": "173.398",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "zzcsufwnxe2xt34v",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "5cx3tat7fjhx427g",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 03:10",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "c26e4f5cb682444ba31c326bfabccef9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "1203",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu3,Bottom_to_Top,bad:/Income/inc5,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/de_maxdiff/Q22/v67,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Region/reg3,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "67",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "1",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "1",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "3",
        "Q24": "it means safer air for my kids and reliable power for my work. i like how solar and wind can help our commuinity grow without hurting the environment",
        "sectionLOIr4": "2.88996666667",
        "sectionLOIr1": "2.88996666667",
        "sectionLOIr3": "2.52256666667",
        "sectionLOIr2": "0.1895",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "9",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1990",
        "Q3": "1",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "f6423a5a-e0a8-45fa-bd20-f16c6042cf23",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "6",
        "Q22_3c1": "9",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "01/30/2026 03:13",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c26e4f5cb682444ba31c326bfabccef9&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=f6423a5a-e0a8-45fa-bd20-f16c6042cf23",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "76",
        "vbrowser": "10",
        "qtime": "178.893",
        "Q14r9": "5",
        "Q14r8": "4",
        "session": "bwyhr582c4ejzqa6",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "23",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "5rkjnmmtxyf04dxf",
        "Q22_9c2": "6",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 03:10",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "3f6be46836a143dc8006bbd7be3bd6fb",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "1204",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,bad:/Income/inc3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),bad:/Age/age6,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/de_maxdiff/Q22/v281,bad:/Region/reg4,Top_to_Bottom,bad:/Gender/gen2,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "281",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "2",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "5",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power that’s better for the environment. I see it as a way to keep things stable without harming the air.",
        "sectionLOIr4": "2.98155",
        "sectionLOIr1": "2.98155",
        "sectionLOIr3": "2.45593333333",
        "sectionLOIr2": "0.209366666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "7",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1949",
        "Q3": "6",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "65e74b79-b02f-4507-9bcb-e6d922c86faa",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "5",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "8",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "01/30/2026 03:14",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3f6be46836a143dc8006bbd7be3bd6fb&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=65e74b79-b02f-4507-9bcb-e6d922c86faa",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "44",
        "vbrowser": "10",
        "qtime": "159.536",
        "Q14r9": "5",
        "Q14r8": "10",
        "session": "erdujh7xq114nn8b",
        "Q41r1": "0",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "q6fkf0uqqdnaf02m",
        "Q22_9c2": "9",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 03:11",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b6a9af92c0f84254aa5a23745e0d0bfe",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "1205",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Income/inc5,bad:/Education/edu1,bad:/de_maxdiff/Q22/v148,bad:/Rotate Selection/Top_to_Bottom,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Ethnicity/eth4,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "148",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "It reminds me of reliable power for our community, like the water systems I work on. I think it's good for local jobs and keeping things running smoothly.",
        "sectionLOIr4": "2.65893333333",
        "sectionLOIr1": "2.65893333333",
        "sectionLOIr3": "2.30228333333",
        "sectionLOIr2": "0.205766666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "9",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "10",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "10",
        "Q1": "1981",
        "Q3": "14",
        "Q2": "1",
        "Q5": "2",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "27dec926-b3ee-41fd-89b6-120a567ed4f0",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "3",
        "Q22_3c1": "6",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/30/2026 03:14",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b6a9af92c0f84254aa5a23745e0d0bfe&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=27dec926-b3ee-41fd-89b6-120a567ed4f0",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "57",
        "vbrowser": "10",
        "qtime": "159.671",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "72sgsad0mxvs17te",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "76pc4zg98v3bxbe8",
        "Q22_9c2": "2",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 03:13",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b349663fa400452fa98916d9106e22d0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "1206",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Income/inc5,Bottom_to_Top,bad:/Ethnicity/eth1,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/de_maxdiff/Q22/v162,bad:/Vote/vote2,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,bad:/Region/reg1,bad:/Overall/qual",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "162",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "2",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means lower bills for my kids gaming setup but still worry about storms knocking out the grid",
        "sectionLOIr4": "2.66118333333",
        "sectionLOIr1": "2.66118333333",
        "sectionLOIr3": "2.30735",
        "sectionLOIr2": "0.229766666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "7",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1968",
        "Q3": "33",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "60653d17-9296-429c-accb-11af8980d17a",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "2",
        "Q22_3c1": "6",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "1",
        "date": "01/30/2026 03:16",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b349663fa400452fa98916d9106e22d0&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=60653d17-9296-429c-accb-11af8980d17a",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "160.602",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "mwe1vd9v0qcer92q",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "5",
        "Q14r2": "19",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "x5kxn7de2sessn74",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 03:13",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "f7659b73602a4db7afe887e61ed26863",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "1207",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Region/reg4,bad:/Income/inc2,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/de_maxdiff/Q22/v254,bad:/Gender/gen1,bad:/Vote/vote2,bad:/Age/age2,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "254",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "1",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it's about saving money and staying stable. solar panels and efficiency help keep costs down and avoid surprises.",
        "sectionLOIr4": "2.6767",
        "sectionLOIr1": "2.6767",
        "sectionLOIr3": "2.35666666667",
        "sectionLOIr2": "0.199883333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "8",
        "Q1": "1999",
        "Q3": "5",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6e513996-49cf-4b56-ac02-b7ab4b2e1aaf",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "01/30/2026 03:16",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f7659b73602a4db7afe887e61ed26863&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=6e513996-49cf-4b56-ac02-b7ab4b2e1aaf",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "180.847",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "6jcr85m6qyj503w1",
        "Q41r1": "1",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "22",
        "Q14r5": "13",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "vxrgtsw03zdvs7uj",
        "Q22_9c2": "5",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "01/30/2026 03:14",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "872f1eb2500447418c3890ed7f99efc8",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "1208",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,bad:/Income/inc5,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,bad:/de_maxdiff/Q22/v221,bad:/Ethnicity/eth4,Top_to_Bottom,bad:/Gender/gen2,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "1",
        "Q32": "1",
        "Q31": "1",
        "Q22_version": "221",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It means reliable power for my home and tech work, plus a future where clean sources like solar and wind grow, keeping things stable and innovative!",
        "sectionLOIr4": "3.01411666667",
        "sectionLOIr1": "3.01411666667",
        "sectionLOIr3": "2.54231666667",
        "sectionLOIr2": "0.263616666667",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "87.5",
        "HIDAge2": "4",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "10",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1979",
        "Q3": "14",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "0e0c0e05-6d6d-4d11-8217-37dfd38a7c6e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "5",
        "date": "01/30/2026 03:17",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=872f1eb2500447418c3890ed7f99efc8&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=0e0c0e05-6d6d-4d11-8217-37dfd38a7c6e",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "49",
        "vbrowser": "10",
        "qtime": "145.47",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "37e5y380u89m766k",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "gjyt1n8ppaefaxs8",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "01/30/2026 03:14",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4538e6e5887340a1bedf8dfcb084bd7c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "record": "1209",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "bad:/Vote/vote2,bad:/Education/edu1,bad:/Rotate Selection/Top_to_Bottom,bad:/Income/inc3,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age4,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Gender/gen1,Top_to_Bottom,bad:/de_maxdiff/Q22/v228,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "228",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means dependable power for my place and job without pushing too hard on any single option. i see it as a way to keep things stable while moving forward",
        "sectionLOIr4": "2.4245",
        "sectionLOIr1": "2.4245",
        "sectionLOIr3": "2.14828333333",
        "sectionLOIr2": "0.209166666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "7",
        "Q15r6": "10",
        "Q15r7": "8",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1976",
        "Q3": "36",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d13e9494-3635-4995-9c07-fce83a4080d1",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08de5e7c-e575-4d9f-8af6-728df72d4e53",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "1",
        "DIVISION": "3",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "01/30/2026 03:17",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4538e6e5887340a1bedf8dfcb084bd7c&s5=08de5e7c-e575-4d9f-8af6-728df72d4e53&s2=d13e9494-3635-4995-9c07-fce83a4080d1",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "82",
        "vbrowser": "10",
        "qtime": "228.592",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "7yynw5jsjycy66s2",
        "Q41r1": "0",
        "Q14r1": "22",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "18",
        "Q14r5": "13",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "4",
        "uuid": "gst07wubsq1yhxuh",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "02/06/2026 06:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "ab3ea49a011845cdb81a1a6402b8d8b3",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "3",
        "record": "1222",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v98,Top_to_Bottom,/Gender/gen2,/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "98",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "2",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means having reliable power for my trips and home while also thinking about the planet. i like how solar and wind can help reduce pollution but i know we need steady options too",
        "sectionLOIr4": "3.14226666667",
        "sectionLOIr1": "3.14226666667",
        "sectionLOIr3": "2.8084",
        "sectionLOIr2": "0.271783333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1943",
        "Q3": "14",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "4",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e4e94975-92f4-47dd-9a2b-9289c69a6fcd",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "02/06/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ab3ea49a011845cdb81a1a6402b8d8b3&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e4e94975-92f4-47dd-9a2b-9289c69a6fcd&isSynthetic=true&or_age=83&or_zip=62801&or_gender=f&or_householdincome=17314",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "46",
        "vbrowser": "10",
        "qtime": "228.995",
        "Q14r9": "14",
        "Q14r8": "5",
        "session": "r7vs3eyt993xcrjz",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "14",
        "Q14r5": "14",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "6z5c8a56afytjrq8",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "4",
        "start_date": "02/06/2026 06:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d8d1dd5467574771bbc5ca6cdb33235c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "record": "1223",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/de_maxdiff/Q22/v202,sawterm:(dvfail.r1),/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "202",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "it means power that's dependable and doesn't add to the costs i'm already worried about",
        "sectionLOIr4": "3.14681666667",
        "sectionLOIr1": "3.14681666667",
        "sectionLOIr3": "2.90095",
        "sectionLOIr2": "0.25825",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1979",
        "Q3": "23",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "a9068aa8-5929-4ac2-8ae6-2818144febbb",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "02/06/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d8d1dd5467574771bbc5ca6cdb33235c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a9068aa8-5929-4ac2-8ae6-2818144febbb&isSynthetic=true&or_age=44&or_zip=49091&or_gender=m&or_householdincome=36000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "214.582",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "8b8yw0qxtbx5gf2x",
        "Q41r1": "1",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "9",
        "Q14r2": "19",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "qahw9redu95qempd",
        "Q22_9c2": "3",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "2",
        "start_date": "02/06/2026 06:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2e7f0505e8a54f6daf5e0b186079dd05",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "record": "1224",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,/Vote/vote2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/de_maxdiff/Q22/v208,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,/Education/edu4",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "208",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "3",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "It means reliable power for my home and community, especially how solar panels cut costs and keep the air cleaner. I also think it's key for creating jobs, but I know some folks worry about consistency.",
        "sectionLOIr4": "2.9086",
        "sectionLOIr1": "2.9086",
        "sectionLOIr3": "2.62236666667",
        "sectionLOIr2": "0.265733333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "50",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "8",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1972",
        "Q3": "14",
        "Q2": "2",
        "Q5": "5",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "422d77c2-db18-44c3-8d09-ce02dc251255",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "02/06/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2e7f0505e8a54f6daf5e0b186079dd05&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=422d77c2-db18-44c3-8d09-ce02dc251255&isSynthetic=true&or_age=54&or_zip=60609&or_gender=f&or_householdincome=36358",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1993",
        "vctq1c22": "0",
        "HIDAge": "32",
        "Q2": "1",
        "Q4": "5",
        "vctq1c24": "1",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "10.79",
        "Q3": "14",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "fjy2cq4d4b7d50mw",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "or1": "91f3bc9433a64427b0f952c8716157bc",
        "vlist": "2",
        "uuid": "h5vah84hxumt6ewr",
        "vmobiledevice": "5",
        "s2": "30f4bd5e-1d58-43dd-aa65-9ddb02c5b1f5",
        "vctq1c25": "0",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,sawterm:Q1.ival gt 2007,OQ,bad:/Gender/gen1,bad:/Age/age2,bad:/Rotate Selection/Bottom_to_Top,bad:/Overall/qual,bad:/Region/reg2",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "2",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "02/06/2026 06:29",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "3",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "2",
        "date": "02/06/2026 06:29",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=91f3bc9433a64427b0f952c8716157bc&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=30f4bd5e-1d58-43dd-aa65-9ddb02c5b1f5&isSynthetic=true&or_age=30&or_zip=60505&or_gender=m&or_householdincome=63000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1225",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "65",
        "vbrowser": "10",
        "qtime": "207.828",
        "Q14r9": "5",
        "Q14r8": "5",
        "session": "czmknyg4wm02j5wx",
        "Q41r1": "0",
        "Q14r1": "21",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/144.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "16",
        "Q14r5": "16",
        "Q14r4": "11",
        "Q14r7": "5",
        "Q14r6": "5",
        "uuid": "fwxa13ttd0rabem5",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "3",
        "Q43": "2",
        "start_date": "02/06/2026 06:30",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b7a4e70cdb3a4fef90b8059d0c676ce2",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "1226",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth1,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v193,/Gender/gen1,Top_to_Bottom,/Income/inc5,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "193",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "It's about keeping the lights on without messing up the environment, and not too pricey for the family.",
        "sectionLOIr4": "2.79451666667",
        "sectionLOIr1": "2.79451666667",
        "sectionLOIr3": "2.56748333333",
        "sectionLOIr2": "0.208666666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "3",
        "Q12": "1",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "1",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1960",
        "Q3": "39",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "fa6a7a9e-152e-427c-aa81-ebd2c08bdd96",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "02/06/2026 06:33",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b7a4e70cdb3a4fef90b8059d0c676ce2&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=fa6a7a9e-152e-427c-aa81-ebd2c08bdd96&isSynthetic=true&or_age=63&or_zip=15642&or_gender=m&or_householdincome=135300",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1980",
        "vctq1c22": "0",
        "HIDAge": "45",
        "Q2": "2",
        "Q4": "5",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "104.276",
        "Q3": "1",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "rgaz4fadpy4wvwud",
        "s5": "TC_14_0001",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "or1": "TC_14_0001",
        "vlist": "2",
        "uuid": "a2fp6rdzc1p4tc3n",
        "vmobiledevice": "5",
        "s2": "TC_14_0001",
        "vctq1c25": "1",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,bad:/Region/reg3,OQ,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "4",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "02/23/2026 11:36",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "6",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "3",
        "date": "02/23/2026 11:39",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001&s5=TC_14_0001&s2=TC_14_0001&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1321",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1960",
        "vctq1c22": "1",
        "HIDAge": "65",
        "Q2": "2",
        "Q4": "6",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "7.624",
        "Q3": "1",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "7wcb3mvrztc3tv8m",
        "s5": "TC_14_0001_01",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "or1": "TC_14_0001_01",
        "vlist": "2",
        "uuid": "32evrf33a778m9j1",
        "vmobiledevice": "5",
        "s2": "TC_14_0001_01",
        "vctq1c25": "1",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,bad:/Age/age6,qual,sawterm:Q1.ival gt 2007,bad:/Region/reg3,OQ,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "6",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "02/23/2026 11:39",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "6",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "3",
        "date": "02/23/2026 11:40",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001_01&s5=TC_14_0001_01&s2=TC_14_0001_01&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1322",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1980",
        "vctq1c22": "0",
        "HIDAge": "45",
        "Q2": "4",
        "Q4": "8",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "122.317",
        "Q3": "49",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "9asgardz06hhp5bj",
        "s5": "TC_14_0001_02",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "or1": "TC_14_0001_02",
        "vlist": "2",
        "uuid": "my7521tk6rp0t00b",
        "vmobiledevice": "5",
        "s2": "TC_14_0001_02",
        "vctq1c25": "0",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen3,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "4",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "02/23/2026 13:25",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "5",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "3",
        "date": "02/23/2026 14:06",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001_02&s5=TC_14_0001_02&s2=TC_14_0001_02&or_auto=1&norestore=1&prev_uuid=q4r27u9fy18fvffh",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1324",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1980",
        "vctq1c22": "0",
        "HIDAge": "45",
        "Q2": "2",
        "Q4": "8",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "33.01",
        "Q3": "42",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "dnedfw5v2nr87xsb",
        "s5": "TC_14_0001_03",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "or1": "TC_14_0001_03",
        "vlist": "2",
        "uuid": "kr1ev9fxwcj6pya0",
        "vmobiledevice": "5",
        "s2": "TC_14_0001_03",
        "vctq1c25": "1",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,OQ,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen2,bad:/Overall/qual,bad:/Region/reg2",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "4",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "02/23/2026 14:07",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "4",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "2",
        "date": "02/23/2026 14:08",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001_03&s5=TC_14_0001_03&s2=TC_14_0001_03&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1354",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1980",
        "vctq1c22": "0",
        "HIDAge": "45",
        "Q2": "2",
        "Q4": "8",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "21.268",
        "Q3": "13",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "j2hthcgfprcjf5p5",
        "s5": "TC_14_0001_04",
        "vos": "4",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "or1": "TC_14_0001_04",
        "vlist": "2",
        "uuid": "7fdhyq4cp1s54ymw",
        "vmobiledevice": "5",
        "s2": "TC_14_0001_04",
        "vctq1c25": "1",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,OQ,bad:/Region/reg4,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "4",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "02/23/2026 14:08",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "8",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "4",
        "date": "02/23/2026 14:09",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001_04&s5=TC_14_0001_04&s2=TC_14_0001_04&or_auto=1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1355",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "958.793",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "5ex2rnyvtpcxgcbj",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "20",
        "Q14r5": "20",
        "Q14r4": "20",
        "Q14r7": "20",
        "Q14r6": "0",
        "uuid": "au618xuh9hpjmcat",
        "Q22_9c2": "2",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "1",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "2",
        "Q21r2": "7",
        "Q21r5": "5",
        "Q21r4": "6",
        "Q21r7": "3",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "02/23/2026 14:09",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "TC_14_0001_05",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "3",
        "record": "1356",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v237,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Education/edu2,/Gender/gen2,/Income/inc2",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "237",
        "Q37": "2",
        "Q35": "5",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "7",
        "Q22_4c2": "4",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "aro decipio tempora amita clarus nisi deprimo claustrum cariosus tandem vix audio assentator patrocinor agnitio admitto delinquo possimus apud communis ocer eos versus velit reprehenderit blandior victus centum custodia tum vorax praesentium cilicium taceo carpo tenus sub natus triumphus via tergo ducimus",
        "sectionLOIr4": "15.9776833333",
        "sectionLOIr1": "15.9776833333",
        "sectionLOIr3": "14.6924166667",
        "sectionLOIr2": "0.419383333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "1",
        "Q15r5": "8",
        "Q15r6": "7",
        "Q15r7": "4",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1980",
        "Q3": "25",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "6",
        "Q22_8c1": "1",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "TC_14_0001_05",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "TC_14_0001_05",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "5",
        "Q22_3c2": "4",
        "Q8r5": "5",
        "Q8r4": "5",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "02/23/2026 15:33",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001_05&s5=TC_14_0001_05&s2=TC_14_0001_05&or_auto=1",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "375.661",
        "Q14r9": "100",
        "Q14r8": "0",
        "session": "jmxx82u9u2r5ndu5",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "ddusnpq7cb1fa9fy",
        "Q22_9c2": "2",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "3",
        "Q21r2": "4",
        "Q21r5": "7",
        "Q21r4": "1",
        "Q21r7": "5",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "3",
        "start_date": "02/23/2026 15:34",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "TC_14_0001_06",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "7",
        "record": "1357",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v295,/Income/inc5,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "1",
        "Q31": "2",
        "Q22_version": "295",
        "Q36": "4",
        "Q35": "2",
        "Q22_7c1": "8",
        "Q39r4": "3",
        "Q22_7c2": "5",
        "Q39r2": "5",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "censura verto spiculum exercitationem tondeo laudantium varius coniuratio sollers substantia colligo sodalitas tener capitulus chirographum ademptio vindico communis aestas considero dolorem voro depereo auctor decor solitudo balbus causa demulceo quaerat votum hic anser cedo aegre",
        "sectionLOIr4": "6.25875",
        "sectionLOIr1": "6.25875",
        "sectionLOIr3": "6.18558333333",
        "sectionLOIr2": "1.62238333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "3",
        "Q10": "2",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "75",
        "HIDAge2": "4",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q15r5": "1",
        "Q15r6": "1",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "2",
        "Q15r3": "6",
        "Q15r8": "9",
        "Q15r9": "10",
        "Q1": "1980",
        "Q3": "46",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "8",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "TC_14_0001_06",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "TC_14_0001_06",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "7",
        "Q22_3c2": "3",
        "Q8r5": "1",
        "Q8r4": "6",
        "Q8r6": "2",
        "Q8r1": "5",
        "Q8r3": "6",
        "Q8r2": "3",
        "date": "02/23/2026 15:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001_06&s5=TC_14_0001_06&s2=TC_14_0001_06&or_auto=1",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "346.926",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "1sacfvt5e6cvvng4",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "100",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "67yq9z1kfub183b8",
        "Q22_9c2": "3",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q22_version": "163",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "7",
        "Q21r2": "3",
        "Q21r5": "2",
        "Q21r4": "1",
        "Q21r7": "4",
        "Q21r6": "5",
        "Q38": "4",
        "Q43": "2",
        "Q39r2": "2",
        "start_date": "02/23/2026 15:43",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "TC_14_0001_07",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "6",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Vote/vote2,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v163,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Income/inc6,/Education/edu3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "2",
        "Q9r3": "5",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q30": "3",
        "Q39r3": "4",
        "Q9r5": "4",
        "Q9r6": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "9",
        "Q22_4c2": "7",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "cura auctus ustilo acies absque volutabrum antea explicabo enim depraedor auctor allatus conqueror accendo tamisium demulceo umquam patior asporto iure ascit arma ager modi ultio claro blanditiis centum xiphias ademptio",
        "sectionLOIr4": "5.7782",
        "sectionLOIr1": "5.7782",
        "sectionLOIr3": "4.02033333333",
        "sectionLOIr2": "1.01758333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "4",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "75",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "record": "1358",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q9r1": "4",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q9r4": "5",
        "Q15r1": "3",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "9",
        "Q15r9": "4",
        "Q1": "1980",
        "Q3": "5",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "9",
        "Q22_8c1": "6",
        "vos": "4",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "TC_14_0001_07",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "TC_14_0001_07",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "5",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "5",
        "Q8r6": "4",
        "Q8r1": "2",
        "Q8r3": "5",
        "Q8r2": "2",
        "date": "02/23/2026 15:50",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001_07&s5=TC_14_0001_07&s2=TC_14_0001_07&or_auto=1",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "45",
        "vbrowser": "10",
        "qtime": "263.06",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "3amyazbj6t737vhy",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/145.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "0",
        "Q14r5": "100",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "tnpy426wc16qbyym",
        "Q22_9c2": "5",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "6",
        "vlist": "2",
        "Q30r6oe": "tamen atqui utilis curvo peior vinculum aer ea voluptatem pauper",
        "Q22_5c2": "8",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "1",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "7",
        "Q21r2": "1",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "4",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "4",
        "start_date": "02/24/2026 13:18",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "TC_14_0001_08",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "6",
        "record": "1387",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "bad:/Education/edu2,bad:/Income/inc4,bad:/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,term:(dvfail.r1),qual,bad:/Age/age4,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/de_maxdiff/Q22/v86,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen2,bad:/Overall/qual,bad:/Region/reg2",
        "Q33": "1",
        "Q32": "4",
        "Q31": "3",
        "Q22_version": "86",
        "Q35": "6",
        "Q22_7c1": "4",
        "Q39r4": "5",
        "Q22_7c2": "5",
        "Q39r2": "5",
        "Q39r3": "2",
        "Q39r1": "5",
        "Q22_6c1": "5",
        "Q22_6c2": "1",
        "Q22_4c2": "7",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "37.5",
        "Q23": "2",
        "Q24": "accendo varius abstergo clementia suffoco clarus tantillus crux cupio vociferor commodo beatus est aestus cuppedia vir comparo cogito vero excepturi vester creber casus auctus acidus suscipio cunabula charisma adficio thalassinus condico",
        "sectionLOIr4": "4.38433333333",
        "sectionLOIr1": "4.38433333333",
        "sectionLOIr3": "3.75996666667",
        "sectionLOIr2": "0.3388",
        "vctq1c21": "1",
        "Q35r6oe": "atqui decumbo sophismata alienus curto curtus verus tabula blanditiis vestigium",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "1",
        "Q13": "4",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "2",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "8",
        "Q15r6": "8",
        "Q15r7": "6",
        "Q15r1": "10",
        "Q15r2": "3",
        "Q15r3": "5",
        "Q15r8": "2",
        "Q15r9": "1",
        "Q1": "1980",
        "Q3": "28",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "4",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "TC_14_0001_08",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "TC_14_0001_08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "1",
        "DIVISION": "4",
        "Q22_3c1": "1",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "6",
        "Q8r1": "5",
        "Q8r3": "6",
        "Q8r2": "2",
        "date": "02/24/2026 13:27",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=TC_14_0001_08&s5=TC_14_0001_08&s2=TC_14_0001_08&or_auto=1",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "1",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "MA",
        "GeoIP_Detailsr5": "Massachusetts",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "506",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "451.123",
        "Q14r9": "19",
        "Q14r8": "5",
        "session": "5ve1uzjc6544ayte",
        "Q41r1": "0",
        "Q14r1": "19",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "24",
        "Q14r5": "9",
        "Q14r4": "5",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "gy4jp9m0rszaajaj",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "1",
        "start_date": "03/11/2026 09:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "de4e0abf2e94481c8e78cc0425219c96",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "1453",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote1,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),/de_maxdiff/Q22/v133,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Region/reg3,sawterm:Q1.ival gt 2007,/Income/inc5,/Age/age6,/Education/edu3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "133",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "mostly about jobs and keeping things running smoothly for my family",
        "sectionLOIr4": "7.51013333333",
        "sectionLOIr1": "7.51013333333",
        "sectionLOIr3": "6.05238333333",
        "sectionLOIr2": "0.3194",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "100",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "5",
        "Q15r6": "6",
        "Q15r7": "5",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "6",
        "Q1": "1957",
        "Q3": "4",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "8",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "cd59766e-a420-44b1-9849-2595fa52e52d",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "03/11/2026 10:05",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=de4e0abf2e94481c8e78cc0425219c96&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cd59766e-a420-44b1-9849-2595fa52e52d&isSynthetic=true&or_age=59&or_zip=72845&or_gender=m&or_householdincome=34700",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "620.315",
        "Q14r9": "0",
        "Q14r8": "10",
        "session": "6zdf2jk1numvzewp",
        "Q41r1": "0",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "15",
        "Q14r5": "15",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "1x0phh7f9fe23wgb",
        "Q22_9c2": "1",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 09:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "d28f7f5b5009459985fee5572dc385a5",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "1454",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote3,/Education/edu2,/Region/reg4,/de_maxdiff/Q22/v230,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "230",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "it's the kind that doesn't mess up the air we breathe at home",
        "sectionLOIr4": "10.33555",
        "sectionLOIr1": "10.33555",
        "sectionLOIr3": "8.8928",
        "sectionLOIr2": "0.609483333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "4",
        "Q15r5": "4",
        "Q15r6": "4",
        "Q15r7": "4",
        "Q15r1": "4",
        "Q15r2": "4",
        "Q15r3": "4",
        "Q15r8": "4",
        "Q15r9": "6",
        "Q1": "1999",
        "Q3": "29",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "0955a433-a48a-4a15-8491-a2a05f021da6",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "5",
        "Q22_3c2": "1",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "1",
        "date": "03/11/2026 10:08",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d28f7f5b5009459985fee5572dc385a5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0955a433-a48a-4a15-8491-a2a05f021da6&isSynthetic=true&or_age=27&or_zip=89129&or_gender=m&or_householdincome=64346",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "65",
        "vbrowser": "10",
        "qtime": "524.894",
        "Q14r9": "0",
        "Q14r8": "17",
        "session": "8fc1vq1110xxrcw0",
        "Q41r1": "1",
        "Q14r1": "11",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "22",
        "Q14r2": "11",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "9y9km065rbr47h17",
        "Q22_9c2": "1",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 09:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "f54db7fd75524e6783cf9921a0d3f8e9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1455",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v253,/Gender/gen1,Top_to_Bottom,/Income/inc1,/Vote/vote3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "253",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "My dad used to work at a plant that burned clean fuels, but the newer projects weren't as reliable. I want something dependable for my cats and my bills.",
        "sectionLOIr4": "8.74518333333",
        "sectionLOIr1": "8.74518333333",
        "sectionLOIr3": "7.11478333333",
        "sectionLOIr2": "0.686033333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "3",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "9",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "5",
        "Q15r6": "7",
        "Q15r7": "5",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1960",
        "Q3": "15",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "8",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "11",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "9199c157-e4f4-4da6-8bc1-72a7c8680b27",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "03/11/2026 10:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f54db7fd75524e6783cf9921a0d3f8e9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9199c157-e4f4-4da6-8bc1-72a7c8680b27&isSynthetic=true&or_age=66&or_zip=46235&or_gender=m&or_householdincome=30000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "40",
        "vbrowser": "10",
        "qtime": "493.322",
        "Q14r9": "18",
        "Q14r8": "4",
        "session": "mqbdhv66e6zfrpas",
        "Q41r1": "0",
        "Q14r1": "23",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "23",
        "Q14r2": "9",
        "Q14r5": "14",
        "Q14r4": "9",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "za6hpz3kefg03q7n",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "start_date": "03/11/2026 09:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "713290e7eaa7494185cb9530f1232594",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "1456",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,/de_maxdiff/Q22/v36,/Education/edu1,20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,sawterm:(dvfail.r1),/Age/age3,/Income/inc3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "36",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "means safer air for the people i service especially after that government project where we upgraded systems to meet new standards",
        "sectionLOIr4": "8.21956666667",
        "sectionLOIr1": "8.21956666667",
        "sectionLOIr3": "6.93371666667",
        "sectionLOIr2": "0.5536",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "1",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "5",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1985",
        "Q3": "44",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "2",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "532ba78c-be0e-4ebc-86ad-8bee40fab2ff",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "1",
        "date": "03/11/2026 10:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=713290e7eaa7494185cb9530f1232594&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=532ba78c-be0e-4ebc-86ad-8bee40fab2ff&isSynthetic=true&or_age=41&or_zip=77494&or_gender=m&or_householdincome=50000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "478.798",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "480ab69cf0dg41f1",
        "Q41r1": "1",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "25",
        "Q14r5": "0",
        "Q14r4": "15",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "ru8ff3nt3d2ymcd9",
        "Q22_9c2": "5",
        "Q22_9c1": "6",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "03/11/2026 09:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "a6b517cfae7741b59672147c57d50df6",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1457",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Gender/gen2,/Income/inc1,/Education/edu3,/de_maxdiff/Q22/v99",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "99",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "6",
        "Q39r4": "5",
        "Q22_7c2": "5",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "keeps the air cleaner for the kids, but the price tag is still tough to swallow",
        "sectionLOIr4": "7.97736666667",
        "sectionLOIr1": "7.97736666667",
        "sectionLOIr3": "6.68443333333",
        "sectionLOIr2": "0.514383333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "25",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "75",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "7",
        "Q15r7": "3",
        "Q15r1": "6",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "5",
        "Q15r9": "6",
        "Q1": "1967",
        "Q3": "11",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "47f24c85-97ff-4836-ad0f-93bd9cbdaacc",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "3",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "03/11/2026 10:05",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a6b517cfae7741b59672147c57d50df6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=47f24c85-97ff-4836-ad0f-93bd9cbdaacc&isSynthetic=true&or_age=22&or_zip=30507&or_gender=f&or_householdincome=20000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "34",
        "vbrowser": "10",
        "qtime": "449.212",
        "Q14r9": "20",
        "Q14r8": "5",
        "session": "dpsm5gwyp5c76s02",
        "Q41r1": "1",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "15",
        "Q14r5": "5",
        "Q14r4": "10",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "af803z6twk0hu291",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "2",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "4",
        "start_date": "03/11/2026 09:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "68e2aaa0c47d4fc69079b917cfe56d81",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "7",
        "record": "1458",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg2,/Ethnicity/eth1,/Vote/vote4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v241,/Gender/gen1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "241",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "2",
        "Q22_4c2": "2",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "reliable power for my house and work",
        "sectionLOIr4": "7.48423333333",
        "sectionLOIr1": "7.48423333333",
        "sectionLOIr3": "6.28791666667",
        "sectionLOIr2": "0.496983333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "2",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "37.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "10",
        "Q15r5": "8",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1991",
        "Q3": "36",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "4",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "aee3e5cc-f2b3-4bc0-bb92-16a7efed3ae5",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "03/11/2026 10:05",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=68e2aaa0c47d4fc69079b917cfe56d81&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=aee3e5cc-f2b3-4bc0-bb92-16a7efed3ae5&isSynthetic=true&or_age=35&or_zip=45209&or_gender=m&or_householdincome=40100",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "533.432",
        "Q14r9": "15",
        "Q14r8": "0",
        "session": "enar6wkz5nt24xqk",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "0",
        "Q14r5": "20",
        "Q14r4": "15",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "j0qbcc5ubhuhp2vc",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "1",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "03/11/2026 10:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "85b3ff15e198422db3e022a63f74da6f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "2",
        "record": "1459",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc4,/Education/edu3,/Age/age3,/de_maxdiff/Q22/v248",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "248",
        "Q37": "1",
        "Q35": "4",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "2",
        "Q22_6c1": "1",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "clean energy means steady jobs and lower bills which helps me juggle work and parenting",
        "sectionLOIr4": "8.88795",
        "sectionLOIr1": "8.88795",
        "sectionLOIr3": "6.74988333333",
        "sectionLOIr2": "0.543366666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1983",
        "Q3": "23",
        "Q2": "1",
        "Q5": "4",
        "Q4": "2",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f5c94420-7fcf-422e-892e-91364b29b0ef",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "2",
        "Q22_3c2": "7",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "1",
        "date": "03/11/2026 10:14",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=85b3ff15e198422db3e022a63f74da6f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f5c94420-7fcf-422e-892e-91364b29b0ef&isSynthetic=true&or_age=43&or_zip=49221&or_gender=m&or_householdincome=72000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "63",
        "vbrowser": "10",
        "qtime": "480.801",
        "Q14r9": "10",
        "Q14r8": "20",
        "session": "s6pwkjrpve3sx3q4",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "5",
        "Q14r5": "25",
        "Q14r4": "15",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "wqm9tjx4nm2twjxh",
        "Q22_9c2": "8",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "03/11/2026 10:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "bdec5fd856ad4442b8651bd6fb8f541f",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1460",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg4,/Vote/vote4,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,/de_maxdiff/Q22/v239,qual,sawterm:Q1.ival gt 2007,/Income/inc5,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "239",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "clean energy means the air's cleaner when i work on systems that cut down on fumes from old boilers",
        "sectionLOIr4": "8.00866666667",
        "sectionLOIr1": "8.00866666667",
        "sectionLOIr3": "6.5264",
        "sectionLOIr2": "0.492516666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "100",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "7",
        "Q15r1": "8",
        "Q15r2": "9",
        "Q15r3": "10",
        "Q15r8": "8",
        "Q15r9": "9",
        "Q1": "1962",
        "Q3": "5",
        "Q2": "2",
        "Q5": "2",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "f3e92b9b-f0dc-4906-919e-6d2bee34a9a2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "03/11/2026 10:13",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bdec5fd856ad4442b8651bd6fb8f541f&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f3e92b9b-f0dc-4906-919e-6d2bee34a9a2&isSynthetic=true&or_age=45&or_zip=94539&or_gender=f&or_householdincome=88000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "62",
        "vbrowser": "10",
        "qtime": "431.974",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "vcwhvzwg2pn2vknx",
        "Q41r1": "1",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "14",
        "Q14r4": "18",
        "Q14r7": "4",
        "Q14r6": "0",
        "uuid": "da9zcccp5t3bvqtb",
        "Q22_9c2": "2",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 10:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "60af05d45d0642ef8fcdbe5c2be232fc",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "1461",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,Bottom_to_Top,sawterm:(dvfail.r1),/de_maxdiff/Q22/v181,20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6,/Education/edu3,/Vote/vote3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "1",
        "Q22_version": "181",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "2",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "3",
        "Q24": "clean energy means having a reliable backup plan for the lights at home and the campus after dark",
        "sectionLOIr4": "7.19638333333",
        "sectionLOIr1": "7.19638333333",
        "sectionLOIr3": "5.85678333333",
        "sectionLOIr2": "0.5701",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "5",
        "Q22_scorer5": "75",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "8",
        "Q15r7": "7",
        "Q15r1": "6",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "8",
        "Q1": "1963",
        "Q3": "15",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "7",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "172d0613-19a0-4d51-8362-13d044d45443",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "03/11/2026 10:13",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=60af05d45d0642ef8fcdbe5c2be232fc&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=172d0613-19a0-4d51-8362-13d044d45443&isSynthetic=true&or_age=63&or_zip=46219&or_gender=m&or_householdincome=35000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "73",
        "vbrowser": "10",
        "qtime": "482.594",
        "Q14r9": "22",
        "Q14r8": "6",
        "session": "vfyjdnm0drp9f3w0",
        "Q41r1": "1",
        "Q14r1": "11",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "11",
        "Q14r2": "5",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "6",
        "Q14r6": "0",
        "uuid": "95jzexb4zvfwb1ka",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "1",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "6",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "03/11/2026 10:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "3e64cbeec9ed4c6583315466a1c45695",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "1462",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg4,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,/de_maxdiff/Q22/v293,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Income/inc5",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "293",
        "Q37": "2",
        "Q35": "4",
        "Q22_7c1": "1",
        "Q39r4": "5",
        "Q22_7c2": "3",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "political term, but I stick with proven sources for my bills",
        "sectionLOIr4": "8.03985",
        "sectionLOIr1": "8.03985",
        "sectionLOIr3": "6.62483333333",
        "sectionLOIr2": "0.54785",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "100",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "5",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "5",
        "Q15r9": "6",
        "Q1": "1952",
        "Q3": "5",
        "Q2": "1",
        "Q5": "3",
        "Q4": "3",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "11",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "ea0dbca9-a740-4ee1-878b-d8292d7564cd",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "03/11/2026 10:14",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3e64cbeec9ed4c6583315466a1c45695&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ea0dbca9-a740-4ee1-878b-d8292d7564cd&isSynthetic=true&or_age=74&or_zip=93722&or_gender=m&or_householdincome=12446",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "502.447",
        "Q14r9": "15",
        "Q14r8": "5",
        "session": "n2zew2ku1ef484v8",
        "Q41r1": "1",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "5",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "7mqwy3a1dbtev92u",
        "Q22_9c2": "9",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "3",
        "Q21r2": "6",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "2",
        "Q21r6": "7",
        "Q38": "2",
        "Q43": "4",
        "start_date": "03/11/2026 10:07",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "58dd2224e7624ec1a0a1e8d9909bf09d",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "2",
        "record": "1463",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v296,/Gender/gen1,/Income/inc4,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "3",
        "Q22_version": "296",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "local jobs and lower bills keep us stable",
        "sectionLOIr4": "8.37155",
        "sectionLOIr1": "8.37155",
        "sectionLOIr3": "7.1597",
        "sectionLOIr2": "0.559016666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "3",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "5",
        "Q15r9": "6",
        "Q1": "1972",
        "Q3": "44",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "4",
        "Q22_8c2": "8",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a37429c8-daed-46a3-bfc9-a00923083021",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "6",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "03/11/2026 10:15",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=58dd2224e7624ec1a0a1e8d9909bf09d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a37429c8-daed-46a3-bfc9-a00923083021&isSynthetic=true&or_age=54&or_zip=75104&or_gender=m&or_householdincome=91960",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "553.449",
        "Q14r9": "38",
        "Q14r8": "0",
        "session": "hmnf314vn0nm17wx",
        "Q41r1": "0",
        "Q14r1": "12",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "25",
        "Q14r2": "6",
        "Q14r5": "19",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "9arakken764g210j",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "5",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "4",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 10:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "0b5eed20796f4a589c9564ae56e2fcca",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "1464",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,/Education/edu4,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v210,/Gender/gen1,/Income/inc4,Top_to_Bottom",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "210",
        "Q36": "4",
        "Q35": "2",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "2",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "hearing it makes me think of how it affects my clients' reliability and local job markets",
        "sectionLOIr4": "9.221",
        "sectionLOIr1": "9.221",
        "sectionLOIr3": "7.55603333333",
        "sectionLOIr2": "0.573733333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "4",
        "Q15r6": "4",
        "Q15r7": "5",
        "Q15r1": "4",
        "Q15r2": "4",
        "Q15r3": "5",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1996",
        "Q3": "10",
        "Q2": "1",
        "Q5": "5",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "4764d5e1-306f-4817-a52f-98fe7e4ecaf6",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "03/11/2026 10:17",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=0b5eed20796f4a589c9564ae56e2fcca&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4764d5e1-306f-4817-a52f-98fe7e4ecaf6&isSynthetic=true&or_age=30&or_zip=33837&or_gender=m&or_householdincome=85000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "92",
        "vbrowser": "10",
        "qtime": "456.813",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "0nba2szg0pb3bb3w",
        "Q41r1": "1",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "30",
        "Q14r5": "15",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "qqc25badn9hw1vcp",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 10:14",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "6aa57bc50e324cf4987df7435ebd5c51",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "record": "1465",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg2,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v283,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Age/age6,/Education/edu3,/Vote/vote3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "283",
        "Q36": "2",
        "Q35": "2",
        "Q22_7c1": "2",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "5",
        "Q22_6c2": "3",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Means safer breathing for my clients and the cat. The community projects I work on focus on this, even if politics get messy",
        "sectionLOIr4": "7.60708333333",
        "sectionLOIr1": "7.60708333333",
        "sectionLOIr3": "6.03916666667",
        "sectionLOIr2": "0.359233333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "3",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "75",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "5",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1933",
        "Q3": "28",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "9",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "9239a33d-316a-4d65-b5c3-82a3700b9fcf",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "4",
        "Q22_3c1": "4",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "4",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "1",
        "date": "03/11/2026 10:21",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6aa57bc50e324cf4987df7435ebd5c51&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9239a33d-316a-4d65-b5c3-82a3700b9fcf&isSynthetic=true&or_age=42&or_zip=33603&or_gender=f&or_householdincome=65000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "58",
        "vbrowser": "10",
        "qtime": "494.638",
        "Q14r9": "18",
        "Q14r8": "5",
        "session": "wmmy4xjjfubx27u0",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "9",
        "Q14r5": "9",
        "Q14r4": "14",
        "Q14r7": "4",
        "Q14r6": "0",
        "uuid": "qk4p6xvz9s3drbu7",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "4",
        "start_date": "03/11/2026 10:14",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "bac067b0eaa54aec918a8a98589b8922",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "1466",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/de_maxdiff/Q22/v61,/Income/inc1",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "61",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "2",
        "Q39r1": "2",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "7",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "democrats push it but i've seen too many promises fall flat",
        "sectionLOIr4": "8.24115",
        "sectionLOIr1": "8.24115",
        "sectionLOIr3": "6.57396666667",
        "sectionLOIr2": "0.488083333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "0",
        "HIDAge2": "5",
        "Q22_scorer5": "50",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "9",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "3",
        "Q15r6": "6",
        "Q15r7": "5",
        "Q15r1": "4",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "4",
        "Q15r9": "5",
        "Q1": "1967",
        "Q3": "18",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "4a06a912-f2ec-4f50-b736-37c441555fae",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "6",
        "Q22_3c2": "9",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "03/11/2026 10:22",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bac067b0eaa54aec918a8a98589b8922&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4a06a912-f2ec-4f50-b736-37c441555fae&isSynthetic=true&or_age=58&or_zip=42633&or_gender=m&or_householdincome=23930",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1945",
        "vctq1c22": "0",
        "HIDAge": "80",
        "Q2": "2",
        "Q4": "8",
        "vctq1c24": "0",
        "vctq1c23": "1",
        "list": "1",
        "vbrowser": "10",
        "qtime": "24.261",
        "Q3": "47",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "d2k2rtsrrjkdsnr8",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "da5c1f21c35543069fea0d5fe09c6a98",
        "vlist": "2",
        "uuid": "svcynasqe274n7uy",
        "vmobiledevice": "5",
        "s2": "3cc06f4a-0146-42d0-846c-23b30f0283e0",
        "vctq1c25": "1",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,bad:/Age/age6,qual,sawterm:Q1.ival gt 2007,bad:/Region/reg3,OQ,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "6",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "03/11/2026 10:15",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "5",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "3",
        "date": "03/11/2026 10:15",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=da5c1f21c35543069fea0d5fe09c6a98&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3cc06f4a-0146-42d0-846c-23b30f0283e0&isSynthetic=true&or_age=80&or_zip=20155&or_gender=f&or_householdincome=29000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1467",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "476.564",
        "Q14r9": "5",
        "Q14r8": "0",
        "session": "7uxt3b158gvy34zh",
        "Q41r1": "1",
        "Q14r1": "45",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "15",
        "Q14r5": "10",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "a8wdfma1h6bwwc57",
        "Q22_9c2": "8",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "4",
        "start_date": "03/11/2026 10:15",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "fba9b2fb39134208a6cfc4c065efcf86",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "7",
        "record": "1468",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg4,/Vote/vote4,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/de_maxdiff/Q22/v180,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,sawterm:(dvfail.r1),/Income/inc7",
        "Q33": "2",
        "Q32": "3",
        "Q31": "3",
        "Q22_version": "180",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "3",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "just the Democratic Party’s thing, not sure how it affects my bills or the kid’s school stuff",
        "sectionLOIr4": "7.94013333333",
        "sectionLOIr1": "7.94013333333",
        "sectionLOIr3": "6.31081666667",
        "sectionLOIr2": "0.408533333333",
        "vctq1c21": "1",
        "Q17": "1",
        "Q16": "1",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "62.5",
        "HIDAge2": "4",
        "Q22_scorer5": "25",
        "Q22_scorer4": "12.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "7",
        "Q22_2c2": "8",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "8",
        "Q15r7": "4",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1972",
        "Q3": "5",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "7",
        "Q22_8c2": "4",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "6a2d31f5-c918-4a22-b0d7-a49a9298d172",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "1",
        "Q22_3c2": "4",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "4",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "03/11/2026 10:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=fba9b2fb39134208a6cfc4c065efcf86&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6a2d31f5-c918-4a22-b0d7-a49a9298d172&isSynthetic=true&or_age=54&or_zip=90025&or_gender=m&or_householdincome=60000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "66",
        "vbrowser": "10",
        "qtime": "508.434",
        "Q14r9": "10",
        "Q14r8": "5",
        "session": "eqjds77hrwbucq9d",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "19",
        "Q14r2": "9",
        "Q14r5": "14",
        "Q14r4": "24",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "zx1pzexc6tvds6xr",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 10:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "69cb3b827d1d40f68b99924855d22e39",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1469",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Gender/gen2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v194,/Age/age6,/Income/inc1,/Vote/vote3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "194",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "keeps the neighborhood safe for the kids and local jobs",
        "sectionLOIr4": "8.47098333333",
        "sectionLOIr1": "8.47098333333",
        "sectionLOIr3": "6.84445",
        "sectionLOIr2": "0.480766666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "5",
        "Q15r6": "6",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "5",
        "Q15r9": "6",
        "Q1": "1959",
        "Q3": "14",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "9",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "1ee35546-2f4b-4b00-bcae-4c9e09979ec3",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "3",
        "Q22_3c2": "8",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "03/11/2026 10:24",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=69cb3b827d1d40f68b99924855d22e39&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1ee35546-2f4b-4b00-bcae-4c9e09979ec3&isSynthetic=true&or_age=60&or_zip=60613&or_gender=f&or_householdincome=16800",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "98",
        "vbrowser": "10",
        "qtime": "468.719",
        "Q14r9": "5",
        "Q14r8": "0",
        "session": "mdabby68x9qzbmhy",
        "Q41r1": "1",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "25",
        "Q14r5": "15",
        "Q14r4": "20",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "zsmqrj3sr5k2sma4",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "5",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "4",
        "Q21r6": "2",
        "Q38": "3",
        "Q43": "2",
        "start_date": "03/11/2026 10:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "47a3a994ac8b40188721d31ddfc150af",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "6",
        "record": "1470",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v286,/Gender/gen1,/Income/inc5,/Age/age6",
        "Q33": "1",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "286",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Means the Democratic Party's push but I'm not sure about the cost",
        "sectionLOIr4": "7.80916666667",
        "sectionLOIr1": "7.80916666667",
        "sectionLOIr3": "6.30136666667",
        "sectionLOIr2": "0.596583333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "6",
        "Q15r7": "5",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1927",
        "Q3": "36",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "5",
        "Q22_8c2": "5",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "770708c5-6588-4a4f-8390-2798c5f6d8de",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "7",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "03/11/2026 10:24",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=47a3a994ac8b40188721d31ddfc150af&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=770708c5-6588-4a4f-8390-2798c5f6d8de&isSynthetic=true&or_age=42&or_zip=45853&or_gender=m&or_householdincome=121400",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1955",
        "vctq1c22": "1",
        "HIDAge": "70",
        "Q2": "1",
        "Q4": "5",
        "vctq1c24": "1",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "11.355",
        "Q3": "44",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "hm6x6zedh339r6kv",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "4bd45599b1f04b369c4d1d9567fedcda",
        "vlist": "2",
        "uuid": "wfrjdv628bm7a1b2",
        "vmobiledevice": "5",
        "s2": "93cea663-e292-48b7-81df-3eb811b15dad",
        "vctq1c25": "0",
        "markers": "bad:/Rotate Selection/Top_to_Bottom,OQ /Ethnicity/eth5,20260109_07:39_v14,bad:/Age/age6,qual,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Gender/gen1,Top_to_Bottom,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "6",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "03/11/2026 10:18",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "7",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "3",
        "date": "03/11/2026 10:18",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4bd45599b1f04b369c4d1d9567fedcda&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=93cea663-e292-48b7-81df-3eb811b15dad&isSynthetic=true&or_age=71&or_zip=77346&or_gender=m&or_householdincome=48000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1471",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "93",
        "vbrowser": "10",
        "qtime": "511.356",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "nn4pta6hw8utmtfg",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "0",
        "Q14r2": "25",
        "Q14r5": "15",
        "Q14r4": "20",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "9n9p82uczg189vsa",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "1",
        "Q43": "2",
        "start_date": "03/11/2026 10:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "c80e7d166f2146e3b6e17a8cbb22b15c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "record": "1472",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Vote/vote2,/Ethnicity/eth4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v228,Top_to_Bottom,/Gender/gen2,/Income/inc1,/Education/edu3",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "228",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "5",
        "Q22_7c2": "7",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "2",
        "Q22_6c2": "9",
        "Q22_4c2": "9",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "Means my dad’s old job is a mixed bag, but now I focus on keeping the costs down for our apartment",
        "sectionLOIr4": "8.52001666667",
        "sectionLOIr1": "8.52001666667",
        "sectionLOIr3": "6.77685",
        "sectionLOIr2": "0.566383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "9",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "6",
        "Q15r5": "5",
        "Q15r6": "10",
        "Q15r7": "4",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "9",
        "Q15r8": "5",
        "Q15r9": "7",
        "Q1": "1932",
        "Q3": "33",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "1",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "745b6522-9159-4479-b134-3025b670e653",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "03/11/2026 10:27",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c80e7d166f2146e3b6e17a8cbb22b15c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=745b6522-9159-4479-b134-3025b670e653&isSynthetic=true&or_age=94&or_zip=11369&or_gender=f&or_householdincome=18847",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "81",
        "vbrowser": "10",
        "qtime": "509.553",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "27qj6efu8zdtpj4r",
        "Q41r1": "0",
        "Q14r1": "40",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "15",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "73gjhacp37f4acma",
        "Q22_9c2": "7",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "1",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "4",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "03/11/2026 10:22",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "3acbca7292d64ffeb2e73974205dcddf",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "9",
        "record": "1473",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Gender/gen2,/Region/reg4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v91,/Ethnicity/eth1,/Age/age6,/Income/inc1,/Education/edu4",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "91",
        "Q37": "2",
        "Q35": "4",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "6",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "2",
        "Q24": "Means cheaper bills and less worry about the grid but I still check those ads for solar panels on Facebook got tired of the scams after my neighbor's experience",
        "sectionLOIr4": "8.4899",
        "sectionLOIr1": "8.4899",
        "sectionLOIr3": "6.76958333333",
        "sectionLOIr2": "0.593816666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "5",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1944",
        "Q3": "5",
        "Q2": "2",
        "Q5": "5",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "90022d0c-af5b-4739-a226-3f16a789f36c",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "4",
        "date": "03/11/2026 10:30",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=3acbca7292d64ffeb2e73974205dcddf&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=90022d0c-af5b-4739-a226-3f16a789f36c&isSynthetic=true&or_age=82&or_zip=93065&or_gender=f&or_householdincome=26540",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "62",
        "vbrowser": "10",
        "qtime": "479.697",
        "Q14r9": "5",
        "Q14r8": "0",
        "session": "fw215v59as10rtjf",
        "Q41r1": "0",
        "Q14r1": "28",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "19",
        "Q14r2": "24",
        "Q14r5": "14",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "gyab3bwfz4fnu6ya",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 10:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "15ad8a26a22d4871bed054cd34840e83",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1474",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/Ethnicity/eth1,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,/de_maxdiff/Q22/v51,sawterm:Q1.ival gt 2007,/Income/inc4,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "51",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Means safer air for my kids but I'm still wary of costs after seeing gas prices climb",
        "sectionLOIr4": "7.99218333333",
        "sectionLOIr1": "7.99218333333",
        "sectionLOIr3": "6.5821",
        "sectionLOIr2": "0.574566666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "5",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "1963",
        "Q3": "40",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "3",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "5",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "9bb3039a-7daa-4969-8109-22b59d4b7356",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "1",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "1",
        "Q8r2": "2",
        "date": "03/11/2026 10:31",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=15ad8a26a22d4871bed054cd34840e83&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9bb3039a-7daa-4969-8109-22b59d4b7356&isSynthetic=true&or_age=63&or_zip=60804&or_gender=f&or_householdincome=38760",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "31",
        "vbrowser": "10",
        "qtime": "472.449",
        "Q14r9": "25",
        "Q14r8": "0",
        "session": "46exckk2ajq1840j",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "15",
        "Q14r5": "5",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "wb92j2b1a87c8sx3",
        "Q22_9c2": "8",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "2",
        "Q21r6": "7",
        "Q38": "4",
        "Q43": "2",
        "start_date": "03/11/2026 10:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "761e1a138849492a87e3bd00a86cd72c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1475",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Education/edu2,/Gender/gen2,/de_maxdiff/Q22/v89,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "89",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "Means more bills for my kids' future but I trust Democrats on this",
        "sectionLOIr4": "7.87158333333",
        "sectionLOIr1": "7.87158333333",
        "sectionLOIr3": "6.39076666667",
        "sectionLOIr2": "0.59815",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "4",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "87.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q15r1": "5",
        "Q15r2": "4",
        "Q15r3": "5",
        "Q15r8": "7",
        "Q15r9": "7",
        "Q1": "1994",
        "Q3": "1",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "2",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "10",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "d44c2e77-6538-455c-97cf-7a67a887a345",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "6",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "03/11/2026 10:31",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=761e1a138849492a87e3bd00a86cd72c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d44c2e77-6538-455c-97cf-7a67a887a345&isSynthetic=true&or_age=32&or_zip=36116&or_gender=f&or_householdincome=74000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "47",
        "vbrowser": "10",
        "qtime": "491.405",
        "Q14r9": "17",
        "Q14r8": "6",
        "session": "8sxm9j9g0mfeuphv",
        "Q41r1": "0",
        "Q14r1": "11",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "22",
        "Q14r2": "28",
        "Q14r5": "11",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "f3jcwj2cr1s43q0y",
        "Q22_9c2": "8",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "4",
        "Q43": "2",
        "start_date": "03/11/2026 10:24",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "b5e3447dc7754d9dbf888a30eac5cf50",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "6",
        "record": "1476",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg2,/Vote/vote2,/Ethnicity/eth1,sawterm:(dvfail.r1),/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v81,/Gender/gen1,Top_to_Bottom,/Income/inc1",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "81",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "1",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "something about the local jobs and keeping costs down for the place I work",
        "sectionLOIr4": "8.18745",
        "sectionLOIr1": "8.18745",
        "sectionLOIr3": "6.76055",
        "sectionLOIr2": "0.496",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "9",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q15r5": "4",
        "Q15r6": "9",
        "Q15r7": "5",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1978",
        "Q3": "15",
        "Q2": "1",
        "Q5": "2",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "7f75946f-38af-45a3-8e65-9d936e4a5348",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "4",
        "date": "03/11/2026 10:32",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b5e3447dc7754d9dbf888a30eac5cf50&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7f75946f-38af-45a3-8e65-9d936e4a5348&isSynthetic=true&or_age=48&or_zip=47408&or_gender=m&or_householdincome=33000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "529.779",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "kucx8g9sgdzp7fvc",
        "Q41r1": "1",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "25",
        "Q14r5": "5",
        "Q14r4": "15",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "27z7z6qfjnh2bekn",
        "Q22_9c2": "2",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 10:25",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "60c96e011fd14c74ab636163209e5697",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "9",
        "record": "1477",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v138,/Region/reg2,/Ethnicity/eth2,/Education/edu1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Age/age3,/Vote/vote3,/Income/inc2",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "138",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "1",
        "Q22_4c2": "7",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "3",
        "Q24": "keeps my apartment warm without the bills piling up",
        "sectionLOIr4": "8.82705",
        "sectionLOIr1": "8.82705",
        "sectionLOIr3": "7.5388",
        "sectionLOIr2": "0.6015",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "100",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "25",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q15r5": "7",
        "Q15r6": "8",
        "Q15r7": "5",
        "Q15r1": "7",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "7",
        "Q15r9": "8",
        "Q1": "1983",
        "Q3": "36",
        "Q2": "2",
        "Q5": "2",
        "Q4": "3",
        "Q6": "2",
        "Q22_8c2": "8",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "423ff520-5754-4d4d-b834-6967a2e4e0a1",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "4",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "03/11/2026 10:34",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=60c96e011fd14c74ab636163209e5697&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=423ff520-5754-4d4d-b834-6967a2e4e0a1&isSynthetic=true&or_age=43&or_zip=44104&or_gender=f&or_householdincome=33000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "29",
        "vbrowser": "10",
        "qtime": "438.07",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "786ruh7tr4gf0b7d",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "30",
        "Q14r5": "5",
        "Q14r4": "15",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "1egrsggh70hyybnb",
        "Q22_9c2": "8",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "4",
        "Q43": "4",
        "start_date": "03/11/2026 10:28",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "42becd401f1c4ad9915dc8327c475c95",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "3",
        "record": "1478",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v62,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/Education/edu2,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc4",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "62",
        "Q36": "2",
        "Q35": "2",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "3",
        "Q22_6c2": "1",
        "Q22_4c2": "2",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "community safety, my partner's job makes me think about that",
        "sectionLOIr4": "7.29673333333",
        "sectionLOIr1": "7.29673333333",
        "sectionLOIr3": "5.893",
        "sectionLOIr2": "0.393",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "3",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "2",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "12.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "100",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "5",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "8",
        "Q15r9": "7",
        "Q1": "1996",
        "Q3": "37",
        "Q2": "1",
        "Q5": "3",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "1",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "6f51732c-d2c7-4d45-b3de-daa605d4859c",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "03/11/2026 10:35",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=42becd401f1c4ad9915dc8327c475c95&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6f51732c-d2c7-4d45-b3de-daa605d4859c&isSynthetic=true&or_age=30&or_zip=74960&or_gender=m&or_householdincome=134000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "61",
        "vbrowser": "10",
        "qtime": "535.49",
        "Q14r9": "15",
        "Q14r8": "0",
        "session": "32vgj1s4ppeth6z7",
        "Q41r1": "0",
        "Q14r1": "70",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "5s12t34yqqt5873m",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "3",
        "Q21r5": "2",
        "Q21r4": "4",
        "Q21r7": "6",
        "Q21r6": "5",
        "Q38": "4",
        "Q43": "3",
        "start_date": "03/11/2026 10:31",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "bfb4922a72cf4762a4564e20c7da1b8c",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "3",
        "record": "1479",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,sawterm:(dvfail.r1),/Education/edu1,20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,/de_maxdiff/Q22/v161,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,/Income/inc1",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "161",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "6",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q39r2": "4",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "just trying to keep the bill down each month",
        "sectionLOIr4": "8.92223333333",
        "sectionLOIr1": "8.92223333333",
        "sectionLOIr3": "7.44956666667",
        "sectionLOIr2": "0.665433333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "100",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "1",
        "Q22_2c2": "8",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "2",
        "Q15r5": "1",
        "Q15r6": "4",
        "Q15r7": "7",
        "Q15r1": "3",
        "Q15r2": "5",
        "Q15r3": "6",
        "Q15r8": "3",
        "Q15r9": "3",
        "Q1": "1964",
        "Q3": "11",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "2",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "0ee11fc9-3d50-4dea-92ec-c1291e66cc92",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "1",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "03/11/2026 10:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bfb4922a72cf4762a4564e20c7da1b8c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0ee11fc9-3d50-4dea-92ec-c1291e66cc92&isSynthetic=true&or_age=62&or_zip=30274&or_gender=f&or_householdincome=34200",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "26",
        "vbrowser": "10",
        "qtime": "470.67",
        "Q14r9": "18",
        "Q14r8": "5",
        "session": "yk6taufuea2mwuqc",
        "Q41r1": "0",
        "Q14r1": "27",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "14",
        "Q14r2": "23",
        "Q14r5": "0",
        "Q14r4": "9",
        "Q14r7": "4",
        "Q14r6": "0",
        "uuid": "q1tq65u4hn5qrwmg",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "3",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "4",
        "Q43": "3",
        "start_date": "03/11/2026 10:31",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "60f892cdeffd4d1884678001c1088744",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "record": "1480",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Vote/vote3,/Region/reg3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v240,Top_to_Bottom,/Gender/gen2,/Income/inc1,/Education/edu3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "3",
        "Q22_version": "240",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "4",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "12.5",
        "Q23": "2",
        "Q24": "not sure how it affects my budget but i know it's safer for the kids",
        "sectionLOIr4": "7.84181666667",
        "sectionLOIr1": "7.84181666667",
        "sectionLOIr3": "6.63428333333",
        "sectionLOIr2": "0.6404",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "2",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "9",
        "Q15r5": "5",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "5",
        "Q15r9": "8",
        "Q1": "1999",
        "Q3": "8",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "1",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "a82cb1de-07bb-40a7-9aa5-ae9355b59b7e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "03/11/2026 10:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=60f892cdeffd4d1884678001c1088744&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a82cb1de-07bb-40a7-9aa5-ae9355b59b7e&isSynthetic=true&or_age=26&or_zip=19945&or_gender=f&or_householdincome=26520",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "49",
        "vbrowser": "10",
        "qtime": "476.182",
        "Q14r9": "4",
        "Q14r8": "9",
        "session": "6y05y993dckhrbg5",
        "Q41r1": "0",
        "Q14r1": "26",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "13",
        "Q14r2": "22",
        "Q14r5": "9",
        "Q14r4": "13",
        "Q14r7": "4",
        "Q14r6": "0",
        "uuid": "xg76h82d5efrnagf",
        "Q22_9c2": "1",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "3",
        "start_date": "03/11/2026 10:32",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "bd564fc757ca4cd7beb50295b9ea223b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "4",
        "record": "1481",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg4,/de_maxdiff/Q22/v128,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc4,/Ethnicity/eth1,/Gender/gen2,/Education/edu4",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "128",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "5",
        "Q22_7c2": "8",
        "Q39r2": "2",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "3",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "it's about keeping costs down and not relying on foreign stuff, but my partner's job makes me think it's not the only way",
        "sectionLOIr4": "7.93326666667",
        "sectionLOIr1": "7.93326666667",
        "sectionLOIr3": "6.54978333333",
        "sectionLOIr2": "0.596633333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "25",
        "Q22_scorer4": "87.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "1",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "5",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "7",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "6",
        "Q1": "1976",
        "Q3": "13",
        "Q2": "2",
        "Q5": "5",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "8911bee5-0ddd-45c0-8e24-2e37733f2853",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "8",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "3",
        "Q8r4": "1",
        "Q8r6": "2",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "1",
        "date": "03/11/2026 10:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bd564fc757ca4cd7beb50295b9ea223b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8911bee5-0ddd-45c0-8e24-2e37733f2853&isSynthetic=true&or_age=50&or_zip=83702&or_gender=f&or_householdincome=97000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "578.425",
        "Q14r9": "15",
        "Q14r8": "5",
        "session": "egy8546vkkbyycdp",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "10",
        "Q14r5": "5",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "772r4yk033rawvtj",
        "Q22_9c2": "7",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "1",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "2",
        "Q21r6": "7",
        "Q38": "2",
        "Q43": "2",
        "start_date": "03/11/2026 10:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "4ceabbcc99ee47888eb616b02a2dd8a4",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "1",
        "record": "1482",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/de_maxdiff/Q22/v132,/Overall/qual,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc3,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Education/edu1",
        "Q33": "1",
        "Q32": "3",
        "Q31": "2",
        "Q22_version": "132",
        "Q37": "2",
        "Q35": "4",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "1",
        "Q22_6c2": "6",
        "Q22_4c2": "7",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "0",
        "Q23": "2",
        "Q24": "depends on the job it creates",
        "sectionLOIr4": "9.63775",
        "sectionLOIr1": "9.63775",
        "sectionLOIr3": "8.6353",
        "sectionLOIr2": "0.932016666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "4",
        "Q10": "2",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "100",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q15r5": "6",
        "Q15r6": "9",
        "Q15r7": "5",
        "Q15r1": "6",
        "Q15r2": "8",
        "Q15r3": "7",
        "Q15r8": "6",
        "Q15r9": "7",
        "Q1": "2002",
        "Q3": "11",
        "Q2": "2",
        "Q5": "2",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "3a85f825-68ab-4ba4-b244-2f22b87572f5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "8",
        "Q8r5": "4",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "1",
        "Q8r2": "3",
        "date": "03/11/2026 10:43",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4ceabbcc99ee47888eb616b02a2dd8a4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3a85f825-68ab-4ba4-b244-2f22b87572f5&isSynthetic=true&or_age=24&or_zip=30311&or_gender=f&or_householdincome=66913",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "494.777",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "f6hev0bnej5dgh2c",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "60",
        "Q14r2": "0",
        "Q14r5": "15",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "25",
        "uuid": "xtwjbu3yf8xvc2y9",
        "Q22_9c2": "3",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q22_version": "54",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "1",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "6",
        "Q21r2": "3",
        "Q21r5": "7",
        "Q21r4": "4",
        "Q21r7": "5",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 14:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e4b276ff68a14fcdaddc897b74f49dc4",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "Q15r5": "2",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v54,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "3",
        "Q9r3": "3",
        "Q36": "5",
        "Q35": "2",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "5",
        "Q22_4c2": "8",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "37.5",
        "Q23": "1",
        "Q24": "talks a big game about the environment but mostly sounds like just another way to raise taxes on regular folks like me",
        "sectionLOIr4": "8.24225",
        "sectionLOIr1": "8.24225",
        "sectionLOIr3": "7.15023333333",
        "sectionLOIr2": "0.362383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "87.5",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "record": "1519",
        "Q22_scorer9": "25",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "4",
        "Q9r1": "2",
        "Q15r6": "2",
        "Q15r7": "2",
        "Q9r4": "2",
        "Q15r1": "2",
        "Q15r2": "2",
        "Q15r3": "2",
        "Q15r8": "2",
        "Q15r9": "2",
        "Q1": "1957",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "5",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "6eb4acad-41fc-4a26-8723-37bd8602aecb",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "7",
        "Q22_3c2": "9",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "04/06/2026 14:48",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e4b276ff68a14fcdaddc897b74f49dc4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=6eb4acad-41fc-4a26-8723-37bd8602aecb&isSynthetic=true&or_zip=33030&or_householdincome=65000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "83",
        "vbrowser": "10",
        "qtime": "414.868",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "446v9fehmcjvebu3",
        "Q41r1": "0",
        "Q14r1": "14",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "60",
        "Q14r2": "1",
        "Q14r5": "20",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "qmzu7c0d49a6pbvf",
        "Q22_9c2": "5",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "1",
        "Q21r2": "3",
        "Q21r5": "7",
        "Q21r4": "6",
        "Q21r7": "4",
        "Q21r6": "5",
        "Q38": "4",
        "Q43": "1",
        "start_date": "04/06/2026 14:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "8a98a6b883b04555a47ce3bff0f11060",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "record": "1520",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote1,/Region/reg1,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v57,Top_to_Bottom,/Gender/gen2,/Income/inc1",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q22_version": "57",
        "Q36": "4",
        "Q35": "2",
        "Q22_7c1": "9",
        "Q39r4": "5",
        "Q22_7c2": "4",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "9",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "4",
        "Q24": "sounds like a fancy word for politicians to raise my rates",
        "sectionLOIr4": "6.90963333333",
        "sectionLOIr1": "6.90963333333",
        "sectionLOIr3": "5.87958333333",
        "sectionLOIr2": "0.32555",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "5",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "5",
        "Q15r5": "3",
        "Q15r6": "7",
        "Q15r7": "6",
        "Q15r1": "6",
        "Q15r2": "3",
        "Q15r3": "4",
        "Q15r8": "5",
        "Q15r9": "4",
        "Q1": "1942",
        "Q3": "33",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "7",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "e390fcd6-ea46-4faa-8f69-422ee390386c",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "2",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "04/06/2026 14:47",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=8a98a6b883b04555a47ce3bff0f11060&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e390fcd6-ea46-4faa-8f69-422ee390386c&isSynthetic=true&or_zip=14623&or_householdincome=12108",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1983",
        "vctq1c22": "0",
        "HIDAge": "42",
        "Q2": "1",
        "Q4": "1",
        "vctq1c24": "1",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "14.921",
        "Q3": "23",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "bf3jp4fquy0naf8x",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "b9580f2e8c78430d93c26f7ced0264c7",
        "vlist": "2",
        "uuid": "e3adjhkfjt5d5vyx",
        "vmobiledevice": "5",
        "s2": "4d38785c-a011-4b46-aaec-12195b82ce57",
        "vctq1c25": "0",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,OQ,bad:/Overall/qual,bad:/Region/reg2",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 14:40",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "3",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "2",
        "date": "04/06/2026 14:40",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b9580f2e8c78430d93c26f7ced0264c7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4d38785c-a011-4b46-aaec-12195b82ce57&isSynthetic=true&or_zip=49404&or_householdincome=163500",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1521",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "83",
        "vbrowser": "10",
        "qtime": "504.116",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "zdd9u9b77sx0qv0g",
        "Q41r1": "0",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "45",
        "Q14r2": "20",
        "Q14r5": "10",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "n21sd0bm5gdc1j7x",
        "Q22_9c2": "6",
        "Q22_9c1": "9",
        "Q34r4": "1",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "7",
        "Q21r2": "4",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "04/06/2026 14:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "bc41126d0c914326847478c7f16570a7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "2",
        "record": "1522",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v92,Top_to_Bottom,/Gender/gen2,/Income/inc1",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "92",
        "Q35": "3",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q39r2": "3",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "8",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "3",
        "Q24": "saves the grocery bill, keeps us warm without raising taxes",
        "sectionLOIr4": "8.39548333333",
        "sectionLOIr1": "8.39548333333",
        "sectionLOIr3": "7.43688333333",
        "sectionLOIr2": "0.34985",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "3",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "3",
        "Q15r5": "3",
        "Q15r6": "1",
        "Q15r7": "4",
        "Q15r1": "7",
        "Q15r2": "1",
        "Q15r3": "7",
        "Q15r8": "3",
        "Q15r9": "3",
        "Q1": "1942",
        "Q3": "33",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "9",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "4f95c913-7629-45aa-9d58-b1c3e3a8111d",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "04/06/2026 14:48",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=bc41126d0c914326847478c7f16570a7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4f95c913-7629-45aa-9d58-b1c3e3a8111d&isSynthetic=true&or_zip=14623&or_householdincome=12108",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "525.525",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "y46ua9xqj1rvaasc",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "45",
        "Q14r2": "10",
        "Q14r5": "30",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "nyc430yp3rpnquyf",
        "Q22_9c2": "6",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "1",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "6",
        "Q21r6": "7",
        "Q38": "3",
        "Q43": "4",
        "start_date": "04/06/2026 14:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "ba5e3807bf3643339c80b1de054dcc13",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "4",
        "record": "1523",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,/de_maxdiff/Q22/v258,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "258",
        "Q37": "4",
        "Q35": "4",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "62.5",
        "Q23": "3",
        "Q24": "focuses on safety for my kid's lungs",
        "sectionLOIr4": "8.75431666667",
        "sectionLOIr1": "8.75431666667",
        "sectionLOIr3": "7.78676666667",
        "sectionLOIr2": "0.3226",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "1",
        "Q22_scorer5": "0",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "2",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "8",
        "Q15r5": "6",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q15r1": "9",
        "Q15r2": "9",
        "Q15r3": "8",
        "Q15r8": "7",
        "Q15r9": "4",
        "Q1": "2003",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "ae121f4e-1c26-45fd-b12c-81d853af5e64",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "1",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "2",
        "Q22_3c2": "5",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "2",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 14:49",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ba5e3807bf3643339c80b1de054dcc13&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ae121f4e-1c26-45fd-b12c-81d853af5e64&isSynthetic=true&or_zip=79015&or_householdincome=30874",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "486.622",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "wyajk61qet0zc908",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "40",
        "Q14r2": "15",
        "Q14r5": "25",
        "Q14r4": "10",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "23ft5qdddj7jqk3z",
        "Q22_9c2": "3",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q22_version": "236",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "6",
        "Q21r2": "1",
        "Q21r5": "7",
        "Q21r4": "5",
        "Q21r7": "3",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "3",
        "Q39r2": "4",
        "start_date": "04/06/2026 14:40",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "08903efbe7064286889b3a3676a6b5ba",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "6",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/de_maxdiff/Q22/v236,/Vote/vote3,/Region/reg4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Ethnicity/eth1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "2",
        "Q35": "6",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "2",
        "Q9r6": "3",
        "Q22_6c1": "7",
        "Q22_6c2": "2",
        "Q22_4c2": "8",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "1",
        "Q24": "when the Dems push solar, it's just a way to force their tech on us",
        "sectionLOIr4": "8.10595",
        "sectionLOIr1": "8.10595",
        "sectionLOIr3": "7.1801",
        "sectionLOIr2": "0.248816666667",
        "vctq1c21": "1",
        "Q35r6oe": "I'm a mixed-race individual living in Oregon, so political identity feels like it doesn't fit into the standard binary or even the moderate categories like 'Independent' or 'Moderate.' I'm just a pragmatist with my own gut instincts.",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "87.5",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "record": "1524",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "4",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "1",
        "Q15r6": "1",
        "Q15r7": "10",
        "Q9r4": "3",
        "Q15r1": "6",
        "Q15r2": "1",
        "Q15r3": "1",
        "Q15r8": "2",
        "Q15r9": "6",
        "Q1": "1972",
        "Q3": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "8d544d0d-5bdc-4533-9150-42cbea8a731e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "6",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "2",
        "Q8r3": "1",
        "Q8r2": "3",
        "date": "04/06/2026 14:49",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=08903efbe7064286889b3a3676a6b5ba&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=8d544d0d-5bdc-4533-9150-42cbea8a731e&isSynthetic=true&or_zip=97305&or_householdincome=62000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "521.895",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "a60762ugzq7j50wm",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "25",
        "Q14r2": "0",
        "Q14r5": "60",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "f2ua0rx9qafg405z",
        "Q22_9c2": "3",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q22_version": "187",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "3",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "7",
        "Q21r4": "1",
        "Q21r7": "5",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 14:41",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "593500f6a33843df9821ce32e607a974",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "2",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),/de_maxdiff/Q22/v187,20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc5,/Gender/gen2,/Education/edu3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "1",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "7",
        "Q22_6c2": "3",
        "Q22_4c2": "4",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "75",
        "Q23": "3",
        "Q24": "good for the job, less foreign reliance",
        "sectionLOIr4": "8.69233333333",
        "sectionLOIr1": "8.69233333333",
        "sectionLOIr3": "7.84151666667",
        "sectionLOIr2": "0.361133333333",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "100",
        "HIDAge2": "5",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "record": "1525",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "8",
        "Q22_2c2": "3",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "2",
        "Q9r1": "1",
        "Q15r6": "3",
        "Q15r7": "3",
        "Q9r4": "2",
        "Q15r1": "2",
        "Q15r2": "2",
        "Q15r3": "2",
        "Q15r8": "2",
        "Q15r9": "6",
        "Q1": "1970",
        "Q3": "10",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "5",
        "Q22_8c2": "6",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "d0f95aad-90e2-404d-bbf9-259cd568a2ca",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "9",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "04/06/2026 14:50",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=593500f6a33843df9821ce32e607a974&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d0f95aad-90e2-404d-bbf9-259cd568a2ca&isSynthetic=true&or_zip=33462&or_householdincome=85000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "412.968",
        "Q41r2": "0",
        "Q14r9": "2",
        "Q14r8": "0",
        "session": "0xxc2btbnda5res7",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "60",
        "Q14r2": "0",
        "Q14r5": "10",
        "Q14r4": "3",
        "Q14r7": "0",
        "Q14r6": "25",
        "uuid": "a24fp60ny24cvbmw",
        "Q22_9c2": "4",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q22_version": "149",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 14:47",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "6dcc0bfc7ab54a6cbeca64d997fec810",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "6",
        "Q22_1c1": "7",
        "Q15r5": "3",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "4",
        "markers": "qualified,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v149,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "3",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "8",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "4",
        "Q9r6": "4",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "4",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "37.5",
        "Q23": "1",
        "Q24": "just another label Democrats use to push their agenda while costs go up",
        "sectionLOIr4": "6.8779",
        "sectionLOIr1": "6.8779",
        "sectionLOIr3": "5.85425",
        "sectionLOIr2": "0.300666666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "4",
        "Q12": "3",
        "Q22_scorer7": "87.5",
        "HIDAge2": "6",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "12.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "record": "1526",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "5",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "3",
        "Q9r1": "2",
        "Q15r6": "1",
        "Q15r7": "4",
        "Q9r4": "4",
        "Q15r1": "2",
        "Q15r2": "1",
        "Q15r3": "2",
        "Q15r8": "4",
        "Q15r9": "4",
        "Q1": "1957",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "fc889179-f720-4158-92a1-1e35f7413a4a",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "7",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 14:54",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=6dcc0bfc7ab54a6cbeca64d997fec810&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=fc889179-f720-4158-92a1-1e35f7413a4a&isSynthetic=true&or_zip=33030&or_householdincome=65000",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1987",
        "vctq1c22": "0",
        "HIDAge": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "vctq1c24": "1",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "17.757",
        "Q3": "40",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "yamsuserbajswppt",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "f8c87eea1c04458dbf00196bc13f9bc9",
        "vlist": "2",
        "uuid": "heyvmrn2y7p6ky58",
        "vmobiledevice": "5",
        "s2": "bfc47837-6371-4251-96d0-216a31c53015",
        "vctq1c25": "0",
        "markers": "bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,OQ /Income/inc5,20260109_07:39_v14,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,Top_to_Bottom,bad:/Region/reg1,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 14:49",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "1",
        "date": "04/06/2026 14:49",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=f8c87eea1c04458dbf00196bc13f9bc9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=bfc47837-6371-4251-96d0-216a31c53015&isSynthetic=true&or_zip=02879&or_householdincome=145000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1527",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "442.064",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "pfp3cznxhjaz0xzv",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "60",
        "Q14r2": "0",
        "Q14r5": "25",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "dze10swbf3wg5arm",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "4",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "2",
        "Q21r6": "5",
        "Q38": "4",
        "Q43": "4",
        "start_date": "04/06/2026 14:49",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "dcb3e76c951349e99a38d777095ad308",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "2",
        "Q22_1c1": "4",
        "record": "1528",
        "Q41r7": "1",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg3,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v264,Top_to_Bottom,/Gender/gen2,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "264",
        "Q35": "3",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "9",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "it's mostly about cheap power that keeps the lights on at work",
        "sectionLOIr4": "7.36291666667",
        "sectionLOIr1": "7.36291666667",
        "sectionLOIr3": "6.43188333333",
        "sectionLOIr2": "0.336233333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "3",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "7",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "3",
        "Q15r5": "2",
        "Q15r6": "6",
        "Q15r7": "1",
        "Q15r1": "6",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "1",
        "Q15r9": "5",
        "Q1": "1986",
        "Q3": "34",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "2",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "15",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "dde2d6ce-66a2-4f23-b3b0-8b06bc142434",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "04/06/2026 14:56",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=dcb3e76c951349e99a38d777095ad308&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=dde2d6ce-66a2-4f23-b3b0-8b06bc142434&isSynthetic=true&or_zip=28345&or_householdincome=53600",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "454.039",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "t0q6jyy5m2v79mw9",
        "Q41r1": "0",
        "Q14r1": "25",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "15",
        "Q14r2": "30",
        "Q14r5": "15",
        "Q14r4": "10",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "kt60n38pr56hwezv",
        "Q22_9c2": "1",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q22_version": "101",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "9",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "3",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "3",
        "Q39r2": "4",
        "start_date": "04/06/2026 14:49",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "1",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2ca9fe7203204a4386dc9a14a91e8db4",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "4",
        "Q15r5": "10",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q9r2": "3",
        "markers": "qualified,/de_maxdiff/Q22/v101,/Vote/vote3,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "3",
        "Q22_7c2": "8",
        "Q30": "1",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "4",
        "Q22_4c1": "3",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "More like fixing the Subaru engine than some big sci-fi project, honestly",
        "sectionLOIr4": "7.55615",
        "sectionLOIr1": "7.55615",
        "sectionLOIr3": "6.60863333333",
        "sectionLOIr2": "0.29395",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "1529",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "62.5",
        "dvflagr2": "0",
        "dvflagr3": "1",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "10",
        "Q9r1": "2",
        "Q15r6": "10",
        "Q15r7": "10",
        "Q9r4": "2",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "2002",
        "Q3": "8",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "6",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "5",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3ad027e7-4ccf-4153-bac3-df513ceac528",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 14:57",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2ca9fe7203204a4386dc9a14a91e8db4&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3ad027e7-4ccf-4153-bac3-df513ceac528&isSynthetic=true&or_zip=19963&or_householdincome=38282",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1987",
        "vctq1c22": "0",
        "HIDAge": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "vctq1c24": "1",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "18.362",
        "Q3": "40",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "5jhcyczf9j66vb1j",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "451fbb6cc3de48e38d9cae50bed4aede",
        "vlist": "2",
        "uuid": "ftf067uwqzc2gu7x",
        "vmobiledevice": "5",
        "s2": "86f5d357-0082-4afa-85b3-60532c1cbaba",
        "vctq1c25": "0",
        "markers": "bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,OQ /Income/inc5,20260109_07:39_v14,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,Top_to_Bottom,bad:/Region/reg1,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 14:49",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "1",
        "date": "04/06/2026 14:50",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=451fbb6cc3de48e38d9cae50bed4aede&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=86f5d357-0082-4afa-85b3-60532c1cbaba&isSynthetic=true&or_zip=02879&or_householdincome=145000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1530",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "420.419",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "ru7kdxknsg9xbkx8",
        "Q41r1": "0",
        "Q14r1": "33",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "22",
        "Q14r2": "17",
        "Q14r5": "11",
        "Q14r4": "17",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "5ygh9h9xuhtttmug",
        "Q22_9c2": "3",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q22_version": "114",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "7",
        "Q21r2": "1",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "5",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "1",
        "Q39r2": "3",
        "start_date": "04/06/2026 14:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "cc38dd69dd7f4bea80908ec937a3ca5e",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Vote/vote1,/Region/reg3,/Ethnicity/eth1,/de_maxdiff/Q22/v114,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "3",
        "Q22_7c2": "3",
        "Q30": "3",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "1",
        "Q22_6c2": "7",
        "Q22_4c2": "7",
        "Q22_4c1": "2",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "37.5",
        "Q23": "3",
        "Q24": "feels like it supports our town by paying local taxes",
        "sectionLOIr4": "7.00265",
        "sectionLOIr1": "7.00265",
        "sectionLOIr3": "6.12611666667",
        "sectionLOIr2": "0.302433333333",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "0",
        "HIDAge2": "1",
        "Q22_scorer5": "50",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "record": "1531",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "8",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "2",
        "Q9r1": "2",
        "Q15r6": "6",
        "Q15r7": "6",
        "Q9r4": "4",
        "Q15r1": "8",
        "Q15r2": "7",
        "Q15r3": "4",
        "Q15r8": "3",
        "Q15r9": "5",
        "Q1": "2002",
        "Q3": "8",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "aeaecce2-9012-46f5-823e-8c3c46a86d58",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "4",
        "date": "04/06/2026 14:57",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=cc38dd69dd7f4bea80908ec937a3ca5e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=aeaecce2-9012-46f5-823e-8c3c46a86d58&isSynthetic=true&or_zip=19963&or_householdincome=38282",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1987",
        "vctq1c22": "0",
        "HIDAge": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "vctq1c24": "1",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "18.765",
        "Q3": "40",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "t1rfdjkdvtcvp111",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "5f0a6bd460f54801bd7edebf15c81f7b",
        "vlist": "2",
        "uuid": "3nhx199rkcnamd29",
        "vmobiledevice": "5",
        "s2": "92e13e69-0f38-41ff-b936-415e3bf2e379",
        "vctq1c25": "0",
        "markers": "bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,OQ /Income/inc5,20260109_07:39_v14,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,Top_to_Bottom,bad:/Region/reg1,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 14:50",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "1",
        "date": "04/06/2026 14:50",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5f0a6bd460f54801bd7edebf15c81f7b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=92e13e69-0f38-41ff-b936-415e3bf2e379&isSynthetic=true&or_zip=02879&or_householdincome=145000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1532",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "60",
        "vbrowser": "10",
        "qtime": "510.2",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "zcq2yk50xpw2nnqg",
        "Q41r1": "1",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "35",
        "Q14r2": "0",
        "Q14r5": "45",
        "Q14r4": "15",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "bcqd7gswszgg0nub",
        "Q22_9c2": "4",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q22_version": "87",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "2",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "7",
        "Q21r2": "4",
        "Q21r5": "3",
        "Q21r4": "5",
        "Q21r7": "6",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "3",
        "Q39r2": "3",
        "start_date": "04/06/2026 14:50",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "dfb3ff6d7dcd49e18e3f305693307d8e",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "2",
        "Q15r5": "4",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q9r2": "4",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/Ethnicity/eth1,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v87,sawterm:Q1.ival gt 2007,/Income/inc4,/Gender/gen2,sawterm:(dvfail.r1)",
        "Q33": "1",
        "Q32": "3",
        "Q31": "3",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "2",
        "Q9r6": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "3",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "associated with both parties equally",
        "sectionLOIr4": "8.46998333333",
        "sectionLOIr1": "8.46998333333",
        "sectionLOIr3": "7.45566666667",
        "sectionLOIr2": "0.279733333333",
        "vctq1c21": "1",
        "Q17": "1",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "75",
        "HIDAge2": "5",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "37.5",
        "record": "1533",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "5",
        "Q22_2c2": "3",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "2",
        "Q9r1": "2",
        "Q15r6": "4",
        "Q15r7": "6",
        "Q9r4": "3",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "4",
        "Q15r8": "3",
        "Q15r9": "4",
        "Q1": "1965",
        "Q3": "33",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "4",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "345801b2-6cc4-4c6e-9053-9a7c3e307c7f",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "5",
        "Q22_3c2": "3",
        "Q8r5": "1",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "04/06/2026 14:59",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=dfb3ff6d7dcd49e18e3f305693307d8e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=345801b2-6cc4-4c6e-9053-9a7c3e307c7f&isSynthetic=true&or_zip=10994&or_householdincome=99265",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "516.518",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "r4ua2u4kugz8kapz",
        "Q41r1": "0",
        "Q14r1": "35",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "22",
        "Q14r2": "12",
        "Q14r5": "18",
        "Q14r4": "8",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "kfdb7fffg6n1mwt5",
        "Q22_9c2": "5",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "3",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "3",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "1",
        "Q21r7": "4",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "2",
        "start_date": "04/06/2026 14:51",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "fa6d4a7a9af04020937cf092e3c878b0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "5",
        "record": "1534",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "1",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/Vote/vote2,sawterm:Q1.ival gt 2007,/Income/inc6,Top_to_Bottom,/Gender/gen2,/Education/edu3,/de_maxdiff/Q22/v45",
        "Q33": "2",
        "Q32": "2",
        "Q31": "1",
        "Q22_version": "45",
        "Q35": "3",
        "Q22_7c1": "8",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q39r2": "4",
        "Q39r3": "2",
        "Q39r1": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "8",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "87.5",
        "Q23": "1",
        "Q24": "feels like putting money back in our own pockets instead of sending it overseas",
        "sectionLOIr4": "8.60505",
        "sectionLOIr1": "8.60505",
        "sectionLOIr3": "7.4819",
        "sectionLOIr2": "0.371583333333",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "2",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "7",
        "Q15r5": "9",
        "Q15r6": "9",
        "Q15r7": "10",
        "Q15r1": "8",
        "Q15r2": "8",
        "Q15r3": "9",
        "Q15r8": "10",
        "Q15r9": "8",
        "Q1": "1972",
        "Q3": "11",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "3",
        "Q22_8c1": "8",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "0a06e862-fd50-43f9-8c02-c66b3430e672",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "1",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "9",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:00",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=fa6d4a7a9af04020937cf092e3c878b0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0a06e862-fd50-43f9-8c02-c66b3430e672&isSynthetic=true&or_zip=30215&or_householdincome=209180",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "60",
        "vbrowser": "10",
        "qtime": "503.097",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "jbysszjmhker6hz7",
        "Q41r1": "1",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "30",
        "Q14r2": "5",
        "Q14r5": "45",
        "Q14r4": "15",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "s8j7d25zsbwwr5dr",
        "Q22_9c2": "5",
        "Q22_9c1": "4",
        "Q34r4": "1",
        "Q22_version": "284",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "7",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "5",
        "Q21r7": "4",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 14:55",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "2",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "dd4aaa2fee234847ba6a50446bb53995",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "2",
        "Q15r5": "0",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg1,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,/Education/edu1,20260109_07:39_v14,/Age/age5,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v284,/Income/inc4,/Gender/gen2,sawterm:(dvfail.r1)",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "1",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "3",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "1",
        "Q9r6": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "6",
        "Q22_4c2": "5",
        "Q22_4c1": "8",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "5",
        "Q24": "I mean energy that actually keeps the lights on without blackouts, like keeping my clinic running",
        "sectionLOIr4": "8.38018333333",
        "sectionLOIr1": "8.38018333333",
        "sectionLOIr3": "7.24343333333",
        "sectionLOIr2": "0.32165",
        "vctq1c21": "1",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "4",
        "Q12": "3",
        "Q22_scorer7": "50",
        "HIDAge2": "5",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "record": "1535",
        "Q22_scorer9": "75",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "5",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "2",
        "Q9r1": "2",
        "Q15r6": "5",
        "Q15r7": "1",
        "Q9r4": "2",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "4",
        "Q15r8": "5",
        "Q15r9": "4",
        "Q1": "1965",
        "Q3": "33",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "Q6": "4",
        "Q22_8c2": "4",
        "Q22_8c1": "9",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "4e360532-9499-49f5-abe8-457ca532be81",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "9",
        "Q22_3c2": "8",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:03",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=dd4aaa2fee234847ba6a50446bb53995&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4e360532-9499-49f5-abe8-457ca532be81&isSynthetic=true&or_zip=10994&or_householdincome=99265",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "424.525",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "1c7mkupdak9x9nkq",
        "Q41r1": "1",
        "Q14r1": "19",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "50",
        "Q14r2": "19",
        "Q14r5": "12",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "8cn2xv97kn4tm6gh",
        "Q22_9c2": "9",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q22_version": "38",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "1",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "1",
        "Q21r2": "6",
        "Q21r5": "3",
        "Q21r4": "2",
        "Q21r7": "5",
        "Q21r6": "7",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 14:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "1cdd7d971cc2448384f8b70ba0baa97e",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "2",
        "Q22_1c1": "4",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v38,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "3",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "3",
        "Q22_7c2": "7",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "5",
        "Q9r6": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "4",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "it just feels like a new way to say the same old thing, keeping the lights on without everyone fighting over who owns the power lines",
        "sectionLOIr4": "7.06366666667",
        "sectionLOIr1": "7.06366666667",
        "sectionLOIr3": "5.93666666667",
        "sectionLOIr2": "0.304483333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "0",
        "HIDAge2": "1",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "record": "1536",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "87.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "6",
        "Q9r1": "2",
        "Q15r6": "2",
        "Q15r7": "6",
        "Q9r4": "4",
        "Q15r1": "2",
        "Q15r2": "3",
        "Q15r3": "1",
        "Q15r8": "3",
        "Q15r9": "5",
        "Q1": "2003",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "5",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "9cf4c2da-7999-4cb9-b335-854f29a64aa3",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "3",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "2",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "04/06/2026 15:04",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=1cdd7d971cc2448384f8b70ba0baa97e&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9cf4c2da-7999-4cb9-b335-854f29a64aa3&isSynthetic=true&or_zip=79015&or_householdincome=30874",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "521.869",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "sqpf2z5nn2k6twfb",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "35",
        "Q14r2": "0",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "25",
        "uuid": "gq4yjgx8jtt9jasw",
        "Q22_9c2": "3",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q22_version": "112",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "7",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 14:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "5",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "654254feb7904094a8ed7ac62554f859",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "2",
        "Q15r5": "8",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "1",
        "markers": "qualified,/de_maxdiff/Q22/v112,/Region/reg3,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "4",
        "Q9r6": "5",
        "Q22_6c1": "2",
        "Q22_6c2": "4",
        "Q22_4c2": "3",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "4",
        "Q24": "sounds like some green initiative maybe",
        "sectionLOIr4": "8.693",
        "sectionLOIr1": "8.693",
        "sectionLOIr3": "7.62106666667",
        "sectionLOIr2": "0.305416666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "62.5",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "75",
        "record": "1537",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "7",
        "Q9r1": "2",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q9r4": "2",
        "Q15r1": "0",
        "Q15r2": "1",
        "Q15r3": "2",
        "Q15r8": "3",
        "Q15r9": "5",
        "Q1": "1986",
        "Q3": "34",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "40",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "5cb22197-cb58-46b7-808f-cbf6cbabfdbb",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "5",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "6",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "04/06/2026 15:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=654254feb7904094a8ed7ac62554f859&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5cb22197-cb58-46b7-808f-cbf6cbabfdbb&isSynthetic=true&or_zip=28345&or_householdincome=53600",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "482.628",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "06vfhgq6gzzgw13m",
        "Q41r1": "1",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "60",
        "Q14r2": "15",
        "Q14r5": "0",
        "Q14r4": "1",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "xvz6n9ca6tj8wf0z",
        "Q22_9c2": "5",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q22_version": "86",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "2",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 14:57",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "e869dd151e9947d59cfc1df0bb122afb",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "6",
        "Q22_1c1": "3",
        "Q15r5": "5",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v86,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "2",
        "Q9r3": "3",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "4",
        "Q9r6": "4",
        "Q22_6c1": "8",
        "Q22_6c2": "1",
        "Q22_4c2": "7",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "62.5",
        "Q23": "1",
        "Q24": "reminds me of the drilling noise outside last summer when I thought they were going to blow that well",
        "sectionLOIr4": "8.04025",
        "sectionLOIr1": "8.04025",
        "sectionLOIr3": "7.02683333333",
        "sectionLOIr2": "0.296616666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "record": "1538",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "7",
        "Q22_2c2": "6",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "7",
        "Q9r1": "2",
        "Q15r6": "3",
        "Q15r7": "3",
        "Q9r4": "3",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "3",
        "Q15r8": "3",
        "Q15r9": "5",
        "Q1": "1957",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "f24205ec-d245-42a6-b613-bac7ffdf41fb",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:06",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=e869dd151e9947d59cfc1df0bb122afb&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f24205ec-d245-42a6-b613-bac7ffdf41fb&isSynthetic=true&or_zip=33030&or_householdincome=65000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1987",
        "vctq1c22": "0",
        "HIDAge": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "vctq1c24": "1",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "19.759",
        "Q3": "40",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "us3nncmv6qydkw5z",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "c2a8c571cb0240aebf6e08cad810c2d7",
        "vlist": "2",
        "uuid": "uax7edxz5ng799js",
        "vmobiledevice": "5",
        "s2": "38d3d349-92f6-4f19-b813-702290be9d6e",
        "vctq1c25": "0",
        "markers": "bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,OQ /Income/inc5,20260109_07:39_v14,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,Top_to_Bottom,bad:/Region/reg1,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 14:59",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "1",
        "date": "04/06/2026 15:00",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c2a8c571cb0240aebf6e08cad810c2d7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=38d3d349-92f6-4f19-b813-702290be9d6e&isSynthetic=true&or_zip=02879&or_householdincome=145000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1539",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "493.416",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "sq8knvfap5qsyvwz",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "65",
        "Q14r2": "10",
        "Q14r5": "15",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "2fr24mrtc7f5vzq2",
        "Q22_9c2": "9",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q22_version": "263",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "8",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "1",
        "Q21r2": "4",
        "Q21r5": "2",
        "Q21r4": "5",
        "Q21r7": "3",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "3",
        "Q39r2": "4",
        "start_date": "04/06/2026 15:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "4e911b9e302c4834816b864f91a17db5",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "5",
        "Q15r5": "7",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg2,Bottom_to_Top,/Vote/vote3,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Income/inc6,/Age/age3,/de_maxdiff/Q22/v263",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "2",
        "Q36": "4",
        "Q35": "1",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q30": "4",
        "Q39r3": "4",
        "Q9r5": "2",
        "Q9r6": "3",
        "Q22_6c1": "7",
        "Q22_6c2": "3",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "62.5",
        "Q23": "1",
        "Q24": "it's just a label Democrats use to shut down smart engineering",
        "sectionLOIr4": "8.21953333333",
        "sectionLOIr1": "8.21953333333",
        "sectionLOIr3": "7.23695",
        "sectionLOIr2": "0.299966666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "50",
        "HIDAge2": "3",
        "Q22_scorer5": "50",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "record": "1540",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "7",
        "Q9r1": "1",
        "Q15r6": "2",
        "Q15r7": "3",
        "Q9r4": "2",
        "Q15r1": "4",
        "Q15r2": "2",
        "Q15r3": "4",
        "Q15r8": "3",
        "Q15r9": "4",
        "Q1": "1983",
        "Q3": "23",
        "Q2": "1",
        "Q5": "3",
        "Q4": "4",
        "Q6": "6",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "a3959fdd-86f1-4c6d-bc31-57a852de6c8e",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "1",
        "Q22_3c2": "3",
        "Q8r5": "1",
        "Q8r4": "2",
        "Q8r6": "1",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:09",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=4e911b9e302c4834816b864f91a17db5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a3959fdd-86f1-4c6d-bc31-57a852de6c8e&isSynthetic=true&or_zip=49404&or_householdincome=163500",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "83",
        "vbrowser": "10",
        "qtime": "612.232",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "ep8br2arbeacbdjx",
        "Q41r1": "0",
        "Q14r1": "30",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "35",
        "Q14r2": "5",
        "Q14r5": "20",
        "Q14r4": "10",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "5m5b8qpfgy35fu58",
        "Q22_9c2": "3",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q22_version": "144",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "5",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "3",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "3",
        "Q39r2": "4",
        "start_date": "04/06/2026 15:00",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "80eb0b84f37e42578bb48c50b6662f71",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "4",
        "Q15r5": "3",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/Ethnicity/eth1,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v144,Top_to_Bottom,/Gender/gen2,/Income/inc1",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "3",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "2",
        "Q9r6": "4",
        "Q22_6c1": "4",
        "Q22_6c2": "9",
        "Q22_4c2": "8",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "37.5",
        "Q23": "1",
        "Q24": "it's just political theatre, makes me want to order a takeout dinner instead of cooking",
        "sectionLOIr4": "10.1996666667",
        "sectionLOIr1": "10.1996666667",
        "sectionLOIr3": "9.10443333333",
        "sectionLOIr2": "0.293433333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "3",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "100",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "record": "1541",
        "Q22_scorer9": "0",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "7",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "5",
        "Q9r1": "2",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q9r4": "3",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "6",
        "Q15r8": "3",
        "Q15r9": "3",
        "Q1": "1942",
        "Q3": "33",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "4f71b4c3-42a1-44fe-960a-4ef2e23970f5",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "4",
        "Q22_3c2": "7",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:11",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=80eb0b84f37e42578bb48c50b6662f71&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=4f71b4c3-42a1-44fe-960a-4ef2e23970f5&isSynthetic=true&or_zip=14623&or_householdincome=12108",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "474.363",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "ugmw1gdhnx3ykh6u",
        "Q41r1": "0",
        "Q14r1": "24",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "58",
        "Q14r2": "18",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "zsf81dkujz290erv",
        "Q22_9c2": "6",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q22_version": "217",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "5",
        "Q21r4": "4",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "5",
        "start_date": "04/06/2026 15:04",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b438a13c376b48679235d1d073834f94",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "3",
        "Q22_1c1": "2",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,/de_maxdiff/Q22/v217,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "4",
        "Q9r6": "3",
        "Q22_6c1": "7",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "1",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "5",
        "Q24": "It feels like a flex to be independent from foreign countries and keep our economy strong",
        "sectionLOIr4": "7.902",
        "sectionLOIr1": "7.902",
        "sectionLOIr3": "6.8902",
        "sectionLOIr2": "0.314366666667",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "87.5",
        "HIDAge2": "1",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "record": "1542",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "1",
        "Q9r1": "3",
        "Q15r6": "2",
        "Q15r7": "5",
        "Q9r4": "4",
        "Q15r1": "3",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "3",
        "Q15r9": "3",
        "Q1": "2003",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "6",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "800993bc-37f4-4a48-9e9b-d2f5645f45d6",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "1",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:12",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b438a13c376b48679235d1d073834f94&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=800993bc-37f4-4a48-9e9b-d2f5645f45d6&isSynthetic=true&or_zip=79015&or_householdincome=30874",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "482.614",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "33sx4rpq8kscm4j5",
        "Q41r1": "0",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "45",
        "Q14r2": "5",
        "Q14r5": "35",
        "Q14r4": "10",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "bqt0fq35tgw4deux",
        "Q22_9c2": "6",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q22_version": "77",
        "vlist": "2",
        "Q22_5c2": "9",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "7",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "5",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 15:05",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "5acd17b4f50a4faca27602a32bb07310",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "2",
        "Q15r5": "3",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v77,sawterm:Q1.ival gt 2007,/Gender/gen2,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "3",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q30": "4",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "2",
        "Q22_6c2": "1",
        "Q22_4c2": "4",
        "Q22_4c1": "7",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "1",
        "Q24": "Just the usual Democratic talking point. I hear it in every meeting, always tied to the latest regulations or grants, never about keeping the grid actually running. Feels like a label to sell a political agenda rather than a description of the power keeping our hospital lights on. Nothing to do with the real work of energy security.",
        "sectionLOIr4": "8.0398",
        "sectionLOIr1": "8.0398",
        "sectionLOIr3": "7.1787",
        "sectionLOIr2": "0.31255",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "3",
        "Q12": "2",
        "Q22_scorer7": "87.5",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "1543",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "4",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "100",
        "Q15r4": "5",
        "Q9r1": "2",
        "Q15r6": "1",
        "Q15r7": "1",
        "Q9r4": "3",
        "Q15r1": "1",
        "Q15r2": "2",
        "Q15r3": "2",
        "Q15r8": "2",
        "Q15r9": "4",
        "Q1": "1986",
        "Q3": "34",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "141b63dd-f57a-402c-93d3-1382002ad11e",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "5",
        "Q8r5": "1",
        "Q8r4": "1",
        "Q8r6": "2",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "2",
        "date": "04/06/2026 15:13",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5acd17b4f50a4faca27602a32bb07310&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=141b63dd-f57a-402c-93d3-1382002ad11e&isSynthetic=true&or_zip=28345&or_householdincome=53600",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "471.435",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "dguzg73d5h2d32s5",
        "Q41r1": "1",
        "Q14r1": "40",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "20",
        "Q14r2": "0",
        "Q14r5": "25",
        "Q14r4": "15",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "4scbbhzzmz63533y",
        "Q22_9c2": "9",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q22_version": "66",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "4",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 15:06",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "ff8b1f972f8f42aa851b278d662aa257",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "1",
        "Q15r5": "5",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Education/edu2,/Income/inc7,/Gender/gen2,/de_maxdiff/Q22/v66",
        "Q33": "2",
        "Q32": "1",
        "Q31": "3",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q30": "4",
        "Q39r3": "4",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "6",
        "Q22_6c2": "2",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "2",
        "Q24": "looks like just another way for them to control the grid and rip off utilities with new taxes and rates",
        "sectionLOIr4": "7.85061666667",
        "sectionLOIr1": "7.85061666667",
        "sectionLOIr3": "6.87455",
        "sectionLOIr2": "0.288616666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "3",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "4",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "record": "1544",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "8",
        "Q22_2c2": "9",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q9r1": "2",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q9r4": "3",
        "Q15r1": "8",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1972",
        "Q3": "11",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "7",
        "Q22_8c2": "4",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "575a3db4-0029-4b96-8bd5-8372eec87897",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "6",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "3",
        "Q8r2": "3",
        "date": "04/06/2026 15:14",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ff8b1f972f8f42aa851b278d662aa257&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=575a3db4-0029-4b96-8bd5-8372eec87897&isSynthetic=true&or_zip=30215&or_householdincome=209180",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1970",
        "vctq1c22": "0",
        "HIDAge": "55",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "vctq1c24": "0",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "22.061",
        "Q3": "10",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "tthpva48ew5tmz3a",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "ed948ccf49744c9785e9992cbe591dc7",
        "vlist": "2",
        "uuid": "50wn3xfa1f654wvm",
        "vmobiledevice": "5",
        "s2": "77ae3f1f-326f-42e5-bd8a-a65c61409639",
        "vctq1c25": "1",
        "markers": "bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,OQ /Income/inc5,20260109_07:39_v14,qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Region/reg3,bad:/Ethnicity/eth4,OQ,Top_to_Bottom,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "5",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:07",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "5",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "3",
        "date": "04/06/2026 15:07",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=ed948ccf49744c9785e9992cbe591dc7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=77ae3f1f-326f-42e5-bd8a-a65c61409639&isSynthetic=true&or_zip=33462&or_householdincome=85000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1545",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "405.175",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "wdnj230fffkmj449",
        "Q41r1": "0",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "44",
        "Q14r2": "6",
        "Q14r5": "22",
        "Q14r4": "6",
        "Q14r7": "0",
        "Q14r6": "17",
        "uuid": "n7765w1a1cune58p",
        "Q22_9c2": "2",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q22_version": "14",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "3",
        "Q21r4": "1",
        "Q21r7": "5",
        "Q21r6": "2",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 15:08",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "1",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "847ad52e69564cef969cfbd8c2da48ca",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "2",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg3,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Age/age3,/Income/inc3,/de_maxdiff/Q22/v14",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "2",
        "Q36": "4",
        "Q35": "1",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "6",
        "Q22_6c2": "4",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "4",
        "Q24": "It's about paying taxes and lease money back to our local communities, not big tech hype",
        "sectionLOIr4": "6.74685",
        "sectionLOIr1": "6.74685",
        "sectionLOIr3": "5.77033333333",
        "sectionLOIr2": "0.29925",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "0",
        "HIDAge2": "3",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "record": "1546",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "3",
        "Q22_2c2": "9",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "4",
        "Q9r1": "1",
        "Q15r6": "1",
        "Q15r7": "5",
        "Q9r4": "3",
        "Q15r1": "2",
        "Q15r2": "4",
        "Q15r3": "3",
        "Q15r8": "6",
        "Q15r9": "5",
        "Q1": "1986",
        "Q3": "34",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "1",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "98a47a44-e442-4cf7-b1a9-3fb2b806bdff",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "3",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:14",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=847ad52e69564cef969cfbd8c2da48ca&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=98a47a44-e442-4cf7-b1a9-3fb2b806bdff&isSynthetic=true&or_zip=28345&or_householdincome=53600",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1970",
        "vctq1c22": "0",
        "HIDAge": "55",
        "Q2": "2",
        "Q4": "8",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "12.976",
        "Q3": "10",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "pw7um67ssecmmufc",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "7696505e3b394ba58fd37c05514dee4b",
        "vlist": "2",
        "uuid": "r0u605mvke42dvsf",
        "vmobiledevice": "5",
        "s2": "be02aa1b-bc39-42ef-81c2-d4c2130558b6",
        "vctq1c25": "1",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Region/reg3,OQ,bad:/Rotate Selection/Bottom_to_Top,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "5",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:09",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "5",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "3",
        "date": "04/06/2026 15:09",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7696505e3b394ba58fd37c05514dee4b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=be02aa1b-bc39-42ef-81c2-d4c2130558b6&isSynthetic=true&or_zip=33462&or_householdincome=85000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1547",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "55",
        "vbrowser": "10",
        "qtime": "548.851",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "j87145m8pq438g6b",
        "Q41r1": "0",
        "Q14r1": "52",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "10",
        "Q14r2": "15",
        "Q14r5": "18",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "6grxpcrssc3axapr",
        "Q22_9c2": "7",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q22_version": "148",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "1",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "7",
        "Q21r3": "5",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "1",
        "Q21r7": "4",
        "Q21r6": "2",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 15:10",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "a2cad51cde15420aa6640718c8b65197",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "6",
        "Q15r5": "10",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q9r2": "2",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,/de_maxdiff/Q22/v148,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Age/age5,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Income/inc4,Top_to_Bottom,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "3",
        "Q37": "2",
        "Q35": "4",
        "Q22_7c1": "4",
        "Q39r4": "4",
        "Q22_7c2": "1",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "2",
        "Q22_6c1": "5",
        "Q22_6c2": "6",
        "Q22_4c2": "9",
        "Q22_4c1": "8",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "62.5",
        "Q23": "3",
        "Q24": "honestly just feels like a way to dodge talking about real costs and politics like we see on the news",
        "sectionLOIr4": "9.13943333333",
        "sectionLOIr1": "9.13943333333",
        "sectionLOIr3": "8.03866666667",
        "sectionLOIr2": "0.354716666667",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "12.5",
        "HIDAge2": "5",
        "Q22_scorer5": "87.5",
        "Q22_scorer4": "87.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "1548",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "3",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "10",
        "Q9r1": "1",
        "Q15r6": "10",
        "Q15r7": "5",
        "Q9r4": "4",
        "Q15r1": "9",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "10",
        "Q15r9": "10",
        "Q1": "1970",
        "Q3": "10",
        "Q2": "2",
        "Q5": "4",
        "Q4": "4",
        "Q6": "4",
        "Q22_8c2": "7",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "16a142b7-8026-4504-bf3a-64942c3d9831",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "1",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "04/06/2026 15:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a2cad51cde15420aa6640718c8b65197&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=16a142b7-8026-4504-bf3a-64942c3d9831&isSynthetic=true&or_zip=33462&or_householdincome=85000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "441.287",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "dczy073ka7mq1zk4",
        "Q41r1": "1",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "30",
        "Q14r2": "10",
        "Q14r5": "50",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "sbzqy1rmr7h536xd",
        "Q22_9c2": "4",
        "Q22_9c1": "8",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "6",
        "Q22_5c1": "7",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "5",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "3",
        "Q21r4": "1",
        "Q21r7": "6",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "4",
        "start_date": "04/06/2026 15:11",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "71ff1070163a4057b02f8a026fda720b",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "4",
        "Q22_1c1": "7",
        "record": "1549",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/de_maxdiff/Q22/v5,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Ethnicity/eth2,sawterm:(dvfail.r1),20260109_07:39_v14,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,/Age/age6,/Education/edu3,/Income/inc3",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "5",
        "Q36": "4",
        "Q35": "2",
        "Q22_7c1": "8",
        "Q39r4": "4",
        "Q22_7c2": "4",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "7",
        "Q22_6c2": "5",
        "Q22_4c2": "2",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "75",
        "Q23": "1",
        "Q24": "It links everything to that party's agenda",
        "sectionLOIr4": "7.35035",
        "sectionLOIr1": "7.35035",
        "sectionLOIr3": "6.32525",
        "sectionLOIr2": "0.243616666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "87.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "12.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "3",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "2",
        "Q15r5": "4",
        "Q15r6": "2",
        "Q15r7": "5",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "1",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1957",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "126c8f5b-0f18-41c8-b5b0-83a5aedff02d",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "5",
        "Q22_3c2": "3",
        "Q8r5": "5",
        "Q8r4": "3",
        "Q8r6": "4",
        "Q8r1": "4",
        "Q8r3": "4",
        "Q8r2": "3",
        "date": "04/06/2026 15:19",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=71ff1070163a4057b02f8a026fda720b&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=126c8f5b-0f18-41c8-b5b0-83a5aedff02d&isSynthetic=true&or_zip=33030&or_householdincome=65000",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "466.688",
        "Q14r9": "0",
        "Q14r8": "1",
        "session": "qs1z9y3hu1gxwkp7",
        "Q41r1": "0",
        "Q14r1": "29",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "32",
        "Q14r2": "19",
        "Q14r5": "6",
        "Q14r4": "5",
        "Q14r7": "1",
        "Q14r6": "0",
        "uuid": "yqqt8gwhr7ejuffa",
        "Q22_9c2": "4",
        "Q22_9c1": "7",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "7",
        "Q21r2": "3",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "5",
        "Q21r6": "4",
        "Q38": "2",
        "Q43": "3",
        "start_date": "04/06/2026 15:13",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "55a5e09d05854ca097dfe30701d71703",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "2",
        "Q22_1c1": "1",
        "record": "1550",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q41r2": "0",
        "markers": "qualified,/Vote/vote3,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v49,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "3",
        "Q22_version": "49",
        "Q35": "6",
        "Q22_7c1": "5",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "7",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "1",
        "Q24": "linked to the jobs race, less about climate",
        "sectionLOIr4": "7.77385",
        "sectionLOIr1": "7.77385",
        "sectionLOIr3": "6.55726666667",
        "sectionLOIr2": "0.280666666667",
        "vctq1c21": "0",
        "Q35r6oe": "I would say I'm lean liberal but independent. My main concern is usually how things affect my immediate community and the stability of local infrastructure rather than big ideological battles.",
        "Q17": "2",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "100",
        "HIDAge2": "1",
        "Q22_scorer5": "50",
        "Q22_scorer4": "25",
        "Q19": "2",
        "Q18": "1",
        "Q22_scorer1": "75",
        "Q22_scorer9": "25",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "3",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "9",
        "Q15r5": "9",
        "Q15r6": "8",
        "Q15r7": "9",
        "Q15r1": "9",
        "Q15r2": "9",
        "Q15r3": "9",
        "Q15r8": "9",
        "Q15r9": "7",
        "Q1": "2002",
        "Q3": "8",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "9",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "7",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "3c118ae8-f5cc-4d0c-a3b4-9d980ab588fc",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "5",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "3",
        "Q8r2": "2",
        "date": "04/06/2026 15:20",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=55a5e09d05854ca097dfe30701d71703&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=3c118ae8-f5cc-4d0c-a3b4-9d980ab588fc&isSynthetic=true&or_zip=19963&or_householdincome=38282",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1965",
        "vctq1c22": "0",
        "HIDAge": "60",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "vctq1c24": "0",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "17.07",
        "Q3": "33",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "becdkjf0y8xxdz3u",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "c69315ee44c04380a85107162745fa28",
        "vlist": "2",
        "uuid": "433upz67nujjjuz0",
        "vmobiledevice": "5",
        "s2": "815cc868-3a58-47b8-b1cc-972d15d35afb",
        "vctq1c25": "1",
        "markers": "bad:/Education/edu1,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth1,20260109_07:39_v14,OQ /Income/inc5,qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,OQ,Top_to_Bottom,bad:/Region/reg1,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "5",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:13",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "2",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "1",
        "date": "04/06/2026 15:14",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=c69315ee44c04380a85107162745fa28&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=815cc868-3a58-47b8-b1cc-972d15d35afb&isSynthetic=true&or_zip=10994&or_householdincome=99265",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1551",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1970",
        "vctq1c22": "0",
        "HIDAge": "55",
        "Q2": "2",
        "Q4": "8",
        "vctq1c24": "0",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "12.926",
        "Q3": "10",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "jv69yuksqbtmyg2n",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "941b94bc7a974e07bfd0f91f6356ba1a",
        "vlist": "2",
        "uuid": "5z4kx10gx4q2sfza",
        "vmobiledevice": "5",
        "s2": "011f1b86-dd47-4794-b20c-4f6e44e90565",
        "vctq1c25": "1",
        "markers": "bad:/Rotate Selection/Top_to_Bottom,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,bad:/Region/reg3,OQ,Top_to_Bottom,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "5",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:14",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "5",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "3",
        "date": "04/06/2026 15:14",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=941b94bc7a974e07bfd0f91f6356ba1a&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=011f1b86-dd47-4794-b20c-4f6e44e90565&isSynthetic=true&or_zip=33462&or_householdincome=85000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1552",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "471.765",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "4bjc8sbtxqhzs12d",
        "Q41r1": "0",
        "Q14r1": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "65",
        "Q14r2": "10",
        "Q14r5": "0",
        "Q14r4": "10",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "1p7u38gzanju1hur",
        "Q22_9c2": "9",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q22_version": "216",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "6",
        "Q21r2": "4",
        "Q21r5": "7",
        "Q21r4": "3",
        "Q21r7": "1",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:15",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "65555042228e480bb3a81b9738f72436",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "1",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg4,/Vote/vote4,/Ethnicity/eth3,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v216,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "1",
        "Q35": "3",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "1",
        "Q9r6": "4",
        "Q22_6c1": "8",
        "Q22_6c2": "7",
        "Q22_4c2": "5",
        "Q22_4c1": "3",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "62.5",
        "Q23": "4",
        "Q24": "just marketing jargon to keep the bills high while the grid stays weak",
        "sectionLOIr4": "7.85815",
        "sectionLOIr1": "7.85815",
        "sectionLOIr3": "6.89828333333",
        "sectionLOIr2": "0.290833333333",
        "vctq1c21": "1",
        "Q17": "2",
        "Q16": "1",
        "Q11": "4",
        "Q10": "4",
        "Q13": "1",
        "Q12": "3",
        "Q22_scorer7": "50",
        "HIDAge2": "4",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "37.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "record": "1553",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "1",
        "Q22_2c1": "9",
        "Q22_2c2": "4",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "62.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "1",
        "Q9r1": "4",
        "Q15r6": "5",
        "Q15r7": "9",
        "Q9r4": "2",
        "Q15r1": "3",
        "Q15r2": "3",
        "Q15r3": "3",
        "Q15r8": "1",
        "Q15r9": "1",
        "Q1": "1972",
        "Q3": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "2",
        "Q6": "3",
        "Q22_8c2": "9",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "cd5e0c77-faca-49f7-aa75-235647de1bbc",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "9",
        "Q22_3c2": "6",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "04/06/2026 15:22",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=65555042228e480bb3a81b9738f72436&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=cd5e0c77-faca-49f7-aa75-235647de1bbc&isSynthetic=true&or_zip=97305&or_householdincome=62000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "39",
        "vbrowser": "10",
        "qtime": "483.334",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "8g127araau06vab4",
        "Q41r1": "0",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "55",
        "Q14r2": "5",
        "Q14r5": "15",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "qwdprct07zucqkeu",
        "Q22_9c2": "6",
        "Q22_9c1": "9",
        "Q34r4": "0",
        "Q22_version": "270",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "9",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "7",
        "Q21r2": "3",
        "Q21r5": "1",
        "Q21r4": "2",
        "Q21r7": "5",
        "Q21r6": "4",
        "Q38": "4",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:15",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "a3da9004ad6945febe8dfad3be770ac6",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "5",
        "Q22_1c1": "3",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q9r2": "3",
        "markers": "qualified,/Region/reg3,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,qual,/de_maxdiff/Q22/v270,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Age/age3,/Income/inc3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "6",
        "Q30": "1",
        "Q39r3": "4",
        "Q9r5": "2",
        "Q9r6": "4",
        "Q22_6c1": "9",
        "Q22_6c2": "5",
        "Q22_4c2": "7",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "2",
        "Q24": "just some buzzword people use to sell solar panels while the grid still depends on gas",
        "sectionLOIr4": "8.03926666667",
        "sectionLOIr1": "8.03926666667",
        "sectionLOIr3": "7.06153333333",
        "sectionLOIr2": "0.3099",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "2",
        "Q10": "4",
        "Q13": "4",
        "Q12": "3",
        "Q22_scorer7": "25",
        "HIDAge2": "3",
        "Q22_scorer5": "12.5",
        "Q22_scorer4": "62.5",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "record": "1554",
        "Q22_scorer9": "87.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "5",
        "Q22_scorer6": "37.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "37.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "5",
        "Q9r1": "1",
        "Q15r6": "10",
        "Q15r7": "3",
        "Q9r4": "4",
        "Q15r1": "5",
        "Q15r2": "5",
        "Q15r3": "5",
        "Q15r8": "0",
        "Q15r9": "3",
        "Q1": "1986",
        "Q3": "34",
        "Q2": "2",
        "Q5": "3",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "3",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "c45e66c9-f936-4453-9e08-9b856fa66932",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "7",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:23",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=a3da9004ad6945febe8dfad3be770ac6&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=c45e66c9-f936-4453-9e08-9b856fa66932&isSynthetic=true&or_zip=28345&or_householdincome=53600",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1983",
        "vctq1c22": "0",
        "HIDAge": "42",
        "Q2": "1",
        "Q4": "1",
        "vctq1c24": "1",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "12.438",
        "Q3": "23",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "cj3ye9g1fy9vfb1p",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "291d2b89b7fd43a28eab4c111990a01c",
        "vlist": "2",
        "uuid": "td95mpzda2nf189q",
        "vmobiledevice": "5",
        "s2": "05894cd3-adb6-407f-94cb-c202f110f953",
        "vctq1c25": "0",
        "markers": "Bottom_to_Top,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,bad:/Rotate Selection/Bottom_to_Top,OQ,bad:/Overall/qual,bad:/Region/reg2",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:15",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "3",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "2",
        "date": "04/06/2026 15:15",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=291d2b89b7fd43a28eab4c111990a01c&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=05894cd3-adb6-407f-94cb-c202f110f953&isSynthetic=true&or_zip=49404&or_householdincome=163500",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1555",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "506.881",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "acm0ctjdm5y6dqn9",
        "Q41r1": "0",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "36",
        "Q14r2": "9",
        "Q14r5": "32",
        "Q14r4": "9",
        "Q14r7": "9",
        "Q14r6": "0",
        "uuid": "3gvu7ku893vs7hqa",
        "Q22_9c2": "7",
        "Q22_9c1": "8",
        "Q34r4": "0",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "2",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "start_date": "04/06/2026 15:16",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "d6d52632f40c47cfa679d88f4c317990",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "2",
        "record": "1556",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/de_maxdiff/Q22/v134,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc7,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "134",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "3",
        "Q22_6c1": "2",
        "Q22_6c2": "8",
        "Q22_4c2": "9",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "4",
        "Q24": "it's just another label for green energy, same old political stuff",
        "sectionLOIr4": "8.44201666667",
        "sectionLOIr1": "8.44201666667",
        "sectionLOIr3": "7.40496666667",
        "sectionLOIr2": "0.302166666667",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "0",
        "HIDAge2": "4",
        "Q22_scorer5": "25",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "8",
        "Q15r5": "9",
        "Q15r6": "9",
        "Q15r7": "5",
        "Q15r1": "6",
        "Q15r2": "5",
        "Q15r3": "6",
        "Q15r8": "7",
        "Q15r9": "10",
        "Q1": "1972",
        "Q3": "11",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "7",
        "Q22_8c2": "5",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "0",
        "s2": "e86e67b0-81d8-4e20-9dc3-e4a30ebbc13d",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "4",
        "Q22_3c2": "1",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:24",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=d6d52632f40c47cfa679d88f4c317990&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e86e67b0-81d8-4e20-9dc3-e4a30ebbc13d&isSynthetic=true&or_zip=30215&or_householdincome=209180",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "543.594",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "jzckpy0pa165d0nq",
        "Q41r1": "1",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "60",
        "Q14r2": "10",
        "Q14r5": "20",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "aag12s00d8qf7uqq",
        "Q22_9c2": "7",
        "Q22_9c1": "4",
        "Q34r4": "0",
        "Q22_version": "111",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "3",
        "Q21r4": "5",
        "Q21r7": "6",
        "Q21r6": "1",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:19",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "5caafd77e1b949b5a3f8b656d9cae517",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "6",
        "Q15r5": "1",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "1",
        "Q9r2": "1",
        "markers": "qualified,/de_maxdiff/Q22/v111,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Income/inc6,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "5",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "4",
        "Q9r6": "3",
        "Q22_6c1": "4",
        "Q22_6c2": "8",
        "Q22_4c2": "5",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "12.5",
        "Q23": "5",
        "Q24": "like fake climate talk from env grou that dont care bout house",
        "sectionLOIr4": "9.05463333333",
        "sectionLOIr1": "9.05463333333",
        "sectionLOIr3": "7.83518333333",
        "sectionLOIr2": "0.288266666667",
        "vctq1c21": "1",
        "Q17": "1",
        "Q16": "1",
        "Q11": "3",
        "Q10": "2",
        "Q13": "4",
        "Q12": "4",
        "Q22_scorer7": "25",
        "HIDAge2": "4",
        "Q22_scorer5": "25",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "1557",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "3",
        "Q22_2c2": "8",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "87.5",
        "Q15r4": "0",
        "Q9r1": "3",
        "Q15r6": "6",
        "Q15r7": "8",
        "Q9r4": "2",
        "Q15r1": "0",
        "Q15r2": "10",
        "Q15r3": "4",
        "Q15r8": "4",
        "Q15r9": "0",
        "Q1": "1972",
        "Q3": "11",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "9",
        "Q22_8c1": "3",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "a6a622da-b5ee-4138-afc4-a5408da9bf2d",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "2",
        "Q22_3c2": "1",
        "Q8r5": "3",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "4",
        "Q8r2": "2",
        "date": "04/06/2026 15:28",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5caafd77e1b949b5a3f8b656d9cae517&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a6a622da-b5ee-4138-afc4-a5408da9bf2d&isSynthetic=true&or_zip=30215&or_householdincome=209180",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "68",
        "vbrowser": "10",
        "qtime": "444.115",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "h7jvhdj9y30g5c8k",
        "Q41r1": "0",
        "Q14r1": "10",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "65",
        "Q14r2": "5",
        "Q14r5": "20",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "smk5jdp8dvwg838u",
        "Q22_9c2": "7",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q22_version": "15",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "1",
        "Q21r3": "2",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "3",
        "Q21r7": "7",
        "Q21r6": "6",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "4",
        "start_date": "04/06/2026 15:20",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "1",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "93a6a49c10b6408588d8e0cc96c715be",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "Q15r5": "2",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/de_maxdiff/Q22/v15,/Region/reg3,/Vote/vote4,/Ethnicity/eth2,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "3",
        "Q31": "2",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "1",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q30": "1",
        "Q39r3": "3",
        "Q9r5": "4",
        "Q9r6": "3",
        "Q22_6c1": "3",
        "Q22_6c2": "5",
        "Q22_4c2": "5",
        "Q22_4c1": "6",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "talks a lot about wind farms and subsidies but the tax bill is still the same",
        "sectionLOIr4": "7.38686666667",
        "sectionLOIr1": "7.38686666667",
        "sectionLOIr3": "6.43328333333",
        "sectionLOIr2": "0.302383333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "3",
        "Q10": "2",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "0",
        "HIDAge2": "6",
        "Q22_scorer5": "0",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "75",
        "record": "1558",
        "Q22_scorer9": "62.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "6",
        "Q22_2c2": "7",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "75",
        "vmobiledevice": "5",
        "Q22_scorer2": "37.5",
        "Q15r4": "8",
        "Q9r1": "2",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q9r4": "2",
        "Q15r1": "8",
        "Q15r2": "6",
        "Q15r3": "8",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1957",
        "Q3": "10",
        "Q2": "1",
        "Q5": "4",
        "Q4": "3",
        "Q6": "3",
        "Q22_8c2": "2",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "1",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "ec852d51-236f-4eda-89b7-5006672771a5",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "9",
        "Q22_3c2": "5",
        "Q8r5": "4",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:27",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=93a6a49c10b6408588d8e0cc96c715be&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ec852d51-236f-4eda-89b7-5006672771a5&isSynthetic=true&or_zip=33030&or_householdincome=65000",
        "Q34r3": "1",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "1",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "425.758",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "d1yj089ernyt2vau",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "60",
        "Q14r2": "0",
        "Q14r5": "25",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "zsrep6e6722paa5a",
        "Q22_9c2": "3",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q22_version": "8",
        "vlist": "2",
        "Q22_5c2": "7",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "6",
        "Q21r3": "7",
        "Q21r2": "2",
        "Q21r5": "4",
        "Q21r4": "3",
        "Q21r7": "1",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "1",
        "Q39r2": "4",
        "start_date": "04/06/2026 15:21",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "9a2abf428bed47b98c7bb0fdb6cdb4a9",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "3",
        "Q22_1c1": "5",
        "Q15r5": "4",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q9r2": "1",
        "markers": "qualified,/de_maxdiff/Q22/v8,/Vote/vote1,/Region/reg3,/Ethnicity/eth1,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "3",
        "Q9r3": "2",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "7",
        "Q30": "2",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "5",
        "Q22_4c1": "4",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "1",
        "Q24": "Makes me worry about the grid staying stable when my husband is unemployed",
        "sectionLOIr4": "7.09188333333",
        "sectionLOIr1": "7.09188333333",
        "sectionLOIr3": "6.15043333333",
        "sectionLOIr2": "0.33015",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "2",
        "Q11": "3",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "1",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "50",
        "record": "1559",
        "Q22_scorer9": "37.5",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "4",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "5",
        "Q9r1": "2",
        "Q15r6": "1",
        "Q15r7": "6",
        "Q9r4": "2",
        "Q15r1": "5",
        "Q15r2": "1",
        "Q15r3": "6",
        "Q15r8": "4",
        "Q15r9": "5",
        "Q1": "2002",
        "Q3": "8",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "3",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "15",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "5e3acb0d-4644-4284-ab35-3509eb327849",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "1",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "7",
        "Q22_3c2": "9",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "1",
        "Q8r3": "1",
        "Q8r2": "1",
        "date": "04/06/2026 15:28",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=9a2abf428bed47b98c7bb0fdb6cdb4a9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=5e3acb0d-4644-4284-ab35-3509eb327849&isSynthetic=true&or_zip=19963&or_householdincome=38282",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "22",
        "vbrowser": "10",
        "qtime": "533.955",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "51dmpkgq4k4rsdxd",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "59",
        "Q14r2": "4",
        "Q14r5": "14",
        "Q14r4": "5",
        "Q14r7": "9",
        "Q14r6": "0",
        "uuid": "m8nbtxq6rkra9988",
        "Q22_9c2": "3",
        "Q22_9c1": "1",
        "Q34r4": "0",
        "Q22_version": "196",
        "vlist": "2",
        "Q22_5c2": "5",
        "Q22_5c1": "2",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "3",
        "Q21r3": "7",
        "Q21r2": "1",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "4",
        "Q21r6": "5",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:23",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "5537437c02b44f87ba1a9425d0142dbf",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "6",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q9r2": "2",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,/Age/age1,/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/de_maxdiff/Q22/v196,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "3",
        "Q9r3": "3",
        "Q35": "3",
        "Q22_7c1": "4",
        "Q39r4": "3",
        "Q22_7c2": "9",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "4",
        "Q9r6": "2",
        "Q22_6c1": "2",
        "Q22_6c2": "9",
        "Q22_4c2": "3",
        "Q22_4c1": "5",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "4",
        "Q24": "it sounds like the republicans are trying to trick us",
        "sectionLOIr4": "8.89531666667",
        "sectionLOIr1": "8.89531666667",
        "sectionLOIr3": "7.97455",
        "sectionLOIr2": "0.272833333333",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "6",
        "Q12": "3",
        "Q22_scorer7": "62.5",
        "HIDAge2": "1",
        "Q22_scorer5": "37.5",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "record": "1560",
        "Q22_scorer9": "12.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "3",
        "Q22_scorer6": "75",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "4",
        "Q9r1": "2",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q9r4": "3",
        "Q15r1": "6",
        "Q15r2": "6",
        "Q15r3": "5",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "2003",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "2",
        "Q22_8c1": "4",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "1",
        "Q14r10": "9",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "f824088b-cac8-4c18-a371-4075a61fa1ca",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "7",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:32",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5537437c02b44f87ba1a9425d0142dbf&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=f824088b-cac8-4c18-a371-4075a61fa1ca&isSynthetic=true&or_zip=79015&or_householdincome=30874",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "382.254",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "089djvmbkfzn8h4c",
        "Q41r1": "0",
        "Q14r1": "70",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "18",
        "Q14r2": "12",
        "Q14r5": "0",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "0",
        "uuid": "tsnazqrgkhwtgjn8",
        "Q22_9c2": "1",
        "Q22_9c1": "3",
        "Q34r4": "0",
        "Q22_version": "244",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "6",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "1",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "1",
        "Q21r2": "3",
        "Q21r5": "7",
        "Q21r4": "6",
        "Q21r7": "5",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:24",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "4",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "783954d7c6584b17a9a5c9158e767e80",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "7",
        "Q15r5": "0",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q9r2": "2",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg4,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,/Age/age4,qual,/de_maxdiff/Q22/v244,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Income/inc3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "3",
        "Q36": "4",
        "Q35": "1",
        "Q22_7c1": "8",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "2",
        "Q9r6": "1",
        "Q22_6c1": "6",
        "Q22_6c2": "3",
        "Q22_4c2": "7",
        "Q22_4c1": "4",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "1",
        "Q24": "it's just a fancy name for political stuff pushing solar panels while the lights go out",
        "sectionLOIr4": "6.36535",
        "sectionLOIr1": "6.36535",
        "sectionLOIr3": "5.39055",
        "sectionLOIr2": "0.3093",
        "vctq1c21": "1",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "4",
        "Q12": "3",
        "Q22_scorer7": "37.5",
        "HIDAge2": "4",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "62.5",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "37.5",
        "record": "1561",
        "Q22_scorer9": "0",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "5",
        "Q22_2c2": "9",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "1",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "50",
        "Q15r4": "0",
        "Q9r1": "2",
        "Q15r6": "4",
        "Q15r7": "3",
        "Q9r4": "2",
        "Q15r1": "3",
        "Q15r2": "3",
        "Q15r3": "3",
        "Q15r8": "0",
        "Q15r9": "0",
        "Q1": "1972",
        "Q3": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "4",
        "Q6": "3",
        "Q22_8c2": "7",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "d8041343-8066-4e7b-94e7-da01fb7cb251",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "9",
        "Q22_3c1": "6",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:30",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=783954d7c6584b17a9a5c9158e767e80&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=d8041343-8066-4e7b-94e7-da01fb7cb251&isSynthetic=true&or_zip=97305&or_householdincome=62000",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1965",
        "vctq1c22": "0",
        "HIDAge": "60",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "vctq1c24": "0",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "18.53",
        "Q3": "33",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "b7745negfdk3s4nx",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "2ad43ce88cef40108076a2d18a0cca7d",
        "vlist": "2",
        "uuid": "vrvzjrwfpjjguwy9",
        "vmobiledevice": "5",
        "s2": "ffd69cc9-1092-4528-b8a5-85471e898fed",
        "vctq1c25": "1",
        "markers": "bad:/Education/edu1,Bottom_to_Top,bad:/Ethnicity/eth1,20260109_07:39_v14,OQ /Income/inc5,qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,OQ,bad:/Rotate Selection/Bottom_to_Top,bad:/Region/reg1,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "5",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:25",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "2",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "1",
        "date": "04/06/2026 15:25",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2ad43ce88cef40108076a2d18a0cca7d&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=ffd69cc9-1092-4528-b8a5-85471e898fed&isSynthetic=true&or_zip=10994&or_householdincome=99265",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1562",
        "RotateSelect": "2",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "475.235",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "fr2s38tdfhwnkfhw",
        "Q41r1": "0",
        "Q14r1": "18",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "32",
        "Q14r2": "18",
        "Q14r5": "9",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "tcc4jjc4jxg15xct",
        "Q22_9c2": "4",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q22_version": "242",
        "vlist": "2",
        "Q22_5c2": "1",
        "Q22_5c1": "3",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "7",
        "Q21r2": "4",
        "Q21r5": "5",
        "Q21r4": "1",
        "Q21r7": "6",
        "Q21r6": "3",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:26",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "Q39r1": "4",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "741225b8fc14442ba79eb631b8426fe9",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "5",
        "Q22_1c1": "2",
        "Q15r5": "9",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "1",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/de_maxdiff/Q22/v242,/Gender/gen2,sawterm:(dvfail.r1),/Income/inc2",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "1",
        "Q35": "3",
        "Q22_7c1": "6",
        "Q39r4": "2",
        "Q22_7c2": "7",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "2",
        "Q9r6": "3",
        "Q22_6c1": "6",
        "Q22_6c2": "4",
        "Q22_4c2": "4",
        "Q22_4c1": "6",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "50",
        "Q23": "3",
        "Q24": "frankly it's just about keeping the lights on and taxes in the bank",
        "sectionLOIr4": "7.9109",
        "sectionLOIr1": "7.9109",
        "sectionLOIr3": "7.00421666667",
        "sectionLOIr2": "0.50405",
        "vctq1c21": "0",
        "Q17": "3",
        "Q16": "2",
        "Q11": "1",
        "Q10": "4",
        "Q13": "2",
        "Q12": "1",
        "Q22_scorer7": "37.5",
        "HIDAge2": "1",
        "Q22_scorer5": "50",
        "Q22_scorer4": "0",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "37.5",
        "record": "1563",
        "Q22_scorer9": "50",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "1",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "2",
        "Q22_2c2": "3",
        "Q22_scorer6": "100",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "0",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "50",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "9",
        "Q9r1": "1",
        "Q15r6": "7",
        "Q15r7": "7",
        "Q9r4": "2",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "10",
        "Q15r8": "7",
        "Q15r9": "5",
        "Q1": "2002",
        "Q3": "8",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "2",
        "Q22_8c2": "1",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "9",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "294f9f95-3533-40bb-81bd-2475091149f2",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "2",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "1",
        "Q22_3c2": "4",
        "Q8r5": "1",
        "Q8r4": "2",
        "Q8r6": "2",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:34",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=741225b8fc14442ba79eb631b8426fe9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=294f9f95-3533-40bb-81bd-2475091149f2&isSynthetic=true&or_zip=19963&or_householdincome=38282",
        "Q34r3": "0",
        "Q41r8": "1",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "42",
        "vbrowser": "10",
        "qtime": "394.869",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "p47bt25z77gabrh4",
        "Q41r1": "0",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "65",
        "Q14r2": "0",
        "Q14r5": "10",
        "Q14r4": "5",
        "Q14r7": "0",
        "Q14r6": "20",
        "uuid": "41wfdebju90fqdhy",
        "Q22_9c2": "6",
        "Q22_9c1": "1",
        "Q34r4": "1",
        "Q22_version": "142",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "8",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "5",
        "Q21r2": "4",
        "Q21r5": "7",
        "Q21r4": "3",
        "Q21r7": "6",
        "Q21r6": "1",
        "Q38": "2",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:28",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "2",
        "Q39r1": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "1",
        "dvscore": "0",
        "vctq1c24": "1",
        "vctq1c25": "0",
        "or1": "2bdde26f3ff1465999cb5535c6c37cb7",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "7",
        "Q15r5": "4",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "1",
        "Q41r4": "0",
        "Q41r3": "1",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg2,/Income/inc6,/Ethnicity/eth1,/Vote/vote4,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Overall/qual,qual,sawterm:Q1.ival gt 2007,/Gender/gen1,Top_to_Bottom,/Education/edu3,/Age/age3,/de_maxdiff/Q22/v142",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "1",
        "Q36": "1",
        "Q35": "1",
        "Q22_7c1": "7",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "1",
        "Q9r6": "2",
        "Q22_6c1": "8",
        "Q22_6c2": "5",
        "Q22_4c2": "2",
        "Q22_4c1": "8",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "87.5",
        "Q23": "1",
        "Q24": "feels like a political signal more than actual power",
        "sectionLOIr4": "6.57593333333",
        "sectionLOIr1": "6.57593333333",
        "sectionLOIr3": "5.61076666667",
        "sectionLOIr2": "0.26575",
        "vctq1c21": "0",
        "Q17": "1",
        "Q16": "1",
        "Q11": "2",
        "Q10": "4",
        "Q13": "4",
        "Q12": "3",
        "Q22_scorer7": "87.5",
        "HIDAge2": "3",
        "Q22_scorer5": "25",
        "Q22_scorer4": "50",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "62.5",
        "record": "1564",
        "Q22_scorer9": "50",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "1",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "2",
        "Q22_2c2": "3",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "62.5",
        "Q15r4": "3",
        "Q9r1": "3",
        "Q15r6": "1",
        "Q15r7": "4",
        "Q9r4": "2",
        "Q15r1": "1",
        "Q15r2": "1",
        "Q15r3": "2",
        "Q15r8": "5",
        "Q15r9": "4",
        "Q1": "1983",
        "Q3": "23",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "Q6": "6",
        "Q22_8c2": "6",
        "Q22_8c1": "7",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "1a148f9c-6db3-43a6-96d4-946b49cecc21",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "3",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "1",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "3",
        "Q22_3c1": "2",
        "Q22_3c2": "3",
        "Q8r5": "1",
        "Q8r4": "2",
        "Q8r6": "3",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "04/06/2026 15:34",
        "vmobileos": "6",
        "Q34r5": "1",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2bdde26f3ff1465999cb5535c6c37cb7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=1a148f9c-6db3-43a6-96d4-946b49cecc21&isSynthetic=true&or_zip=49404&or_householdincome=163500",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "53",
        "vbrowser": "10",
        "qtime": "508.469",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "uzrhe2hzkb1a0jxh",
        "Q41r1": "0",
        "Q14r1": "5",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "33",
        "Q14r2": "14",
        "Q14r5": "29",
        "Q14r4": "9",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "d5p4f5k8nvrezb0t",
        "Q22_9c2": "3",
        "Q22_9c1": "5",
        "Q34r4": "1",
        "Q30": "4",
        "vlist": "2",
        "Q22_5c2": "3",
        "Q22_5c1": "4",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "1",
        "Q21r1": "6",
        "Q21r3": "3",
        "Q21r2": "2",
        "Q21r5": "1",
        "Q21r4": "4",
        "Q21r7": "7",
        "Q21r6": "5",
        "Q38": "2",
        "Q43": "4",
        "start_date": "04/06/2026 15:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "acd5c5a3a5a54536a81d1b1df707abc0",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "8",
        "Q22_1c1": "5",
        "record": "1565",
        "Q41r7": "0",
        "Q41r6": "0",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "0",
        "markers": "qualified,/Region/reg3,/Ethnicity/eth1,/Vote/vote4,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Age/age4,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,/de_maxdiff/Q22/v32,sawterm:Q1.ival gt 2007,/Income/inc7,/Gender/gen2,/Education/edu3",
        "Q33": "2",
        "Q32": "4",
        "Q31": "2",
        "Q22_version": "32",
        "Q36": "3",
        "Q35": "1",
        "Q22_7c1": "8",
        "Q39r4": "4",
        "Q22_7c2": "9",
        "Q39r2": "3",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "2",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "2",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "2",
        "Q22_scorer8": "50",
        "Q23": "1",
        "Q24": "getting rid of the dirty plants that hurt people while building schools and jobs nearby, which i think is what most families need",
        "sectionLOIr4": "8.47005",
        "sectionLOIr1": "8.47005",
        "sectionLOIr3": "7.42893333333",
        "sectionLOIr2": "0.32305",
        "vctq1c21": "1",
        "Q17": "3",
        "Q16": "2",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "62.5",
        "HIDAge2": "4",
        "Q22_scorer5": "100",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "50",
        "Q22_scorer9": "12.5",
        "Q7r8": "0",
        "Q7r6": "0",
        "Q7r7": "1",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "0",
        "Q7r1": "1",
        "Q22_2c1": "7",
        "Q22_2c2": "9",
        "Q22_scorer6": "50",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "0",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "9",
        "Q15r5": "7",
        "Q15r6": "9",
        "Q15r7": "10",
        "Q15r1": "10",
        "Q15r2": "10",
        "Q15r3": "9",
        "Q15r8": "4",
        "Q15r9": "8",
        "Q1": "1972",
        "Q3": "11",
        "Q2": "2",
        "Q5": "4",
        "Q4": "7",
        "Q6": "7",
        "Q22_8c2": "4",
        "Q22_8c1": "5",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "1",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "1",
        "Q40r5": "1",
        "s2": "a49fdb32-5c4f-42fb-8080-f913362ae58c",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "5",
        "Q22_3c1": "5",
        "Q22_3c2": "9",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "04/06/2026 15:37",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=acd5c5a3a5a54536a81d1b1df707abc0&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=a49fdb32-5c4f-42fb-8080-f913362ae58c&isSynthetic=true&or_zip=30215&or_householdincome=209180",
        "Q34r3": "1",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "83",
        "vbrowser": "10",
        "qtime": "477.836",
        "Q41r2": "1",
        "Q14r9": "0",
        "Q14r8": "0",
        "session": "24rswmjt4sap7k18",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "55",
        "Q14r2": "0",
        "Q14r5": "15",
        "Q14r4": "0",
        "Q14r7": "0",
        "Q14r6": "20",
        "uuid": "hhbvknrsn3cfdya6",
        "Q22_9c2": "9",
        "Q22_9c1": "2",
        "Q34r4": "0",
        "Q22_version": "37",
        "vlist": "2",
        "Q22_5c2": "4",
        "Q22_5c1": "5",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "2",
        "Q21r3": "7",
        "Q21r2": "1",
        "Q21r5": "6",
        "Q21r4": "3",
        "Q21r7": "5",
        "Q21r6": "4",
        "Q38": "3",
        "Q43": "4",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:29",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "2",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "96d97f50a47c4b02bced8ef2284ee778",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "9",
        "Q22_1c1": "2",
        "Q15r5": "5",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg1,/Gender/gen2,/Ethnicity/eth1,/de_maxdiff/Q22/v37,Bottom_to_Top,sawterm:(dvfail.r1),20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Age/age6,/Income/inc1,/Vote/vote4",
        "Q33": "2",
        "Q32": "4",
        "Q31": "3",
        "Q9r3": "2",
        "Q36": "2",
        "Q35": "1",
        "Q22_7c1": "6",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q30": "4",
        "Q39r3": "2",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "5",
        "Q22_6c2": "3",
        "Q22_4c2": "3",
        "Q22_4c1": "9",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "1",
        "Q22_scorer8": "50",
        "Q23": "5",
        "Q24": "connected to the tax loopholes and foreign interference arguments they always push when they think i'm not listening, but honestly i just see the job cuts and think it's a scam",
        "sectionLOIr4": "7.95963333333",
        "sectionLOIr1": "7.95963333333",
        "sectionLOIr3": "6.94101666667",
        "sectionLOIr2": "0.328933333333",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "2",
        "Q10": "2",
        "Q13": "2",
        "Q12": "2",
        "Q22_scorer7": "50",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "25",
        "Q19": "1",
        "Q18": "1",
        "Q22_scorer1": "50",
        "record": "1566",
        "Q22_scorer9": "37.5",
        "Q7r8": "1",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "0",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "6",
        "Q22_2c2": "3",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "1",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "0",
        "Q22_scorer3": "12.5",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "5",
        "Q9r1": "1",
        "Q15r6": "5",
        "Q15r7": "5",
        "Q9r4": "2",
        "Q15r1": "8",
        "Q15r2": "5",
        "Q15r3": "2",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "1942",
        "Q3": "33",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "4",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "1",
        "Q40r2": "0",
        "Q14r10": "10",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "1",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "e3b1963e-0327-4738-887a-dd1b51bfcee2",
        "Q40r8": "1",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "1",
        "vctq1c8": "1",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "1",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "6",
        "Q22_3c2": "2",
        "Q8r5": "1",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "1",
        "Q8r3": "2",
        "Q8r2": "3",
        "date": "04/06/2026 15:37",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=96d97f50a47c4b02bced8ef2284ee778&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=e3b1963e-0327-4738-887a-dd1b51bfcee2&isSynthetic=true&or_zip=14623&or_householdincome=12108",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "1",
        "Q34r9": "0",
        "Q34r8": "0",
        "Q34r7": "1",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "83",
        "vbrowser": "10",
        "qtime": "488.261",
        "Q41r2": "0",
        "Q14r9": "0",
        "Q14r8": "5",
        "session": "8m40cnahxaar4ffh",
        "Q41r1": "1",
        "Q14r1": "20",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "25",
        "Q14r2": "20",
        "Q14r5": "15",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "0",
        "uuid": "ytufxkyda1p9bttd",
        "Q22_9c2": "3",
        "Q22_9c1": "5",
        "Q34r4": "0",
        "Q22_version": "227",
        "vlist": "2",
        "Q22_5c2": "8",
        "Q22_5c1": "7",
        "vctq1c18": "1",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "4",
        "Q21r3": "1",
        "Q21r2": "5",
        "Q21r5": "6",
        "Q21r4": "2",
        "Q21r7": "7",
        "Q21r6": "3",
        "Q38": "3",
        "Q43": "3",
        "Q39r2": "3",
        "start_date": "04/06/2026 15:31",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "1",
        "Q39r1": "2",
        "vctq1c22": "0",
        "vctq1c23": "1",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "b687fbdceac34abca168fa426f45aaa9",
        "DevType": "1",
        "vctq1c19": "0",
        "Q22_1c2": "3",
        "Q22_1c1": "9",
        "Q15r5": "3",
        "Q41r7": "0",
        "Q41r6": "1",
        "Q41r5": "0",
        "Q41r4": "0",
        "Q41r3": "0",
        "Q9r2": "2",
        "markers": "qualified,/Region/reg1,/Vote/vote3,/Ethnicity/eth1,/de_maxdiff/Q22/v227,sawterm:(dvfail.r1),/Rotate Selection/Top_to_Bottom,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Age/age6,qual,sawterm:Q1.ival gt 2007,Top_to_Bottom,/Gender/gen2,/Income/inc1",
        "Q33": "1",
        "Q32": "2",
        "Q31": "2",
        "Q9r3": "3",
        "Q35": "3",
        "Q22_7c1": "2",
        "Q39r4": "4",
        "Q22_7c2": "3",
        "Q30": "4",
        "Q39r3": "3",
        "Q9r5": "3",
        "Q9r6": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "5",
        "Q22_4c2": "6",
        "Q22_4c1": "9",
        "RotateSelect": "1",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "25",
        "Q23": "1",
        "Q24": "dems and republicans can't agree on it anymore, which is fine",
        "sectionLOIr4": "8.1329",
        "sectionLOIr1": "8.1329",
        "sectionLOIr3": "7.30773333333",
        "sectionLOIr2": "0.298266666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "1",
        "Q11": "3",
        "Q10": "4",
        "Q13": "3",
        "Q12": "3",
        "Q22_scorer7": "62.5",
        "HIDAge2": "6",
        "Q22_scorer5": "62.5",
        "Q22_scorer4": "50",
        "Q19": "2",
        "Q18": "3",
        "Q22_scorer1": "75",
        "record": "1567",
        "Q22_scorer9": "75",
        "Q7r8": "0",
        "Q7r6": "1",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "1",
        "Q7r3": "0",
        "Q7r1": "0",
        "Q22_2c1": "1",
        "Q22_2c2": "3",
        "Q22_scorer6": "25",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "0",
        "Q42r3": "1",
        "Q42r4": "0",
        "Q42r5": "1",
        "Q42r6": "0",
        "Q42r7": "0",
        "Q42r8": "1",
        "Q22_scorer3": "0",
        "vmobiledevice": "5",
        "Q22_scorer2": "75",
        "Q15r4": "6",
        "Q9r1": "1",
        "Q15r6": "6",
        "Q15r7": "6",
        "Q9r4": "2",
        "Q15r1": "7",
        "Q15r2": "6",
        "Q15r3": "7",
        "Q15r8": "4",
        "Q15r9": "6",
        "Q1": "1942",
        "Q3": "33",
        "Q2": "2",
        "Q5": "3",
        "Q4": "7",
        "Q6": "1",
        "Q22_8c2": "6",
        "Q22_8c1": "2",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "1",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "1",
        "s2": "360cac89-18fc-4cac-b2ea-18559abd6a2c",
        "Q40r8": "0",
        "Q40r9": "0",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "2",
        "Q22_3c1": "5",
        "Q22_3c2": "8",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "3",
        "Q8r1": "2",
        "Q8r3": "2",
        "Q8r2": "2",
        "date": "04/06/2026 15:39",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=b687fbdceac34abca168fa426f45aaa9&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=360cac89-18fc-4cac-b2ea-18559abd6a2c&isSynthetic=true&or_zip=14623&or_householdincome=12108",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "0",
        "Q34r8": "1",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "HIDAge": "23",
        "vbrowser": "10",
        "qtime": "447.854",
        "Q14r9": "5",
        "Q14r8": "1",
        "session": "39y86s4avqkhx1en",
        "Q41r1": "1",
        "Q14r1": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "Q14r3": "60",
        "Q14r2": "1",
        "Q14r5": "3",
        "Q14r4": "10",
        "Q14r7": "5",
        "Q14r6": "15",
        "uuid": "tsd95ejy1ysj6s4m",
        "Q22_9c2": "3",
        "Q22_9c1": "6",
        "Q34r4": "0",
        "Q30": "1",
        "vlist": "2",
        "Q22_5c2": "2",
        "Q22_5c1": "5",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "dvfail": "2",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "Q21r1": "5",
        "Q21r3": "6",
        "Q21r2": "2",
        "Q21r5": "7",
        "Q21r4": "1",
        "Q21r7": "3",
        "Q21r6": "4",
        "Q38": "4",
        "Q43": "4",
        "start_date": "04/06/2026 15:33",
        "list": "1",
        "Q21comment": "2",
        "Q42r9": "0",
        "HQREGION": "3",
        "vctq1c22": "0",
        "vctq1c23": "0",
        "vctq1c20": "0",
        "dvscore": "0",
        "vctq1c24": "0",
        "vctq1c25": "1",
        "or1": "2a393a962a294058acb556b2fed9e7e7",
        "DevType": "1",
        "vctq1c19": "1",
        "Q22_1c2": "7",
        "Q22_1c1": "6",
        "record": "1568",
        "Q41r7": "1",
        "Q41r6": "1",
        "Q41r5": "1",
        "Q41r4": "1",
        "Q41r3": "0",
        "Q41r2": "1",
        "markers": "qualified,/Ethnicity/eth4,/Region/reg3,/Vote/vote4,Bottom_to_Top,/Age/age1,20260109_07:39_v14,/Education/edu2,/Overall/qual,/Rotate Selection/Bottom_to_Top,qual,sawterm:Q1.ival gt 2007,/Gender/gen2,sawterm:(dvfail.r1),/de_maxdiff/Q22/v182,/Income/inc2",
        "Q33": "2",
        "Q32": "2",
        "Q31": "2",
        "Q22_version": "182",
        "Q35": "3",
        "Q22_7c1": "9",
        "Q39r4": "4",
        "Q22_7c2": "5",
        "Q39r2": "4",
        "Q39r3": "3",
        "Q39r1": "4",
        "Q22_6c1": "1",
        "Q22_6c2": "2",
        "Q22_4c2": "7",
        "Q22_4c1": "5",
        "RotateSelect": "2",
        "isSynthetic": "true",
        "dcua": "..",
        "Q20": "3",
        "Q22_scorer8": "50",
        "Q23": "4",
        "Q24": "makes my taxes go to less, wind farms paying more",
        "sectionLOIr4": "7.4605",
        "sectionLOIr1": "7.4605",
        "sectionLOIr3": "6.6276",
        "sectionLOIr2": "0.325966666667",
        "vctq1c21": "0",
        "Q17": "2",
        "Q16": "2",
        "Q11": "3",
        "Q10": "4",
        "Q13": "2",
        "Q12": "3",
        "Q22_scorer7": "12.5",
        "HIDAge2": "1",
        "Q22_scorer5": "50",
        "Q22_scorer4": "75",
        "Q19": "1",
        "Q18": "3",
        "Q22_scorer1": "62.5",
        "Q22_scorer9": "62.5",
        "Q7r8": "1",
        "Q7r6": "0",
        "Q7r7": "0",
        "Q7r4": "1",
        "Q7r5": "0",
        "Q7r2": "0",
        "Q7r3": "1",
        "Q7r1": "0",
        "Q22_2c1": "4",
        "Q22_2c2": "7",
        "Q22_scorer6": "87.5",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "Q42r1": "0",
        "Q42r2": "1",
        "Q42r3": "1",
        "Q42r4": "1",
        "Q42r5": "1",
        "Q42r6": "1",
        "Q42r7": "1",
        "Q42r8": "1",
        "Q22_scorer3": "25",
        "vmobiledevice": "5",
        "Q22_scorer2": "25",
        "Q15r4": "5",
        "Q15r5": "3",
        "Q15r6": "4",
        "Q15r7": "5",
        "Q15r1": "4",
        "Q15r2": "5",
        "Q15r3": "3",
        "Q15r8": "5",
        "Q15r9": "5",
        "Q1": "2002",
        "Q3": "44",
        "Q2": "2",
        "Q5": "3",
        "Q4": "4",
        "Q6": "2",
        "Q22_8c2": "5",
        "Q22_8c1": "6",
        "vos": "15",
        "Q40r3": "0",
        "Q40r2": "0",
        "Q14r10": "0",
        "Q40r1": "0",
        "Q40r6": "0",
        "Q40r7": "0",
        "Q40r4": "0",
        "Q40r5": "0",
        "s2": "9ac7cbf1-e283-4bea-8850-7beafd659500",
        "Q40r8": "0",
        "Q40r9": "1",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "Q39r5": "4",
        "vctq1c16": "0",
        "vctq1c3": "0",
        "vctq1c2": "0",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "vctq1c6": "0",
        "vctq1c5": "0",
        "vctq1c4": "1",
        "status": "3",
        "DIVISION": "7",
        "Q22_3c1": "4",
        "Q22_3c2": "3",
        "Q8r5": "2",
        "Q8r4": "3",
        "Q8r6": "2",
        "Q8r1": "3",
        "Q8r3": "2",
        "Q8r2": "1",
        "date": "04/06/2026 15:40",
        "vmobileos": "6",
        "Q34r5": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=2a393a962a294058acb556b2fed9e7e7&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=9ac7cbf1-e283-4bea-8850-7beafd659500&isSynthetic=true&or_zip=79015&or_householdincome=30874",
        "Q34r3": "0",
        "Q41r8": "0",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "Q34r2": "0",
        "Q34r9": "1",
        "Q34r8": "0",
        "Q34r7": "0",
        "Q34r6": "0",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "Q34r1": "0",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1965",
        "vctq1c22": "0",
        "HIDAge": "60",
        "Q2": "2",
        "Q5": "2",
        "Q4": "7",
        "vctq1c24": "0",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "18.789",
        "Q3": "33",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "hcf2gm5sxd5zrvrp",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "5642fc4c04804efbb8377a06aad51ed5",
        "vlist": "2",
        "uuid": "6y079k3yy150u1v7",
        "vmobiledevice": "5",
        "s2": "0207d130-b61f-486d-8844-067558edc9c1",
        "vctq1c25": "1",
        "markers": "bad:/Education/edu1,bad:/Rotate Selection/Top_to_Bottom,bad:/Ethnicity/eth1,20260109_07:39_v14,OQ /Income/inc5,qual,bad:/Age/age5,sawterm:Q1.ival gt 2007,OQ,Top_to_Bottom,bad:/Region/reg1,bad:/Gender/gen2,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "5",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:34",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "2",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "1",
        "date": "04/06/2026 15:35",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=5642fc4c04804efbb8377a06aad51ed5&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=0207d130-b61f-486d-8844-067558edc9c1&isSynthetic=true&or_zip=10994&or_householdincome=99265",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1569",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1987",
        "vctq1c22": "0",
        "HIDAge": "38",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "vctq1c24": "1",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "18",
        "Q3": "40",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "8kfphf4dn9mn6vpf",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "7e9c40f974dd4410a770f3177faae823",
        "vlist": "2",
        "uuid": "e09peykgfv7p6t0x",
        "vmobiledevice": "5",
        "s2": "eef93979-79e6-4668-a281-127ea166a25d",
        "vctq1c25": "0",
        "markers": "bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,OQ /Income/inc5,20260109_07:39_v14,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,Top_to_Bottom,bad:/Region/reg1,OQ,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:35",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "1",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "1",
        "date": "04/06/2026 15:35",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=7e9c40f974dd4410a770f3177faae823&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=eef93979-79e6-4668-a281-127ea166a25d&isSynthetic=true&or_zip=02879&or_householdincome=145000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1570",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1972",
        "vctq1c22": "0",
        "HIDAge": "53",
        "Q2": "1",
        "Q4": "8",
        "vctq1c24": "1",
        "vctq1c23": "0",
        "list": "1",
        "vbrowser": "10",
        "qtime": "13.79",
        "Q3": "38",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "3hzzkjqutucscgrp",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "898d9184d10640adb12d83ef59660107",
        "vlist": "2",
        "uuid": "ennands3fjzxm7x1",
        "vmobiledevice": "5",
        "s2": "7e95f4ee-10d7-4061-90e7-7910d01ad421",
        "vctq1c25": "0",
        "markers": "bad:/Rotate Selection/Top_to_Bottom,OQ /Ethnicity/eth5,20260109_07:39_v14,qual,bad:/Age/age4,sawterm:Q1.ival gt 2007,OQ,bad:/Region/reg4,bad:/Gender/gen1,Top_to_Bottom,bad:/Overall/qual",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "0",
        "vctq1c3": "0",
        "HIDAge2": "4",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:35",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "9",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "1",
        "HQREGION": "4",
        "date": "04/06/2026 15:35",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=898d9184d10640adb12d83ef59660107&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=7e95f4ee-10d7-4061-90e7-7910d01ad421&isSynthetic=true&or_zip=97305&or_householdincome=62000",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1571",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    },
    {
        "Q1": "1983",
        "vctq1c22": "0",
        "HIDAge": "42",
        "Q2": "1",
        "Q5": "4",
        "Q4": "7",
        "vctq1c24": "1",
        "Q6": "5",
        "list": "1",
        "vbrowser": "10",
        "qtime": "18.629",
        "Q3": "23",
        "dcua": "..",
        "vctq1c2": "0",
        "DevType": "1",
        "session": "yc1ch7wvah3hn9fg",
        "s5": "08dde649-2219-4e75-8a9d-884b5f9b1f08",
        "vos": "15",
        "vctq1c23": "0",
        "userAgent": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/146.0.0.0 Safari/537.36",
        "or1": "89338ddd7fea4519aa7ec4413c2e6f52",
        "vlist": "2",
        "uuid": "u0k2t49e7bchs0u1",
        "vmobiledevice": "5",
        "s2": "38f03418-e0e5-414d-a860-c53750a99c02",
        "vctq1c25": "0",
        "markers": "bad:/Education/edu3,bad:/Rotate Selection/Top_to_Bottom,OQ /Income/inc5,20260109_07:39_v14,qual,bad:/Ethnicity/eth1,sawterm:Q1.ival gt 2007,bad:/Age/age3,bad:/Gender/gen1,Top_to_Bottom,OQ,bad:/Overall/qual,bad:/Region/reg2",
        "vctq1c9": "0",
        "vctq1c8": "0",
        "vctq1c20": "1",
        "vctq1c3": "0",
        "HIDAge2": "3",
        "vctq1c1": "1",
        "vctq1c7": "0",
        "start_date": "04/06/2026 15:36",
        "vctq1c5": "0",
        "vctq1c4": "0",
        "status": "2",
        "DIVISION": "3",
        "vctq1c19": "0",
        "vctq1c18": "0",
        "vctq1c17": "0",
        "vctq1c16": "0",
        "vctq1c15": "0",
        "vctq1c14": "0",
        "vctq1c13": "0",
        "vctq1c12": "0",
        "vctq1c11": "0",
        "vctq1c10": "0",
        "vctq1c21": "0",
        "HQREGION": "2",
        "date": "04/06/2026 15:36",
        "vmobileos": "6",
        "dvflagr2": "0",
        "dvflagr3": "0",
        "dvflagr1": "0",
        "dvflagr96": "0",
        "dvflagr97": "0",
        "url": "/survey/selfserve/5c2/251213?list=1&or1=89338ddd7fea4519aa7ec4413c2e6f52&s5=08dde649-2219-4e75-8a9d-884b5f9b1f08&s2=38f03418-e0e5-414d-a860-c53750a99c02&isSynthetic=true&or_zip=49404&or_householdincome=163500",
        "isSynthetic": "true",
        "dvflagr98": "0",
        "dvflagr99": "0",
        "vctq1c6": "0",
        "record": "1572",
        "RotateSelect": "1",
        "GeoIP_Detailsr4": "OH",
        "GeoIP_Detailsr5": "Ohio",
        "GeoIP_Detailsr2": "United States",
        "GeoIP_Detailsr3": "535",
        "GeoIP_Detailsr1": "us"
    }
]